"use strict";

class PaymentDetailsController {

    constructor($scope, $window, $filter, $parse, $sce, SSUserService, SSAppService, SSHttpService, SSUtilService, SSDateService, SSEoiService, SSAwsService, SSAlertService, OTPService, SSConfirmationService, $timeout, SSConfigService, SettingsService, SSSaleRemarksService, Upload) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$filter = $filter;
        self.$parse = $parse;
        self.$sce = $sce;

        self.$scope.$on('ngRepeatFinished', function(ngRepeatFinishedEvent) {
            self.initSelectizejsClass();
        });

        self.SSUserService = SSUserService;
        self.SSAppService = SSAppService;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSEoiService = SSEoiService;
        self.SSAwsService = SSAwsService;
        self.SSAlertService = SSAlertService;
        self.$timeout = $timeout;
        self.SSConfigService = SSConfigService;
        self.SettingsService = SettingsService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSSaleRemarksService = SSSaleRemarksService;
        self.Upload = Upload;

        self.data = SHOWSUITE.data;
        self.urlPaymentInformation = false;

        self.sale_id = self.data.sale_id;
        self.parameters = self.data.url_param;
        self.reorder_buyers = [];
        self.selected_loa_documents = [];

        // Config Data
        self.maritalStatuses = self.SSConfigService.getMaritalStatuses();
        self.genders = self.SSConfigService.getGenders();

        let serverConfig = self.SSConfigService.serverConfig;
        self.payment_types = serverConfig.payment_types;
        self.payment_type_percents = serverConfig.payment_type_percents;
        self.payment_statuses = serverConfig.payment_statuses;
        self.instrument_statuses = serverConfig.instrument_statuses;
        self.instrument_types = serverConfig.instrument_types;

        self.SALE_STATUS_DRAFT = SHOWSUITE.SALE_STATUS_DRAFT;
        self.SALE_STATUS_PENDING = SHOWSUITE.SALE_STATUS_PENDING;
        self.SALE_STATUS_SUBMITTED = SHOWSUITE.SALE_STATUS_SUBMITTED;
        self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
        self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
        self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
        self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;
        self.SALE_STATUS_CHEQUE_ENTERED = SHOWSUITE.SALE_STATUS_CHEQUE_ENTERED;
        self.SALE_STATUS_SPA_ENTERED = SHOWSUITE.SALE_STATUS_SPA_ENTERED;
        self.SALE_STATUS_EXPIRED = SHOWSUITE.SALE_STATUS_EXPIRED;
        self.SALE_STATUS_EXERCISED = SHOWSUITE.SALE_STATUS_EXERCISED;
        self.SALE_STATUS_EXTENDED = SHOWSUITE.SALE_STATUS_EXTENDED;
        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;
        self.SALE_STATUS_INVALID = SHOWSUITE.SALE_STATUS_INVALID;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;
        self.SALE_STATUS_DELETED = SHOWSUITE.SALE_STATUS_DELETED;
        self.SALE_STATUS_DONE = SHOWSUITE.SALE_STATUS_DONE;

        // WEB-3614 Subsale Draft → Approved lifecycle
        self.SUBSALE_STATUS_DRAFT = SHOWSUITE.SUBSALE_STATUS_DRAFT;
        self.SUBSALE_STATUS_APPROVED = SHOWSUITE.SUBSALE_STATUS_APPROVED;
        // WEB-3614 — project-level toggle (subsale_approval_flow); default OFF until read in getPropertySettings()
        self.isSubsaleApprovalFlowEnabled = false;

        // WEB-3908 — project-level toggle (billing_date_follows_notice_served_date); default OFF
        // until read in getPropertySettings(). Must start false: the setting is read asynchronously
        // and the server fails closed, so an optimistic default would lock the field on a project
        // that never opted in.
        self.isBillingDateFollowsNoticeServedDateEnabled = false;

        self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
        self.EOI_STATUS_TRANSFERRED = SHOWSUITE.EOI_STATUS_TRANSFERRED;
        self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
        self.EOI_STATUS_VERIFIED = SHOWSUITE.EOI_STATUS_VERIFIED;
        self.EOI_STATUS_WITHDRAWN = SHOWSUITE.EOI_STATUS_WITHDRAWN;
        self.EOI_STATUS_REJECTED = SHOWSUITE.EOI_STATUS_REJECTED;
        self.EOI_STATUS_REGISTERED = SHOWSUITE.EOI_STATUS_REGISTERED;
        self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;
        self.EOI_STATUS_UNSUCCESSFUL = SHOWSUITE.EOI_STATUS_UNSUCCESSFUL;
        self.EOI_STATUS_COMPLETED = SHOWSUITE.EOI_STATUS_COMPLETED;

        self.PAYMENT_STATUS_PENDING = SHOWSUITE.PAYMENT_STATUS_PENDING;
        self.PAYMENT_STATUS_RECEIVED = SHOWSUITE.PAYMENT_STATUS_RECEIVED;
        self.PAYMENT_STATUS_PROCESSING = SHOWSUITE.PAYMENT_STATUS_PROCESSING;
        self.PAYMENT_STATUS_DONE = SHOWSUITE.PAYMENT_STATUS_DONE;
        self.PAYMENT_STATUS_DELETED = SHOWSUITE.PAYMENT_STATUS_DELETED;

        self.PAYMENT_TYPE_01_BOOKING_FEE = SHOWSUITE.PAYMENT_TYPE_01_BOOKING_FEE;
        self.PAYMENT_TYPE_20_REFUND = SHOWSUITE.PAYMENT_TYPE_20_REFUND;
        self.PAYMENT_TYPE_02_DEPOSIT = SHOWSUITE.PAYMENT_TYPE_02_DEPOSIT;
        self.PAYMENT_TYPE_14_MAINTENANCE_FEE = SHOWSUITE.PAYMENT_TYPE_14_MAINTENANCE_FEE;
        self.PAYMENT_TYPE_15_SURVEY_FEE = SHOWSUITE.PAYMENT_TYPE_15_SURVEY_FEE;
        self.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE = SHOWSUITE.PAYMENT_TYPE_17_SUB_MAINTENANCE_FEE;

        self.INSTRUMENT_STATUS_RECEIVED = SHOWSUITE.INSTRUMENT_STATUS_RECEIVED;
        self.INSTRUMENT_STATUS_BOUNCED = SHOWSUITE.INSTRUMENT_STATUS_BOUNCED;
        self.INSTRUMENT_STATUS_COMPLETED = SHOWSUITE.INSTRUMENT_STATUS_COMPLETED;
        self.INSTRUMENT_STATUS_READY_FOR_BANK_IN = SHOWSUITE.INSTRUMENT_STATUS_READY_FOR_BANK_IN;
        self.INSTRUMENT_STATUS_BANKED_IN = SHOWSUITE.INSTRUMENT_STATUS_BANKED_IN;

        // PAYMENT INSTRUMENT TYPES
        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_EDP = SHOWSUITE.INSTRUMENT_TYPE_EDP;
        self.INSTRUMENT_TYPE_EDP_PLUS = SHOWSUITE.INSTRUMENT_TYPE_EDP_PLUS;

        self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;
        self.PROPERTY_DOCUMENT_KIND_OTP = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTP;

        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL;
        self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS = SHOWSUITE.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS;
        self.HISTORY_ENTRY_TYPE_AML_RISK_ASSESSMENT = SHOWSUITE.HISTORY_ENTRY_TYPE_AML_RISK_ASSESSMENT;
        self.AML_RISK_ASSESSMENT_NOT_CONFIGURED_MESSAGE = "AML Risk Assessment questions are not set up for this project. Please configure them in the project questionnaire before reviewing.";
        self.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CDD_DOCUMENTS;
        self.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_CONSISTENT_TRANSACTIONS;
        self.QUESTION_MARKER_KEY_HANDOVER_RISK_ML = SHOWSUITE.QUESTION_MARKER_KEY_HANDOVER_RISK_ML;

        self.ASSET_MODEL_SALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT;
        self.ASSET_MODEL_DOCUMENT_HISTORY = SHOWSUITE.ASSET_MODEL_DOCUMENT_HISTORY;
        self.ASSET_MODEL_PAYMENT_INSTRUMENT = SHOWSUITE.ASSET_MODEL_PAYMENT_INSTRUMENT;
        self.ASSET_MODEL_KEY_HANDOVER_APPOINTMENT_DOCUMENT = SHOWSUITE.ASSET_MODEL_KEY_HANDOVER_APPOINTMENT_DOCUMENT;

        self.PROPERTY_DOCUMENT_TYPE_FORM = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_FORM;
        self.PROPERTY_DOCUMENT_TYPE_USER_DOC = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_USER_DOC;
        self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED = SHOWSUITE.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED;

        self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM;
        self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS;
        self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM;
        self.PROPERTY_DOCUMENT_KIND_PDI_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PDI_FORM;
        self.PROPERTY_DOCUMENT_KIND_AML = SHOWSUITE.PROPERTY_DOCUMENT_KIND_AML;
        self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ANNEXES = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEXES;
        self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SIDE_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_A = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_A;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_B3 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_B3;
        self.PROPERTY_DOCUMENT_KIND_ANNEX_C = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ANNEX_C;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT;
        self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION;
        self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS;
        self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER;
        self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM = SHOWSUITE.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM;
        self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE;
        self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT;
        self.PROPERTY_DOCUMENT_KIND_OTHER = SHOWSUITE.PROPERTY_DOCUMENT_KIND_OTHER;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F;
        self.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2 = SHOWSUITE.PROPERTY_DOCUMENT_KIND_CDD_FORM_F_A2;
        self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT;
        self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION;

        self.PROPERTY_ACCOUNT_TYPE_CURRENT_ACCOUNT = SHOWSUITE.PROPERTY_ACCOUNT_TYPE_CURRENT_ACCOUNT;
        self.PROPERTY_ACCOUNT_TYPE_MANAGING_COUNCIL_ACCOUNT = SHOWSUITE.PROPERTY_ACCOUNT_TYPE_MANAGING_COUNCIL_ACCOUNT;

        self.DISCOUNT_TYPE_STANDARD = SHOWSUITE.DISCOUNT_TYPE_STANDARD;
        self.DISCOUNT_TYPE_STAFF = SHOWSUITE.DISCOUNT_TYPE_STAFF;
        self.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_SINGLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_MULTIPLE_USE;
        self.DISCOUNT_TYPE_PROMO_CODE_OTHER = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_OTHER
        self.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL = SHOWSUITE.DISCOUNT_TYPE_PROMO_CODE_ADDITIONAL;

        self.CRYSTAL_REPORT_SERVER_URL = SHOWSUITE.CRYSTAL_REPORT_SERVER_URL;
        self.LARAVEL_REPORT_SERVER_URL = SHOWSUITE.LARAVEL_REPORT_SERVER_URL;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;
        self.BUYER_TYPES = [
            {id: self.BUYER_TYPE_INDIVIDUAL, name: 'Individual'},
            {id: self.BUYER_TYPE_COMPANY, name: 'Company'}
        ];

        self.EMPLOYMENT_STATUS_UNEMPLOYED = SHOWSUITE.EMPLOYMENT_STATUS_UNEMPLOYED;
        self.EMPLOYMENT_STATUS_RETIRED_WITH_PENSION = SHOWSUITE.EMPLOYMENT_STATUS_RETIRED_WITH_PENSION;
        self.EMPLOYMENT_STATUS_EMPLOYED = SHOWSUITE.EMPLOYMENT_STATUS_EMPLOYED;
        self.EMPLOYMENT_STATUS_SELF_EMPLOYED = SHOWSUITE.EMPLOYMENT_STATUS_SELF_EMPLOYED;
        self.EMPLOYMENT_STATUS_EMPLOYED_COMMISSION_INCENTIVE_BASED = SHOWSUITE.EMPLOYMENT_STATUS_EMPLOYED_COMMISSION_INCENTIVE_BASED;
        self.EMPLOYMENT_STATUS_ODD_JOB_PART_TIME_WORKER = SHOWSUITE.EMPLOYMENT_STATUS_ODD_JOB_PART_TIME_WORKER;

        self.EMPLOYMENT_STATUSES = [
            {id: self.EMPLOYMENT_STATUS_UNEMPLOYED, name: 'Un-employed'},
            {id: self.EMPLOYMENT_STATUS_RETIRED_WITH_PENSION, name: 'Retired With Pesion'},
            {id: self.EMPLOYMENT_STATUS_EMPLOYED, name: 'Employed'},
            {id: self.EMPLOYMENT_STATUS_SELF_EMPLOYED, name: 'Self Employed'},
            {id: self.EMPLOYMENT_STATUS_EMPLOYED_COMMISSION_INCENTIVE_BASED, name: 'Employed Commission Incentive Based'},
            {id: self.EMPLOYMENT_STATUS_ODD_JOB_PART_TIME_WORKER, name: 'Part Time Worker'}
        ];

        self.IDENTITY_TYPE_SINGAPOREAN = SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN;
        self.IDENTITY_TYPE_SINGAPORE_PR = SHOWSUITE.IDENTITY_TYPE_SINGAPORE_PR;
        self.IDENTITY_TYPE_FOREIGNER = SHOWSUITE.IDENTITY_TYPE_FOREIGNER;
        self.IDENTITY_TYPE_COMPANY = SHOWSUITE.IDENTITY_TYPE_COMPANY;

        self.bounced_reasons = self.SSConfigService.getBouncedReasons();
        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;
        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;

        self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES;
        self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_CO_BROKE_SALES;
        self.STAFF_COMMISSION_TYPE_SC_SALES = SHOWSUITE.STAFF_COMMISSION_TYPE_SC_SALES;

        self.STAFF_COMMISSION_TYPES = [
            {id: self.STAFF_COMMISSION_TYPE_APPOINTED_AGENCY_SALES, name: 'Direct Sales by any Appointed Agent'},
            {id: self.STAFF_COMMISSION_TYPE_CO_BROKE_SALES, name: 'Co-Broke with an External Non-Appointed Agent'},
            {id: self.STAFF_COMMISSION_TYPE_SC_SALES, name: 'Direct Sales Consultant Sales'},
        ];

        self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE;
        self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER;
        self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT;
        self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER;
        self.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF = SHOWSUITE.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF;

        self.STAFF_COMMISSION_TEAM_ROLES = [
            {id: self.STAFF_COMMISSION_TEAM_ROLE_MANAGER_IN_CHARGE , name: "Manager in Charge of Project"},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_DEPUTY_MANAGER , name: "Deputy in Charge of Project"},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_SALES_CONSULTANT , name: "Sales Consultant/Buyer Agent"},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_OTHER_MANAGER , name: "Other Manager"},
            {id: self.STAFF_COMMISSION_TEAM_ROLE_OTHER_STAFF , name: "Other Staff"},
        ];

        self.PROPERTY_DOCUMENT_FORMAT_PDF = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_PDF;
        self.PROPERTY_DOCUMENT_FORMAT_IMG = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_IMG;
        self.PROPERTY_DOCUMENT_FORMAT_HTML = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML;
        self.PROPERTY_DOCUMENT_FORMAT_HTML_PREVIEW_ONLY = SHOWSUITE.PROPERTY_DOCUMENT_FORMAT_HTML_PREVIEW_ONLY;

        self.ASSET_MODEL_BUYER_DOCUMENT = SHOWSUITE.ASSET_MODEL_BUYER_DOCUMENT;

        self.PROPERTY_DOCUMENT_KIND_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_NRIC_BACK;

        self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE;
        self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION = SHOWSUITE.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION;
        self.ASSET_MODEL_PAYMENT_SERVING_LETTER = SHOWSUITE.ASSET_MODEL_PAYMENT_SERVING_LETTER;

        self.PROPERTY_SETTINGS_SELECTIONS = SHOWSUITE.PROPERTY_SETTINGS_SELECTIONS;

        self.SELECTIONS_STATUS_SELECTED = SHOWSUITE.SELECTIONS_STATUS_SELECTED;
        self.SELECTIONS_STATUS_PENDING_RESELECTION = SHOWSUITE.SELECTIONS_STATUS_PENDING_RESELECTION;

        self.PAYMENT_PLAN_TYPE_PVT = SHOWSUITE.PAYMENT_PLAN_TYPE_PVT;
        self.PAYMENT_PLAN_TYPE_NPS = SHOWSUITE.PAYMENT_PLAN_TYPE_NPS;
        self.PAYMENT_PLAN_TYPE_DPS = SHOWSUITE.PAYMENT_PLAN_TYPE_DPS;

        self.SALE_COMMISSION_STATUS_APPROVED = SHOWSUITE.SALE_COMMISSION_STATUS_APPROVED;

        self.QUESTION_TYPE_YES_NO = SHOWSUITE.QUESTION_TYPE_YES_NO;
        self.QUESTION_TYPE_YES_NO_NA = SHOWSUITE.QUESTION_TYPE_YES_NO_NA;
        self.QUESTION_TYPE_TEXT = SHOWSUITE.QUESTION_TYPE_TEXT;
        self.QUESTION_TYPE_NUMBER = SHOWSUITE.QUESTION_TYPE_NUMBER;
        self.QUESTION_TYPE_SELECT = SHOWSUITE.QUESTION_TYPE_SELECT;
        self.QUESTION_TYPE_CHECKBOX = SHOWSUITE.QUESTION_TYPE_CHECKBOX;
        self.QUESTION_TYPE_RADIO = SHOWSUITE.QUESTION_TYPE_RADIO;
        self.QUESTION_TYPE_DATE = SHOWSUITE.QUESTION_TYPE_DATE;

        self.BENEFICIARY_IDENTITY_NRIC = SHOWSUITE.BENEFICIARY_IDENTITY_NRIC;
        self.BENEFICIARY_IDENTITY_PASSPORT = SHOWSUITE.BENEFICIARY_IDENTITY_PASSPORT;
        self.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE = SHOWSUITE.BENEFICIARY_IDENTITY_BIRTH_CERTIFICATE;

        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_FRONT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_NRIC_BACK;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_PASSPORT;
        self.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE = SHOWSUITE.PROPERTY_DOCUMENT_KIND_BENEFICIARY_BIRTH_CERTIFICATE;

        self.PROPERTY_SETTINGS_BUYING_IN_TRUST = SHOWSUITE.PROPERTY_SETTINGS_BUYING_IN_TRUST;
        self.ASSET_MODEL_SUBSALE_DOCUMENT = SHOWSUITE.ASSET_MODEL_SUBSALE_DOCUMENT;

        self.INSTRUMENT_TYPE_CHEQUE = SHOWSUITE.INSTRUMENT_TYPE_CHEQUE;
        self.INSTRUMENT_TYPE_CASHIERS_ORDER = SHOWSUITE.INSTRUMENT_TYPE_CASHIERS_ORDER;
        self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER;
        self.INSTRUMENT_TYPE_CASH_IN = SHOWSUITE.INSTRUMENT_TYPE_CASH_IN;
        self.INSTRUMENT_TYPE_GIRO = SHOWSUITE.INSTRUMENT_TYPE_GIRO;
        self.INSTRUMENT_TYPE_DEBIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_DEBIT_CARD;
        self.INSTRUMENT_TYPE_FAST_CASH = SHOWSUITE.INSTRUMENT_TYPE_FAST_CASH;
        self.INSTRUMENT_TYPE_BANK_TRANSFER = SHOWSUITE.INSTRUMENT_TYPE_BANK_TRANSFER;
        self.INSTRUMENT_TYPE_PAYNOW_OTHERS = SHOWSUITE.INSTRUMENT_TYPE_PAYNOW_OTHERS;
        self.INSTRUMENT_TYPE_CREDIT_CARD = SHOWSUITE.INSTRUMENT_TYPE_CREDIT_CARD;
        self.INSTRUMENT_TYPE_CASH = SHOWSUITE.INSTRUMENT_TYPE_CASH;
        self.INSTRUMENT_TYPE_EDP = SHOWSUITE.INSTRUMENT_TYPE_EDP;
        self.INSTRUMENT_TYPE_EDP_PLUS = SHOWSUITE.INSTRUMENT_TYPE_EDP_PLUS;

        self.PROPERTY_TYPE_EXECUTIVE_CONDO = SHOWSUITE.PROPERTY_TYPE_EXECUTIVE_CONDO;

        // WEB-3524 — "GST receiving" instrument flag is only offered for commercial units
        // (commercial is a unit-level attribute; mixed developments mix residential + commercial units).
        self.UNIT_CATEGORY_COMMERCIAL = SHOWSUITE.UNIT_CATEGORY_COMMERCIAL;

        self.QUESTION_ENTITY_TYPE_DEVELOPER = SHOWSUITE.QUESTION_ENTITY_TYPE_DEVELOPER;
        self.QUESTION_ENTITY_TYPE_BROKER = SHOWSUITE.QUESTION_ENTITY_TYPE_BROKER;
        self.QUESTION_PHASE_BOOKING = SHOWSUITE.QUESTION_PHASE_BOOKING;

        self.PAYMENT_REFUND_TYPE_10_WAIVER = SHOWSUITE.PAYMENT_REFUND_TYPE_10_WAIVER;
        self.PAYMENT_REFUND_TYPE_20_REFUND = SHOWSUITE.PAYMENT_REFUND_TYPE_20_REFUND;
        self.PAYMENT_TYPE_12_DLP = SHOWSUITE.PAYMENT_TYPE_12_DLP;

        self.AML_SCAN_TYPE_EOI = SHOWSUITE.AML_SCAN_TYPE_EOI;
        self.AML_SCAN_TYPE_OTP = SHOWSUITE.AML_SCAN_TYPE_OTP;
        self.AML_SCAN_TYPE_ON_GOING = SHOWSUITE.AML_SCAN_TYPE_ON_GOING;
        self.AML_SCAN_TYPE_MANUAL = SHOWSUITE.AML_SCAN_TYPE_MANUAL;
        self.AML_SCAN_TYPE_TOP = SHOWSUITE.AML_SCAN_TYPE_TOP;
        self.AML_SCAN_TYPE_LEGAL_COMPLETION = SHOWSUITE.AML_SCAN_TYPE_LEGAL_COMPLETION;
        self.RESIDENCE_TYPE_LANDED_PROPERTY = SHOWSUITE.RESIDENCE_TYPE_LANDED_PROPERTY;

        self.DAILY_INTEREST_STATUS_PENDING = SHOWSUITE.DAILY_INTEREST_STATUS_PENDING;
        self.DAILY_INTEREST_STATUS_CHARGEABLE = SHOWSUITE.DAILY_INTEREST_STATUS_CHARGEABLE;
        self.DAILY_INTEREST_STATUS_WAIVED = SHOWSUITE.DAILY_INTEREST_STATUS_WAIVED;

        self.INSTRUMENT_POSTING_STATUS_PENDING = SHOWSUITE.INSTRUMENT_POSTING_STATUS_PENDING; // null
        self.INSTRUMENT_POSTING_STATUS_REVIEWED = SHOWSUITE.INSTRUMENT_POSTING_STATUS_REVIEWED;
        self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING = SHOWSUITE.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING;
        self.INSTRUMENT_POSTING_STATUS_POSTED = SHOWSUITE.INSTRUMENT_POSTING_STATUS_POSTED;

        self.CATEGORY_PAYMENT = 'payment';
        self.CATEGORY_INSTRUMENT = 'instrument'

        self.refundTypes = [{
            id: self.PAYMENT_REFUND_TYPE_10_WAIVER,
            name: 'WAIVER'
        }, {
            id: self.PAYMENT_REFUND_TYPE_20_REFUND,
            name: 'REFUND'
        }];

        self.THAILAND_COUNTRY_CODE = 764;

        self.law_firms = self.SSConfigService.getLawFirms();
        self.law_firms.push({'code': '999999', 'name': 'OTHERS'});
        self.SSEoiService.brokers_obj = [];
        self.payment_plan_clauses = [];

        self.today = moment().format('DD/MM/YYYY');
        self.payment_plan = null;
        self.unit_loading = true;
        self.documents_loading = true;
        self.showViewDetailModal = false;
        self.detailModalBody = "";

        self.downloadReportModal = false;
        self.pp_form_settings = null;
        self.nbp_pp_form_settings = null;
        self.beneficiary_pp_form_settings = null;
        self.generateReport = {
            from_date:null,
            to_date:null
        };

        self.mortgagee_banks = [];

        /** WEB-2827 Show/Hide Payment Settings **/
        self.is_payment_section_disabled = false;
        self.is_upload_doc_section_disabled = {};
        self.is_skip_upload_buyer_documents_step = false;

        self.prepareSaleStatuses();
        self.prepareSubsaleStatuses();
        self.prepareEoiStatuses();

        self.resetEmailObject();
        self.has_access = false;

        /** WEB-2918 DMS: OTP Date - Add permissions **/
        self.selected_property_id = null;

        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;
        self.booking_fee_percentage = 5;

        self.searched = false;

        self.selectedSaleBuyer = null;
        self.selectedSaleBeneficiary = null;
        self.saleBuyerEditMode = false;
        self.saleNonBuyerPayeeEditMode = false;
        self.saleBeneficiaryEditMode = false;
        self.enable_buying_in_trust = false;
        self.saveButton = false;
        self.saveButton_after_remove = false;
        self.subSaleMode = false;
        self.previous_sale_buyers = [];
        self.subsales = [];
        self.buyerToCopy = null;
        self.propertyCommissions = null;
        self.saleCommissions = null;
        self.current_sale_commission_params = {};
        self.commissionEditMode = false;
        self.display_selection_row = false;

        self.updateSaleParams = {};
        self.updateSaleEditMode = false;
        self.calculateInterestParams = {};
        self.calculateInterestErrors = {};
        self.selectedPayment = null;

        // self.getAgencies();
        self.SINGAPORE_SELECTOR_ID = 702;
        self.primary_address_type = "primary_address";

        self.mailing_address_type = "mailing_address";
        self.prepareMortgageeList();

        self.developerSettings = null;
        self.SettingsService.getDeveloperSettings((developerSettings) => self.developerSettings = developerSettings);

        self.afterAbort = true;
        self.isSubSale = false;
        self.getSaleDetails();

        /** WEB-4343 Sale status shown in UNIT DETAILS - load the listing's display labels **/
        self.getStatus();

        // self.getSalePayments();
        // self.getPageUrlId();
        self.getBuyerRepresentative();

        jQuery('.datepicker').datepicker({
            dateFormat: "dd/mm/yy",
        });

        $('#otpDatepicker').datepicker({dateFormat: 'dd/mm/yy'});
        $('#otpDatepickerTwo').datepicker({dateFormat: 'dd/mm/yy'});

        // Don't allow future date for 'Cheque Date' field
        $('#cheque_date').datepicker({dateFormat: 'dd/mm/yy', maxDate: new Date()});
        // WEB-3641: Refund Due Date — only current/past dates allowed (block future dates)
        $('#refund_due_date').datepicker({dateFormat: 'dd/mm/yy', maxDate: new Date()});
        $('#waiver_date').datepicker({dateFormat: 'dd/mm/yy'});
        $('#calculate_payment_interest_date').datepicker({
            changeMonth: true,
            changeYear: true,
            dateFormat: "dd/mm/yy"
        });
        self.posting_date =  null;
        self.interestCalculation = false;


        $('#requested_spa_issue_date').datepicker({dateFormat: 'dd/mm/yy'});

        self.$timeout(function() {
            self.maskPhoneNumber(self, 'ctrl.', 'paymentDetails');
            self.maskModalPhoneNumber(self, 'ctrl.', 'registerEoiAgentModal');
        });

        self.card_companies = [
            {id: 'Visa', name: 'Visa'},
            {id: 'Mastercard', name: 'Mastercard'},
            {id: 'Other', name: 'Other'}
        ];

        self.pdi_document_kinds = [
            {
                'id': self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Declaration Form'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Cover Letter'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Side Letter'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'PDI Form'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEXES,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annexes Document'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex A'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex B3'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Annex C'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Letter Of Agreement'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Particulars (System Generated)'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Purchaser Particulars Form (Signable)'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_OTP,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Option To Purchase (OTP)'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'Buyer Congratulations Letter'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_APPLICATION,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Application'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EOI_BALLOT_TICKETS,
                'type': self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
                'name': 'EOI Ballot Tickets'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_ELITE_MEMBERSHIP_FORM,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'Elite Membership Form'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': 'External Agent Represented'
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
                'type': self.PROPERTY_DOCUMENT_TYPE_FORM,
                'name': "3rd Party Payor",
            },
            {
                'id': self.PROPERTY_DOCUMENT_KIND_OTHER,
                'type': self.PROPERTY_DOCUMENT_TYPE_USER_DOC,
                'name': "Other",
            }
        ];
        self.interest_request_status = null;
        self.getEmailDataForChargeableInterest();
        self.editViewChargedWaiveOff = false;
    }

    checkScroll(){
        const self = this;

        self.$timeout(function(){
            $(function(){
                if(SHOWSUITE.data.url_param.div === "paymentInformation"){
                    self.urlPaymentInformation = true;
                    // const unitDetails = $("#unitDetails");
                    // if(unitDetails){
                    //     unitDetails.trigger('click');
                    // }
                    const paymentInformation = $("#paymentInformation");
                    if(paymentInformation){
                        self.$timeout(function(){
                            paymentInformation.trigger('click');
                            self.$timeout(function(){
                                paymentInformation[0].scrollIntoView({ behavior: 'smooth' });
                            }, 980);
                        });
                    }
                }
                if(SHOWSUITE.data.url_param.div === "generatedDocuments"){
                    const generatedDocumetnDiv = $("#generatedDocuments");
                    if(generatedDocumetnDiv){
                        self.$timeout(function(){
                            generatedDocumetnDiv.trigger('click');
                            self.$timeout(function(){
                                generatedDocumetnDiv[0].scrollIntoView({ behavior: 'smooth' });
                            }, 980);
                        });
                    }
                }
            });
        });
    }

    prepareBanksData() {
        const self = this;

        self.banks = angular.copy(self.SSConfigService.getBanks(self.PROJECT_COUNTRY));

        self.banks_master = [];
        jQuery.each(self.banks, function (i, bank) {
            if(bank.name.toLowerCase() !== 'others')
                self.banks_master.push(bank.name);
        });
    }

    prepareMortgageeList() {
        const self = this;

        let url = 'sec/developer/sales/mortgagee/all';
        let params = {};

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.mortgage_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.mortgage_loading = false;
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.mortgagee_banks = response.data.mortgagee;
            self.mortgagee_banks.push({
                id: 9999,
                code: '',
                name: 'Others'
            });
        });

        // self.mortgagee_banks = angular.copy(self.SSConfigService.getBanks());
        // self.mortgagee_banks.push({
        //     id: 7777,
        //     code: 'CPF',
        //     name: 'CPF'
        // });

        // self.mortgagee_banks.push({
        //     id: 8888,
        //     code: 'None',
        //     name: 'None'
        // });

    }

    mortgageeSelectionChanged(){
        const self = this;
        // let search_name = self.mortgageeDetailsPararms.mortgagee_name;
        // let results = self.mortgagee_banks.filter((value) => {
        //     return value.name == search_name;
        // });
        self.mortgageeDetailsPararms = self.selectedMortgagee;
        self.mortgageeDetailsPararms.mortgagee_name = self.mortgageeDetailsPararms.name;
    }

    getPageUrlId() {
        var path = window.location.pathname;

        // Break the path into segments
        var segments = path.split("/");

        // Return the segment that has the ID
    }

    getSaleDetails(updatePaymentsData = false) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id;
        let params = {
            include: 'question_answers,eoi_unit'
        };

        loading(!updatePaymentsData? true : false);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Get sale details
            self.sale_sales = response.data.sales[0];
            self.pId = self.sale_sales.property_id;
            // self.getPropertySettings(self.sale_sales.property_id);

            if(!updatePaymentsData){
                // Get Property Questions
                self.getPropertyQuestions(self.sale_sales.property_id);

                //Get sale selections
                self.getSalesSelections();

                //Get sale mortgagee details
                self.getSalesMortgagees();
                self.getPropertySettings();
            }

            self.is_resend_selection_email = false;

            if (self.sale_sales.selections_status && (self.sale_sales.selections_status == self.SELECTIONS_STATUS_SELECTED || self.sale_sales.selections_status == self.SELECTIONS_STATUS_PENDING_RESELECTION)) {
                self.is_resend_selection_email = true;
            }

            if (self.sale_sales.requested_spa_issue_date) {
                self.sale_sales.requested_spa_issue_date = self.SSUtilService.formatUtcToLocalDate(self.sale_sales.requested_spa_issue_date);
            }

            self.sale_sales.actual_expiry_date = moment(self.sale_sales.spa_date).add('21', 'days');
            self.sale_expired = moment().isBefore(self.sale_sales.actual_expiry_date) ? true : false;
            self.salePriceCopy = angular.copy(self.sale_sales.price);
            self.ppFormRemarksCopy = self.sale_sales.pp_form_remarks ? angular.copy(self.sale_sales.pp_form_remarks) : '';
            self.agentRemarksCopy = self.sale_sales.remarks ? angular.copy(self.sale_sales.remarks) : '';
            // (self.sale_sales.commission_gst_inclusive == 1) ? self.sale_sales.commission_gst_inclusive = true : self.sale_sales.commission_gst_inclusive = false;
            // (self.sale_sales.gst_inclusive == 1) ? self.sale_sales.gst_inclusive = true : self.sale_sales.gst_inclusive = false;

            // Check if 'AML' and 'Buyer Particulars' are not in documents
            // then create emtpy objects with these kinds to provide 'Generate' option
            if (self.sale_sales.documents) {
                // For 'Buyer Particulars'
                let buyer_particulars = self.sale_sales.documents.find(x => x.document_kind == self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS);

                if (!buyer_particulars) {
                    buyer_particulars = self.initEmptyDocument(self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS);
                    self.sale_sales.documents.push(buyer_particulars);
                }

                // For 'AML'
                let aml_cft = self.sale_sales.documents.find(x => x.document_kind == self.PROPERTY_DOCUMENT_KIND_AML);

                if (!aml_cft) {
                    aml_cft = self.initEmptyDocument(self.PROPERTY_DOCUMENT_KIND_AML);
                    self.sale_sales.documents.push(aml_cft);
                }
            }

            if(!updatePaymentsData){
                //Get Property Commissions
                self.getPropertyCommissions();

                self.getAgencies();

                self.$timeout(function(){
                    //Get Sale Buyer & Subsales
                    self.getSalesBuyers();
                });

                //get sale occupiers

                self.getSalesOccupier();

                self.getSalesNonBuyerPayees();

                self.getSalesWitnesses();

                self.getOtherAmlCftEntities();
            }

            try {
                let _agency = (response.data.agencies && response.data.agencies.length > 0) ? response.data.agencies.find(x => x.id === self.sale_sales.agency_id) : null;
                self.sale_sales.agency_name = _agency ? _agency.name : null;

                $.each(self.sale_sales.brokers, function (index, broker) {
                    if (broker.broker_role == 1) {
                        //self.sale_sales.broker_name = response.data.brokers.find(x => x.user_id === broker.broker_user_id).user;
                        self.sale_sales.broker_name = response.data.brokers.findIndex(x => x.user_id === broker.broker_user_id);
                        self.sale_sales.broker_name = response.data.brokers[self.sale_sales.broker_name].user;
                    }
                });
            } catch (ex) {
                console.log(ex);
            }
        });
        self.$timeout(function(){
            if(self.urlPaymentInformation){
                const paymentInformation = $("#paymentInformation");
                if(paymentInformation){
                    paymentInformation[0].scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }

    getPropertyQuestions(property_id){
        const self = this;

        self.questions = [];
        self.property_questions_loaded = false;

        //Get property questions
        let url = 'sec/developer/properties/' + property_id + '/questions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let property_questions = response.data.property_questions.filter(item => item.is_active === 1);

            property_questions = _.sortBy(property_questions, "order");

            // Filter questions for 'Developer' and phase 'Booking'
            let entity_type = self.QUESTION_ENTITY_TYPE_DEVELOPER;
            let agent_entity_type = self.QUESTION_ENTITY_TYPE_BROKER;
            let phase_type = self.QUESTION_PHASE_BOOKING;
            let group = null;
            self.questions = self.SSEoiService.getQuestions(entity_type, phase_type, group, property_questions);
            // WEB-4408 - lets the AML documents table tell "still loading" from "no questions".
            self.property_questions_loaded = true;
            self.bindQuestionAnswers(self.sale_sales.question_answers);
            self.initBrokerQuestions(self.sale_sales.question_answers,property_questions)

        });
    }

    initBrokerQuestions(question_answers, property_questions){
        const self = this;

        self.broker_agent_questions = self.SSEoiService.getQuestions(
            self.QUESTION_ENTITY_TYPE_BROKER,
            self.QUESTION_PHASE_BOOKING,
            null,
            property_questions
        );


        $.each(self.broker_agent_questions, function(index, question) {
            if(question_answers){
                $.each(question_answers, function (i, answer) {
                    if (answer.code === question.code) {
                        question.answer_text = answer.answer_text;
                        return false;
                    }
                });
            }

            if (question.type === SHOWSUITE.QUESTION_TYPE_CHECKBOX
                || question.type === SHOWSUITE.QUESTION_TYPE_SELECT
                || question.type === SHOWSUITE.QUESTION_TYPE_RADIO
            ) {
                // Process answer
                let answer_array = [];
                if (question.answer_text) {
                    try {
                        answer_array = JSON.parse(question.answer_text);
                        if(typeof answer_array === 'number'){ // JSON string parses number in string to number causing error
                            answer_array = [question.answer_text];
                        }
                    } catch (e) { // Means is just a plain text
                        answer_array = [question.answer_text];
                    }
                }

                question.formatted_choices = [];
                $.each(JSON.parse(question.choices), function (j, choice) {
                    question.formatted_choices.push({
                        label: choice,
                        answer: answer_array.indexOf(choice) > -1
                    });
                });
            }

            // Bind parent questions
            self.SSEoiService.findParentQuestion(self.broker_agent_questions, question); // Set parent question object
        });
    }

    bindQuestionAnswers(question_answers){
        const self = this;

        $.each(self.questions, function(index, question) {

            if(question_answers){
                $.each(question_answers, function (i, answer) {
                    if (answer.code === question.code) {
                        if(question.type === SHOWSUITE.QUESTION_TYPE_YES_NO
                                || question.type === SHOWSUITE.QUESTION_TYPE_YES_NO_NA){
                            // Set uppercase answer
                            question.answer_text = answer.answer_text ? answer.answer_text.toUpperCase() : answer.answer_text;
                        } else{
                            question.answer_text = answer.answer_text;
                        }

                        return false;
                    }
                });
            }

            if (question.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX
                || question.type == SHOWSUITE.QUESTION_TYPE_SELECT
                || question.type == SHOWSUITE.QUESTION_TYPE_RADIO
            ) {
                // Process answer
                let answer_array = [];
                if (question.answer_text) {
                    try {
                        answer_array = JSON.parse(question.answer_text);
                        if(typeof answer_array === 'number'){ // JSON string parses number in string to number causing error
                            answer_array = [question.answer_text];
                        }
                    } catch (e) { // Means is just a plain text
                        answer_array = [question.answer_text];
                    }
                }

                question.formatted_choices = [];
                $.each(JSON.parse(question.choices), function (j, choice) {
                    question.formatted_choices.push({
                        label: choice,
                        answer: answer_array.indexOf(choice) > -1
                    });
                });
            }

            self.SSEoiService.findParentQuestion(self.questions, question); // Set parent question object
        });

        self.$timeout(function() {
            $('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+20",
                dateFormat: "dd/mm/yy"
            });
        });

        self.$timeout(function() {
            self.questions_backup = angular.copy(self.questions);
            $("select.eoi-select.questionaire_select").niceSelect('update');
        });
    }

    bindCheckOption(question, answer_text){
        const self = this;

        question.answer_text = answer_text;

        self.$timeout(function() {
            $('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+20",
                dateFormat: "dd/mm/yy"
            });
        });
    }

    editQuestionAnswer(editMode){
        const self = this;

        self.questionAnswerEditMode = editMode;

        if(editMode == false)
            self.questions = angular.copy(self.questions_backup);
    }

    updateQuestionAnswers() {
        const self = this;

        if (self.SSEoiService.validateQuestionAnswers(self.questions)) {

            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                'Are you sure, you want to update question answers?',
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    // Update question answers
                    self._updateQuestionAnswers(function(response) {
                        self.SSAlertService.success("Question answers updated successfully.");
                        self.questions = angular.copy(self.questions_backup);
                        self.bindQuestionAnswers(response.data.eoi_question_answers);
                        self.questionAnswerEditMode = false;
                    });
                }
            );
        }
    }

    _updateQuestionAnswers(callback) {
        const self = this;

        let answers = self.SSEoiService.getQuestionAnswers(self.questions);

        let url = 'sec/sales/' + self.sale_sales.id + '/questions-answers/save-multiple';

        let params = {
            question_answers: JSON.stringify(answers),
            entity_type: self.QUESTION_ENTITY_TYPE_DEVELOPER
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response);
            }
        });
    }

    getBuyerRepresentative(){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/sale-otp-representatives';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.sale_otp_representative)
                self.representative = response.data.sale_otp_representative;
        });
    }

    checkPermission(permission){
        const self = this;

        if(!(permission && self.pId)){
            return false;
        }

        return self.SSUserService.hasPermissionForProperty(permission, self.pId);
    }

    documentSigningHistory(document){
        const self = this;

        if(!document){
            return;
        }

        // Check if array/single object
        if(document.history && document.history.length){
            self.documents_history = document.history;
        }
        else{
            self.documents_history = [document.history];
        }

        $('#documentSigningHistoryModal').modal('show');
    }

    viewDocument(document){
        const self = this;

        if(!(document && document.pdf_file_uri)){
            return;
        }

        self.getPresignedUrl(
            self.ASSET_MODEL_DOCUMENT_HISTORY,
            document.id,
            function (presignedUrl) {
                loading(false);
                if (presignedUrl) {
                    self.$window.open(presignedUrl, '_blank');
                }
            }
        );
    }

    deleteDocument(document){
        const self = this;

        if(!document || !self.sale_sales){
            return;
        }
        self.delete_document_id = document.id;

        let url = 'sec/developer/sales/'+ self.sale_sales.id +'/documents/'+ self.delete_document_id +'/delete';

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                $.each(self.sale_sales.other_documents, function(key, document) {
                    if (document.id === self.delete_document_id) {
                        delete self.sale_sales.other_documents[key];
                    }
                });

                self.SSAlertService.success('Success!', 'Sale document deleted successfully.');
            });
        });
    }

    getUserNameById(userId){
        const self = this;

        let name = '--';

        if(!userId){
            return name;
        }

        try {
            let user = self.sale_users.find(x => x.id == userId);
            if (user) {
                name = user.display_name ? user.display_name : [user.first_name, user.last_name].join(' ');
            }
        } catch (ex) {
            console.log(ex);
        }

        return name;
    }

    getSaleCreateByUserName() {
        const self = this;

        let userName = null;

        if (self.sale_sales && self.sale_users) {
            try {
                let user = self.sale_users.find(x => x.id == self.sale_sales.created_by);
                if (user) {
                    userName = user.display_name ? user.display_name : [user.first_name, user.last_name].join(' ');
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        return userName;
    }

    getSubsaleCreateByUserName(subsale) {
        const self = this;

        let userName = null;

        if (subsale && self.subsale_users) {
            try {
                let user = self.subsale_users.find(x => x.id == subsale.created_by);
                if (user) {
                    userName = user.display_name ? user.display_name : [user.first_name, user.last_name].join(' ');
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        return userName;
    }

    initEmptyDocument(document_kind) {
        const self = this;

        return {
            created_at: null,
            document_id: null,
            document_kind: document_kind,
            file_uri: null,
            format: null,
            id: null,
            name: (document_kind == self.PROPERTY_DOCUMENT_KIND_AML) ? "AML/CFT" : "Buyer Particulars",
            sale_buyer_id: null,
            sale_id: self.sale_sales.id,
            type: self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED,
            updated_at: null
        };
    }

    regenerateAmlCft(copy) {
        const self = this;
        let message = '';
        if(copy){
            message = 'Are you sure you want to re-generate AML Scans? Please note that the scans will be generated only for entities with the change. The checking for changes and scans generation might take some time. Please refresh your page after a min to confirm the updates. Thanks.'
            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                message,
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self._regenerateAmlCft(copy);
                }
            );
        }else{
            self._regenerateAmlCft(copy);
        }

    }

    _regenerateAmlCft(copy) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_sales.id + '/re-generate-aml';
        let params = {};
        if(copy){
            params['copy'] = copy;
        }
        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.documents_loading = true;
            self.$timeout(function() { self.getSalesDocuments(); }, 3000);
            if(copy){
                self.SSAlertService.success('Success!', 'AML scans generated successfully.');
            }
        });
    }

    regenerateHtmlDocument(document) {
        const self = this;

        let url = 'sec/developer/sales/reGenerateDocument';

        let param = {
            sale_document_id : document.id
        };

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            loading(true);
            self.SSHttpService.getAPIRequest(url, param).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                // self.getSaleDetails();
                self.updateLocalDocument(document, response.data);
                self.getSalesDocuments();

                self.SSAlertService.success('Success!', 'HTML Document generated successfully.');
            });
        });
    }

    isPriceEditable(status) {
        const self = this;

        if (!status) {
            return false;
        }

        if (status == self.SALE_STATUS_APPROVED
            || status == self.SALE_STATUS_OTP
            || status == self.SALE_STATUS_SPA_ENTERED
            || status == self.SALE_STATUS_EXTENDED) {
            return true;
        } else {
            return false;
        }
    }

    editSaleAgents(edit) {
        const self = this;

        self.SSEoiService.brokers_obj = angular.copy(self.brokers);
        self.criteria = "";

        self.prepareRoles();

        $.each(self.brokers, function (index, broker) {
            self.$timeout(function () {
                $("select.eoi-select#broker_" + index).niceSelect('update');
            });
        });

        self.EDIT_AGENTS = edit;
    }

    getSubsales() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/subsales';
        let params = {
            include: 'subsale_buyers, created_by'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305013) {
                    //User not allowed to access to the sale
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.allBuyersList = [];
            self.buyerListForCopyData = [];

            if (response.data && response.data.subsales && response.data.subsales.length > 0) {
                self.isSubSale = true;
                self.subsale_users = response.data.users;

                self.current_subsale = response.data.subsales[response.data.subsales.length - 1];

                let previous_sale_buyers = self.sale_sales.sale_buyers;
                self.sale_sales.sale_buyers = self.current_subsale.subsale_buyers;

                /** WEB-2937 Corporate Sale - Support for Multiple Signatories
                 * Set Sub-sale buyers in SSEoiService for utility functions **/
                self.SSEoiService.buyers = self.sale_sales.sale_buyers.map(buyer => {
                    try{
                        return JSON.parse(buyer.data);
                    }catch(e){
                        console.warn("Error occurred parsing buyer data", e);
                    }
                });

                self.sale_sales.subsales = response.data.subsales;
                self.subsales = self.sale_sales.subsales;

                self.getSubsaleBuyers(self.subsales);

                jQuery.each(self.subsales, function (i, subsale) {
                    subsale.label = 'Sub Sale ' + (i + 1);
                });

                try {
                    // Add original sale
                    self.subsales = [{
                        original_sale: true,
                        label: 'Original Sale',
                        tracking_no: self.sale_sales.otp_no,
                        completion_date: self.sale_sales.otp_date,
                        price: self.sale_sales.price,
                        remarks: self.sale_sales.remarks,
                        subsale_buyers: previous_sale_buyers,
                        created_by: self.getSaleCreateByUserName(),
                        created_at: self.sale_sales.updated_at,
                    }].concat(self.subsales);
                } catch (ex) {
                    console.log(ex);
                }

                //creating Separate list for copy buyer

                let processedBuyer = null;
                if (self.sale_sales.subsales && self.sale_sales.subsales.length > 0){

                    $.each(self.subsales, function (index, subSale) {
                        $.each(subSale.subsale_buyers, function (index, buyer) {
                            if (typeof buyer.data === "string") {
                                processedBuyer = JSON.parse(buyer.data);
                                buyer.data = JSON.parse(buyer.data);
                            } else {
                                processedBuyer = angular.copy(buyer.data);
                            }

                            let buyerName = null;
                            if (processedBuyer.individual) {
                                buyerName = processedBuyer.individual.legal_name;
                            } else if (processedBuyer.company) {
                                buyerName = processedBuyer.company.name;
                            }

                            self.initEditLawyerDetail(buyer.data, processedBuyer);

                            processedBuyer.sale_buyer_id = processedBuyer.id;
                            processedBuyer.id = buyer.id;

                            self.buyerListForCopyData.push({
                                "id": processedBuyer.id,
                                "name": subSale.tracking_no + " - " + buyerName
                            });

                            self.allBuyersList.push(processedBuyer);
                        });
                    });
                }

                $.each(self.sale_sales.sale_buyers, function (index, buyer) {
                    if (typeof buyer.data === "string") {
                        processedBuyer = JSON.parse(buyer.data);
                        buyer.data = JSON.parse(buyer.data);
                    } else {
                        processedBuyer = angular.copy(buyer.data);
                    }

                    self.initEditLawyerDetail(buyer.data, processedBuyer);

                    processedBuyer.sale_buyer_id = processedBuyer.id;
                    processedBuyer.id = buyer.id;

                });

                self.selectSaleBuyer((self.sale_sales.sale_buyers && self.sale_sales.sale_buyers.length > 0)? self.sale_sales.sale_buyers[0] : null);
            }else{
                self.isSubSale = false;
                self.buyerListForCopyData = [];
                let processedBuyer = null;
                $.each(self.sale_sales.sale_buyers, function (index, buyer) {
                    if (typeof buyer.data === "string") {
                        processedBuyer = JSON.parse(buyer.data);
                    } else {
                        processedBuyer = angular.copy(buyer.data);
                    }

                    let buyerName = null;
                    if (processedBuyer.individual) {
                        buyerName = processedBuyer.individual.legal_name;
                    } else if (processedBuyer.company) {
                        buyerName = processedBuyer.company.name;
                    }

                    processedBuyer.sale_buyer_id = processedBuyer.id;
                    processedBuyer.id = buyer.id;
                    self.allBuyersList.push(processedBuyer);
                    self.buyerListForCopyData.push({
                        "id": processedBuyer.id,
                        "name": buyerName
                    });

                });
            }
        });
    }

    getPropertyDocs(property) {
        const self = this;

        if (!property) {
            return;
        }

        let url = 'sec/developer/properties/' + property.id + '/documents/';

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.property_doc_loading = true;
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            self.property_doc_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.property_documents) {
                self.property_documents = response.data.property_documents;
            }
            self.getOtpDocs();
        });
    }

    showReversalPopup(payment, instrument) {
        const self = this;
        self.hideModals();
        self.current_payment = payment;
        self.current_instrument = angular.copy(instrument);
        self.current_instrument.status = self.INSTRUMENT_STATUS_BOUNCED;
        self.edit_bounce_date_mode = false;
        self.prepareBouncedDateInput(instrument);
        jQuery('#ReversalModal').modal('show');
    }

    showEditBouncedDatePopup(payment, instrument) {
        const self = this;
        if (!self.checkPermission('DMS_PAYMENTS_INSTRUMENT_BOUNCE_BACKDATE')) {
            return;
        }
        self.hideModals();
        self.current_payment = payment;
        self.current_instrument = angular.copy(instrument);
        self.edit_bounce_date_mode = true;
        self.prepareBouncedDateInput(instrument);
        jQuery('#ReversalModal').modal('show');
    }

    formatBouncedDateForApi(value) {
        const self = this;

        if (!value) {
            return null;
        }

        let date = value;
        if (typeof date !== 'string') {
            date = self.SSUtilService.formatDateDMY(date);
        }
        if (!date) {
            return null;
        }
        if (date.indexOf(' ') > -1) {
            date = date.split(' ')[0];
        }
        if (date.indexOf('/') > -1) {
            let parts = date.split('/');
            if (parts.length !== 3) {
                return null;
            }
            return parts[2] + '-' + parts[1].padStart(2, '0') + '-' + parts[0].padStart(2, '0');
        }
        return date;
    }

    prepareBouncedDateInput(instrument) {
        const self = this;

        self.can_backdate_bounce = self.checkPermission('DMS_PAYMENTS_INSTRUMENT_BOUNCE_BACKDATE');
        self.error_bounced_date = null;

        let initial = instrument && instrument.bounced_date
            ? instrument.bounced_date
            : (new Date());
        self.bounced_date_input = self.SSUtilService.formatDateDMY(
            typeof initial === 'string' ? initial.split(' ')[0] : initial
        );

        self.$timeout(function () {
            let $picker = jQuery('#reversal_bounced_date');
            try { $picker.datepicker('destroy'); } catch (e) {}

            if (!self.can_backdate_bounce) {
                return;
            }

            let opts = {
                dateFormat: 'dd/mm/yy',
                maxDate: new Date(),
                /**
                 * WEB-3646: the Reversal modal (#ReversalModal) is a fixed
                 * Bootstrap modal, so jQuery UI renders the calendar
                 * position:fixed but leaves the page scrollTop baked into its
                 * `top`, dropping the calendar below the field by exactly the
                 * scrolled amount (off-screen when scrolled far). Re-pin it to
                 * the input's viewport position once jQuery UI has finished
                 * positioning — same guarded approach as WEB-3555
                 * (arms/details.js) / WEB-2834 (lms_dms_util.js). In-page
                 * inputs keep jQuery UI's own (correct) positioning.
                 */
                beforeShow: function (input, inst) {
                    let $input = jQuery(input);
                    let inFixedContainer = $input.parents().filter(function () {
                        return jQuery(this).css('position') === 'fixed';
                    }).length > 0;

                    if (!inFixedContainer) {
                        return;
                    }

                    setTimeout(function () {
                        inst.dpDiv.css({
                            top: $input.offset().top - jQuery(document).scrollTop() + $input.outerHeight(),
                            left: $input.offset().left - jQuery(document).scrollLeft()
                        });
                    }, 0);
                },
            };

            if (instrument && instrument.receiving_date) {
                let receivingRaw = typeof instrument.receiving_date === 'string'
                    ? instrument.receiving_date.split(' ')[0]
                    : instrument.receiving_date;
                let minDate = new Date(receivingRaw);
                if (!isNaN(minDate.getTime())) {
                    opts.minDate = minDate;
                }
            }

            $picker.datepicker(opts);
        });
    }

    saveBouncedDate() {
        const self = this;

        self.error_bounced_date = null;

        if (!self.bounced_date_input) {
            self.error_bounced_date = 'Please select a bounced date.';
            return;
        }

        let formatted = self.formatBouncedDateForApi(self.bounced_date_input);
        if (!formatted) {
            self.error_bounced_date = 'Please select a valid bounced date.';
            return;
        }

        // WEB-3599: post-hoc bounce-date corrections go through the dedicated
        // single-field endpoint — send ONLY bounced_date. `updated_by` is set
        // server-side from the authenticated user, and `type`/`status` must NOT
        // be sent: the generic saveInstrument validator requires `type`, which
        // is what broke this edit-date flow ("The type field is required").
        // The server writes only bounced_date and leaves every other column
        // (type, status, bounced_reason, …) untouched.
        let params = {
            bounced_date: formatted,
        };

        let url = 'sec/developer/sales/' + self.sale_id
            + '/payments/' + self.current_payment.id
            + '/instruments/' + self.current_instrument.id
            + '/bounced-date';

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Bounced date updated.');
            self.hideModals();
            self.edit_bounce_date_mode = false;
            self.updateLocalPaymentObject(response.data.payment);
            self.processSalePayments();
        });
    }

    showInterestWaivePopup(payment) {
        const self = this;
        self.hideModals();
        self.current_payment = angular.copy(payment);
        if(self.current_payment.waiver_date)
        {
            self.current_payment.waiver_date = self.SSUtilService.formatDateDMY(self.current_payment.waiver_date.split(" ")[0]);
        }
        else
        {
            self.current_payment.waiver_date = '';
        }

        jQuery('#InterestWaiverModal').modal('show');
    }

    getDiscountValue(discount) {
        const self = this;

        if (!discount) {
            return '--';
        }

        if (discount.amount_type == self.VALUE_TYPE_PERCENTAGE) {
            return discount.amount_value + '%';
        } else if (discount.amount_type == self.VALUE_TYPE_AMOUNT) {
            return self.SSAppService.getFormattedAmountWithDecimal(discount.amount_value);
        }
    }

    showLawyerPopup(buyer_id, lawyer_id) {
        const self = this;

        self.edit_buyer_id = buyer_id;
        self.edit_lawyer_id = lawyer_id;

        self.hideModals();

        self.resetErrors();

        let buyer = self.selectedSaleBuyer;

        let lawyer = {};
        if (buyer && buyer.lawyer) {
            lawyer = buyer.lawyer;
        }

        self.lawyer = angular.copy(lawyer);

        self.maskPhoneNumber(self, 'ctrl.', 'formLawyerInfo');

        $('#LawyerDetailModal').modal('show');
    }

    updateLawyerDetails() {
        const self = this;

        if (self.lawyer.law_firm_name == '' && self.lawyer.first_name == ''
            && self.lawyer.last_name == '' && self.lawyer.email == ''
            && self.lawyer.phone1 == '') {
            //Check if lawyer id is exist, if yes then delete the lawyer
            if (self.lawyer.id) {
                let url = 'sec/buyers/' + self.edit_buyer_id + '/lawyers/' + self.lawyer.id + '/delete';

                let handleResponse = function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.SSAlertService.success('Buyer lawyer updated successfully.');
                    self.$window.location.reload();
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(handleResponse);

            } else {
                self.hideModals();
            }
        } else {
            let url = 'sec/buyers/' + self.edit_buyer_id + '/lawyers';
            if (self.lawyer.id) {
                url += '/' + self.lawyer.id;
            }
            let params = self.lawyer;

            self.resetErrors();

            if (!self.isValidInput()) {
                return;
            }

            self.hideModals();

            let handleResponse = function (response) {
                loading(false);
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }
                self.SSAlertService.success('Buyer lawyer updated successfully.');
                self.$window.location.reload();
            };

            loading(true);
            if (self.lawyer.id) {
                self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
            } else {
                self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
            }
        }
    }

    isSubSaleAllowed(sale_status) {
        const self = this;

        if (sale_status == self.SALE_STATUS_OTP
            || sale_status == self.SALE_STATUS_SPA_ENTERED
            || sale_status == self.SALE_STATUS_EXTENDED
            || sale_status == self.SALE_STATUS_EXERCISED) {
            return true;
        } else {
            return false;
        }
    }

    createSubSale() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self.addSubsaleErrors = {};
            // WEB-3614 — create-form behaviour depends on the project-level subsale_approval_flow toggle:
            // ON → empty Draft (price/remarks optional here, completion date via Edit); OFF → legacy form
            // (price/completion_date/remarks required, validated in addSubsale()). The server sets the
            // status (Draft when ON, Approved when OFF).
            self.addSubsaleParams = {
                id: null,
                sale_id: self.sale_sales.id
            };

            self.hideModals();
            $('#addSubsaleModal').modal('show');

            // WEB-3614 — init the completion-date picker used by the OFF (legacy) create form. The
            // beforeShow re-pin avoids the in-modal scroll offset (mirrors lms_dms_util executeSPAModal).
            self.$timeout(function () {
                jQuery('#add_subsale_completion_date_datepicker').datepicker({
                    changeMonth: true,
                    changeYear: true,
                    yearRange: "1900:+0",
                    dateFormat: "dd/mm/yy",
                    beforeShow: function (input, inst) {
                        setTimeout(function () {
                            inst.dpDiv.css({
                                top: $(input).offset().top - $(document).scrollTop() + 35,
                                left: $(input).offset().left
                            });
                        }, 0);
                    }
                });
            });
        });
    }

    createPopUpForCopyBuyerData() {
        const self = this;


        self.buyerToCopy = (self.buyerListForCopyData && self.buyerListForCopyData.length > 0)? self.buyerListForCopyData[0].id : null;

        $('#copyBuyerDataModal').modal('show');
    }

    copyBuyerData()
    {
        $('#copyBuyerDataModal').modal('hide');

        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'You are about to copy the buyer data.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._copyBuyerData();
            }
        );
    }

    _copyBuyerData() {
        const self = this;
        $.each(self.allBuyersList, function (index, buyer) {
            if(self.buyerToCopy == buyer.id) {
                let processedBuyer = buyer;
                if(!self.saleBuyerParams)
                {
                    self.saleBuyerParams = {
                        sale_id: self.sale_sales.id,
                        subsale_id: self.current_subsale ? self.current_subsale.id : null,
                        data: {}
                    }
                }
                self.saleBuyerParams.data = processedBuyer;
                self.initEditLawyerDetail(self.saleBuyerParams.data, processedBuyer);

                self.saleBuyerParams.data.individual.dob = self.SSUtilService.formatDateDMY(self.saleBuyerParams.data.individual.dob);
                self.$timeout(function () {
                    $("select.dashboard-select#sub-sale-law-firm-name-select").niceSelect('update');
                });
            }
        });
    }

    addSubsale() {
        const self = this;

        let subsaleParams = angular.copy(self.addSubsaleParams);

        // WEB-3614 — when the project's subsale_approval_flow is OFF (legacy), price, completion date and
        // remarks are REQUIRED at creation (the server creates the sub-sale as Approved). When ON, the
        // sub-sale is created as a Draft and these are optional here (mandatory at approval).
        if (!self.isSubsaleApprovalFlowEnabled) {
            let subsaleErrors = {};
            if (!subsaleParams.price) { subsaleErrors.price = "Price field can not be empty."; }
            if (!subsaleParams.completion_date) { subsaleErrors.completion_date = "Completion date can not be empty."; }
            if (!subsaleParams.remarks) { subsaleErrors.remarks = "Remarks field can not be empty."; }
            if (Object.keys(subsaleErrors).length > 0) {
                self.addSubsaleErrors = subsaleErrors;
                return;
            }
        }

        // Format completion date for the API when supplied (OFF create form collects it).
        if (subsaleParams.completion_date) {
            subsaleParams.completion_date = self.SSUtilService.formatDateToStoreWithUtc12(subsaleParams.completion_date);
        }

        let url = 'sec/developer/sales/' + subsaleParams.sale_id + '/subsales';

        loading(true);
        self.SSHttpService.postAPIRequest(url, subsaleParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data || !response.data.subsale) {
                self.SSAlertService.danger("Error!", "Something went wrong, please contact admin.");
                return;
            }

            self.addSubsaleParams.id = response.data.subsale.id;
            self.addSubsaleParams.subsaleId = response.data.subsale.id;

            self.hideModals();
            self._createSubSale();
        });
    }

    editSubsale(subsale) {
        const self = this;

        self.subsaleErrors = {};
        self.subsaleParams = {
            id: subsale.id,
            sale_id: subsale.sale_id,
            price: subsale.price,
            completion_date: subsale.completion_date,
            remarks: subsale.remarks
        };

        if (self.subsaleParams.completion_date) {
            self.subsaleParams.completion_date = self.SSUtilService.formatUtcToLocalDate(self.subsaleParams.completion_date);
        }

        jQuery('#subsale_' + subsale.id + '_completion_date_datepicker').datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:+0",
            dateFormat: "dd/mm/yy"
        });

        subsale.editMode = true;
    }

    deleteSubsale(subsale) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this main subsale?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._deleteSubsale(subsale);
            }
        );
    }

    _deleteSubsale(subsale) {
        const self = this;
        let url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + subsale.id ;
        loading(true);
        self.SSHttpService.deleteAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                // if (response.sub_code == 305015 || response.sub_code == 412002) {
                //     self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                //     return;
                // }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Sub Sale deleted successfully.');
            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    editBuyerSale() {
        const self = this;

        // self.subsaleErrors = {};
        self.buyerSaleParams = {
            race: self.sale_sales.race,
            household_type: self.sale_sales.household_type,
            declared_household_type: self.sale_sales.declared_household_type
        };

        self.buyerSaleEditMode = true;
    }

    updateSubsale(subsale) {
        const self = this;

        let subsaleErrors = self.subsaleErrors;
        let subsaleParams = angular.copy(self.subsaleParams);

        // WEB-3614 — price is OPTIONAL while Draft (it becomes mandatory at approval, server-enforced
        // with subcode 305054); keep it required when editing an already-Approved subsale.
        if (subsale.status == self.SUBSALE_STATUS_APPROVED && !subsaleParams.price) {
            subsaleErrors.price = "Price field can not be empty.";
            return;
        }

        // Format date for API
        if (subsaleParams.completion_date) {
            subsaleParams.completion_date = self.SSUtilService.formatDateToStoreWithUtc12(subsaleParams.completion_date);
        }

        let url = 'sec/developer/sales/' + subsaleParams.sale_id + '/subsales/' + subsale.id;

        loading(true);
        self.SSHttpService.putAPIRequest(url, subsaleParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!response.data || !response.data.subsale) {
                self.SSAlertService.danger("Error!", "Something went wrong, please contact admin.");
                return;
            }

            angular.merge(subsale, response.data.subsale);

            subsale.created_by = self.getSubsaleCreateByUserName(subsale);
            subsale.editMode = false;
        });
    }

    /**
     * WEB-3614 — Confirm then approve a Draft subsale.
     * Approval is hard-gated server-side on AML review completion for every subsale buyer; the
     * server rejection message is surfaced as-is when the gate is not met.
     * @param {Object} subsale The Draft subsale to approve.
     */
    approveSubsale(subsale) {
        const self = this;

        // WEB-3614 — price, completion date and remarks are mandatory before approval (the server enforces
        // this with subcode 305054; pre-check here for immediate feedback before the request).
        let missingFields = [];
        if (!subsale.price) { missingFields.push('Price'); }
        if (!subsale.completion_date) { missingFields.push('Completion Date'); }
        if (!subsale.remarks) { missingFields.push('Remarks'); }
        if (missingFields.length > 0) {
            self.SSAlertService.danger('Cannot approve yet', 'Please enter the following before approving this sub sale: ' + missingFields.join(', ') + '.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to approve this sub sale? AML scans for all sub sale buyers must be reviewed before it can be approved.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._approveSubsale(subsale);
            }
        );
    }

    /**
     * WEB-3614 — Call the server approve endpoint and flip the local status to Approved on success.
     * @param {Object} subsale The Draft subsale to approve.
     */
    _approveSubsale(subsale) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + subsale.id + '/approve';

        loading(true);
        self.SSHttpService.postAPIRequest(url, {}).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                // WEB-3614 — the approve gate returns a 409 with a descriptive server message
                // (incomplete data 305054 / AML not reviewed 305052 / no buyers 305051 / already
                // approved 305053). parseAndDisplayError maps every 409 to a generic
                // "Conflict! Another entry already exists" toast, masking the real reason — so
                // surface response.message directly for gate rejections, keeping
                // parseAndDisplayError for auth side-effects (401/403) and as a fallback.
                if (response.code != 401 && response.code != 403 && response.sub_code && response.message) {
                    self.SSAlertService.danger('Unable to approve sub sale', response.message);
                } else {
                    self.SSAlertService.parseAndDisplayError(response);
                }
                return;
            }

            if (response.data && response.data.subsale) {
                angular.merge(subsale, response.data.subsale);
                subsale.created_by = self.getSubsaleCreateByUserName(subsale);
            } else {
                subsale.status = self.SUBSALE_STATUS_APPROVED;
            }

            self.SSAlertService.success('Success!', 'Sub Sale approved successfully.');
        });
    }

    _createSubSale() {
        const self = this;

        if(self.saleBuyerParams){
            self.saleBuyerParams.data = {};
        }

        self.subSaleMode = true;
        self.saleBuyerEditMode = true;
        self.sale_buyers = self.sale_sales.sale_buyers;
        self.sale_sales.sale_buyers = [];
        self.resetBuyerErrors();

        self.$timeout(function () {
            self.maskPhoneNumber(self, 'ctrl.', 'sub_sale_buyer');
            jQuery('.datepicker').datepicker({
                // dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });
        self.$timeout(function () {
            $("select.dashboard-select#sub-sale-law-firm-name-select").niceSelect('update');
        });
    }

    saveSubSale(saleBuyerParams) {
        const self = this;

        self.resetBuyerErrors();
        if (!self.isValidBuyerInput(saleBuyerParams)) {
            return false;
        }

        // Remove text style to properly display lengthy message
        $('.modal-body>p').removeAttr("style");
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'You are about to perform a Sub-Sale Transaction. Once the new Buyer(s) information is saved, you cannot undo this.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveSubSale();
            }
        );
    }

    _saveSubSale() {
        const self = this;

        if (!self.saleBuyerParams || !self.saleBuyerParams.data) {
            console.error("Error, Buyer params not found!");
            return false;
        }

        let url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + self.addSubsaleParams.subsaleId + '/buyers';
        // let url = 'sec/developer/sales/'+ self.sale_id +'/sub-sale';

        let params = self.saleBuyerParams;

        if (params.mailing_address_same && params.data.primary_address) {
            //Copy primary address to mailing address if exists
            params.data.mailing_address = {};
            params.data.mailing_address.line1 = params.data.primary_address.line1;
            params.data.mailing_address.line2 = params.data.primary_address.line2;
            params.data.mailing_address.unit_no = params.data.primary_address.unit_no;
            params.data.mailing_address.postcode = params.data.primary_address.postcode;
            params.data.mailing_address.city = params.data.primary_address.city;
            params.data.mailing_address.district = params.data.primary_address.district;
            params.data.mailing_address.province = params.data.primary_address.province;
            params.data.mailing_address.country = params.data.primary_address.country;
        }

        if(params.data.individual){
            if (params.data.individual.dob) {
                params.data.individual.dob = self.SSUtilService.formatDateToStoreWithUtc12(params.data.individual.dob);
            }
            if(params.data.individual.industry_other && params.data.individual.industry === "OTHERS"){
                params.data.individual.industry = params.data.individual.industry_other;
            }
            if(params.data.individual.occupation_other && params.data.individual.occupation === "OTHERS"){
                params.data.individual.occupation = params.data.individual.occupation_other;
            }
            if(params.data.individual.race_other && params.data.individual.race === "OTHERS"){
                params.data.individual.race = params.data.individual.race_other;
            }

            delete params.data.individual.industry_other;
            delete params.data.individual.occupation_other;
            delete params.data.individual.race_other;
        }

        /** WEB-2925 AMS: Sale - Add option to update Buyer Lawyer Info
         * Save lawyer info in lawyer object
        if (params.data.lawyer) {
            params.data.lawyers = [params.data.lawyer];
            delete params.data.lawyer;
        } **/
        if (params.data.lawyer) {
            params.data.lawyer.law_firm_name = params.data.lawyer.law_firm_name === "OTHERS" ? params.data.lawyer.law_firm_name_other : params.data.lawyer.law_firm_name;
            params.data.lawyers = null;
        }

        if (params.data.type === self.BUYER_TYPE_INDIVIDUAL) {
            params.data.company = null;
        } else if (params.data.type === self.BUYER_TYPE_COMPANY) {
            params.data.individual = null;
        }

        params.data = JSON.stringify(params.data);

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Sub sale added successfully.');

            self.showInfoModal = true;
            self.info_message = "Sub sale added successfully.";
            $('#infoMessageModal').modal('show');

            self.$window.location.reload(); // TODO: Fix the data issue

            // self.SSConfirmationService.getConfirmed(
            //     'Confirm!',
            //     'Sub sale added successfully.',
            //     self.SSConfirmationService.TYPE_DEFAULT,
            //     function() {
            //         self.$window.location.reload();
            //     }
            // );
        });
    }

    onInfoMessage() {
        const self = this;

        self.hideModals();
        self.$window.location.reload();
    }

    cancelSubSale() {
        const self = this;

        self.sale_sales.sale_buyers = self.sale_buyers;

        // Delete currently created empty subsale
        let url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + self.addSubsaleParams.subsaleId + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.buyerErrors = {};
            // Switch subSaleMode
            self.subSaleMode = false;
            self.saleBuyerEditMode = false;
        });
    }

    isNewBuyerAllowed() {
        const self = this;

        let allowed = true;

        if ((!self.subSaleMode && !self.newBuyerMode)
            && (self.previous_sale_buyers && self.previous_sale_buyers.length > 0)) {

            try {
                // NOW CHECK IF 1st BUYER IS COMPNAY AND TOTAL BUYERS ARE TWO (CORPORATE BUYER AND AUTHOIRSED OFFICER) THEN CAN NOT ADD MORE
                if (!!self.sale_sales
                    && self.sale_sales.sale_buyers
                    && self.sale_sales.sale_buyers.length > 0
                    && self.sale_sales.sale_buyers[0].data
                    && self.sale_sales.sale_buyers[0].data.type == self.BUYER_TYPE_COMPANY
                    && self.sale_sales.sale_buyers.length == 2
                ) {
                    allowed = false;
                }
                // OTHER CASE IS: 1st BUYER IS INDIVIDUAL, THEN CAN ADD MORE BUYER OF INDIVIDUAL TYPE
                if (!!self.sale_sales
                    && self.sale_sales.sale_buyers
                    && self.sale_sales.sale_buyers.length > 0
                    && self.sale_sales.sale_buyers[0].data
                    && self.sale_sales.sale_buyers[0].data.type == self.BUYER_TYPE_INDIVIDUAL
                ) {
                    allowed = true;
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        return allowed;
    }

    addNewSaleBuyer(is_company_buyer = false, saleBuyer) {
        const self = this;

        self.newBuyerMode = true;
        self.saleBuyerEditMode = true;
        let firstBuyer = null;

        self.saleBuyerParams = {
            sale_id: self.sale_sales.id,
            subsale_id: self.current_subsale ? self.current_subsale.id : null,
            data: {
                type: is_company_buyer? self.BUYER_TYPE_COMPANY : self.BUYER_TYPE_INDIVIDUAL
            }
        };
        self.resetBuyerErrors();

        self.$timeout(function () {
            self.maskPhoneNumber(self, 'ctrl.', 'sub_sale_buyer');
            jQuery('.datepicker').datepicker({
                // dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });

        if(saleBuyer && saleBuyer.data && saleBuyer.data.company){ // If adding signatory for company
            self.saleBuyerParams.data.buyer_company_id = saleBuyer.data.id; // TODO: check and add id for sale buyer if missing
        }

        // Initialize Lawyer Detail
        if (self.sale_sales.sale_buyers && self.sale_sales.sale_buyers.length > 0) {
            firstBuyer = self.sale_sales.sale_buyers[0];

            self.initEditLawyerDetail(self.saleBuyerParams.data, firstBuyer.data);
        }

        // 'self.subSaleBuyerParams' this object is being used to add new buyer
        // 'self.saleBuyerParams.data.lawyer' is used only to handle lawyer details
        // Init email_contact, phone1_contact, phone2_contact
        try {
            self.saleBuyerParams.data.email_contact = {};
            self.saleBuyerParams.data.email_contact.type = 1;
            self.saleBuyerParams.data.email_contact.verified = 0;

            self.saleBuyerParams.data.phone1_contact = {};
            self.saleBuyerParams.data.phone1_contact.type = 2;
            self.saleBuyerParams.data.phone1_contact.verified = 0;

            self.saleBuyerParams.data.phone2_contact = {};
            self.saleBuyerParams.data.phone2_contact.type = 2;
            self.saleBuyerParams.data.phone2_contact.verified = 0;
        } catch (ex) {
            console.log(ex);
        }

        self.$timeout(function () {
            $("select.dashboard-select#sub-sale-law-firm-name-select").niceSelect('update');
        });
    }

    addNewSaleNonBuyerPayee(company) {
        const self = this;

        self.newNonBuyerPayeeMode = true;
        self.saleNonBuyerPayeeEditMode = true;
        self.saleNonBuyerPayeeParams = {};
        self.resetNonBuyerPayeeErrors();

        // If adding signatory set type and buyer_company_id
        if(company && company.company){
            self.saleNonBuyerPayeeParams.type = self.BUYER_TYPE_INDIVIDUAL;
            self.saleNonBuyerPayeeParams.buyer_company_id = company.id;
        }

        self.$timeout(function () {
            $("select.eoi-select").niceSelect('update');
            self.maskPhoneNumber(self, 'ctrl.', 'new_sale_non_buyer');

            jQuery('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });
    }

    saleNonBuyerPayeeTypeChange(){
        const self = this;

        self.$timeout(function () {
            $("select.eoi-select").niceSelect('update');
            self.maskPhoneNumber(self, 'ctrl.', 'new_sale_non_buyer');

            jQuery('.datepicker').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });
    }

    isSaleNonBuyerPayeeLimitReached(){
        const self = this;

        if( !self.sale_sales
                || !self.sale_sales.sale_non_buyer_payees
                || !self.sale_sales.sale_non_buyer_payees.length){
            return false;
        }

        let indAndCompNonBuyerPayee = self.sale_sales.sale_non_buyer_payees
            .filter(b => b.type === self.BUYER_TYPE_COMPANY || (b.type === self.BUYER_TYPE_INDIVIDUAL && !b.buyer_company_id))
        if(indAndCompNonBuyerPayee && indAndCompNonBuyerPayee.length >= 6){
            return true;
        }

        return false;
    }

    addNewSaleWitness(witness) {
        const self = this;

        if(self.sale_sales.sale_witnesses && self.sale_sales.sale_witnesses.length == 4){
            self.SSAlertService.warning('Can not add more than 4 witness.');
            return;
        }

        if(!witness) self.newWitnessMode = true;

        self.witnessEditMode = true;
        self.profileErrors = {};

        self.witnessParams = {individual: {}, email_contact: {}, phone1_contact: {}, phone2_contact: {}, primary_address: {}, mailing_address: {}};

        self.witnessParams.type = self.BUYER_TYPE_INDIVIDUAL;

        if(witness){
            self.witnessParams = angular.copy(witness);
            if(self.witnessParams.individual){
                if (self.witnessParams.individual.dob) {
                    self.witnessParams.individual.dob = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.dob);
                }
                if (self.witnessParams.individual.passport_issued_date) {
                    self.witnessParams.individual.passport_issued_date = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.passport_issued_date);
                }
                if (self.witnessParams.individual.passport_expiry_date) {
                    self.witnessParams.individual.passport_expiry_date = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.passport_expiry_date);
                }

                if (self.witnessParams.individual.industry){
                    self.witnessParams.individual.industry = self.witnessParams.individual.industry.toUpperCase();

                    if (self.witnessParams.individual.industry === "OTHERS"){
                        self.witnessParams.individual.occupation_other = self.witnessParams.individual.occupation;
                        self.witnessParams.individual.occupation = "OTHERS";
                    } else{
                        let EoiOccupation = false;
                        if (self.SSEoiService.industry_occupation[self.witnessParams.individual.industry]){
                            jQuery.each(self.SSEoiService.industry_occupation[self.witnessParams.individual.industry].occupation,function(index,occ){
                                if(occ.name === self.witnessParams.individual.occupation){
                                    EoiOccupation = true;
                                }
                            });
                        }
                        if(!EoiOccupation){
                            if (!self.SSEoiService.industry_occupation[self.witnessParams.individual.industry]) { // If occupations not found against industry
                                self.witnessParams.individual.industry_other = self.witnessParams.individual.industry;
                                self.witnessParams.individual.industry = "OTHERS";
                            }

                            self.witnessParams.individual.occupation_other = self.witnessParams.individual.occupation;
                            self.witnessParams.individual.occupation = "OTHERS";
                        }
                    }
                }
            }
        }

        self.$timeout(function () {
            self.maskPhoneNumber(self, 'ctrl.', 'new_sale_witness');
            self.maskPhoneNumber(self, 'ctrl.', 'div_witnesses');

            jQuery('.datepicker').datepicker({
                // dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });
    }

    editWitness(editMode){
        const self = this;

        self.witnessEditMode = editMode;
        self.newWitnessMode = editMode;

        self.witnessParams = angular.copy(self.selectedwitness);

        if (self.witnessParams.individual && self.witnessParams.individual.dob) {
            self.witnessParams.individual.dob = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.dob);
        }
        if (self.witnessParams.individual && self.witnessParams.individual.passport_issued_date) {
            self.witnessParams.individual.passport_issued_date = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.passport_issued_date);
        }
        if (self.witnessParams.individual && self.witnessParams.individual.passport_expiry_date) {
            self.witnessParams.individual.passport_expiry_date = self.SSUtilService.formatUtcToLocalDate(self.witnessParams.individual.passport_expiry_date);
        }
    }

    removeWitness(witness){
        const self = this;

        if(!witness) return;

        let url = 'sec/developer/sales/' + self.sale_id + '/witnesses/'+ witness.id +'/delete';
        let params = {
            buyer_ids: witness.id,
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Witness removed successfully.');

                    self.sale_sales.sale_witnesses = jQuery.grep(self.sale_sales.sale_witnesses, function (obj) {
                        return obj.id !== witness.id;
                    });

                    if(self.sale_sales.sale_witnesses.length){
                        self.selectWitness(self.sale_sales.sale_witnesses[0]);
                    }
                });
            }
        );
    }

    // add new Occupier
    addNewSaleOccupier() {
        const self = this;

        self.newOccupierMode = true;
        self.newOccupier = {};
        self.saleOccupierParams = {
            data:{}
        };
        self.resetOccupierErrors();
        self.$timeout(function () {
            self.maskPhoneNumber(self, 'ctrl.', 'new_occupier');
            jQuery('.datepicker').datepicker({
                // dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });

        // Init email_contact, phone1_contact, phone2_contact
        try {
            self.saleOccupierParams.data.email_contact = {};
            self.saleOccupierParams.data.email_contact.type = 1;
            self.saleOccupierParams.data.email_contact.verified = 0;

            self.saleOccupierParams.data.phone1_contact = {};
            self.saleOccupierParams.data.phone1_contact.type = 2;
            self.saleOccupierParams.data.phone1_contact.verified = 0;

            self.saleOccupierParams.data.phone2_contact = {};
            self.saleOccupierParams.data.phone2_contact.type = 2;
            self.saleOccupierParams.data.phone2_contact.verified = 0;
        } catch (ex) {
            console.log(ex);
        }
    }

    editMortgageeDetails(editMode) {
        const self = this;

        $('#mortgagee_details_possession_date').datepicker({dateFormat: 'dd/mm/yy'});

        self.mortgageeDetailsPararms = self.sale_sales.mortgagee;
        self.mortgageeDetailsErrors = {};

        if (!self.mortgageeDetailsPararms) {
            self.mortgageeDetailsPararms = {};
        } else {
            self.getMortgageeDetailsAddress('mortgagee', self.sale_sales.mortgagee.mortgagee_address);
            self.getMortgageeDetailsAddress('sub_mortgagee', self.sale_sales.mortgagee.sub_mortgagee_address);
            self.getMortgageeDetailsAddress('service_notice', self.sale_sales.mortgagee.service_notice_address);

            try {
                let mortgagee_name = self.mortgagee_banks.find(x => x.name == self.mortgageeDetailsPararms.mortgagee_name);
                if (!mortgagee_name) {
                    self.mortgageeDetailsPararms.other_mortgagee_name = self.mortgageeDetailsPararms.mortgagee_name;
                    self.mortgageeDetailsPararms.mortgagee_name = "Others";
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        self.mortgageeDetailsEditMode = editMode;
    }

    saveMortgageeDetails() {
        const self = this;

        self.mortgageeDetailsErrors = {};
        if (!self.isValidMortgageeDetail(self.mortgageeDetailsPararms)) {
            try {
                $('html, body').animate({
                    scrollTop: $("#mortgagee_name").offset().top
                }, 700);
            } catch (ex) {
                console.log(ex);
            }

            return;
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let handleResponse = function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success('Mortgagee details updated successfully.');

                if (response.data && response.data.sale_motgagee_details) {
                    if (response.data.sale_motgagee_details.possession_date) {
                        response.data.sale_motgagee_details.possession_date = self.SSUtilService.formatUtcToLocalDate(response.data.sale_motgagee_details.possession_date);
                    }

                    // Can not use 'angular.merge' if destination object is null
                    if (self.sale_sales.mortgagee) {
                        angular.merge(self.sale_sales.mortgagee, response.data.sale_motgagee_details);
                    } else {
                        self.sale_sales.mortgagee = {};
                        angular.merge(self.sale_sales.mortgagee, response.data.sale_motgagee_details);
                    }
                }

                self.mortgageeDetailsEditMode = false;
            };

            let url = 'sec/developer/sales/' + self.sale_sales.id + '/mortgagee';
            let params = self.mortgageeDetailsPararms;

            if (params.mortgagee_name && (params.mortgagee_name == 'Others' || params.mortgagee_name == 'Other')) {
                params.mortgagee_name = params.other_mortgagee_name;
            }

            if (params.possession_date) {
                params.possession_date = self.SSDateService.formateWithTimeAsNoon(params.possession_date);
            }

            loading(true);
            if (self.mortgageeDetailsPararms.id) {
                url += '/' + self.mortgageeDetailsPararms.id;
                self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
            } else {
                self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
            }
        });
    }

    isValidMortgageeDetail(data) {
        const self = this;

        let isValid = true;

        // Validate 'Addresses'
        isValid = self.isValidMortgageeAddress('mortgagee', isValid);
        isValid = self.isValidMortgageeAddress('sub_mortgagee', isValid);
        isValid = self.isValidMortgageeAddress('service_notice', isValid);

        if (!data.mortgagee_name) {
            isValid = false;
            self.mortgageeDetailsErrors.mortgagee_name = "Mortgagee name field is required.";
        }
        // If 'Others' selected for mortgagee name, then verify 'Others' input value
        if (data.mortgagee_name && (data.mortgagee_name == 'Others' || data.mortgagee_name == 'Other')) {
            if (!data.other_mortgagee_name) {
                isValid = false;
                self.mortgageeDetailsErrors.other_mortgagee_name = "Please specify other mortgagee name.";
            }
        }

        return isValid;
    }

    isValidMortgageeAddress(base_param, isValid) {
        const self = this;

        // If anyone of 'Address Line1, Postcode or Country' is entered then these three fields are required, otherwise not

        if (self.mortgageeDetailsPararms[base_param + "_primary_address_line1"]
            || self.mortgageeDetailsPararms[base_param + "_primary_address_postcode"]
            || self.mortgageeDetailsPararms[base_param + "_primary_address_country"]) {
            if (!self.mortgageeDetailsPararms[base_param + "_primary_address_line1"]) {
                isValid = false;
                self.mortgageeDetailsErrors[base_param + "_primary_address_line1"] = "The address line1 field is required.";
            }

            if (!self.mortgageeDetailsPararms[base_param + "_primary_address_postcode"]) {
                isValid = false;
                self.mortgageeDetailsErrors[base_param + "_primary_address_postcode"] = "The postcode field is required.";
            }

            if (!self.mortgageeDetailsPararms[base_param + "_primary_address_country"]) {
                isValid = false;
                self.mortgageeDetailsErrors[base_param + "_primary_address_country"] = "The country field is required.";
            }
        }

        return isValid;
    }

    getMortgageeDetailsAddress(base_param, address) {
        const self = this;

        if (address) {
            self.mortgageeDetailsPararms[base_param + "_primary_address_line1"] = address.line1;
            self.mortgageeDetailsPararms[base_param + "_primary_address_line2"] = address.line2;
            // self.mortgageeDetailsPararms[base_param + "_primary_address_unit_no"] = address.unit_no;
            self.mortgageeDetailsPararms[base_param + "_primary_address_postcode"] = address.postcode;
            // self.mortgageeDetailsPararms[base_param + "_primary_address_city"] = address.city;
            // self.mortgageeDetailsPararms[base_param + "_primary_address_district"] = address.district;
            self.mortgageeDetailsPararms[base_param + "_primary_address_country"] = address.country;
        }
    }

    editSaleType(editMode) {
        const self = this;

        self.saleEditParams = editMode ? angular.copy(self.sale_sales) : null;
        self.saleTypeEditMode = editMode;
    }

    saveSaleType() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/sales/' + self.sale_sales.id + '/update-sale-fields';

            loading(true);
            self.SSHttpService.putAPIRequest(url, self.saleEditParams).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.");
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success('Sale Type details updated successfully.');

                self.sale_sales.sale_type = self.saleEditParams.sale_type;
                self.saleTypeEditMode = false;
            });
        });
    }

    editReferralInfo(editMode) {
        const self = this;

        self.saleReferralInfoParams = editMode ? angular.copy(self.sale_sales) : null;
        self.saleReferralInfoEditMode = editMode;
    }

    saveReferralInfo() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            let url = 'sec/developer/sales/' + self.sale_sales.id + '/update-sale-fields';

            loading(true);
            self.SSHttpService.putAPIRequest(url, self.saleReferralInfoParams).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success('Sale\'s referral details updated successfully.');

                angular.merge(self.sale_sales, self.saleReferralInfoParams);
                self.saleReferralInfoEditMode = false;
            });
        });
    }

    getReferralLabel() {
        const self = this;
        let referralType = null;
        if(self.saleReferralInfoEditMode){
            if(self.saleReferralInfoParams){
                referralType = self.saleReferralInfoParams.referral_type;
            }else if(self.sale_sales){
                referralType = self.sale_sales.referral_type;
            }
        }
        return self.SSConfigService.getReferralCodeLabel(referralType);
    }

    /**
     * Check if lawyer info exists in from_buyer and copy in to_buyer
     * @param to_buyer
     * @param from_buyer
     * @returns {boolean}
     */
    initEditLawyerDetail(to_buyer, from_buyer) {
        const self = this;

        if (!to_buyer || !from_buyer) { return false; }

        try {
            // If from_buyer has lawyer info, populate in to_buyer
            if (from_buyer.lawyer && Object.keys(from_buyer.lawyer).length > 0) {
                to_buyer.lawyer = from_buyer.lawyer;
            } else if (from_buyer.lawyers && from_buyer.lawyers.length > 0) {
                to_buyer.lawyer = from_buyer.lawyers[0];
            }

            if (to_buyer.lawyer) {
                //Check if law firm stored is others
                if (to_buyer.lawyer.law_firm_name // If law_firm_name not found in list, set as OTHERS
                    && !self.law_firms.find(x => x.name === to_buyer.lawyer.law_firm_name)) {
                    to_buyer.lawyer.law_firm_name_other = angular.copy(to_buyer.lawyer.law_firm_name);
                    to_buyer.lawyer.law_firm_name = "OTHERS";
                }
            } else {
                to_buyer.lawyer = {};
            }
        } catch (e) {
            console.error("An error occured, trying to initialize Lawyer info.")
        }
    }

    saveNewBuyer(newBuyer) {
        const self = this;

        self.resetBuyerErrors();
        if (!self.isValidBuyerInput(newBuyer)) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveNewBuyer();
            }
        );
    }

    _saveNewBuyer() {
        const self = this;

        if (!self.saleBuyerParams) { return false; }

        let url = 'sec/developer/sales/' + self.sale_id + '/buyers';
        if (self.saleBuyerParams.subsale_id) {
            url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + self.saleBuyerParams.subsale_id + '/buyers';
        }

        let params = angular.copy(self.saleBuyerParams);
        /** WEB-2925 AMS: Sale - Add option to update Buyer Lawyer Info
         * Save lawyer info in lawyer object
        if (params.data.lawyer) { // If has lawyer data add as array
            params.data.lawyers = [params.data.lawyer];
            delete params.data.lawyer;
        } **/
        if (params.data.lawyer) {
            params.data.lawyer.law_firm_name = params.data.lawyer.law_firm_name === "OTHERS" ? params.data.lawyer.law_firm_name_other : params.data.lawyer.law_firm_name;
            params.data.lawyers = null;
        }

        if (params.mailing_address_same && params.data.primary_address) {
            // Copy primary address to mailing address if exists
            params.data.mailing_address = {};
            params.data.mailing_address.line1 = params.data.primary_address.line1;
            params.data.mailing_address.line2 = params.data.primary_address.line2;
            params.data.mailing_address.unit_no = params.data.primary_address.unit_no;
            params.data.mailing_address.postcode = params.data.primary_address.postcode;
            params.data.mailing_address.city = params.data.primary_address.city;
            params.data.mailing_address.district = params.data.primary_address.district;
            params.data.mailing_address.province = params.data.primary_address.province;
            params.data.mailing_address.country = params.data.primary_address.country;
        }

        if(!self.isValidUnitNum(params.data)) return false; // TODO: Verify and remove

        if(params.data.individual){
            if (params.data.individual.dob) {
                params.data.individual.dob = self.SSUtilService.formatDateToStoreWithUtc12(params.data.individual.dob);
            }
            if(params.data.individual.occupation_other && params.data.individual.occupation === "OTHERS"){
                params.data.individual.occupation = params.data.individual.occupation_other;
            }
            if(params.data.individual.race_other && params.data.individual.race === "OTHERS"){
                params.data.individual.race = params.data.individual.race_other;
            }

            delete params.data.individual.occupation_other;
            delete params.data.individual.race_other;
        }

        if (params.data.type === self.BUYER_TYPE_INDIVIDUAL) {
            params.data.company = null;
        } else if (params.data.type === self.BUYER_TYPE_COMPANY) {
            params.data.individual = null;
        }

        // params.data = self.initEmptyValues(params.data);
        params.data = JSON.stringify(params.data);
        params.order = (self.sale_sales.sale_buyers && self.sale_sales.sale_buyers.length > 0)? self.sale_sales.sale_buyers.length + 1 : 1;

        /** WEB-2937 Corporate Sale - Support for Multiple Signatories
         * Set order in case of signatory **/
        if(self.sale_sales && self.sale_sales.sale_buyers && self.sale_sales.sale_buyers[0]
                && self.sale_sales.sale_buyers[0].data.type === self.BUYER_TYPE_COMPANY
                && self.saleBuyerParams.data.type === self.BUYER_TYPE_INDIVIDUAL){ /* Signatory */
            /* Set order for signatory according to its company */
            let signatory_index = self.SSEoiService.getNextIndexForAddingSignatory(self.saleBuyerParams.data.buyer_company_id);
            params.order =  signatory_index? signatory_index + 1 : self.sale_sales.sale_buyers.length;
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code === 305015 || response.sub_code === 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                } else if (response.sub_code == 412001 && response.data && response.data.individual_national_id){
                    self.buyerErrors = {
                        individual_national_id: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'New buyer added successfully.');

            try {
                // Update sale_buyers
                // angular.merge(self.sale_sales.sale_buyers, response.data.sale_buyer);
                self.sale_sales.sale_buyers.push(response.data.sale_buyer);
                self.selectSaleBuyer(self.sale_sales.sale_buyers[self.sale_sales.sale_buyers.length - 1]);
            } catch (ex) {
                console.log(ex);
            }

            self.newBuyerMode = false;
            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    isValidUnitNum(data){
        const self = this;

        if(!data) return;

        // Validate Unit Number
        let isValidUnit = true;

        // If address is not provided then don't need to check
        if(!data.primary_address) return true;

        if(data.primary_address.unit_no && !self.SSEoiService.isValidUnitNum(data.primary_address.unit_no)){
            self.errPrimaryAddressUnit = "please enter valid Unit#";
            isValidUnit = false;
        }
        if(data.mailing_address && data.mailing_address.unit_no && !self.SSEoiService.isValidUnitNum(data.mailing_address.unit_no)){
            self.errMailingAddressUnit = "please enter valid Unit#";
            isValidUnit = false;
        }

        // If other structure (with _ instead of .)
        if(data.primary_address_unit_no && !self.SSEoiService.isValidUnitNum(data.primary_address_unit_no)){
            self.errPrimaryAddressUnit = "please enter valid Unit#";
            isValidUnit = false;
        }
        if(data.mailing_address_unit_no && !self.SSEoiService.isValidUnitNum(data.mailing_address_unit_no)){
            self.errMailingAddressUnit = "please enter valid Unit#";
            isValidUnit = false;
        }

        if(!isValidUnit){
            self.SSAlertService.danger("Please enter valid unit number.");
        }

        return isValidUnit;
    }

    saveNewOccupier(newOccupier) {
        const self = this;

        self.resetOccupierErrors();
        if (!self.isValidOccupierInput(newOccupier)) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveNewOccupier();
            }
        );
    }

    _saveNewOccupier() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/occupiers';

        let params = self.saleOccupierParams;

        if (!params) {
            return;
        }

        if (self.saleOccupierParams.data && self.saleOccupierParams.data.individual.dob) {
            self.saleOccupierParams.data.individual.dob = self.SSUtilService.formatDateToStoreWithUtc12(self.saleOccupierParams.data.individual.dob);
        }

        params.data = JSON.stringify(params.data);

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'New buyer added successfully.');

            try {
                self.sale_sales.sale_occupiers.push(response.data.sale_occupiers);
                self.selectSaleOccupier(self.sale_sales.sale_occupiers[self.sale_sales.sale_occupiers.length - 1]);
            } catch (ex) {
                console.log(ex);
            }

            self.newOccupierMode = false;

            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    getSubsaleBuyers(subsales) {
        const self = this;

        if (subsales && subsales.length > 0) {
            // Buyer in latest subsale is current buyer and all other buyers are 'previous'
            $.each(subsales, function (index, subsale) {
                if (index < subsales.length - 1) {
                    $.each(subsale.subsale_buyers, function (i, buyer) {
                        let processed_buyer = buyer;
                        processed_buyer.data = JSON.parse(buyer.data);
                        processed_buyer['sub_sale_date'] = subsale.created_at;
                        self.previous_sale_buyers.push(processed_buyer);
                    });
                }
                self.getSubsalesDocuments(subsale);
            });


            // if(self.previous_sale_buyers && self.previous_sale_buyers.length > 0){
            //     self.selectPreviousBuyer(self.previous_sale_buyers[0]);
            // }
        }
    }

    // Previous Sub Sales
    selectPreviousSubsale(previousSubsale) {
        const self = this;

        if (!previousSubsale) {
            return;
        }

        self.SHOW_PREVIOUS_BUYERS = true;
        self.selectedPreviousSubsale = previousSubsale;
        self.previous_sale_buyers = [];

        if (!!self.subsale_users) {
            try {
                let user = self.subsale_users.find(x => x.id == previousSubsale.created_by);
                if (user) {
                    previousSubsale.created_by = user.display_name ? user.display_name : user.first_name + ' ' + user.last_name;
                }
            } catch (ex) {
                console.log(ex);
            }
        }

        try {
            let processedBuyer = null;

            $.each(previousSubsale.subsale_buyers, function (index, buyer) {
                if (typeof buyer.data === "string") {
                    processedBuyer = JSON.parse(buyer.data);
                    processedBuyer.data = JSON.parse(buyer.data); // For common code handling
                } else {
                    processedBuyer = buyer.data;
                    processedBuyer.data = buyer.data; // For common code handling
                }

                processedBuyer.sale_buyer_id = processedBuyer.id;
                processedBuyer.id = buyer.id;

                if(buyer.documents){
                    processedBuyer.documents = buyer.documents;
                }

                self.previous_sale_buyers.push(processedBuyer);
            });

            self.selectPreviousBuyer(self.previous_sale_buyers[0]);
        } catch (ex) {
            console.log(ex);
        }
    }

    // Previous Sale Buyers
    selectPreviousBuyer(previousBuyer) {
        const self = this;

        if (!previousBuyer) {
            return;
        }

        if (previousBuyer.data) {
            previousBuyer = previousBuyer.data;
        }

        if (typeof previousBuyer === "string") {
            previousBuyer = JSON.parse(previousBuyer);
        }

        // Map buyer documents (NRIC/Passport) from sale_documents
        $.each(self.sale_sales.documents, function(index, document){
            if(document.sale_buyer_id == previousBuyer.id){
                if(document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT
                    || document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_BACK
                    || document.document_kind == self.PROPERTY_DOCUMENT_KIND_PASSPORT
                    || document.document_kind == self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE
                    || document.document_kind == self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION){

                    if(!previousBuyer.hasOwnProperty('documents')){
                        previousBuyer['documents'] = {};
                    }

                    // To retrieve preview image
                    if (document.file_uri && document.id) {
                        self.getPresignedUrl(
                            self.ASSET_MODEL_SALE_DOCUMENT,
                            document.id,
                            function (presignedUrl) {
                                previousBuyer.documents[document.document_kind] = document;
                                previousBuyer.documents[document.document_kind]["show_file_url"] = presignedUrl;
                            }
                        );
                    }
                }
            }
        });

        self.selectedPreviousBuyer = previousBuyer;
    }

    getSubSaleDate() {
        const self = this;

        try {
            if (self.subsales.length > 0) {
                // Fetch last object for latest sub-sale date
                let date = self.subsales[self.subsales.length - 1].created_at;
                return self.SSUtilService.formatUtcToLocalDate(date) + " " + self.SSUtilService.formatUtcToLocalTime(date);
            } else {
                return '--';
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    removeSubSaleBuyer(buyer) {
        const self = this;

        // Get 2FA before allowing to delete buyer
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function() {
            self.del_buyer_confirm_txt = "";
            self.del_buyer_confirm_txt_err = false;
            self.selected_del_buyer = buyer;
            $('#delete_buyer_confirmation_modal').modal('show');
        });
    }

    confirmRemoveSubSaleBuyer() {
        const self = this;

        self.del_buyer_confirm_txt_err = false;
        try{
            if (self.selected_del_buyer
                    && self.del_buyer_confirm_txt
                    && self.del_buyer_confirm_txt.trim().toUpperCase() === "DELETE BUYER") {
                $('#delete_buyer_confirmation_modal').modal('hide');
                self._removeSubSaleBuyer(self.selected_del_buyer);
            } else {
                self.del_buyer_confirm_txt_err = true;
            }
        } catch(e){
            console.error(e);
        }
    }

    _removeSubSaleBuyer(buyer) {
        const self = this;

        if (self.sale_sales){ // Check if has at lease 1 buyer, else show error
            if (!self.sale_sales.sale_buyers.length || self.sale_sales.sale_buyers.length < 2){
                self.SSAlertService.danger("Error!", "Sale must have at least 1 buyer");
                return false;
            }
        }

        // Old records have 'buyer_id' new have 'buyer.id'
        // UPDATED: 10-April-2019, pass sale buyer id (i.e buyer.id) to delete buyer
        var buyer_id = buyer.id;
        let url = 'sec/developer/sales/' + self.sale_id + '/buyers/' + buyer_id + '/delete';

        // If buyer object has 'subsale_id' parameter then its url and other values are different
        if (buyer.subsale_id) {
            url = 'sec/developer/sales/' + self.sale_id + '/subsales/' + buyer.subsale_id + '/buyers/' + buyer_id + '/delete';
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.sale_buyers = jQuery.grep(self.sale_sales.sale_buyers, function (obj) {
                return obj.id !== buyer_id;
            });
            self.SSEoiService.removeBuyer(buyer.data);

            // User can not delete first buyer, so there must be one buyer
            self.selectSaleBuyer(self.sale_sales.sale_buyers[0])

            self.updateSaleBuyersOrder();
        });
    }
    removeSaleNonBuyerPayee(buyer, skipConfirmation) {
        const self = this;

        // Old records have 'buyer_id' new have 'buyer.id'
        // UPDATED: 10-April-2019, pass sale buyer id (i.e buyer.id) to delete buyer
        var buyer_id = buyer.id;
        let url = 'sec/developer/sales/' + self.sale_id + '/non-buyer-payees/'+buyer.id+'/delete';
        let params = {
            buyer_ids: buyer.id,
        }

        if(skipConfirmation){
            self._removeSaleNonBuyerPayee(url, params, buyer);
        } else {
            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                'Please confirm to proceed.',
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self._removeSaleNonBuyerPayee(url, params, buyer);
                }
            );
        }
    }

    _removeSaleNonBuyerPayee(url, params, buyer){
        const self = this;

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Entity removed successfully.");

            // If removing company Non Buyer Payee, also need to remove its signatories
            if(buyer.type === self.BUYER_TYPE_COMPANY){
                let company_signatories = self.SSEoiService.getSignatoriesAgainstCompanyId(buyer.id, self.SSEoiService.nonBuyerPayees);
                if(company_signatories && company_signatories.length){
                    company_signatories.forEach(s => {
                        self.removeSaleNonBuyerPayee(s, true);
                    })
                }

                self.SSEoiService.removeNonBuyerPayee(buyer);
            } else {
                self.SSEoiService.removeNonBuyerPayee(buyer);
            }

            self.sale_sales.sale_non_buyer_payees = jQuery.grep(self.sale_sales.sale_non_buyer_payees, function (obj) {
                return obj.id !== buyer.id;
            });

            if(self.sale_sales.sale_non_buyer_payees.length){
                self.selectSaleNonBuyerPayee(self.sale_sales.sale_non_buyer_payees[0]);
            }
        });
    }

    removeSaleOccupier(occupier) {
        const self = this;

        // Old records have 'occupier_id' new have 'occupier.id'
        // UPDATED: 10-April-2019, pass sale occupier id (i.e occupier.id) to delete occupier
        var occupier_id = occupier.id;
        let url = 'sec/developer/sales/' + self.sale_id + '/occupiers/' + occupier_id + '/delete';

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.sale_sales.sale_occupiers = jQuery.grep(self.sale_sales.sale_occupiers, function (obj) {
                        return obj.id !== occupier_id;
                    });

                    // User can not delete first occupier, so there must be one occupier
                    self.selectSaleOccupier(self.sale_sales.sale_occupiers[0]);
                });
            }
        );
    }

    resetBuyerErrors() {
        const self = this;

        self.buyerErrors = {};

        // Reset Buyer Errors
        self.errorBuyerType = null;
        self.errTitle = null;
        self.errRace = null;
        self.errLegalName = null;
        self.errFirstName = null;
        self.errLastName = null;
        self.errIdentityType = null;
        self.errNric = null;
        self.errNationality = null;
        self.errGender = null;
        self.errPassport = null;
        self.errEmail = null;
        self.errDateOfBirth = null;
        self.errPrimaryContactNumber = null;
        self.errPrimaryAddress = null;

        self.errPrimaryAddressUnit = null;
        self.errMailingAddressUnit = null;

        // Reset Lawyer Errors
        self.error_law_firm_name = null;
        self.error_first_name = null;
        self.error_last_name = null;
        self.error_email = null;
        self.error_contact_number = null;
    }

    resetNonBuyerPayeeErrors() {
        const self = this;

        self.nonBuyerPayeeErrors = {};

        // Reset Buyer Errors
        /** WEB-2937 Corporate Sale - Support for Multiple Signatories
         * Following variables are no longer in use
        self.errNonBuyerPayeeLegalName = null;
        self.errNonBuyerPayeeFirstName = null;
        self.errNonBuyerPayeeLastName = null;
        self.errNonBuyerPayeeIdentityType = null;
        self.errNonBuyerPayeeNric = null;
        self.errNonBuyerPayeeNationality = null;
        self.errNonBuyerPayeePassport = null;
        self.errNonBuyerPayeeForeignerNationalId = null;
        self.errNonBuyerPayeeEmail = null;
        self.errNonBuyerPayeeDateOfBirth = null;
        self.errNonBuyerPayeePrimaryContactNumber = null;
        self.errNonBuyerPayeeRelationship = null;
        self.errNonBuyerPayeePrimaryAddress = null;
        self.errNonBuyerPayeePrimaryAddressLine1 = null;
        self.errNonBuyerPayeePrimaryAddressPostCode = null;
        self.errNonBuyerPayeePrimaryAddressCountry = null;

        self.errPrimaryAddressUnit = null;
        self.errMailingAddressUnit = null; **/
    }

    resetOccupierErrors() {
        const self = this;

        // Reset Occupier Errors
        self.errorOccupierType = null;
        self.errOccTitle = null;
        self.errOccRace = null;
        self.errOccLegalName = null;
        self.errOccFirstName = null;
        self.errOccLastName = null;
        self.errOccIdentityType = null;
        self.errOccNric = null;
        self.errOccNationality = null;
        self.errOccPassport = null;
        self.errOccEmail = null;
        self.errOccDateOfBirth = null;
        self.errOccPrimaryContactNumber = null;
    }

    isValidBuyerInput(BuyerObject) {
        const self = this;

        self.buyerErrors = {};

        let isValid = true;

        // Initialize empty objects to validate respective field(s)
        self.initValidateParams();

        // Buyer type check
        if (!BuyerObject || !BuyerObject.data || !BuyerObject.data.type) {
            self.buyerErrors.type = "Please Select Type of Buyer";
            return false;
        }

        // Validate Company Fields
        if (BuyerObject.data.type === SHOWSUITE.BUYER_TYPE_COMPANY) {
            if(!BuyerObject.data.company){
                console.error("Error, invalid buyer object");
                BuyerObject.data.company = {};
            }

            // Name of the Company
            if (self.pp_form_settings.company_name
                    && self.pp_form_settings.company_name.required && !BuyerObject.data.company.name) {
                self.buyerErrors.company_name = "Please Enter Name of the Company";
                isValid = false;
            }

            // Company UEN No.
            if (self.pp_form_settings.company_registration_no
                    && self.pp_form_settings.company_registration_no.required && !BuyerObject.data.company.reg_no) {
                self.buyerErrors.company_reg_no = "Please Enter Company Registration No.";
                isValid = false;
            }

            // Country Of Birth
            if (self.pp_form_settings.company_country_of_origin
                    && self.pp_form_settings.company_country_of_origin.required
                    && ( BuyerObject.data.company.nationality === null
                        ||  BuyerObject.data.company.nationality === undefined
                        ||  BuyerObject.data.company.nationality === 0)) {
                self.buyerErrors.company_nationality = "Please Select Country of Origin";
                isValid = false;
            }

            // Company Email
            if (self.pp_form_settings.company_email
                    && self.pp_form_settings.company_email.required) {
                if (!BuyerObject.data.email_contact || !BuyerObject.data.email_contact.value) {
                    self.buyerErrors.email_contact_value = "Please Enter Company Email";
                    isValid = false;
                }
            }

            // Company Contact Number
            if (self.pp_form_settings.company_phone1
                    && self.pp_form_settings.company_phone1.required
                    && (!BuyerObject.data.phone1_contact || !BuyerObject.data.phone1_contact.value)) {
                self.buyerErrors.phone1_contact_value = "Please Enter Contact Number";
                isValid = false;
            }

            // Company Secondary Contact Number
            if (self.pp_form_settings.company_phone2
                    && self.pp_form_settings.company_phone2.required
                    && (!BuyerObject.data.phone2_contact || !BuyerObject.data.phone2_contact.value)) {
                self.buyerErrors.phone2_contact_value = "Please Enter Secondary Contact Number";
                isValid = false;
            }

            // Validate Company Address
            if(!self.isValidAddress(BuyerObject)){
                isValid = false;
            }
        } else if(self.sale_sales && self.sale_sales.sale_buyers && self.sale_sales.sale_buyers[0]
                && self.sale_sales.sale_buyers[0].data.type === self.BUYER_TYPE_COMPANY
                && BuyerObject.data.type === self.BUYER_TYPE_INDIVIDUAL){ // Signatory

            if(!BuyerObject.data.individual){
                console.error("Error, invalid buyer object");
                BuyerObject.data.individual = {};
            }

            // Signatory Designation
            if (self.pp_form_settings.signatory_designation
                    && self.pp_form_settings.signatory_designation.required
                    && !BuyerObject.data.individual.designation) {
                self.buyerErrors.individual_designation = "Please Enter Signatory Designation";
                isValid = false;
            }

            // Salutation of Signatory
            if (self.pp_form_settings.signatory_title
                    && self.pp_form_settings.signatory_title.required
                    && (BuyerObject.data.individual.title === null || BuyerObject.data.individual.title === undefined)) {
                self.buyerErrors.individual_title = "Please Select Salutation";
                isValid = false;
            }

            // Full Name as in NRIC/Passport of Signatory
            if (self.pp_form_settings.signatory_legal_name
                    && self.pp_form_settings.signatory_legal_name.required
                    && !BuyerObject.data.individual.legal_name) {
                self.buyerErrors.individual_legal_name = "Please Enter Name as in NRIC/Passport";
                isValid = false;
            }

            // First Name of Signatory
            if (self.pp_form_settings.signatory_first_name
                    && self.pp_form_settings.signatory_first_name.required
                    && !BuyerObject.data.individual.first_name) {
                self.buyerErrors.individual_first_name = "Please Enter First Name of Signatory";
                isValid = false;
            }

            // Last Name of Signatory(Surname)
            if (self.pp_form_settings.signatory_last_name
                    && self.pp_form_settings.signatory_last_name.required
                    && !BuyerObject.data.individual.last_name) {
                self.buyerErrors.individual_last_name = "Please Enter Last Name of Signatory";
                isValid = false;
            }

            // Type of Industry
            if (self.pp_form_settings.signatory_industry
                    && self.pp_form_settings.signatory_industry.required) {
                if ((BuyerObject.data.individual.industry === null
                        || BuyerObject.data.individual.industry === undefined
                        || BuyerObject.data.individual.industry === "")) {
                    self.buyerErrors.individual_industry = "Please Select Type of Industry";
                    isValid = false;
                } else if (BuyerObject.data.individual.industry === "OTHERS" && !BuyerObject.data.individual.industry_other) {
                    self.buyerErrors.individual_industry_other = "Please Specify Other Industry";
                    isValid = false;
                }
            }

            // Occupation
            if (self.pp_form_settings.signatory_occupation
                    && self.pp_form_settings.signatory_occupation.required) {
                if (BuyerObject.data.individual.occupation === null || BuyerObject.data.individual.occupation === undefined) {
                    self.buyerErrors.individual_occupation = "Please Select Signatory's Occupation";
                    isValid = false;
                } else if (BuyerObject.data.individual.occupation === "OTHERS" && !BuyerObject.data.individual.occupation_other) {
                    self.buyerErrors.individual_occupation_other = "Please Specify Other Occupation";
                    isValid = false;
                }
            }

            // Gender
            if (self.pp_form_settings.signatory_gender
                    && self.pp_form_settings.signatory_gender.required
                    && (BuyerObject.data.individual.gender === null || BuyerObject.data.individual.gender === undefined)) {
                self.buyerErrors.individual_gender = "Please Select Gender";
                isValid = false;
            }

            if (self.pp_form_settings.signatory_identity_type
                    && self.pp_form_settings.signatory_identity_type.required) {
                // Identity Type
                if (!BuyerObject.data.individual.identity_type) {
                    self.buyerErrors.individual_identity_type = "Please Select Identity Type";
                    isValid = false;
                } else {
                    if (BuyerObject.data.individual.identity_type === self.IDENTITY_TYPE_FOREIGNER) {
                        // Passport No
                        if (self.pp_form_settings.signatory_passport_no
                                && self.pp_form_settings.signatory_passport_no.required
                                && !BuyerObject.data.individual.passport_no) {
                            self.buyerErrors.individual_passport_no = "Please Enter Passport";
                            isValid = false;
                        }

                        // Passport Issued By
                        if (self.pp_form_settings.signatory_passport_issued_by
                                && self.pp_form_settings.signatory_passport_issued_by.required
                                && !BuyerObject.data.individual.passport_issued_by) {
                            self.buyerErrors.individual_passport_issued_by = "Please Enter Passport Issued By";
                            isValid = false;
                        }

                        // Passport Issued Date
                        if (self.pp_form_settings.signatory_passport_issued_date
                                && self.pp_form_settings.signatory_passport_issued_date.required
                                && !BuyerObject.data.individual.passport_issued_date) {
                            self.buyerErrors.individual_passport_issued_date = "Please Select Passport Issued Date";
                            isValid = false;
                        }

                        // Passport Expiry Date
                        if (self.pp_form_settings.signatory_passport_expiry_date
                                && self.pp_form_settings.signatory_passport_expiry_date.required
                                && !BuyerObject.data.individual.passport_expiry_date) {
                            self.buyerErrors.individual_passport_expiry_date = "Please Select Passport Expiry Date";
                            isValid = false;
                        }
                    } else if (BuyerObject.data.individual.identity_type) {
                        // NRIC
                        if (self.pp_form_settings.signatory_national_id
                                && self.pp_form_settings.signatory_national_id.required) {
                            if (!BuyerObject.data.individual.national_id) {
                                self.buyerErrors.individual_national_id = "Please Enter NRIC";
                                isValid = false;
                            } else if (!self.SSUtilService.isValidNRIC(BuyerObject.data.individual.national_id, self.sale_property.country)) {
                                self.buyerErrors.individual_national_id = "Please Enter a valid NRIC";
                                isValid = false;
                            }
                        }

                        // Race
                        if (self.pp_form_settings.signatory_race
                                && self.pp_form_settings.signatory_race.required) {
                            if (!BuyerObject.data.individual.race) {
                                self.buyerErrors.individual_race = "Please Select Race";
                                isValid = false;
                            } else if (BuyerObject.data.individual.race === "Other" && !BuyerObject.data.individual.race_other) {
                                self.buyerErrors.individual_race_other = "Please Specify Other Race";
                                isValid = false;
                            }
                        }
                    }
                }
            }

            // Nationality
            if (self.pp_form_settings.signatory_nationality
                    && self.pp_form_settings.signatory_nationality.required
                    && (BuyerObject.data.individual.nationality === null || BuyerObject.data.individual.nationality === undefined)) {
                self.buyerErrors.individual_nationality = "Please Select Nationality";
                isValid = false;
            }

            // Country Of Birth
            if (self.pp_form_settings.signatory_country_of_origin
                    && self.pp_form_settings.signatory_country_of_origin.required
                    && (BuyerObject.data.individual.country_of_origin === null
                        || BuyerObject.data.individual.country_of_origin === undefined
                        || BuyerObject.data.individual.country_of_origin === 0)) {
                self.buyerErrors.individual_country_of_origin = "Please Select Country of Birth";
                isValid = false;
            }

            // Monthly Income (S$)
            if (self.pp_form_settings.signatory_monthly_income
                    && self.pp_form_settings.signatory_monthly_income.required
                    && (BuyerObject.data.individual.monthly_income === null
                        || BuyerObject.data.individual.monthly_income === undefined
                        || BuyerObject.data.individual.monthly_income === "")) {
                self.buyerErrors.individual_monthly_income = "Please Enter Monthly Income";
                isValid = false;
            }

            // Employment Status
            if (self.pp_form_settings.signatory_employment_status
                    && self.pp_form_settings.signatory_employment_status.required
                    && (BuyerObject.data.individual.employment_status === null || BuyerObject.data.individual.employment_status === undefined)) {
                self.buyerErrors.individual_employment_status = "Please Select Employment Status";
                isValid = false;
            }

            // Education Level
            if (self.pp_form_settings.signatory_education_level
                    && self.pp_form_settings.signatory_education_level.required
                    && (BuyerObject.data.individual.education_level === null || BuyerObject.data.individual.education_level === undefined)) {
                self.buyerErrors.individual_education_level = "Please Select Education Level";
                isValid = false;
            }

            // Marital Status
            if (self.pp_form_settings.signatory_marital_status
                    && self.pp_form_settings.signatory_marital_status.required) {
                if(!BuyerObject.data.individual.marital_status === null
                        || BuyerObject.data.individual.marital_status === undefined
                        || BuyerObject.data.individual.marital_status === 0) {
                    self.buyerErrors.individual_marital_status = "Please Select Marital Status";
                    isValid = false;
                } else if (BuyerObject.data.individual.marital_status === 2
                        && self.pp_form_settings.signatory_spouse_national_id
                        && self.pp_form_settings.signatory_spouse_national_id.required
                        && !BuyerObject.data.individual.spouse_national_id) {
                    self.buyerErrors.individual_spouse_national_id = "Please Enter Spouse National ID";
                    isValid = false;
                }
            }

            // Date of Birth
            if (self.pp_form_settings.signatory_dob
                    && self.pp_form_settings.signatory_dob.required) {
                if (!BuyerObject.data.individual.dob) {
                    self.buyerErrors.individual_dob = "Please Enter Date of Birth";
                    isValid = false;
                } else if (moment().diff(moment(BuyerObject.data.individual.dob, "DD/MM/YYYY")) < 0) {
                    self.buyerErrors.individual_dob = "The date of birth cannot be a future date";
                    isValid = false;
                }
            }

            if (self.pp_form_settings.signatory_email
                    && self.pp_form_settings.signatory_email.required) {
                // Email of Signatory
                if (!BuyerObject.data.email_contact || !BuyerObject.data.email_contact.value) {
                    self.buyerErrors.email_contact_value = "Please Enter Email of Signatory";
                    isValid = false;
                }
            }

            // Mobile Number of Signatory
            if (self.pp_form_settings.signatory_phone1
                    && self.pp_form_settings.signatory_phone1.required
                    && (!BuyerObject.data.phone1_contact || !BuyerObject.data.phone1_contact.value)) {
                self.buyerErrors.phone1_contact_value = "Please Enter Mobile Number of Signatory";
                isValid = false;
            }

            // Contact Number of Signatory
            if (self.pp_form_settings.signatory_phon2
                    && self.pp_form_settings.signatory_phon2.required
                    && (!BuyerObject.data.phone2_contact || !BuyerObject.data.phone2_contact.value)) {
                self.buyerErrors.phone2_contact_value = "Please Enter Contact Number of Signatory";
                isValid = false;
            }

            // Residence Type
            if (self.pp_form_settings.signatory_residence_type
                    && self.pp_form_settings.signatory_residence_type.required
                    && !BuyerObject.data.residence_type) {
                self.buyerErrors.residence_type = "Please Select Residence Type";
                isValid = false;
            }
        }else  if (BuyerObject.data.type === self.BUYER_TYPE_INDIVIDUAL) { // Individual
            if(!BuyerObject.data.individual){
                console.error("Error, invalid buyer object");
                BuyerObject.data.individual = {};
            }

            // Salutation
            if (self.pp_form_settings.title
                    && self.pp_form_settings.title.required
                    && !BuyerObject.data.individual.title) {
                self.buyerErrors.individual_title = "Please Select Salutation";
                isValid = false;
            }

            // Full Name as in NRIC/Passport
            if (self.pp_form_settings.legal_name
                    && self.pp_form_settings.legal_name.required
                    && !BuyerObject.data.individual.legal_name) {
                self.buyerErrors.individual_legal_name = "Please Enter Name as in NRIC/Passport";
                isValid = false;
            }

            // First Name of Buyer
            if (self.pp_form_settings.first_name
                    && self.pp_form_settings.first_name.required
                    && !BuyerObject.data.individual.first_name) {
                self.buyerErrors.individual_first_name = "Please Enter First Name of Buyer";
                isValid = false;
            }

            // Last Name of Buyer(Surname)
            if (self.pp_form_settings.last_name
                    && self.pp_form_settings.last_name.required
                    && !BuyerObject.data.individual.last_name) {
                self.buyerErrors.individual_last_name = "Please Enter Last Name of Buyer";
                isValid = false;
            }

            // Type of Industry
            if (self.pp_form_settings.industry
                    && self.pp_form_settings.industry.required) {
                if ((BuyerObject.data.individual.industry === null
                        || BuyerObject.data.individual.industry === undefined
                        || BuyerObject.data.individual.industry === "")) {
                    self.buyerErrors.individual_industry = "Please Select Type of Industry";
                    isValid = false;
                } else if (BuyerObject.data.individual.industry === "OTHERS" && !BuyerObject.data.individual.industry_other) {
                    self.buyerErrors.individual_industry_other = "Please Specify Other Industry";
                    isValid = false;
                }
            }

            // Occupation
            if (self.pp_form_settings.occupation && self.pp_form_settings.occupation.required) {
                if (BuyerObject.data.individual.occupation === null || BuyerObject.data.individual.occupation === undefined) {
                    self.buyerErrors.individual_occupation = "Please Select Individual Occupation";
                    isValid = false;
                } else if (BuyerObject.data.individual.occupation === "OTHERS" && !BuyerObject.data.individual.occupation_other) {
                    self.buyerErrors.individual_occupation_other = "Please Specify Other Occupation";
                    isValid = false;
                }
            }

            // Gender
            if (self.pp_form_settings.gender
                    && self.pp_form_settings.gender.required
                    && (BuyerObject.data.individual.gender === null || BuyerObject.data.individual.gender === undefined)) {
                self.buyerErrors.individual_gender = "Please Select Gender";
                isValid = false;
            }

            if (self.pp_form_settings.identity_type && self.pp_form_settings.identity_type.required) {
                // Identity Type
                if (!BuyerObject.data.individual.identity_type) {
                    self.buyerErrors.individual_identity_type = "Please Select Identity Type";
                    isValid = false;
                } else {
                    if (BuyerObject.data.individual.identity_type === SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        // Passport No
                        if (self.pp_form_settings.passport_no
                                && self.pp_form_settings.passport_no.required
                                && !BuyerObject.data.individual.passport_no) {
                            self.buyerErrors.individual_passport_no = "Please Enter Passport";
                            isValid = false;
                        }
                        // Foreigner National ID
                        if (self.pp_form_settings.foreigner_national_id
                                && self.pp_form_settings.foreigner_national_id.required
                                && !BuyerObject.data.individual.foreigner_national_id) {
                            self.buyerErrors.individual_foreigner_national_id = "Please Enter Foreigner National ID";
                            isValid = false;
                        }
                        // Passport Issued By
                        if (self.pp_form_settings.passport_issued_by
                                && self.pp_form_settings.passport_issued_by.required
                                && !BuyerObject.data.individual.passport_issued_by) {
                            self.buyerErrors.individual_passport_issued_by = "Please Enter Passport Issued By";
                            isValid = false;
                        }
                        // Passport Issued Date
                        if (self.pp_form_settings.passport_issued_date
                                && self.pp_form_settings.passport_issued_date.required
                                && !BuyerObject.data.individual.passport_issued_date) {
                            self.buyerErrors.individual_passport_issued_date = "Please Select Passport Issued Date";
                            isValid = false;
                        }
                        // Passport Expiry Date
                        if (self.pp_form_settings.passport_expiry_date
                                && self.pp_form_settings.passport_expiry_date.required
                                && !BuyerObject.data.individual.passport_expiry_date) {
                            self.buyerErrors.individual_passport_expiry_date = "Please Select Passport Expiry Date";
                            isValid = false;
                        }
                    } else if (BuyerObject.data.individual.identity_type !== SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        if (self.pp_form_settings.national_id && self.pp_form_settings.national_id.required) {
                            // NRIC
                            if (!BuyerObject.data.individual.national_id) {
                                self.buyerErrors.individual_national_id = "Please Enter NRIC";
                                isValid = false;
                            } else if (!self.SSUtilService.isValidNRIC(BuyerObject.data.individual.national_id, self.sale_property.country)) {
                                self.buyerErrors.individual_national_id = "Please Enter a valid NRIC";
                                isValid = false;
                            }
                        }
                        // Race
                        if (self.pp_form_settings.race && self.pp_form_settings.race.required) {
                            if (!BuyerObject.data.individual.race) {
                                self.buyerErrors.individual_race = "Please Select Race";
                                isValid = false;
                            } else if (BuyerObject.data.individual.race === "Other" && !BuyerObject.data.individual.race_other) {
                                self.buyerErrors.individual_race_other = "Please specify Other Race";
                                isValid = false;
                            }
                        }
                    }
                }
            }

            // Nationality
            if (self.pp_form_settings.nationality
                    && self.pp_form_settings.nationality.required
                    && (BuyerObject.data.individual.nationality === null || BuyerObject.data.individual.nationality === undefined)) {
                self.buyerErrors.individual_nationality = "Please Select Nationality";
                isValid = false;
            }

            // Country Of Birth
            if (self.pp_form_settings.country_of_origin
                    && self.pp_form_settings.country_of_origin.required
                    && (BuyerObject.data.individual.country_of_origin === null
                        || BuyerObject.data.individual.country_of_origin === undefined
                        || BuyerObject.data.individual.country_of_origin === 0)) {
                self.buyerErrors.individual_country_of_origin = "Please Select Country of Birth";
                isValid = false;
            }

            // Monthly Income (S$)
            if (self.pp_form_settings.monthly_income
                    && self.pp_form_settings.monthly_income.required
                    && (BuyerObject.data.individual.monthly_income === null
                        || BuyerObject.data.individual.monthly_income === undefined
                        || BuyerObject.data.individual.monthly_income === "")) {
                self.buyerErrors.individual_monthly_income = "Please Enter Monthly Income";
                isValid = false;
            }

            // Employment Status
            if (self.pp_form_settings.employment_status
                    && self.pp_form_settings.employment_status.required
                    && (BuyerObject.data.individual.employment_status === null || BuyerObject.data.individual.employment_status === undefined)) {
                self.buyerErrors.individual_employment_status = "Please Select Employment Status";
                isValid = false;
            }

            // Education Level
            if (self.pp_form_settings.education_level
                    && self.pp_form_settings.education_level.required
                    && (BuyerObject.data.individual.education_level === null || BuyerObject.data.individual.education_level === undefined)) {
                self.buyerErrors.individual_education_level = "Please Select Education Level";
                isValid = false;
            }

            // Marital Status
            if (self.pp_form_settings.marital_status && self.pp_form_settings.marital_status.required) {
                if(BuyerObject.data.individual.marital_status === null
                        || BuyerObject.data.individual.marital_status === undefined
                        || BuyerObject.data.individual.marital_status === 0) {
                    self.buyerErrors.individual_marital_status = "Please Select Marital Status";
                    isValid = false;
                }

                if (BuyerObject.data.individual.marital_status === 2
                        && self.pp_form_settings.spouse_national_id
                        && self.pp_form_settings.spouse_national_id.required
                        && !BuyerObject.data.individual.spouse_national_id) {
                    self.buyerErrors.individual_spouse_national_id = "Please Enter Spouse National ID";
                    isValid = false;
                }
            }

            // Date of Birth
            if (self.pp_form_settings.dob && self.pp_form_settings.dob.required) {
                if (!BuyerObject.data.individual.dob) {
                    self.buyerErrors.individual_dob = "Please Enter Date of Birth";
                    isValid = false;
                } else if (moment().diff(moment(BuyerObject.data.individual.dob, "DD/MM/YYYY")) < 0) {
                    self.buyerErrors.individual_dob = "The Date of Birth Cannot be a Future Date";
                    isValid = false;
                }
            }

            // Email
            if (self.pp_form_settings.email && self.pp_form_settings.email.required) {
                if (!BuyerObject.data.email_contact || !BuyerObject.data.email_contact.value) {
                    self.buyerErrors.email_contact_value = "Please Enter Email";
                    isValid = false;
                }
            }

            // Mobile Number
            if (self.pp_form_settings.phone1
                    && self.pp_form_settings.phone1.required
                    && (!BuyerObject.data.phone1_contact || !BuyerObject.data.phone1_contact.value)) {
                self.buyerErrors.phone1_contact_value = "Please Enter Contact Number";
                isValid = false;
            }

            // Contact Number
            if (self.pp_form_settings.phon2
                    && self.pp_form_settings.phon2.required
                    && (!BuyerObject.data.phone2_contact || !BuyerObject.data.phone2_contact.value)) {
                self.buyerErrors.phone2_contact_value = "Please Enter Contact Number";
                isValid = false;
            }

            // Residence Type
            if (self.pp_form_settings.residence_type
                    && self.pp_form_settings.residence_type.required
                    && !BuyerObject.data.residence_type) {
                self.buyerErrors.residence_type = "Please Select Residence Type";
                isValid = false;
            }

            // Relationship
            if (BuyerObject.order && BuyerObject.order > 1
                    && !BuyerObject.data.individual.relationship) {
                self.buyerErrors.individual_relationship = "Please Select Relationship With Buyer 1";
                isValid = false;
            }

            // Validate Individual Address
            if(!self.isValidAddress(BuyerObject)){
                isValid = false;
            }
        }


        /** Todo: Verify and remove email or phone required on add/edit buyer
        if (!BuyerObject.data.email_contact.value && !BuyerObject.data.phone1_contact.value) {
            // Pop up to display error
            self.displayEmailOrPhoneRequiredModal();
            isValid = false;
        } **/

        // Validate Lawyer Params
        // If any one field for Lawyer is entered then all fields are mandatory

        // NEW REQUIREMENT: LAWYER FIELDS ARE OPTIONAL
        // https://showsuite.atlassian.net/browse/WEB-891

        // if(!self.subSaleBuyerParams.data.lawyer){
        //     self.subSaleBuyerParams.data.lawyer = {};
        // }
        // if(self.subSaleBuyerParams.data.lawyer.law_firm_name
        //     || self.subSaleBuyerParams.data.lawyer.first_name
        //     || self.subSaleBuyerParams.data.lawyer.last_name
        //     || self.subSaleBuyerParams.data.lawyer.email
        //     || self.subSaleBuyerParams.data.lawyer.phone1){

        //     if(!self.subSaleBuyerParams.data.lawyer.law_firm_name){
        //       self.error_law_firm_name = "The law firm name field is required.";
        //       isValid = false;
        //     }
        //     if(!self.subSaleBuyerParams.data.lawyer.first_name){
        //       self.error_first_name = "The first name field is required.";
        //       isValid = false;
        //     }
        //     if(!self.subSaleBuyerParams.data.lawyer.last_name){
        //       self.error_last_name = "The last name field is required.";
        //       isValid = false;
        //     }
        //     if(!self.subSaleBuyerParams.data.lawyer.email){
        //       self.error_email = "The email field is required.";
        //       isValid = false;
        //     }
        //     if(!self.subSaleBuyerParams.data.lawyer.phone1){
        //       self.error_contact_number = "The contact number field is required.";
        //       isValid = false;
        //     }
        // }

        return isValid;
    }

    isValidAddress(editBuyerObj){
        const self = this;
        let valid = true;

        if(!editBuyerObj || !editBuyerObj.data){ return false; } // Buyer object format incorrect

        if(!editBuyerObj.data.primary_address){
            if(self.pp_form_settings.primary_address_country
                    && self.pp_form_settings.primary_address_country.required){
                self.buyerErrors.primary_address_country = "Please Select Country";
            }
            if(self.pp_form_settings.primary_address_postcode
                    && self.pp_form_settings.primary_address_postcode.required){
                self.buyerErrors.primary_address_postcode = "Please Enter Postal Code";
            }
            if(self.pp_form_settings.primary_address_line1
                    && self.pp_form_settings.primary_address_line1.required){
                self.buyerErrors.primary_address_line1 = "Please Enter House/Block";
            }
            if(self.pp_form_settings.primary_address_line2
                    && self.pp_form_settings.primary_address_line2.required){
                self.buyerErrors.primary_address_line2 = "Please Enter Street Name";
            }
            if(self.pp_form_settings.primary_address_unit_no
                    && self.pp_form_settings.primary_address_unit_no.required
                && editBuyerObj.data.residence_type !== self.RESIDENCE_TYPE_LANDED_PROPERTY){
                self.buyerErrors.primary_address_unit_no = "Please Enter Unit No.";
            }
            if(self.pp_form_settings.primary_address_district
                    && self.pp_form_settings.primary_address_district.required){
                self.buyerErrors.primary_address_district = "Please Enter District";
            }
            if(self.pp_form_settings.primary_address_city
                    && self.pp_form_settings.primary_address_city.required){
                self.buyerErrors.primary_address_city = "Please Enter City";
            }
            if(self.pp_form_settings.primary_address_province
                    && self.pp_form_settings.primary_address_province.required){
                self.buyerErrors.primary_address_province = "Please Enter Province";
            }
        }else {
            // Primary Address - Country
            if (self.pp_form_settings.primary_address_country
                && self.pp_form_settings.primary_address_country.required
                && (editBuyerObj.data.primary_address.country === null || editBuyerObj.data.primary_address.country === undefined)) {
                self.buyerErrors.primary_address_country = "Please Select Country";
                valid = false;
            }
            // Primary Address - Postal Code
            if (self.pp_form_settings.primary_address_postcode
                    && self.pp_form_settings.primary_address_postcode.required
                    && !self.SSUtilService.isValidPostcode(editBuyerObj.data.primary_address.postcode, editBuyerObj.data.primary_address.country)) {
                self.buyerErrors.primary_address_postcode = self.SSUtilService.getPostCodeValidationMsg(editBuyerObj.data.primary_address.postcode, editBuyerObj.data.primary_address.country);
                valid = false;
            }
            // Primary Address - House/Block
            if (self.pp_form_settings.primary_address_line1
                && self.pp_form_settings.primary_address_line1.required
                && !editBuyerObj.data.primary_address.line1) {
                self.buyerErrors.primary_address_line1 = "Please Enter House/Block";
                valid = false;
            }
            // Primary Address - Street Name
            if (self.pp_form_settings.primary_address_line2
                && self.pp_form_settings.primary_address_line2.required
                && !editBuyerObj.data.primary_address.line2) {
                self.buyerErrors.primary_address_line2 = "Please Enter Street Name";
                valid = false;
            }
            // Primary Address - Unit Door
            if (self.pp_form_settings.primary_address_unit_no
                && self.pp_form_settings.primary_address_unit_no.required &&
                !editBuyerObj.data.primary_address.residence_type){
                if (!editBuyerObj.data.primary_address.unit_no) {
                    self.buyerErrors.primary_address_unit_no = "Please Enter Unit No.";
                    valid = false;
                } else if(!self.SSEoiService.isValidUnitNum(editBuyerObj.data.primary_address.unit_no)){
                    self.buyerErrors.primary_address_unit_no = "Please Enter Valid Unit No.";
                    valid = false;
                }
            }
            // Primary Address - District
            if (editBuyerObj.data.primary_address.country !== self.SINGAPORE_SELECTOR_ID
                && self.pp_form_settings.primary_address_district
                && self.pp_form_settings.primary_address_district.required
                && !editBuyerObj.data.primary_address.district) {
                self.buyerErrors.primary_address_district = "Please Enter District";
                valid = false;
            }
            // Primary Address - City
            if (self.pp_form_settings.primary_address_city
                && self.pp_form_settings.primary_address_city.required
                && !editBuyerObj.data.primary_address.city) {
                self.buyerErrors.primary_address_city = "Please Enter City";
                valid = false;
            }
            // Primary Address - Province
            if (self.pp_form_settings.primary_address_province
                && self.pp_form_settings.primary_address_province.required
                && !editBuyerObj.data.primary_address.province) {
                self.buyerErrors.primary_address_province = "Please Enter Province";
                valid = false;
            }
        }

        if (!editBuyerObj.mailing_address_same) {
            if(!editBuyerObj.data.primary_address){
                if(self.pp_form_settings.primary_address_country
                    && self.pp_form_settings.primary_address_country.required){
                    self.buyerErrors.mailing_address_country = "Please Select Country";
                }
                if(self.pp_form_settings.primary_address_postcode
                    && self.pp_form_settings.primary_address_postcode.required){
                    self.buyerErrors.mailing_address_postcode = "Please Enter Postal Code";
                }
                if(self.pp_form_settings.primary_address_line1
                    && self.pp_form_settings.primary_address_line1.required){
                    self.buyerErrors.mailing_address_line1 = "Please Enter House/Block";
                }
                if(self.pp_form_settings.primary_address_line2
                    && self.pp_form_settings.primary_address_line2.required){
                    self.buyerErrors.mailing_address_line2 = "Please Enter Street Name";
                }
                if(self.pp_form_settings.primary_address_unit_no
                    && self.pp_form_settings.primary_address_unit_no.required
                    && editBuyerObj.data.residence_type !== self.RESIDENCE_TYPE_LANDED_PROPERTY){
                    self.buyerErrors.mailing_address_unit_no = "Please Enter Unit No.";
                }
                if(self.pp_form_settings.primary_address_district
                    && self.pp_form_settings.primary_address_district.required){
                    self.buyerErrors.mailing_address_district = "Please Enter District";
                }
                if(self.pp_form_settings.primary_address_city
                    && self.pp_form_settings.primary_address_city.required){
                    self.buyerErrors.mailing_address_city = "Please Enter City";
                }
                if(self.pp_form_settings.primary_address_province
                    && self.pp_form_settings.primary_address_province.required){
                    self.buyerErrors.mailing_address_province = "Please Enter Province";
                }
            } else{
                // Mailing Address - Country
                if (self.pp_form_settings.primary_address_country
                    && self.pp_form_settings.primary_address_country.required
                    && (editBuyerObj.data.mailing_address.country === null || editBuyerObj.data.mailing_address.country === undefined)) {
                    self.buyerErrors.mailing_address_country = "Please Select Country";
                    valid = false;
                }
                // Mailing Address - Postal Code
                if (self.pp_form_settings.primary_address_postcode
                        && self.pp_form_settings.primary_address_postcode.required
                        && !self.SSUtilService.isValidPostcode(editBuyerObj.data.mailing_address.postcode, editBuyerObj.data.mailing_address.country)) {
                    self.buyerErrors.mailing_address_postcode = self.SSUtilService.getPostCodeValidationMsg(editBuyerObj.data.mailing_address.postcode, editBuyerObj.data.mailing_address.country);
                    valid = false;
                }
                // Mailing Address - House/Block
                if (self.pp_form_settings.primary_address_line1
                    && self.pp_form_settings.primary_address_line1.required
                    && !editBuyerObj.data.mailing_address.line1) {
                    self.buyerErrors.mailing_address_line1 = "Please Enter House/Block";
                    valid = false;
                }
                // Mailing Address - Street Name
                if (self.pp_form_settings.primary_address_line2
                    && self.pp_form_settings.primary_address_line2.required
                    && !editBuyerObj.data.mailing_address.line2) {
                    self.buyerErrors.mailing_address_line2 = "Please Enter Street Name";
                    valid = false;
                }
                // Mailing Address - Unit Door
                if (self.pp_form_settings.primary_address_unit_no
                    && self.pp_form_settings.primary_address_unit_no.required
                    && !editBuyerObj.data.mailing_address.residence_type) {
                    if (!editBuyerObj.data.mailing_address.unit_no) {
                        self.buyerErrors.mailing_address_unit_no = "Please Enter Unit No.";
                        valid = false;
                    } else if(!self.SSEoiService.isValidUnitNum(editBuyerObj.data.mailing_address.unit_no)){
                        self.buyerErrors.mailing_address_unit_no = "Please Enter Valid Unit No.";
                        valid = false;
                    }
                }
                // Mailing Address - District
                if (editBuyerObj.data.mailing_address.country !== self.SINGAPORE_SELECTOR_ID
                    && self.pp_form_settings.primary_address_district
                    && self.pp_form_settings.primary_address_district.required
                    && !editBuyerObj.data.mailing_address.district) {
                    self.buyerErrors.mailing_address_district = "Please Enter District";
                    valid = false;
                }
                // Mailing Address - City
                if (self.pp_form_settings.primary_address_city
                    && self.pp_form_settings.primary_address_city.required
                    && !editBuyerObj.data.mailing_address.city) {
                    self.buyerErrors.mailing_address_city = "Please Enter City";
                    valid = false;
                }
                // Primary Address - Province
                if (self.pp_form_settings.primary_address_province
                    && self.pp_form_settings.primary_address_province.required
                    && !editBuyerObj.data.mailing_address.province) {
                    self.buyerErrors.mailing_address_province = "Please Enter Province";
                    valid = false;
                }
            }
        }

        return valid;
    }

    isValidNonBuyerPayeeInput() {
        const self = this;

        let valid = true;

        // Initialize empty objects to validate respective field(s)
        self.initValidateNonBuyerPayeeParams();

        // Buyer type check
        if (!self.saleNonBuyerPayeeParams.type) {
            self.nonBuyerPayeeErrors.type = "Please select 3rd Party Payor type.";
            valid = false;
        }

        if(!self.nbp_pp_form_settings){
            console.log("Error, 3rd Party Payor fields validation settings missing");
            return true; // Skip validations if missing
        }

        if (self.saleNonBuyerPayeeParams.type === SHOWSUITE.BUYER_TYPE_COMPANY) {
            // Name of the Company
            if (self.nbp_pp_form_settings.company_name
                    && self.nbp_pp_form_settings.company_name.required
                    && !self.saleNonBuyerPayeeParams.company.name) {
                self.nonBuyerPayeeErrors.company_name = "Please Enter Company Name";
                valid = false;
            }

            // Company UEN No.
            if (self.nbp_pp_form_settings.company_registration_no
                    && self.nbp_pp_form_settings.company_registration_no.required
                    && !self.saleNonBuyerPayeeParams.company.reg_no) {
                self.nonBuyerPayeeErrors.company_reg_no = "Please Enter Company UEN No.";
                valid = false;
            }

            // Country Of Birth
            if (self.nbp_pp_form_settings.company_country_of_origin
                    && self.nbp_pp_form_settings.company_country_of_origin.required
                    && (self.saleNonBuyerPayeeParams.company.nationality === null || self.saleNonBuyerPayeeParams.company.nationality === undefined)) {
                self.nonBuyerPayeeErrors.company_nationality = "Please Select Country Of Birth";
                valid = false;
            }

            // Company Email
            if (self.nbp_pp_form_settings.company_email
                    && self.nbp_pp_form_settings.company_email.required) {
                if(!self.saleNonBuyerPayeeParams.email_contact || !self.saleNonBuyerPayeeParams.email_contact.value){
                    self.nonBuyerPayeeErrors.email_contact_value = "Please Enter Company Email";
                    valid = false;
                }
            }

            // Company Contact Number
            if (self.nbp_pp_form_settings.company_phone1
                    && self.nbp_pp_form_settings.company_phone1.required
                    && (!self.saleNonBuyerPayeeParams.phone1_contact.value || !self.saleNonBuyerPayeeParams.phone1_contact.value)) {
                self.nonBuyerPayeeErrors.phone1_contact_value = "Please Enter Company Contact Number";
                valid = false;
            }

            // Secondary Contact Number
            if (self.nbp_pp_form_settings.company_phone2
                    && self.nbp_pp_form_settings.company_phone2.required
                    && (!self.saleNonBuyerPayeeParams.phone2_contact.value || !self.saleNonBuyerPayeeParams.phone2_contact.value)) {
                self.nonBuyerPayeeErrors.phone2_contact_value = "Please Enter Secondary Contact Number";
                valid = false;
            }

            /** Address Validation **/
            if (valid){
                valid = self.isValidNonBuyerPayeeAddress();
            }
        } else if (self.saleNonBuyerPayeeParams.type === SHOWSUITE.BUYER_TYPE_INDIVIDUAL) {
            // Salutation
            if (self.nbp_pp_form_settings.title
                    && self.nbp_pp_form_settings.title.required
                    && !self.saleNonBuyerPayeeParams.individual.title) {
                self.nonBuyerPayeeErrors.individual_title = "Please Select Salutation";
                valid = false;
            }

            // Full Name as in NRIC/Passport
            if (self.nbp_pp_form_settings.legal_name
                    && self.nbp_pp_form_settings.legal_name.required
                    && !self.saleNonBuyerPayeeParams.individual.legal_name) {
                self.nonBuyerPayeeErrors.individual_legal_name = "Please Enter Name as in NRIC/Passport";
                valid = false;
            }

            // First Name
            if (self.nbp_pp_form_settings.first_name
                    && self.nbp_pp_form_settings.first_name.required
                    && !self.saleNonBuyerPayeeParams.individual.first_name) {
                self.nonBuyerPayeeErrors.individual_first_name = "Please Enter First Name of Buyer";
                valid = false;
            }

            // Last Name(Surname)
            if (self.nbp_pp_form_settings.last_name
                    && self.nbp_pp_form_settings.last_name.required
                    && !self.saleNonBuyerPayeeParams.individual.last_name) {
                self.nonBuyerPayeeErrors.individual_last_name = "Please Enter Last Name of Buyer";
                valid = false;
            }

            // Industry
            if (self.nbp_pp_form_settings.industry
                    && self.nbp_pp_form_settings.industry.required) {
                if (!self.saleNonBuyerPayeeParams.individual.industry) {
                    self.nonBuyerPayeeErrors.individual_industry = "Please Select Type of Industry";
                    valid = false;
                } else if (self.saleNonBuyerPayeeParams.individual.industry === "OTHERS"
                        && !self.saleNonBuyerPayeeParams.individual.industry_other) {
                    self.nonBuyerPayeeErrors.individual_industry_other = "Please Specify Other Industry";
                    valid = false;
                }
            }

            // Occupation
            if (self.nbp_pp_form_settings.occupation
                    && self.nbp_pp_form_settings.occupation.required) {
                if (!self.saleNonBuyerPayeeParams.individual.occupation) {
                    self.nonBuyerPayeeErrors.individual_occupation = "Please Select Individual Occupation";
                    valid = false;
                } else if (self.saleNonBuyerPayeeParams.individual.occupation === "OTHERS"
                        && !self.saleNonBuyerPayeeParams.individual.occupation_other) {
                    self.nonBuyerPayeeErrors.individual_occupation_other = "Please Specify Other Occupation";
                    valid = false;
                }
            }

            // Gender
            if (self.nbp_pp_form_settings.gender
                    && self.nbp_pp_form_settings.gender.required
                    && (self.saleNonBuyerPayeeParams.individual.gender === null
                    || self.saleNonBuyerPayeeParams.individual.gender === undefined)) {
                self.nonBuyerPayeeErrors.individual_gender = "Please Select Gender";
                valid = false;
            }

            if(self.nbp_pp_form_settings.identity_type
                    && self.nbp_pp_form_settings.identity_type.required) {
                // Identity Type
                if (!self.saleNonBuyerPayeeParams.individual.identity_type) {
                    self.nonBuyerPayeeErrors.individual_identity_type = "Please Select Identity Type";
                    valid = false;
                } else {
                    if (self.saleNonBuyerPayeeParams.individual.identity_type === SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        // Passport No
                        if (self.nbp_pp_form_settings.passport_no
                            && self.nbp_pp_form_settings.passport_no.required
                            && !self.saleNonBuyerPayeeParams.individual.passport_no) {
                            self.nonBuyerPayeeErrors.individual_passport_no = "Please Enter Passport";
                            valid = false;
                        }
                        // Foreigner National ID
                        if (self.nbp_pp_form_settings.foreigner_national_id
                            && self.nbp_pp_form_settings.foreigner_national_id.required
                            && !self.saleNonBuyerPayeeParams.individual.foreigner_national_id) {
                            self.nonBuyerPayeeErrors.individual_foreigner_national_id = "Please Enter Foreigner National ID";
                            valid = false;
                        }
                        // Passport Issued By
                        if (self.nbp_pp_form_settings.passport_issued_by
                            && self.nbp_pp_form_settings.passport_issued_by.required
                            && !self.saleNonBuyerPayeeParams.individual.passport_issued_by) {
                            self.nonBuyerPayeeErrors.individual_passport_issued_by = "Please Enter Passport Issued By";
                            valid = false;
                        }
                        // Passport Issued Date
                        if (self.nbp_pp_form_settings.passport_issued_date
                            && self.nbp_pp_form_settings.passport_issued_date.required
                            && !self.saleNonBuyerPayeeParams.individual.passport_issued_date) {
                            self.nonBuyerPayeeErrors.individual_passport_issued_date = "Please Select Passport Issued Date";
                            valid = false;
                        }
                        // Passport Expiry Date
                        if (self.nbp_pp_form_settings.passport_expiry_date
                            && self.nbp_pp_form_settings.passport_expiry_date.required
                            && !self.saleNonBuyerPayeeParams.individual.passport_expiry_date) {
                            self.nonBuyerPayeeErrors.individual_passport_expiry_date = "Please Select Passport Expiry Date";
                            valid = false;
                        }
                    } else if (self.saleNonBuyerPayeeParams.individual.identity_type !== SHOWSUITE.IDENTITY_TYPE_FOREIGNER) {
                        // NRIC
                        if (self.nbp_pp_form_settings.national_id
                            && self.nbp_pp_form_settings.national_id.required) {
                            if (!self.saleNonBuyerPayeeParams.individual.national_id) {
                                self.nonBuyerPayeeErrors.individual_national_id = "Please Enter NRIC";
                                valid = false;
                            } else if (!self.SSUtilService.isValidNRIC(self.saleNonBuyerPayeeParams.individual.national_id, self.PROJECT_COUNTRY)) {
                                self.nonBuyerPayeeErrors.individual_national_id = "Please Enter a valid NRIC";
                                valid = false;
                            }
                        }
                    }
                }
            }

            // Nationality
            if (self.nbp_pp_form_settings.nationality
                    && self.nbp_pp_form_settings.nationality.required
                    && (self.saleNonBuyerPayeeParams.individual.nationality === null || self.saleNonBuyerPayeeParams.individual.nationality === undefined)) {
                self.nonBuyerPayeeErrors.individual_nationality = "Please Select Nationality";
                valid = false;
            }

            // Country Of Birth
            if (self.nbp_pp_form_settings.country_of_origin
                    && self.nbp_pp_form_settings.country_of_origin.required
                    && (self.saleNonBuyerPayeeParams.individual.country_of_origin === null || self.saleNonBuyerPayeeParams.individual.country_of_origin === undefined)) {
                self.nonBuyerPayeeErrors.individual_country_of_origin = "Please Select Country of Origin";
                valid = false;
            }

            // Date of Birth
            if(self.nbp_pp_form_settings.dob
                    && self.nbp_pp_form_settings.dob.required){
                if (!self.saleNonBuyerPayeeParams.individual.dob) {
                    self.nonBuyerPayeeErrors.individual_dob = "Please Enter Date of Birth";
                    valid = false;
                } else if (moment().diff(moment(self.saleNonBuyerPayeeParams.individual.dob, "DD/MM/YYYY")) < 0) {
                    self.nonBuyerPayeeErrors.individual_dob = "The date of birth cannot be a future date";
                    valid = false;
                } else if (self.SSEoiService.min_age_to_purchase && self.editingIndex == 0) {
                    if (moment().diff(moment(self.saleNonBuyerPayeeParams.individual.dob, "DD/MM/YYYY"), 'years') < self.SSEoiService.min_age_to_purchase) {
                        self.nonBuyerPayeeErrors.individual_dob = "Buyer does not meet the minimum age limit (" + self.SSEoiService.min_age_to_purchase + ") required to purchase this property.";
                        valid = false;
                    }
                }
            }

            // Email
            if(self.nbp_pp_form_settings.email
                    && self.nbp_pp_form_settings.email.required
                    && (!self.saleNonBuyerPayeeParams.email_contact || !self.saleNonBuyerPayeeParams.email_contact.value)){
                self.nonBuyerPayeeErrors.email_contact_value = "Please enter Email";
                valid = false;
            }

            // Mobile Number
            if (self.nbp_pp_form_settings.phone1
                    && self.nbp_pp_form_settings.phone1.required
                    && (!self.saleNonBuyerPayeeParams.phone1_contact || !self.saleNonBuyerPayeeParams.phone1_contact.value)) {
                self.nonBuyerPayeeErrors.phone1_contact_value = "Please Enter Mobile Number";
                valid = false;
            }

            // Contact Number
            if (self.nbp_pp_form_settings.phon2
                    && self.nbp_pp_form_settings.phon2.required
                    && (!self.saleNonBuyerPayeeParams.phone2_contact ||!self.saleNonBuyerPayeeParams.phone2_contact.value)) {
                self.nonBuyerPayeeErrors.phone2_contact_value = "Please Enter Secondary Contact Number";
                valid = false;
            }

            // Relationship with Buyer 1
            if (!self.saleNonBuyerPayeeParams.buyer_company_id
                    && self.nbp_pp_form_settings.relationship_with_buyer_1
                    && self.nbp_pp_form_settings.relationship_with_buyer_1.required) {
                if(!self.saleNonBuyerPayeeParams.individual.relationship){
                    self.nonBuyerPayeeErrors.individual_relationship = "Please select Relationship with Buyer 1";
                    valid = false;
                }else if(self.saleNonBuyerPayeeParams.individual.relationship === "Others"
                    && !self.saleNonBuyerPayeeParams.individual.relationship_other){
                    self.nonBuyerPayeeErrors.individual_relationship_other = "Please Enter Relationship with Buyer 1";
                    valid = false;
                }
            }

            /** Address Validation **/
            if (valid && !self.saleNonBuyerPayeeParams.buyer_company_id){
                valid = self.isValidNonBuyerPayeeAddress();
            }
        }

        return valid;
    }

    isValidNonBuyerPayeeAddress(){
        const self = this;

        let valid = true;

        // If settings not found return true
        if (!self.nbp_pp_form_settings){
            console.log("Error, 3rd Party Payor fields validation settings missing");
            return  true;
        }

        if (!self.saleNonBuyerPayeeParams || !self.saleNonBuyerPayeeParams.primary_address){
            if (self.nbp_pp_form_settings.primary_address_country && self.nbp_pp_form_settings.primary_address_country.required) {
                self.nonBuyerPayeeErrors.primary_address_country = "Please select Country";
                valid = false;
            }
            if(self.nbp_pp_form_settings.primary_address_postcode && self.nbp_pp_form_settings.primary_address_postcode.required){
                self.nonBuyerPayeeErrors.primary_address_postcode = "Please Enter Postal Code";
                valid = false;
            }
            if (self.nbp_pp_form_settings.primary_address_line1 && self.nbp_pp_form_settings.primary_address_line1.required) {
                self.nonBuyerPayeeErrors.primary_address_line1 = "please enter House/Block";
                valid = false;
            }
            if (self.nbp_pp_form_settings.primary_address_line2 && self.nbp_pp_form_settings.primary_address_line2.required) {
                self.nonBuyerPayeeErrors.primary_address_line2 = "please enter Street Name";
                valid = false;
            }
            if (self.nbp_pp_form_settings.primary_address_unit_no && self.nbp_pp_form_settings.primary_address_unit_no.required) {
                self.nonBuyerPayeeErrors.primary_address_unit_no = "Please Enter Unit#";
                valid = false;
            }
            if (self.nbp_pp_form_settings.primary_address_city && self.nbp_pp_form_settings.primary_address_city.required) {
                self.nonBuyerPayeeErrors.primary_address_city = "please enter City";
                valid = false;
            }
        }

        // Country
        if (self.nbp_pp_form_settings.primary_address_country
                && self.nbp_pp_form_settings.primary_address_country.required
                && !self.saleNonBuyerPayeeParams.primary_address.country) {
            self.nonBuyerPayeeErrors.primary_address_country = "Please select Country";
            valid = false;
        }

        // Postal Code
        if(self.nbp_pp_form_settings.primary_address_postcode
                && self.nbp_pp_form_settings.primary_address_postcode.required
                && !self.SSUtilService.isValidPostcode(self.saleNonBuyerPayeeParams.primary_address.postcode, self.saleNonBuyerPayeeParams.primary_address.country)){
            self.nonBuyerPayeeErrors.primary_address_postcode = self.SSUtilService.getPostCodeValidationMsg(self.saleNonBuyerPayeeParams.primary_address.postcode, self.saleNonBuyerPayeeParams.primary_address.country);
            valid = false;
        }

        // House/Block
        if (self.nbp_pp_form_settings.primary_address_line1
                && self.nbp_pp_form_settings.primary_address_line1.required
                && !self.saleNonBuyerPayeeParams.primary_address.line1) {
            self.nonBuyerPayeeErrors.primary_address_line1 = "please enter House/Block";
            valid = false;
        }

        // Street Name
        if (self.nbp_pp_form_settings.primary_address_line2
                && self.nbp_pp_form_settings.primary_address_line2.required
                && !self.saleNonBuyerPayeeParams.primary_address.line2) {
            self.nonBuyerPayeeErrors.primary_address_line2 = "please enter Street Name";
            valid = false;
        }

        // Unit Door
        if (self.nbp_pp_form_settings.primary_address_unit_no
                && self.nbp_pp_form_settings.primary_address_unit_no.required
                && !self.saleNonBuyerPayeeParams.primary_address.unit_no
                && !self.saleNonBuyerPayeeParams.primary_address.residence_type ) {
            self.nonBuyerPayeeErrors.primary_address_unit_no = "please enter Unit No.";
            valid = false;
        }

        // City
        if (self.nbp_pp_form_settings.primary_address_city
                && self.nbp_pp_form_settings.primary_address_city.required
                && !self.saleNonBuyerPayeeParams.primary_address.city) {
            self.nonBuyerPayeeErrors.primary_address_city = "please enter City";
            valid = false;
        }

        return valid;
    }

    isValidWitnessInput() {
        const self = this;

        let isValid = true;

        self.profileErrors = {};

        if (!self.witnessParams.type) {
            self.profileErrors.Type = "Please select a buyer type.";
            isValid = false;
        }

        if (self.witnessParams.type == self.BUYER_TYPE_INDIVIDUAL) {

            if (!self.witnessParams.individual.title) {
                self.profileErrors.Title = "The individual Title field is required.";
                isValid = false;
            }
            if (!self.witnessParams.individual.legal_name) {
                self.profileErrors.LegalName = "The individual legal name field is required.";
                isValid = false;
            }
            if (!self.witnessParams.individual.first_name) {
                self.profileErrors.FirstName = "The individual first name field is required.";
                isValid = false;
            }
            if (!self.witnessParams.individual.last_name) {
                self.profileErrors.LastName = "The individual last name field is required.";
                isValid = false;
            }
            if (!self.witnessParams.individual.identity_type) {
                self.profileErrors.IdentityType = "The individual identity type field is required.";
                isValid = false;
            } else {
                if (self.witnessParams.individual.identity_type == 'FOREIGNER'
                    || self.witnessParams.individual.identity_type == 'foreigner') {
                    if (!self.witnessParams.individual.passport_no &&
                            self.pp_form_witness_settings.passport_no.required) {
                        self.profileErrors.Passport = "The passport field is required.";
                        isValid = false;
                    }
                    if (!self.witnessParams.individual.foreigner_national_id) {
                        self.profileErrors.ForeignerNationalId = "The Foreigner National ID field is required.";
                        isValid = false;
                    }
                } else {
                    if (!self.witnessParams.individual.national_id){
                        if(self.pp_form_witness_settings.national_id.required) {
                            self.profileErrors.Nric = "The NRIC field is required.";
                            isValid = false;
                        }
                    } else if(!self.SSUtilService.isValidNRIC(self.witnessParams.individual.national_id, self.PROJECT_COUNTRY)){
                        self.profileErrors.Nric = "Please Enter a valid NRIC";
                        isValid = false;
                    }
                }
            }
            // if(!self.witnessParams.individual.industry){
            //     self.profileErrors.Industry = "The Industry field is required.";
            //     isValid = false;
            // }
            // if(!self.witnessParams.individual.occupation){
            //     self.profileErrors.Occupation = "The Occupation field is required.";
            //     isValid = false;
            // }else{
            //     if(self.witnessParams.individual.occupation == "OTHERS" && !self.witnessParams.individual.occupation_other){
            //         self.profileErrors.OccupationOther = "The other Occupation field is required";
            //         isValid = false;
            //     }
            // }
            if (!self.witnessParams.individual.nationality) {
                self.profileErrors.Nationality = "The nationality field is required.";
                isValid = false;
            }
            if(!self.witnessParams.individual.dob){
                self.profileErrors.DateOfBirth = "The Date of Birth field is required";
                isValid = false;
            }
            if(self.witnessParams.individual.email_contact && !self.witnessParams.individual.email_contact.value){
                self.profileErrors.Email = "The Email field is required";
                isValid = false;
            }
            if(self.witnessParams.individual.phone1_contact && !self.witnessParams.individual.phone1_contact.value){
                self.profileErrors.PrimaryContactNumber = "The Primary Contact field is required";
                isValid = false;
            }
            if(!self.witnessParams.individual.relationship){
                self.profileErrors.Relationship = "The Relationship with buyer 1 is required";
                isValid = false;
            }
            // if(!self.witnessParams.primary_address){
            //     self.errPrimaryAddress = "The Primary Address is required";
            //     // isValid = false;
            // }
            // else{
            //     if(!self.witnessParams.primary_address.line1){
            //         self.profileErrors.PrimaryAddressLine1 = "The Primary Address Line 1 is required";
            //         isValid = false;
            //     }
            //     if(!self.witnessParams.primary_address.postcode){
            //         self.profileErrors.PrimaryAddressPostCode = "The Primary Address Post Code is required";
            //         isValid = false;
            //     }
            //     if(!self.witnessParams.primary_address.country){
            //         self.profileErrors.PrimaryAddressCountry = "The Primary Address Country is required";
            //         isValid = false;
            //     }
            // }
            if(self.witnessParams.primary_address){
                if (!self.SSUtilService.isValidPostcode(self.witnessParams.primary_address.postcode, self.witnessParams.primary_address.country)) {
                    self.profileErrors.PrimaryAddressPostCode = self.SSUtilService.getPostCodeValidationMsg(self.witnessParams.primary_address.postcode, self.witnessParams.primary_address.country);
                    isValid = false;
                }
            }
        }

        if (isValid && !self.witnessParams.email_contact.value && !self.witnessParams.phone1_contact.value) {
            //Pop up to display error
            self.displayEmailOrPhoneRequiredModal();
            isValid = false;
        }

        return isValid;
    }

    isValidOccupierInput(OccupierObject) {
        const self = this;

        let isValid = true;

        // Initialize empty objects to validate respective field(s)
        self.initValidateParams();

        if (!OccupierObject.data.individual.legal_name) {
            self.errOccLegalName = "The legal name field is required.";
            isValid = false;
        }
        if (!OccupierObject.data.individual.first_name) {
            self.errOccFirstName = "The first name field is required.";
            isValid = false;
        }
        if (!OccupierObject.data.individual.last_name) {
            self.errOccLastName = "The last name field is required.";
            isValid = false;
        }
        if (!OccupierObject.data.individual.identity_type) {
            self.errOccIdentityType = "The identity type field is required.";
            isValid = false;
        } else {
            if (OccupierObject.data.individual.identity_type == 'FOREIGNER'
                || OccupierObject.data.individual.identity_type == 'foreigner') {
                if (!OccupierObject.data.individual.passport_no) {
                    self.errOccPassport = "The passport field is required.";
                    isValid = false;
                }
            } else {
                if (!OccupierObject.data.individual.national_id) {
                    self.errOccNric = "The NRIC field is required.";
                    isValid = false;
                }
            }
        }
        if (!OccupierObject.data.individual.nationality) {
            self.errOccNationality = "The nationality field is required.";
            isValid = false;
        }
        if(!OccupierObject.data.individual.dob){
            self.errOccDateOfBirth = "The Date of Birth field is required";
            isValid = false;
        }
        // if(OccupierObject.data.phone1_contact && !OccupierObject.data.phone1_contact.value){
        //     self.errOccPrimaryContactNumber = "The Primary Contact field is required";
        //     isValid = false;
        // }
        if (!OccupierObject.data.email_contact.value && !OccupierObject.data.phone1_contact.value) {
            //Pop up to display error
            self.displayEmailOrPhoneRequiredModal();
            isValid = false;
        }

        return isValid;
    }

    initValidateParams() {
        const self = this;

        // Initialize empty objects to validate respective field(s)
        if (!self.subSaleBuyerParams) {
            self.subSaleBuyerParams = {};
        }
        if (!self.subSaleBuyerParams.data) {
            self.subSaleBuyerParams.data = {};
        }
        if (!self.subSaleBuyerParams.data.individual) {
            self.subSaleBuyerParams.data.individual = {};
        }
        if (!self.subSaleBuyerParams.data.company) {
            self.subSaleBuyerParams.data.company = {};
        }
        if (!self.subSaleBuyerParams.data.email_contact) {
            self.subSaleBuyerParams.data.email_contact = {};
        }
        if (!self.subSaleBuyerParams.data.phone1_contact) {
            self.subSaleBuyerParams.data.phone1_contact = {};
        }
        if (!self.subSaleBuyerParams.data.lawyers) {
            self.subSaleBuyerParams.data.lawyers = [];
        }
    }

    initValidateNonBuyerPayeeParams() {
        const self = this;

        // Initialize empty objects to validate respective field(s)
        self.saleNonBuyerPayeeParams = self.saleNonBuyerPayeeParams || {};
        self.saleNonBuyerPayeeParams.individual = self.saleNonBuyerPayeeParams.individual || {};
        self.saleNonBuyerPayeeParams.company = self.saleNonBuyerPayeeParams.company || {};
        self.saleNonBuyerPayeeParams.email_contact = self.saleNonBuyerPayeeParams.email_contact ||  {};
        self.saleNonBuyerPayeeParams.phone1_contact = self.saleNonBuyerPayeeParams.phone1_contact || {};
        self.saleNonBuyerPayeeParams.phone2_contact = self.saleNonBuyerPayeeParams.phone2_contact || {};
    }

    displayEmailOrPhoneRequiredModal() {
        const self = this;

        self.hideModals();

        self.email_phone_modal = true;
        $('#email_phone_modal').modal('show');
    }

    // EDIT LAWYER INSTRUCTIONS: WEB-921
    editLawyerInstructions(editMode) {
        const self = this;

        $('#requested_spa_issue_date').datepicker({dateFormat: 'dd/mm/yy'});

        self.lawyerInstructionsEditMode = editMode;

        self.editSaleParams = {};
        self.editSaleErrors = {};

        if (self.lawyerInstructionsEditMode) {
            self.editSaleParams = self.getEditSaleParams();
        }
    }

    saveLawyerInstructions() {
        const self = this;

        let params = angular.copy(self.editSaleParams);
        params.requested_spa_issue_date = self.SSDateService.formateWithTimeAsNoon(params.requested_spa_issue_date);

        loading(true);
        self.saveSaleParams(params, function (response) {
            loading(false);

            self.SSAlertService.success('Success!', 'Sale updated successfully.');
            angular.merge(self.sale_sales, self.editSaleParams);

            self.editLawyerInstructions(false);
        });
    }

    saveSaleParams(saleParams, callback) {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {

            let url = 'sec/developer/sales/' + self.sale_sales.id + '/update-sale-fields';

            saleParams.is_management_sale = saleParams.is_management_sale ? 1 : 0;

            loading(true);
            self.SSHttpService.putAPIRequest(url, saleParams).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if (callback) {
                    callback();
                }
            });
        });
    }

    getEditSaleParams() {
        const self = this;

        let params = {
            purchase_mode: self.sale_sales.purchase_mode,
            order_no: self.sale_sales.order_no,
            staff_id: self.sale_sales.staff_id,
            tele_sales_no: self.sale_sales.tele_sales_no,

            referral_type: self.sale_sales.referral_type,
            referral_name: self.sale_sales.referral_name,
            referral_code: self.sale_sales.referral_code,

            remarks_for_lawyer: self.sale_sales.remarks_for_lawyer,
            requested_spa_issue_date: self.sale_sales.requested_spa_issue_date,

            is_management_sale: self.sale_sales.is_management_sale == 1 ? true : false
        };

        return params;
    }

    // EDIT AGENCY NAME
    editAgencyName(editMode) {
        const self = this;

        self.saleAgencyParams = {};
        self.saleAgencyErrors = {};

        if(self.sale_sales && self.sale_sales.agency_id){
            self.saleAgencyParams.agency_id = self.sale_sales.agency_id;
        }

        self.saleAgencyEditMode = editMode;
    }

    updateAgency() {
        const self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            self._updateAgency();
        });
    }

    _updateAgency() {
        const self = this;

        self.saleAgencyErrors = {};

        if (!self.saleAgencyParams.agency_id) {
            self.saleAgencyErrors.agency_id = "Please select agency to proceed.";
            return;
        }

        let url = 'sec/developer/sales/' + self.sale_sales.id + '/update-sale-agency';

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.saleAgencyParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Agency updated successfully.');

            if(response.data && response.data.sale){
                self.sale_sales.agency_id = response.data.sale.agency_id;
                self.sale_sales.agency_name = self.getAgencyName(response.data.sale.agency_id);
            }

            self.editAgencyName(false);
        });
    }

    getAgencyName(agency_id){
        const self = this;

        if(!agency_id){
            return;
        }

        let agency_name = "--";

        if(self.availableAgencies){
            let agency = self.availableAgencies.find(x => x.id == agency_id);
            if(agency){
                agency_name = agency.name;
            }
        }

        return agency_name;
    }

    // SALE COMMISSION & INCENTIVES
    editSaleAgency(editMode) {
        const self = this;

        self.saleCommissionsEditMode = editMode;

        self.saleCommissionsParams = {};
        self.saleCommissionsErrors = {};

        if (self.saleCommissionsEditMode) {
            self.saleCommissionsParams = {
                id: self.sale_sales.id,
                agency_commission_value: self.sale_sales.agency_commission_value,
                agency_commission_type: self.sale_sales.agency_commission_type,
                agency_commission_gst_inclusive: self.sale_sales.agency_commission_gst_inclusive == 1 ? true : false,
                broker_incentives_value: self.sale_sales.broker_incentives_value,
                broker_incentives_type: self.sale_sales.broker_incentives_type,
                broker_incentives_gst_inclusive: self.sale_sales.broker_incentives_gst_inclusive == 1 ? true : false,
                // WEB-3544: per-sale GST rate (sale.gst_value). Pre-fill the current
                // rate so the developer can view/correct it; it is sent on save and the
                // commission Amount/GST/Total display (PR #330) recomputes from it.
                gst_value: self.sale_sales.gst_value,
            };
        }
    }

    saveSaleAgency() {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA, function (data) {
                self._saveSaleAgency();
            });
    }

    _saveSaleAgency() {
        const self = this;

        if (self.saleCommissionsParams.agency_commission_value) {
            if (!self.saleCommissionsParams.agency_commission_type) {
                self.SSAlertService.warning('Missing Params!', 'Please select agency commission type.');
                return;
            }
        }

        if (self.saleCommissionsParams.broker_incentives_value) {
            if (!self.saleCommissionsParams.broker_incentives_type) {
                self.SSAlertService.warning('Missing Params!', 'Please select agent incentive type.');
                return;
            }
        }

        self.saleCommissionsParams.agency_commission_gst_inclusive = self.saleCommissionsParams.agency_commission_gst_inclusive ? 1 : 0
        self.saleCommissionsParams.broker_incentives_gst_inclusive = self.saleCommissionsParams.broker_incentives_gst_inclusive ? 1 : 0

        let url = 'sec/developer/sales/' + self.sale_sales.id + '/updateAgencyCommission';

        self.saleCommissionsErrors = {};

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.saleCommissionsParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                self.saleCommissionsErrors = self.SSHttpService.parseErrors(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Agency Commission updated successfully.');

            angular.merge(self.sale_sales, self.saleCommissionsParams);

            self.editSaleAgency(false);
        });
    }

    formatCommissionValue(type, value, gst_inclusive) {
        const self = this;

        if (value == null)
            return '--';

        let _value = '';

        if (type == 10) {
            _value = self.SSUtilService.formatPercentage(value);
        } else if (type == 20) {
            _value = self.SSUtilService.formatCurrency(value);
        }

        _value += ' (' + (gst_inclusive ? 'With' : 'Without') + ' GST)';

        return _value;
    }

    // Returns the GST amount for the agency commission.
    // The agency commission amount is not persisted — only the type (% or $),
    // the value and the GST-inclusive flag are stored on the sale. The amount,
    // GST and total are therefore derived here from the sale price and the
    // project GST rate (sale.gst_value), so the figures stay consistent across
    // screens and the GST is no longer shown as "S$ 0" for inclusive commissions.

    // Raw commission before any GST handling: price * % for percentage commissions,
    // or the entered $ value for fixed-amount commissions.
    getAgencyCommissionRawAmount() {
        const self = this;

        if (!self.sale_sales || self.sale_sales.agency_commission_value == null) {
            return 0;
        }

        let value = parseFloat(self.sale_sales.agency_commission_value) || 0;

        if (self.sale_sales.agency_commission_type == self.VALUE_TYPE_PERCENTAGE) {
            return (parseFloat(self.sale_sales.price) || 0) * value / 100;
        }

        // VALUE_TYPE_AMOUNT
        return value;
    }

    // GST-exclusive agency commission amount.
    getAgencyCommissionAmount() {
        const self = this;

        let raw = self.getAgencyCommissionRawAmount();

        // When the commission is GST-inclusive the raw amount already contains
        // the GST, so strip it out to get the exclusive amount.
        if (self.sale_sales && self.sale_sales.agency_commission_gst_inclusive == 1) {
            let gst = parseFloat(self.sale_sales.gst_value) || 0;
            return raw / (1 + gst / 100);
        }

        // GST-exclusive commission: the raw amount is already the exclusive amount.
        return raw;
    }

    // GST portion of the agency commission.
    getAgencyCommissionGst() {
        const self = this;

        if (self.sale_sales && self.sale_sales.agency_commission_gst_inclusive == 1) {
            // Inclusive: GST = raw (gross) - exclusive amount.
            return self.getAgencyCommissionRawAmount() - self.getAgencyCommissionAmount();
        }

        // Exclusive: GST is added on top of the exclusive amount.
        let gst = parseFloat(self.sale_sales && self.sale_sales.gst_value) || 0;
        return self.getAgencyCommissionAmount() * gst / 100;
    }

    // Total payable agency commission (exclusive amount + GST).
    getAgencyCommissionTotal() {
        const self = this;
        return self.getAgencyCommissionAmount() + self.getAgencyCommissionGst();
    }

    // Sale Buyers
    selectSaleBuyer(saleBuyer) {
        const self = this;

        self.buyerErrors = {};

        if(!saleBuyer){
            return;
        }

        if (saleBuyer.data && typeof (saleBuyer.data) == 'string') {
            try {
                saleBuyer.data = JSON.parse(saleBuyer.data);
            } catch (ex) {
                saleBuyer.data = {};
                self.SSAlertService.warning('Unable to parse buyer data.');
            }
        }

        self.mapBuyerDocuments(saleBuyer);

        self.saleBuyerEditMode = false;
        self.saleBuyerParams = null;
        self.selectedSaleBuyer = saleBuyer;
    }

    selectSaleNonBuyerPayee(saleNonBuyerPayee) {
        const self = this;

        if (!saleNonBuyerPayee){ return false; } // If selected 3rd Party Payor object null then skip

        self.mapNonBuyerPayeeDocuments(saleNonBuyerPayee);
        self.resetNonBuyerPayeeErrors();

        self.selectedSaleNonBuyerPayee = saleNonBuyerPayee;
        self.saleNonBuyerPayeeEditMode = false;
        self.saleNonBuyerPayeeParams = null;
    }

    selectWitness(witness) {
        const self = this;

        if(!witness){
            return;
        }

        if (witness.data && typeof (witness.data) == 'string') {
            try {
                witness.data = JSON.parse(witness.data);
            } catch (ex) {
                witness.data = {};
                self.SSAlertService.warning('Unable to parse witness data.');
            }
        }

        self.witnessEditMode = false;

        self.profileErrors = {};
        self.selectedwitness = witness;
    }

    //sale Occupier
    selectSaleOccupier(saleOccupier) {
        const self = this;

        if(!saleOccupier){
            return;
        }

        if (saleOccupier.data && typeof (saleOccupier.data) == 'string') {
            try {
                saleOccupier.data = JSON.parse(saleOccupier.data);
            } catch (ex) {
                saleOccupier.data = {};
                self.SSAlertService.warning('Unable to parse occupier data.');
            }
        }
        self.saleOccupierEditMode = false;
        self.saleOccupierParams = null;
        self.selectedSaleOccupier = saleOccupier;
    }

    mapBuyerDocuments(saleBuyer){
        const self = this;

        if(saleBuyer && !(self.sale_sales && self.sale_sales.documents)){
            self.timeout_promise = self.$timeout(function() {
                self.mapBuyerDocuments(saleBuyer);
            });
        }

        if(!self.sale_sales.documents){
            return;
        }

        if (self.timeout_promise) {
            self.$timeout.cancel(self.timeout_promise);
        }

        if(!saleBuyer){
            saleBuyer = (self.sale_sales.sale_buyers && self.sale_sales.sale_buyers.length > 0)? self.sale_sales.sale_buyers[0] : null;
        }

        // Map buyer documents (NRIC/Passport) from sale_documents
        if(saleBuyer){
            $.each(self.sale_sales.documents, function(index, document){
                if(document.sale_buyer_id == saleBuyer.id){
                    if(document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_BACK
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_PASSPORT
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION){

                        if(!saleBuyer.hasOwnProperty('documents')){
                            saleBuyer['documents'] = {};
                        }

                        // To retrieve preview image
                        if (document.file_uri && document.id) {
                            self.getPresignedUrl(
                                self.ASSET_MODEL_SALE_DOCUMENT,
                                document.id,
                                function (presignedUrl) {
                                    saleBuyer.documents[document.document_kind] = document;
                                    saleBuyer.documents[document.document_kind]["show_file_url"] = presignedUrl;
                                }
                            );
                        }
                    }
                }
            });
        } else {
            console.warn("Sale buyer not found while mapping documents")
        }
    }

    mapNonBuyerPayeeDocuments(saleNonBuyerPayee){
        const self = this;

        if(!saleNonBuyerPayee){
            saleNonBuyerPayee = (self.sale_sales.sale_non_buyer_payees && self.sale_sales.sale_non_buyer_payees.length > 0)? self.sale_sales.sale_non_buyer_payees[0] : null;
        }

        // Map buyer documents (NRIC/Passport) from sale_documents
        $.each(saleNonBuyerPayee.sale_documents, function(index, document){
            if(!saleNonBuyerPayee.hasOwnProperty('sale_documents')){
                saleNonBuyerPayee['sale_documents'] = {};
            }

            // To retrieve preview image
            if (document && document.file_uri && document.id) {
                self.getPresignedUrl(
                    self.ASSET_MODEL_SALE_DOCUMENT,
                    document.id,
                    function (presignedUrl) {
                        saleNonBuyerPayee.sale_documents[document.document_kind] = document;
                        saleNonBuyerPayee.sale_documents[document.document_kind]["show_file_url"] = presignedUrl;
                    }
                );
            }
        });
    }

    editSaleNonBuyerPayee(editMode) {
        const self = this;

        if (editMode) {
            self.saleNonBuyerPayeeParams = {};
            self.saleNonBuyerPayeeParams = angular.copy(self.selectedSaleNonBuyerPayee);

            self.saleNonBuyerPayeeParams.individual = self.saleNonBuyerPayeeParams.individual || {};
            self.saleNonBuyerPayeeParams.company = self.saleNonBuyerPayeeParams.company || {};
            self.saleNonBuyerPayeeParams.email_contact = self.saleNonBuyerPayeeParams.email_contact || {};
            self.saleNonBuyerPayeeParams.phone1_contact = self.saleNonBuyerPayeeParams.phone1_contact || {};
            self.saleNonBuyerPayeeParams.phone2_contact = self.saleNonBuyerPayeeParams.phone2_contact || {};
            self.saleNonBuyerPayeeParams.primary_address = self.saleNonBuyerPayeeParams.primary_address || {};
            self.saleNonBuyerPayeeParams.lawyers = self.saleNonBuyerPayeeParams.lawyers || [];

            if(self.saleNonBuyerPayeeParams.individual){
                if (self.saleNonBuyerPayeeParams.individual.title && typeof self.saleNonBuyerPayeeParams.individual.title !== 'string') {
                    self.saleNonBuyerPayeeParams.individual.title = self.SSConfigService.getSalutationName(parseInt(self.saleNonBuyerPayeeParams.individual.title));
                }
                if (self.saleNonBuyerPayeeParams.individual.dob) {
                    self.saleNonBuyerPayeeParams.individual.dob = self.SSUtilService.formatUtcToLocalDate(self.saleNonBuyerPayeeParams.individual.dob);
                }
                if (self.saleNonBuyerPayeeParams.individual.passport_issued_date) {
                    self.saleNonBuyerPayeeParams.individual.passport_issued_date = self.SSUtilService.formatUtcToLocalDate(self.saleNonBuyerPayeeParams.individual.passport_issued_date);
                }
                if (self.saleNonBuyerPayeeParams.individual.passport_expiry_date) {
                    self.saleNonBuyerPayeeParams.individual.passport_expiry_date = self.SSUtilService.formatUtcToLocalDate(self.saleNonBuyerPayeeParams.individual.passport_expiry_date);
                }

                if(!!self.saleNonBuyerPayeeParams.individual.industry && self.saleNonBuyerPayeeParams.individual.industry !== ""){
                    self.saleNonBuyerPayeeParams.individual.industry = self.saleNonBuyerPayeeParams.individual.industry.toUpperCase();
                    if(self.saleNonBuyerPayeeParams.individual.industry === "OTHERS"){
                        self.saleNonBuyerPayeeParams.individual.occupation_other = self.saleNonBuyerPayeeParams.individual.occupation;
                        self.saleNonBuyerPayeeParams.individual.occupation = "OTHERS";
                    } else{
                        let EoiOccupation = false;
                        if (self.SSEoiService.industry_occupation[self.saleNonBuyerPayeeParams.individual.industry]) {
                            jQuery.each(self.SSEoiService.industry_occupation[self.saleNonBuyerPayeeParams.individual.industry].occupation,function(index,occ){
                                if(occ.name === self.saleNonBuyerPayeeParams.individual.occupation){
                                    EoiOccupation = true;
                                }
                            });
                        }
                        if(!EoiOccupation){
                            if (!self.SSEoiService.industry_occupation[self.saleNonBuyerPayeeParams.individual.industry]) { // If occupations not found against industry
                                self.saleNonBuyerPayeeParams.individual.industry_other = self.saleNonBuyerPayeeParams.individual.industry;
                                self.saleNonBuyerPayeeParams.individual.industry = "OTHERS";
                            }

                            self.saleNonBuyerPayeeParams.individual.occupation_other = self.saleNonBuyerPayeeParams.individual.occupation;
                            self.saleNonBuyerPayeeParams.individual.occupation = "OTHERS";
                        }
                    }
                }

                // If editing signatory, set selected company
                if(self.saleNonBuyerPayeeParams.buyer_company_id){
                    self.saleNonBuyerPayeeParams.selected_buyer_company_id = self.saleNonBuyerPayeeParams.buyer_company_id;
                }
            }
        } else {
            self.saleNonBuyerPayeeParams = null;
            self.resetNonBuyerPayeeErrors();
        }

        self.saleNonBuyerPayeeEditMode = editMode;
        self.newNonBuyerPayeeMode = false;

        self.$timeout(function(){
            $("select.eoi-select").niceSelect('update');
            self.maskPhoneNumber(self, 'ctrl.', 'div_non_buyer_payees');

            jQuery('.datepicker').datepicker({
                // dateFormat: "yy-mm-dd",
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });
    }

    editSaleBuyer(editMode) {
        const self = this;

        self.buyerErrors = {};

        if (editMode) {

            self.saleBuyerParams = {};
            self.saleBuyerParams.id = angular.copy(self.selectedSaleBuyer.id);
            self.saleBuyerParams.data = angular.copy(self.selectedSaleBuyer.data);
            self.saleBuyerParams.order = angular.copy(self.selectedSaleBuyer.order);
            self.saleBuyerParams.updated_at = angular.copy(self.selectedSaleBuyer.updated_at);

            // if (!self.saleBuyerParams.data) {
            //     self.saleBuyerParams.data = {};
            // }
            self.saleBuyerParams.data.individual = self.saleBuyerParams.data.individual || {};
            self.saleBuyerParams.data.company = self.saleBuyerParams.data.company || {};
            self.saleBuyerParams.data.email_contact = self.saleBuyerParams.data.email_contact || {};
            self.saleBuyerParams.data.phone1_contact = self.saleBuyerParams.data.phone1_contact || {};
            self.saleBuyerParams.data.phone2_contact = self.saleBuyerParams.data.phone2_contact || {};
            self.saleBuyerParams.data.primary_address = self.saleBuyerParams.data.primary_address || {};
            self.saleBuyerParams.data.mailing_address = self.saleBuyerParams.data.mailing_address || {};
            self.saleBuyerParams.data.lawyers = self.saleBuyerParams.data.lawyers || [];

            if (self.saleBuyerParams.data.individual){
                if (self.saleBuyerParams.data.individual.title
                        && typeof self.saleBuyerParams.data.individual.title !== 'string'){
                    self.saleBuyerParams.data.individual.title = self.SSConfigService.getSalutationName(parseInt(self.saleBuyerParams.data.individual.title));
                }

                if (self.saleBuyerParams.data.individual.dob){
                    self.saleBuyerParams.data.individual.dob = self.SSUtilService.formatUtcToLocalDate(self.saleBuyerParams.data.individual.dob);
                }
                if (self.saleBuyerParams.data.individual.passport_issued_date){
                    self.saleBuyerParams.data.individual.passport_issued_date = self.SSUtilService.formatUtcToLocalDate(self.saleBuyerParams.data.individual.passport_issued_date);
                }
                if (self.saleBuyerParams.data.individual.passport_expiry_date){
                    self.saleBuyerParams.data.individual.passport_expiry_date = self.SSUtilService.formatUtcToLocalDate(self.saleBuyerParams.data.individual.passport_expiry_date);
                }

                if (self.saleBuyerParams.data.individual.industry){
                    self.saleBuyerParams.data.individual.industry = self.saleBuyerParams.data.individual.industry.toUpperCase();

                    if (self.saleBuyerParams.data.individual.industry === "OTHERS"){
                        self.saleBuyerParams.data.individual.occupation_other = self.saleBuyerParams.data.individual.occupation;
                        self.saleBuyerParams.data.individual.occupation = "OTHERS";
                    } else{
                        let EoiOccupation = false;
                        if (self.SSEoiService.industry_occupation[self.saleBuyerParams.data.individual.industry]){
                            jQuery.each(self.SSEoiService.industry_occupation[self.saleBuyerParams.data.individual.industry].occupation,function(index,occ){
                                if(occ.name === self.saleBuyerParams.data.individual.occupation){
                                    EoiOccupation = true;
                                }
                            });
                        }
                        if(!EoiOccupation){
                            if (!self.SSEoiService.industry_occupation[self.saleBuyerParams.data.individual.industry]) { // If occupations not found against industry
                                self.saleBuyerParams.data.individual.industry_other = self.saleBuyerParams.data.individual.industry;
                                self.saleBuyerParams.data.individual.industry = "OTHERS";
                            }

                            self.saleBuyerParams.data.individual.occupation_other = self.saleBuyerParams.data.individual.occupation;
                            self.saleBuyerParams.data.individual.occupation = "OTHERS";
                        }
                    }
                }

                let races = self.SSConfigService.getRaces(self.sale_property.type === self.PROPERTY_TYPE_EXECUTIVE_CONDO);
                if (races && races.length) {
                    // WEB-4518 main name + aliases, so a stored variant binds to the master-list race
                    const raceName = self.SSConfigService.resolveRaceName(self.saleBuyerParams.data.individual.race, races, { log: false });
                    if (raceName) {
                        self.saleBuyerParams.data.individual.race = raceName;
                    } else {
                        self.saleBuyerParams.data.individual.race_other = angular.copy(self.saleBuyerParams.data.individual.race);
                        self.saleBuyerParams.data.individual.race = "Other";
                    }
                }

                // If editing signatory, set selected company
                if(self.saleBuyerParams.data.buyer_company_id){
                    self.saleBuyerParams.data.selected_buyer_company_id = self.saleBuyerParams.data.buyer_company_id;
                }
            }

            // Initialize Lawyer Detail
            self.initEditLawyerDetail(self.saleBuyerParams.data, self.saleBuyerParams.data);

            self.$timeout(function () {
                $("select.dashboard-select#law-firm-name-select").niceSelect('update');
            });
        } else {
            self.saleBuyerParams = null;
            self.resetBuyerErrors();
        }

        self.saleBuyerEditMode = editMode;

        self.maskPhoneNumber(self, 'ctrl.', 'div_buyers');
        jQuery('.datepicker').datepicker({
            // dateFormat: "yy-mm-dd",
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:+0",
            dateFormat: "dd/mm/yy"
        });
    }

    editBuyerRepresentative(editMode){
        const self = this;

        self.representativeParams = {};
        self.representativeErrors = {};

        if (editMode) {

            self.representativeParams = angular.copy(self.representative);
            self.maskPhoneNumber(self, 'ctrl.', 'representativeContact');
        }

        self.representativeEditMode = editMode;
    }

    saveBuyerRepresentative(){
        const self = this;

        if(!self.isValidRepresentativeInput()) return;

        let url = "sec/developer/sales/"+ self.sale_id +"/sale-otp-representatives";
        let params = angular.copy(self.representativeParams);

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Buyer representative updated successfully.');

            if(response.data && response.data.sale_otp_representative){
                self.representative = response.data.sale_otp_representative
            }

            self.representativeEditMode = false;
        };

        loading(true);
        if (params.id) {
            url += '/' + params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    isValidRepresentativeInput(){
        const self = this;

        let isValid = true;
        self.representativeErrors = {};

        if(!self.representativeParams.legal_name){
            isValid = false;
            self.representativeErrors.legal_name = "Please enter legal name.";
        }
        if(!self.representativeParams.identity_no){
            isValid = false;
            self.representativeErrors.identity_no = "Please enter identity number.";
        }
        if(!self.representativeParams.phone){
            isValid = false;
            self.representativeErrors.phone = "Please enter contact number.";
        }
        if(!self.representativeParams.email){
            isValid = false;
            self.representativeErrors.email = "Please enter email address.";
        }

        return isValid;
    }


    deleteBuyerRepresentative(representative){
        const self = this;

        if(!representative || !self.sale_sales){
            return;
        }

        let url = 'sec/developer/sales/'+ self.sale_sales.id +'/sale-otp-representatives/'+ representative.id +'/delete';

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {
            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.representative = {};

                self.SSAlertService.success('Success!', 'Sale OTP representative deleted successfully.');
            });
        });
    }

    editSaleOccupier(editMode) {
        const self = this;

        if (editMode) {

            self.saleOccupierParams = {};
            self.saleOccupierParams.id = angular.copy(self.selectedSaleOccupier.id);
            self.saleOccupierParams.data = angular.copy(self.selectedSaleOccupier.data);

            if (!self.saleOccupierParams.data) {
                self.saleOccupierParams.data = {};
            }
            if (!self.saleOccupierParams.data.email_contact) {
                self.saleOccupierParams.data.email_contact = {};
            }
            if (!self.saleOccupierParams.data.phone1_contact) {
                self.saleOccupierParams.data.phone1_contact = {};
            }
            if (!self.saleOccupierParams.data.phone2_contact) {
                self.saleOccupierParams.data.phone2_contact = {};
            }

            if (self.saleOccupierParams.data && self.saleOccupierParams.data.individual.title) {
                if(typeof self.saleOccupierParams.data.individual.title === 'string')
                    self.saleOccupierParams.data.individual.title = self.saleOccupierParams.data.individual.title;
                else
                    self.saleOccupierParams.data.individual.title = self.SSConfigService.getSalutationName(parseInt(self.saleOccupierParams.data.individual.title));
            }
            if (self.saleOccupierParams.data && self.saleOccupierParams.data.individual.dob) {
                self.saleOccupierParams.data.individual.dob = self.SSUtilService.formatUtcToLocalDate(self.saleOccupierParams.data.individual.dob);
            }

            if(self.saleOccupierParams.data){
                if(!!self.saleOccupierParams.data.individual.industry && self.saleOccupierParams.data.individual.industry != ""){
                    self.saleOccupierParams.data.individual.industry = self.saleOccupierParams.data.individual.industry.toUpperCase();
                    if(self.saleOccupierParams.data.individual.industry == "OTHERS"){
                        self.saleOccupierParams.data.individual.occupation_other = self.saleOccupierParams.data.individual.occupation;
                        self.saleOccupierParams.data.individual.occupation = "OTHERS";
                    }
                    else{
                        let EoiOccupation = false;
                        jQuery.each(self.SSEoiService.industry_occupation[self.saleOccupierParams.data.individual.industry].occupation,function(index,occ){
                            if(occ.name === self.saleOccupierParams.data.individual.occupation){
                                EoiOccupation = true;
                            }
                        });
                        if(!EoiOccupation){
                            self.saleOccupierParams.data.individual.occupation_other = self.saleOccupierParams.data.individual.occupation;
                            self.saleOccupierParams.data.individual.occupation = "OTHERS";
                        }
                    }
                }
            }

            self.$timeout(function () {
                $("select.dashboard-select#law-firm-name-select").niceSelect('update');
            });
        } else {
            self.saleOccupierParams = null;
            self.resetOccupierErrors();
        }

        self.saleOccupierEditMode = editMode;

        self.maskPhoneNumber(self, 'ctrl.', 'div_occupiers');
        jQuery('.datepicker').datepicker({
            // dateFormat: "yy-mm-dd",
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:+0",
            dateFormat: "dd/mm/yy"
        });
    }

    searchAddress(address_type) {
        const self = this;

        self.buyerErrors[address_type + "_postcode"] = null;

        if (!(address_type === self.primary_address_type || address_type === self.mailing_address_type)) {
            console.log("Error! Invalid address type " + address_type);
            return;
        }

        // WEB-4652: via the Showsuite API — OneMap now needs a server-held token.
        self.SSHttpService.getAddressFromPostcode(self.editBuyerObj[address_type + "_postcode"], function (result, errorMessage) {
            self.$timeout(function() {
                if (errorMessage) {
                    self.buyerErrors[address_type + "_postcode"] = errorMessage;
                } else if (result) {
                    //Update address
                    self.editBuyerObj[address_type + "_line1"] = result.BLK_NO;
                    if (result.BUILDING === "NIL" || result.BUILDING === "") {
                        self.editBuyerObj[address_type + "_line2"] = result.ROAD_NAME;
                    } else {
                        self.editBuyerObj[address_type + "_line2"] = result.ROAD_NAME + ", " + result.BUILDING;
                    }

                    self.editBuyerObj[address_type + "_district"] = "";
                    self.editBuyerObj[address_type + "_city"] = "Singapore";
                } else {
                    self.buyerErrors[address_type + "_postcode"] = "Invalid postcode, please try again.";
                }
            });
        }, false);
    }

    editSalePrice(editMode) {
        const self = this;
        if (!editMode) {
            self.salePriceCopy = angular.copy(self.sale_sales.price);
        }
        self.salePriceEditMode = editMode;
    }

    editPPFormRemarks(editMode) {
        const self = this;
        if (!editMode) {
            self.ppFormRemarksCopy = self.sale_sales.pp_form_remarks ? angular.copy(self.sale_sales.pp_form_remarks) : '';
        }
        self.ppFormRemarksEditMode = editMode;
    }

    editAgentRemarks(editMode) {
        const self = this;
        if (!editMode) {
            self.agentRemarksCopy = self.sale_sales.remarks ? angular.copy(self.sale_sales.remarks) : '';
        }
        self.agentRemarksEditMode = editMode;
    }

    saveSaleBuyer(saleBuyerParams) {
        const self = this;

        // Validation is not implemented for edit mode
        // self.resetBuyerErrors();
        // if(!self.isValidBuyerInput()){
        //   return;
        // }
        self.resetBuyerErrors();
        if (!self.isValidBuyerInput(saleBuyerParams)) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveSaleBuyer();
            }
        );
    }

    saveSaleNonBuyerPayee() {
        const self = this;

        self.resetNonBuyerPayeeErrors();
        if (!self.isValidNonBuyerPayeeInput()) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveSaleNonBuyerPayee();
            }
        );
    }

    _saveSaleNonBuyerPayee() {
        const self = this;

        let url = 'sec/buyers';
        if (self.saleNonBuyerPayeeParams.id) {
            url += '/' + self.saleNonBuyerPayeeParams.id;
        }

        let params = angular.copy(self.saleNonBuyerPayeeParams);

        if (params.individual && params.individual.dob) {
            params.individual.dob = self.SSDateService.formateWithTimeAsNoon(params.individual.dob);
        }
        if (params.individual && params.individual.passport_issued_date) {
            params.individual.passport_issued_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_issued_date);
        }
        if (params.individual && params.individual.passport_expiry_date) {
            params.individual.passport_expiry_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_expiry_date);
        }
        if(params.individual.industry_other && params.individual.industry === "OTHERS"){
            params.individual.industry = params.individual.industry_other;
        }
        if(params.individual.occupation_other && params.individual.occupation === "OTHERS"){
            params.individual.occupation = params.individual.occupation_other;
        }

        delete params.individual.industry_other;
        delete params.individual.occupation_other;

        if (params.individual && params.individual.dob) {
            params.individual.dob = self.SSDateService.formateWithTimeAsNoon(params.individual.dob);
        }
        if (params.individual && params.individual.passport_issued_date) {
            params.individual.passport_issued_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_issued_date);
        }
        if (params.individual && params.individual.passport_expiry_date) {
            params.individual.passport_expiry_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_expiry_date);
        }
        if(params.individual.occupation_other && params.individual.occupation === "OTHERS"){
            params.individual.occupation = params.individual.occupation_other;
        }

        delete params.individual.occupation_other;

        params.sale_id = parseInt(self.sale_id);
        params.object_type = "non_buyer_payee";

        if(!$.isEmptyObject(params)){
            if(params.individual && !$.isEmptyObject(params.individual)){
                angular.forEach(params.individual, function(value,key){
                    params["individual_" + key] = value;

                });
            } else if(params.company && !$.isEmptyObject(params.company)){
                angular.forEach(params.company, function(value,key){
                    params["company_" + key] = value;

                });
            }
            if(params.email_contact && !$.isEmptyObject(params.email_contact)){
                params["email_contact_value"] = params.email_contact.value;
            }
            if(params.phone1_contact && !$.isEmptyObject(params.phone1_contact)){
                params["phone1_contact_value"] = params.phone1_contact.value;
            }
            if(params.phone2_contact && !$.isEmptyObject(params.phone2_contact)){
                params["phone2_contact_value"] = params.phone2_contact.value;

            }
            if(params.primary_address && !$.isEmptyObject(params.primary_address)){
                angular.forEach(params.primary_address, function(value,key){
                    params["primary_address_" + key] = value;
                });
            }
        }

        if(!self.isValidUnitNum(params)) return;

        // Check if 'type' not added for contacts, then add default
        try {
            if (params.email_contact && !params.email_contact.type) {
                params.email_contact.type = 1;
                params.email_contact.verified = 0;
            }
            if (params.phone1_contact && !params.phone1_contact.type) {
                params.phone1_contact.type = 2;
                params.phone1_contact.verified = 0;
            }
            if (params.phone2_contact && !params.phone2_contact.type) {
                params.phone2_contact.type = 2;
                params.phone2_contact.verified = 0;
            }
        } catch (ex) {
            console.log(ex);
        }

        params.buyer_id = params.id;
        // if (!params.order) {
        //     //Need to update all buyers' order to avoid incorrect ordering
        //     self.prepareReorderBuyerObj();
        //     self.updateBuyerOrder(self.callUpdateSaleBuyerAPI);
        // } else {
        // }
        if(self.saleNonBuyerPayeeParams.id){
            self.callUpdateSaleNonBuyerPayeeAPI(self, url,params);
        }else{
            self._saveNewNonBuyerPayee(url,params);
        }
    }

    callUpdateSaleNonBuyerPayeeAPI(self, url, params) {
        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                } else if (response.sub_code == 412001 && response.data && response.data.individual_national_id){
                    self.nonBuyerPayeeErrors = {
                        individual_national_id: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('3rd Party Payor updated successfully.');

            /* Update formatted data if successful */
            if (self.saleNonBuyerPayeeParams.individual && self.saleNonBuyerPayeeParams.individual.dob) {
                self.saleNonBuyerPayeeParams.individual.dob = self.SSDateService.formateWithTimeAsNoon(self.saleNonBuyerPayeeParams.individual.dob);
            }
            if (self.saleNonBuyerPayeeParams.individual && self.saleNonBuyerPayeeParams.individual.passport_issued_date) {
                self.saleNonBuyerPayeeParams.individual.passport_issued_date = self.SSDateService.formateWithTimeAsNoon(self.saleNonBuyerPayeeParams.individual.passport_issued_date);
            }
            if (self.saleNonBuyerPayeeParams.individual && self.saleNonBuyerPayeeParams.individual.passport_expiry_date) {
                self.saleNonBuyerPayeeParams.individual.passport_expiry_date = self.SSDateService.formateWithTimeAsNoon(self.saleNonBuyerPayeeParams.individual.passport_expiry_date);
            }
            if(self.saleNonBuyerPayeeParams.individual.occupation_other && self.saleNonBuyerPayeeParams.individual.occupation === "OTHERS"){
                self.saleNonBuyerPayeeParams.individual.occupation = self.saleNonBuyerPayeeParams.individual.occupation_other;
            }

            delete self.saleNonBuyerPayeeParams.individual.occupation_other;

            angular.merge(self.selectedSaleNonBuyerPayee, self.saleNonBuyerPayeeParams);
            self.selectSaleNonBuyerPayee(self.selectedSaleNonBuyerPayee);
            // self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    _saveNewNonBuyerPayee(url, params) {
        const self = this;

        if (params.individual && params.individual.dob) {
            params.individual.dob = self.SSUtilService.formatDateToStoreWithUtc12(params.individual.dob);
        }

        // Set signatory order based on company
        if(params.buyer_company_id){
            params.order = self.SSEoiService.getNextIndexForAddingNonBuyerPayeeSignatory(params.buyer_company_id);
        }else {
            params.order = (self.sale_sales.sale_non_buyer_payees && self.sale_sales.sale_non_buyer_payees.length > 0)? self.sale_sales.sale_non_buyer_payees.length + 1 : 1;
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                } else if (response.sub_code == 412001 && response.data && response.data.individual_national_id){
                    self.nonBuyerPayeeErrors = {
                        individual_national_id: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'New 3rd Party Payor added successfully.');

            // try {
            //     self.sale_sales.sale_non_buyer_payees.push(response.data.sale_buyer);
            //     self.selectSaleBuyer(self.sale_sales.sale_buyers[self.sale_sales.sale_buyers.length - 1]);
            // } catch (ex) {
            //     console.log(ex);
            // }

            // If signatory added need to reorder non buyer payes
            if(params.buyer_company_id){
                if(response && response.data && response.data.buyer){
                    params.id = response.data.buyer.id;
                    self.SSEoiService.addNonBuyerPayee(params);
                }

                self.reorderNonBuyerPayees();
            }else{
                self.newNonBuyerPayeeMode = false;
                self.$window.location.reload(); // TODO: Fix the data issue
            }
        });
    }

    reorderNonBuyerPayees(){
        const self = this;

        if(!self.sale_sales || !self.sale_sales.sale_non_buyer_payees
                || !self.sale_sales.sale_non_buyer_payees.length){
            return false;
        }

        loading(true);
        self.sale_sales.sale_non_buyer_payees.forEach(non_buyer_payee => {
            let url = 'sec/buyers';
            if (non_buyer_payee.id) {
                url += '/' + non_buyer_payee.id;
            }

            let params = angular.copy(non_buyer_payee);
            if(params.individual){
                if (params.individual.dob) {
                    params.individual.dob = self.SSDateService.formateWithTimeAsNoon(params.individual.dob);
                }
                if (params.individual.passport_issued_date) {
                    params.individual.passport_issued_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_issued_date);
                }
                if (params.individual.passport_expiry_date) {
                    params.individual.passport_expiry_date = self.SSDateService.formateWithTimeAsNoon(params.individual.passport_expiry_date);
                }
                if(params.individual.occupation_other && params.individual.occupation === "OTHERS"){
                    params.individual.occupation = params.individual.occupation_other;
                }
                delete non_buyer_payee.individual.occupation_other;
            }

            params.sale_id = parseInt(self.sale_id);
            params.buyer_id = params.id;
            params.object_type = "non_buyer_payee";

            if(!$.isEmptyObject(params)){
                if(params.individual && !$.isEmptyObject(params.individual)){
                    angular.forEach(params.individual, function(value,key){
                        params["individual_" + key] = value;

                    });
                } else if(params.company && !$.isEmptyObject(params.company)){
                    angular.forEach(params.company, function(value,key){
                        params["company_" + key] = value;

                    });
                }
                if(params.email_contact && !$.isEmptyObject(params.email_contact)){
                    params["email_contact_value"] = params.email_contact.value;
                }
                if(params.phone1_contact && !$.isEmptyObject(params.phone1_contact)){
                    params["phone1_contact_value"] = params.phone1_contact.value;
                }
                if(params.phone2_contact && !$.isEmptyObject(params.phone2_contact)){
                    params["phone2_contact_value"] = params.phone2_contact.value;

                }
                if(params.primary_address && !$.isEmptyObject(params.primary_address)){
                    angular.forEach(params.primary_address, function(value,key){
                        params["primary_address_" + key] = value;
                    });
                }

                params.order = self.SSEoiService.nonBuyerPayees.findIndex(b => b.id === params.id) + 1;
            }

            // Check if 'type' not added for contacts, then add default
            try {
                if (params.email_contact && !params.email_contact.type) {
                    params.email_contact.type = 1;
                    params.email_contact.verified = 0;
                }
                if (params.phone1_contact && !params.phone1_contact.type) {
                    params.phone1_contact.type = 2;
                    params.phone1_contact.verified = 0;
                }
                if (params.phone2_contact && !params.phone2_contact.type) {
                    params.phone2_contact.type = 2;
                    params.phone2_contact.verified = 0;
                }
            } catch (ex) {
                console.log(ex);
            }

            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                if (response instanceof Error) {
                    loading(false);
                    if (response.sub_code === 305015 || response.sub_code === 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return false;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return false;
                }

                if(response && response.data && response.data.buyer
                        && self.sale_sales.sale_non_buyer_payees[self.sale_sales.sale_non_buyer_payees.length -1].id === response.data.buyer.id){
                    loading(false);
                    self.newNonBuyerPayeeMode = false;
                    self.$window.location.reload(); // TODO: Fix the data issue
                }
            });
        })
    }

    saveWitness() {
        const self = this;

        self.profileErrors = {};

        if (!self.isValidWitnessInput()) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveNewSaleWitness();
            }
        );
    }

    _saveNewSaleWitness() {
        const self = this;

        let url = 'sec/buyers';
        if (self.witnessParams.id) {
            url += '/' + self.witnessParams.id;
        }

        if(self.witnessParams.individual.industry_other && self.witnessParams.individual.industry === "OTHERS"){
            self.witnessParams.individual.industry = self.witnessParams.individual.industry_other;
        }
        if(self.witnessParams.individual.occupation_other && self.witnessParams.individual.occupation === "OTHERS"){
            self.witnessParams.individual.occupation = self.witnessParams.individual.occupation_other;
        }

        delete self.witnessParams.individual.industry_other;
        delete self.witnessParams.individual.occupation_other;

        let params = angular.copy(self.witnessParams);

        params.sale_id = parseInt(self.sale_id);
        params.object_type = "witness";

        if(!$.isEmptyObject(params)){
            if(params.individual && !$.isEmptyObject(params.individual)){
                angular.forEach(params.individual, function(value,key){
                    params["individual_" + key] = value;

                });
            }
            if(params.email_contact && !$.isEmptyObject(params.email_contact)){
                params["email_contact_value"] = params.email_contact.value;
            }
            if(params.phone1_contact && !$.isEmptyObject(params.phone1_contact)){
                params["phone1_contact_value"] = params.phone1_contact.value;
            }
            if(params.phone2_contact && !$.isEmptyObject(params.phone2_contact)){
                params["phone2_contact_value"] = params.phone2_contact.value;

            }
            if(params.primary_address && !$.isEmptyObject(params.primary_address)){
                angular.forEach(params.primary_address, function(value,key){
                    params["primary_address_" + key] = value;
                });
            }
        }

        // if(!self.isValidUnitNum(params)) return;

        // Check if 'type' not added for contacts, then add default
        try {
            if (params.email_contact && !params.email_contact.type) {
                params.email_contact.type = 1;
                params.email_contact.verified = 0;
            }
            if (params.phone1_contact && !params.phone1_contact.type) {
                params.phone1_contact.type = 2;
                params.phone1_contact.verified = 0;
            }
            if (params.phone2_contact && !params.phone2_contact.type) {
                params.phone2_contact.type = 2;
                params.phone2_contact.verified = 0;
            }
        } catch (ex) {
            console.log(ex);
        }
        params.buyer_id = params.id;

        if (params.individual && params.individual.dob) {
            params.individual.dob = self.SSUtilService.formatDateToStoreWithUtc12(params.individual.dob);
        }
        if (params.individual && params.individual.passport_issued_date) {
            params.individual.passport_issued_date = self.SSUtilService.formatDateToStoreWithUtc12(params.individual.passport_issued_date);
        }
        if (params.individual && params.individual.passport_expiry_date) {
            params.individual.passport_expiry_date = self.SSUtilService.formatDateToStoreWithUtc12(params.individual.passport_expiry_date);
        }

        if(self.witnessParams.id){
            self.callUpdateSaleWitnessAPI(self, true, url, params);
        }else{
            self._saveNewWitness(url, params);
        }
    }

    callUpdateSaleWitnessAPI(self, without_reorder, url, params) {
        if (!without_reorder) {
            let update_buyer = self.reorder_buyers.find(x => x.id === self.update_sale_params.id);
            if (update_buyer) {
                self.update_sale_params.order = update_buyer.order;
            } else {
                self.update_sale_params.order = self.sale_sales.sale_witnesses.findIndex(x => x.id === params.id) + 1;
            }
        }

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                } else if (response.data && response.data.individual_national_id){
                    self.profileErrors = {
                        Nric: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Witness updated successfully.');

            angular.merge(self.selectedwitness, self.witnessParams);

            // self.selectWitness(self.selectedwitness);

            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    _saveNewWitness(url, params) {
        const self = this;

        params.order = (self.sale_sales.sale_witnesses && self.sale_sales.sale_witnesses.length > 0)? self.sale_sales.sale_witnesses.length + 1 : 1;

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                } else if (response.data && response.data.individual_national_id){
                    self.profileErrors = {
                        Nric: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'New witness added successfully.');

            self.newWitnessMode = false;
            // self.$window.location.reload(); // TODO: Fix the data issue

            try {
                params.id = response.data.buyer.id;
                params.individual_id = response.data.buyer.individual_id;

                self.sale_sales.sale_witnesses.push(params);
                self.selectWitness(self.sale_sales.sale_witnesses[self.sale_sales.sale_witnesses.length - 1]);
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    _saveSaleBuyer() {
        const self = this;

        if (!self.saleBuyerParams) { return false; }

        let url = 'sec/developer/sales/' + self.selectedSaleBuyer.sale_id + '/buyers';
        if (self.saleBuyerParams.id) {
            url += '/' + self.saleBuyerParams.id;
        }
        if (self.selectedSaleBuyer.subsale_id) {
            url = 'sec/developer/sales/' + self.sale_sales.id + '/subsales/' + self.selectedSaleBuyer.subsale_id + '/buyers/' + self.selectedSaleBuyer.id;
        }

        let params = angular.copy(self.saleBuyerParams);

        if (params.mailing_address_same && params.data.primary_address) {
            //Copy primary address to mailing address
            params.data.mailing_address = {};
            params.data.mailing_address.line1 = params.data.primary_address.line1;
            params.data.mailing_address.line2 = params.data.primary_address.line2;
            params.data.mailing_address.unit_no = params.data.primary_address.unit_no;
            params.data.mailing_address.postcode = params.data.primary_address.postcode;
            params.data.mailing_address.city = params.data.primary_address.city;
            params.data.mailing_address.district = params.data.primary_address.district;
            params.data.mailing_address.province = params.data.primary_address.province;
            params.data.mailing_address.country = params.data.primary_address.country;
        }

        if (!self.isValidUnitNum(params.data)) return; // TODO: Verify and remove

        if (params.data.individual){
            if (params.data.individual.dob) {
                params.data.individual.dob = self.SSDateService.formateWithTimeAsNoon(params.data.individual.dob);
            }
            if (params.data.individual.passport_issued_date) {
                params.data.individual.passport_issued_date = self.SSDateService.formateWithTimeAsNoon(params.data.individual.passport_issued_date);
            }
            if (params.data.individual.passport_expiry_date) {
                params.data.individual.passport_expiry_date = self.SSDateService.formateWithTimeAsNoon(params.data.individual.passport_expiry_date);
            }
            if (params.data.individual.industry_other && params.data.individual.industry === "OTHERS"){
                params.data.individual.industry = params.data.individual.industry_other;
                delete params.data.individual.industry_other;
            }
            if (params.data.individual.occupation_other && params.data.individual.occupation === "OTHERS"){
                params.data.individual.occupation = params.data.individual.occupation_other;
                delete params.data.individual.occupation_other;
            }
            if(params.data.individual.race_other && params.data.individual.race === "Other"){
                params.data.individual.race = params.data.individual.race_other;
                delete params.data.individual.race_other;
            }

            self.update_sale_buyer_orders = false; // Init re-order buyer trigger to false
            if(params.data.selected_buyer_company_id && params.data.selected_buyer_company_id !== params.data.buyer_company_id){
                // If signatory company changed save updated buyer_company_id and update order of signatory
                params.data.buyer_company_id = params.data.selected_buyer_company_id;
                self.SSEoiService.updateSignatoryCompany(params.data.id, params.data.selected_buyer_company_id);
                delete params.data.selected_buyer_company_id;

                if(self.SSEoiService.buyers){
                    let signatory_updated_index = self.SSEoiService.buyers.findIndex(b => b.id === params.data.id)
                    params.order = signatory_updated_index > -1? signatory_updated_index + 1 : params.order;

                    self.update_sale_buyer_orders = true; // To trigger re-order buyer after update
                }
            }
        }

        if (params.data.type === self.BUYER_TYPE_INDIVIDUAL) {
            params.data.company = null;
        } else if (params.data.type === self.BUYER_TYPE_COMPANY) {
            params.data.individual = null;
        }

        // Check if 'type' not added for contacts, then add default
        try {
            if (params.data.email_contact && !params.data.email_contact.type) {
                params.data.email_contact.type = 1;
                params.data.email_contact.verified = 0;
            }
            if (params.data.email_contact && !params.data.phone1_contact.type) {
                params.data.phone1_contact.type = 2;
                params.data.phone1_contact.verified = 0;
            }
            if (params.data.email_contact && !params.data.phone2_contact.type) {
                params.data.phone2_contact.type = 2;
                params.data.phone2_contact.verified = 0;
            }
        } catch (ex) {
            console.log(ex);
        }

        /** WEB-2925 AMS: Sale - Add option to update Buyer Lawyer Info
         * Save lawyer info in lawyer object
        if (params.data.lawyer) {
            params.data.lawyer.law_firm_name = params.data.lawyer.law_firm_name === "OTHERS" ? params.data.lawyer.law_firm_name_other : params.data.lawyer.law_firm_name;
            params.data.lawyers = [params.data.lawyer];
            delete params.data.lawyer;
        } **/
        if (params.data.lawyer) {
            params.data.lawyer.law_firm_name = params.data.lawyer.law_firm_name === "OTHERS" ? params.data.lawyer.law_firm_name_other : params.data.lawyer.law_firm_name;
            params.data.lawyers = null;
        }

        params.buyer_id = params.data.id;
        params.data = JSON.stringify(params.data);

        self.update_sale_url = url;
        self.update_sale_params = params;

        if (!params.order) {
            //Need to update all buyers' order to avoid incorrect ordering
            self.prepareReorderBuyerObj();
            //self.updateBuyerOrder(self.callUpdateSaleBuyerAPI);
            self.updateBuyerOrder(self.update_sale_params);
        } else {
            self.callUpdateSaleBuyerAPI(self, true);
        }
    }

    saveSaleOccupier(saleOccupierParams) {
        const self = this;

        // Validation is not implemented for edit mode
        // self.resetBuyerErrors();
        // if(!self.isValidBuyerInput()){
        //   return;
        // }
        self.resetOccupierErrors();
        if (!self.isValidOccupierInput(saleOccupierParams)) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self._saveSaleOccupier();
            }
        );
    }

    _saveSaleOccupier() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selectedSaleOccupier.sale_id + '/occupiers';
        if (self.saleOccupierParams.id) {
            url += '/' + self.saleOccupierParams.id;
        }

        if (self.saleOccupierParams.data && self.saleOccupierParams.data.individual.dob) {
            self.saleOccupierParams.data.individual.dob = self.SSDateService.formateWithTimeAsNoon(self.saleOccupierParams.data.individual.dob);
        }

        let params = angular.copy(self.saleOccupierParams);

        // Check if 'type' not added for contacts, then add default
        try {
            if (params.data.email_contact && !params.data.email_contact.type) {
                params.data.email_contact.type = 1;
                params.data.email_contact.verified = 0;
            }
            if (params.data.email_contact && !params.data.phone1_contact.type) {
                params.data.phone1_contact.type = 2;
                params.data.phone1_contact.verified = 0;
            }
            if (params.data.email_contact && !params.data.phone2_contact.type) {
                params.data.phone2_contact.type = 2;
                params.data.phone2_contact.verified = 0;
            }
        } catch (ex) {
            console.log(ex);
        }
        params.Occupier_id = params.data.id;
        params.data = JSON.stringify(params.data);
        self.update_sale_url = url;
        self.update_sale_params = params;


            self.callUpdateSaleOccupierAPI(self);
    }

    callUpdateSaleOccupierAPI(self) {
        loading(true);
        self.SSHttpService.putAPIRequest(self.update_sale_url, self.update_sale_params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Occupier updated successfully.');

            angular.merge(self.selectedSaleOccupier, response.data.sale_occupier);

            self.selectSaleOccupier(self.selectedSaleOccupier);

            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }

    callUpdateSaleBuyerAPI(self, without_reorder) {
        if (!without_reorder) {
            let update_buyer = self.reorder_buyers.find(x => x.id === self.update_sale_params.id);
            if (update_buyer) {
                self.update_sale_params.order = update_buyer.order;
            } else {
                self.update_sale_params.order = self.sale_sales.sale_buyers.findIndex(x => x.id === params.id) + 1;
            }
        }
        loading(true);
        self.SSHttpService.putAPIRequest(self.update_sale_url, self.update_sale_params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }else if (response.sub_code == 412001 && response.data && response.data.individual_national_id){
                    self.buyerErrors = {
                        individual_national_id: "Please Enter a valid NRIC"
                    };
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Buyer updated successfully.');

            angular.merge(self.selectedSaleBuyer, response.data.sale_buyer);

            self.selectSaleBuyer(self.selectedSaleBuyer);

            if(self.update_sale_buyer_orders){
                self.update_sale_buyer_orders = false;
                self.updateSaleBuyersOrder();
            } else{
                self.$window.location.reload(); // TODO: Fix the data issue
            }
        });
    }

    getBuyerTypeName(type) {
        const self = this;

        let name = null;
        jQuery.each(self.BUYER_TYPES, function (i, buyerType) {
            if (buyerType.id == type) {
                name = buyerType.name;
                return false;
            }
        });

        return name;
    }

    chechFieldAvailablity(field){
        const self = this;
        if(field == undefined)
            return false;
        if(field == null)
            return false;
        return true;
    }

    getIdentityTypeName(type) {
        const self = this;

        let name = null;
        jQuery.each(self.IDENTITY_TYPES, function (i, identityType) {
            if (identityType.id == type) {
                name = identityType.name;
                return false;
            }
        });

        return name;
    }

    updateBuyerNationality(individual) {
        const self = this;
        if (individual.identity_type == self.IDENTITY_TYPE_SINGAPOREAN || individual.identity_type == self.IDENTITY_TYPE_SINGAPORE_PR) {
            if(self.PROJECT_COUNTRY != self.SSUtilService.COUNTRY_ID.SINGAPORE){
                individual.nationality = self.PROJECT_COUNTRY;
            }else{
                individual.nationality = 702;
            }
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = false;
        } else {
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = true;
            individual.nationality = 0;
        }
    }

    updateSaleBuyerNationality() {
        const self = this;

        if (self.subSaleBuyerParams.data.individual.identity_type == self.IDENTITY_TYPE_SINGAPOREAN || self.subSaleBuyerParams.data.individual.identity_type == self.IDENTITY_TYPE_SINGAPORE_PR) {
            if(self.PROJECT_COUNTRY != self.SSUtilService.COUNTRY_ID.SINGAPORE){
                self.subSaleBuyerParams.data.individual.nationality = self.PROJECT_COUNTRY;
            }else{
                self.subSaleBuyerParams.data.individual.nationality = 702;
            }
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = false;
        } else {
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = true;
            self.subSaleBuyerParams.data.individual.nationality = 0;
        }
    }

    updateSaleOccupierNationality() {
        const self = this;

        if (self.saleOccupierParams.data.individual.identity_type == self.IDENTITY_TYPE_SINGAPOREAN || self.saleOccupierParams.data.individual.identity_type == self.IDENTITY_TYPE_SINGAPORE_PR) {
            self.saleOccupierParams.data.individual.nationality = 702;
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = false;
        } else {
            self.SALE_BUYER_IDENTITY_TYPE_FOREIGNER = true;
            self.saleOccupierParams.data.individual.nationality = 0;
        }
    }

    resetErrors() {
        const self = this;

        self.error_law_firm_name = null;
        self.error_first_name = null;
        self.error_last_name = null;
        self.error_email = null;
    }

    isValidInput() {
        const self = this;

        let isValid = true;

        if (!self.lawyer.law_firm_name) {
            self.error_law_firm_name = 'The law firm name field is required.';
            isValid = false;
        }
        if (!self.lawyer.first_name) {
            self.error_first_name = 'The first name field is required.';
            isValid = false;
        }
        if (!self.lawyer.last_name) {
            self.error_last_name = 'The last name field is required.';
            isValid = false;
        }
        if (!self.lawyer.email) {
            self.error_email = 'The email field is required.';
            isValid = false;
        }

        return isValid;
    }

    isFirstDateBeforeSecondDate(first_date, second_date){
        const self = this;

        // Expected format: dd/mm/yyyy
        // If date is not in above format then it will cause problem

        if(!first_date || !second_date){
            return;
        }

        try{
            let firstDate = moment.utc(first_date, 'DD/MM/YYYY');
            let secondDate = moment.utc(second_date, 'DD/MM/YYYY');

            if(firstDate.isValid() && secondDate.isValid()){
                if(firstDate.isBefore(secondDate)){
                    return true;
                }
                else{
                    return false;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

    }

    /**
     * Checks whether a user-entered instrument date is a real, storable calendar date.
     *
     * The cheque/receiving/bank-in date inputs are free-text fields with a jQuery UI
     * datepicker only attached, so a manually typed value reaches ng-model verbatim. A
     * dropped year digit (e.g. "16/06/206") would otherwise be serialized by
     * getFormattedDate() as "206-06-16 12:00:00", which MySQL DATETIME (supported year
     * range 1000-9999) silently coerces to "0000-00-00 00:00:00". On reload moment
     * zero-pads the year to "0206", so the bad value round-trips and looks valid. This
     * guard rejects such values before they can be saved.
     *
     * @param {string} value Date string from ng-model, expected display format "DD/MM/YYYY".
     * @returns {boolean} true when value is empty (presence is validated separately) or a
     *                    strictly-valid DD/MM/YYYY calendar date whose year is within
     *                    MySQL's supported [1000, 9999] range; false otherwise.
     * @remarks WEB-3629.
     */
    isValidEntryDate(value) {
        if (value === null || value === undefined || value === '') {
            return true;
        }

        // Only the date part matters; ignore any trailing time component.
        let datePart = value.toString().trim().split(' ')[0];

        // Require a 4-digit year token up front. moment's strict parser still accepts
        // 1-3 digit years for YYYY, which is exactly the dropped-digit corruption (e.g.
        // "16/06/206") we must reject. Day/month may be 1-2 digits (the picker zero-pads).
        if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(datePart)) {
            return false;
        }

        // Strict parse rejects impossible calendar dates (e.g. 31/02/2026).
        let parsed = moment(datePart, ['DD/MM/YYYY', 'D/M/YYYY'], true);
        if (!parsed.isValid()) {
            return false;
        }

        // "0206" passes the 4-digit check but is below MySQL's minimum supported year,
        // so reject the sticky/round-tripped form too.
        let year = parsed.year();
        return year >= 1000 && year <= 9999;
    }

    isValidPaymentInput(){
        const self = this;

        let isValid = true;

        // 'INSTRUMENT_TYPE_CHEQUE' , 'INSTRUMENT_TYPE_CASHIERS_ORDER' VALIDATION
        // REQUIREMENT CHANGED: CHEQUE DATE IS MANDATOR IF 'CHEQUE' IS SELECTED => WEB-715
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CHEQUE || self.current_instrument.type == self.INSTRUMENT_TYPE_CASHIERS_ORDER) {
            if (!self.current_instrument.cheque_date) {
                self.instrument_errors.cheque_date = "Please enter cheque date";
                isValid = false;
            } else {
                if (self.current_instrument.hasOwnProperty("bank_in_date") && self.current_instrument.bank_in_date != null) {
                    // let temp_bank_in_date = moment(self.current_instrument.bank_in_date, 'YYYY-MM-DD');
                    // let temp_cheque_date = moment(self.current_instrument.cheque_date, 'YYYY-MM-DD');
                    // ---------  'moment.isBefore' was not working properly

                    if (self.isFirstDateBeforeSecondDate(self.current_instrument.bank_in_date, self.current_instrument.cheque_date)) {
                        self.instrument_errors.bank_in_date = "Bank in date cannot be earlier than cheque date";
                        isValid = false;
                    }
                }
            }

            // WEB-1127: DMS/ Payments Details page:  Make all Images upload field  Optional
            // if(!self.current_instrument.file_uri){
            //     // If sale is imported from excel, then image is optional
            //     if(!self.sale_sales.added_from_import){
            //         self.instrument_errors.file_uri = "Please upload the required image";
            //         isValid = false;
            //     }
            // }
        }

        //  'INSTRUMENT_TYPE_FAST_CASH' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_FAST_CASH
            || self.current_instrument.type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS
            || self.current_instrument.type == self.INSTRUMENT_TYPE_EDP
            || self.current_instrument.type == self.INSTRUMENT_TYPE_EDP_PLUS) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
            // WEB-1127: DMS/ Payments Details page:  Make all Images upload field  Optional
            // if(!self.current_instrument.file_uri){
            //     self.instrument_errors.file_uri = "Please upload the required image";
            //     isValid = false;
            // }
        }

        // 'INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER || self.current_instrument.type == self.INSTRUMENT_TYPE_BANK_TRANSFER) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
        }

        // 'INSTRUMENT_TYPE_GIRO' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_GIRO) {
            // Validation fields: Transaction number, Amount
            // false params for no validation of account holder name
            isValid = self.validateCommonPaymentInputFields(false);

            // Validate 'Receiving Date'
            if (!self.current_instrument.receiving_date) {
                self.instrument_errors.receiving_date = "The receiving date field is required.";
                isValid = false;
            }
        }

        // 'INSTRUMENT_TYPE_DEBIT_CARD' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_DEBIT_CARD) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
        }

        // 'INSTRUMENT_TYPE_CASH_IN' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CASH_IN) {
            if (!self.current_instrument.amount) {
                self.instrument_errors.amount = "The amount field is required.";
                isValid = false;
            }
        }
        // If 'remarks' are entered then check its length, otherwise no restriction on remarks, its OPTIONAL
        if (self.current_instrument.remarks && self.current_instrument.remarks.toString().length > 255) {
            self.instrument_errors.remarks = "The remarks character is greater than 255.";
            isValid = false;
        }


        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CREDIT_CARD) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
            if (!self.current_instrument.card_company) {
                self.instrument_errors.card_company = "The card company field is required.";
                isValid = false;
            }
        }
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CASH) {
            if (!self.current_instrument.amount) {
                self.instrument_errors.amount = "The amount field is required.";
                isValid = false;
            }
        }
        if(!self.current_instrument.property_account_id && self.current_payment.type == self.PAYMENT_TYPE_14_MAINTENANCE_FEE){
            self.instrument_errors.bank_account = "Developer account is mandatory for this payment.";
            isValid = false;
        }
        if(!self.current_instrument.property_account_id && self.current_payment.type == self.PAYMENT_TYPE_15_SURVEY_FEE){
            self.instrument_errors.bank_account = "Developer account is mandatory for this payment.";
            isValid = false;
        }

        if(self.current_instrument.type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS
            || self.current_instrument.type == self.INSTRUMENT_TYPE_EDP
            || self.current_instrument.type == self.INSTRUMENT_TYPE_EDP_PLUS){
            if (!self.current_instrument.bank_name) {
                self.instrument_errors.bank_name = "Please select bank";
                isValid = false;
            }
        }

        // WEB-3629 — Reject malformed / out-of-range dates before they reach the server.
        // These fields are free-text inputs (jQuery UI datepicker only attached), so a
        // typed value with e.g. a dropped year digit ("16/06/206") would otherwise be
        // serialized as "206-06-16 12:00:00" and silently stored by MySQL as
        // "0000-00-00 00:00:00". Runs after the per-type blocks (which reassign isValid)
        // so the result is never overwritten.
        let instrumentDateFields = {
            cheque_date: "Please enter a valid cheque date (DD/MM/YYYY).",
            receiving_date: "Please enter a valid receiving date (DD/MM/YYYY).",
            bank_in_date: "Please enter a valid bank in date (DD/MM/YYYY)."
        };
        angular.forEach(instrumentDateFields, function (message, field) {
            if (self.current_instrument[field] && !self.isValidEntryDate(self.current_instrument[field])) {
                self.instrument_errors[field] = message;
                isValid = false;
            }
        });

        return isValid;
    }

    isValidInterestWaiverInput()
    {
        const self = this;
        let isValid = true;
        self.current_payment_errors = {};

        if(!self.current_payment.waiver_date)
        {
            self.current_payment_errors.waiver_date = "The waiver date field is required.";
            isValid = false;
        }

        if(!self.current_payment.waiver_amount)
        {
            self.current_payment_errors.waiver_amount = "The waiver amount field is required.";
            isValid = false;
        }

        return isValid;
    }

    validateCommonPaymentInputFields(validate_account_holder_name = true) {
        const self = this;

        let isValid = true;

        if (!self.current_instrument.instrument_no) {
            self.instrument_errors.instrument_no = "This field is required.";
            isValid = false;
        }
        // WEB-3662: a payment instrument is EITHER an amount OR an interest amount, chosen
        // via the payment_type_amount toggle (1 = amount, 0 = interest). In interest mode
        // the blade hides the `amount` input and the figure lives in `interest_amount`, so
        // unconditionally requiring `amount` here made Submit silently no-op for TT and the
        // other common-field modes — and the `amount` error span sits inside the hidden
        // amount block, so the user saw no feedback. Validate the field that matches the
        // selected mode instead.
        if (!self.validateInstrumentAmountField()) {
            isValid = false;
        }
        if (!self.current_instrument.account_holder_name && validate_account_holder_name) {
            self.instrument_errors.account_holder_name = "This field is required.";
            isValid = false;
        }

        return isValid;
    }

    /**
     * Validate the "active" amount field for the current instrument according to the
     * payment_type_amount toggle (1 = plain amount, 0 = interest amount).
     *
     * @remarks
     * In interest mode the blade hides the `amount` input and the value is captured in
     * `interest_amount`, so requiring `amount` would wrongly fail validation. The interest
     * amount may be NEGATIVE (a negative-interest adjustment, WEB-3660), so only an empty
     * value is rejected — never a `> 0` / truthiness check, which would also reject 0 and
     * legitimate negatives.
     *
     * @returns {boolean} true when the field backing the selected mode has a value.
     */
    validateInstrumentAmountField() {
        const self = this;

        if (self.current_instrument.payment_type_amount == 0) {
            let interestAmount = self.current_instrument.interest_amount;
            if (interestAmount === undefined || interestAmount === null || interestAmount === '') {
                self.instrument_errors.interest_amount = "The interest amount field is required.";
                return false;
            }
            return true;
        }

        if (!self.current_instrument.amount) {
            self.instrument_errors.amount = "The amount field is required.";
            return false;
        }

        return true;
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        const self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        /** WEB-2811 AMS/DMS : AUS country support **/
        let country = self.PROJECT_COUNTRY || null;
        let countryCode = self.SSUtilService.getCountryShortCode(country);

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.attr('placeholder', 'Enter contact number');

            field.intlTelInput({
                initialCountry: countryCode,
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: [countryCode]
            });

            let model = field.attr('ng-model');

            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }

                let value = self.$parse(model)(context);

                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {
                field.parent().removeClass("has-warning");
                field.attr('placeholder', 'Enter contact number');
            });

            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-warning");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-warning");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        self.input_error = "Invalid Contact No. Please enter the correct contact no.";
                    }
                } else {
                    self.input_error = "";
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
                field.attr('placeholder', 'Enter contact number');
            });
        });
    }

    getPropertyAccountName(id) {
        const self = this;

        if (!id || !self.property_accounts) {
            return;
        }

        let propertyAccount = null;
        jQuery.each(self.property_accounts, function (i, _propertyAccount) {
            if (_propertyAccount.id == id) {
                propertyAccount = _propertyAccount;
                return false;
            }
        });

        let name = null;
        if (propertyAccount) {
            name = propertyAccount.account_name + ' (' + propertyAccount.account_no + ')';

        }

        return name;
    }

    replaceDocumentFiles(files, file_name, instrument) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        self.uploadDocumentFiles(files, file_name, instrument);
    }

    uploadDocumentFiles(files, file_name, instrument) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/buyers/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            loading(false);
            self.file_url = response.config.data.key;
            self.current_instrument.file_uri = response.config.data.key;
            //self.SSAlertService.success('Success!', 'File uploaded successfully.');
            //self._uploadDocument(response.config.data.key, file_name);
        });
    }

    _uploadDocument(file_uri, file_name) {
        const self = this;

        let url = 'sec/buyers/' + buyer.id + '/documents';
        let params = {
            name: file_name,
            type: upload_type,
            format: format_type,
            document_kind: document_kind,
            file_uri: file_uri
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            if (!buyer.hasOwnProperty("documents")) {
                buyer["documents"] = {};
            }
            buyer["documents"][document_kind] = response.data.buyer_document;

            // To retrieve preview image
            if (response.data.buyer_document.file_uri) {
                self.getPresignedUrl(
                    self.ASSET_MODEL_BUYER_DOCUMENT,
                    response.data.buyer_document.id,
                    function (presignedUrl) {
                        buyer["documents"][document_kind]["show_file_url"] = presignedUrl;
                    }
                );
            }
        });
    }

    viewServingLetter(payment_id){
        const self = this;

        if(!payment_id){
            return;
        }

        loading(true);
        self.getPresignedUrl(
            self.ASSET_MODEL_PAYMENT_SERVING_LETTER,
            payment_id,
            function (presignedUrl) {
                loading(false);
                if(presignedUrl){
                    window.open(presignedUrl, '_blank');
                }
            }
        );
    }

    getPresignedUrl(model, id, callback, forceDownload = false, _url = null) {
        const self = this;

        let url = _url? _url : 'sec/assets/presigned-url';

        let params = {
            'model': model,
            'id': id,
            'force_download': forceDownload
        };

        //loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            //loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (callback) {
                callback(response.data.presigned_url);
            }
        });
    }

    removeDocument(payment) {
        const self = this;
        payment.file_uri = null;
    }

    getSalePayments(first_time) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/payments';
        let params = {
            'include': 'interest_details'
        };

        self.payment_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.payment_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // WEB-4179: render in the order the server returns — Notice Served Date
            // (falling back to Creation Date), ties broken by the payment plan's
            // clause order; each payment also carries a `display_order`. The old
            // sort-by-type and its Survey Fee / Sub Maintenance Fee position swap
            // were a workaround for that type sort and would corrupt this order.
            self.sale_payments = angular.copy(response.data.payments);
            self.processSalePayments();
            if (first_time) {
                if (self.sale_sales.documents) {
                    try {
                        let otp = self.sale_sales.documents.find(x => x.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP);
                        if (otp && otp.created_at) {
                            $.each(self.sale_payments[0].instruments, function (index, instrument) {
                                if (!instrument.receiving_date) {
                                    instrument.receiving_date = otp.created_at;
                                }
                            });
                        }
                        self.sale_sales.documents = _.sortBy(self.sale_sales.documents, 'id');
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                self.getPaymentClauses();
            }
        });
    }

    processSalePayments() {
        const self = this;

        let total_payment_amount = 0;

        jQuery.each(self.sale_payments, function (index1, payment) {

            try{
                // Get payment clause
                if(payment.payment_plan_clause_id){
                    payment.clause = self.getClauseById(payment.payment_plan_clause_id);
                }
            }
            catch(ex){
                console.log(ex);
            }

            if (payment.clause) {
                payment.typeName = payment.clause.name;
                payment.percent = payment.clause.amount_percentage;
            }
            else
            {
                // payment.typeName = self.$filter('filter')(self.payment_types, {id: payment.type}, true)[0].name;
                // payment.percent = self.$filter('filter')(self.payment_type_percents, {id: payment.type}, true)[0].value;
                let filteredName = self.$filter('filter')(self.payment_types, {id: payment.type}, true);
                let filteredPercent = self.$filter('filter')(self.payment_type_percents, {id: payment.type}, true);
                if (filteredName.length > 0) payment.typeName = filteredName[0].name;
                if (filteredPercent.length > 0) payment.percent = filteredPercent[0].value;
            }

            // WEB-4012: a Waiver and a real Refund are both stored as payment type 20
            // (PAYMENT_TYPE_20_REFUND) and both hang off the same "REFUND" payment plan
            // clause, so the clause/payment-type derived typeName above labels BOTH of
            // them "REFUND". Only `payments.refund_type` tells them apart, so override
            // the display label for a Waiver (refund_type = 10). A real Refund
            // (refund_type = 20) and any payment without a refund_type keep the
            // clause-derived name — projects can rename their refund clause and that
            // custom name must still show.
            // Wording is "Interest Waiver", matching the Sale Payments card header and
            // the Flutter app (WEB-4013), so the same record reads the same on web and
            // in the app rather than carrying a third variant. Title case matches the
            // clause names this label sits beside ("Refund", "Balance 20% Deposit"); the
            // card header applies .text-uppercase, so it reads INTEREST WAIVER there and
            // "Interest Waiver" in the plain "Payment Type" field, exactly as a real
            // Refund already behaves.
            // The leading truthy check on refund_type is deliberate: the constants are
            // injected per-page, so on a blade that forgot to inject them a loose
            // `null == undefined` comparison would be TRUE and would mislabel every
            // ordinary refund as a Waiver.
            if (payment.refund_type
                && payment.type == self.PAYMENT_TYPE_20_REFUND
                && payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER) {
                payment.typeName = 'Interest Waiver';
            }

            payment.statusName = self.$filter('filter')(self.payment_statuses, {id: payment.status}, true)[0].name;

            if(payment.type != self.PAYMENT_TYPE_20_REFUND){
                total_payment_amount += payment.amount;
            }

            // add parent payment as childPayment for refund case
            if(payment.payment_id){
                payment.childPayment = self.sale_payments.find(x => x.id === payment.payment_id );
            }

            // calculate waiver amount from other payments
            payment.waiver_amount = self.sale_payments.reduce((acc, _payment) => {
                return _payment.payment_id === payment.id && _payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER ? acc + _payment.amount : acc;
            }, 0);

            let uri = 'sec/assets/presigned-url';

            jQuery.each(payment.instruments, function (index2, instrument) {
                let instrument_type = self.$filter('filter')(self.instrument_types, {id: instrument.type}, true)[0];

                if (instrument_type) {
                    instrument.typeName = instrument_type.name;
                }
                // if (self.banks_master.indexOf(instrument.bank_name) === -1) {
                //     instrument.bank_name_other = instrument.bank_name;
                //     instrument.bank_name = "OTHERS";
                // } else {
                //     if(instrument.bank_name.toLowerCase() != "others")
                //         instrument.bank_name_other = null;
                // }

                // WEB-3660: detect an "Interest Amount" instrument by a NON-ZERO interest
                // amount (including negatives, e.g. a -40 interest adjustment) so the
                // instrument is recognised as interest-mode on load. The old `> 0` check
                // left payment_type_amount unset for negatives, which hid the Interest
                // Amount field (gated on payment_type_amount == 0) when the instrument was
                // re-opened in the Edit modal. parseFloat guards string/null values.
                if(instrument.interest_amount && parseFloat(instrument.interest_amount) != 0)
                {
                    instrument.payment_type_amount = 0;
                }

                if(instrument.amount > 0)
                {
                    instrument.payment_type_amount = 1;
                    instrument.interest_amount = 0;
                }

                if (instrument.file_uri) {
                    self.getPresignedUrl(
                        self.ASSET_MODEL_PAYMENT_INSTRUMENT,
                        instrument.id,
                        function (presignedUrl) {
                            instrument.image_uri = presignedUrl;
                        }
                    );
                }
            });

            if(payment.type == self.PAYMENT_TYPE_20_REFUND){
                // Calculate refund percentage for refund payment
                //
                // WEB-4043: an Interest Waiver is a standalone dated Credit Note, not a
                // portion of an underlying clause payment, so it has no childPayment and
                // the sale_payments reduce below resolves to 0. Dividing by 0 yields
                // Infinity, and (Infinity).toFixed(2) is the truthy string "Infinity", so
                // the blade's `refund_percent ? refund_percent : '--'` fallback never fired
                // and the card rendered "Infinity %". The try/catch is no help — division
                // by zero throws nothing in JS. Skip the calculation for waivers (the row
                // is hidden for them anyway) and guard the division for everything else.
                //
                // The `payment.refund_type &&` truthy check is deliberate: SHOWSUITE.*
                // constants are injected per Blade page, so on a page that forgot the
                // injection self.PAYMENT_REFUND_TYPE_10_WAIVER is undefined and a bare
                // `payment.refund_type == undefined` would be TRUE for every ordinary
                // refund (null == undefined), silently skipping the calculation platform-wide.
                let is_waiver = payment.refund_type && payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER;

                payment.refund_percent = null;

                if (!is_waiver) {
                    try {
                        let refund_payment = payment.childPayment;
                        let paid_amount = 1;

                        if (!refund_payment) {
                            paid_amount = self.sale_payments.reduce((acc, _payment) => {
                                return _payment.type != self.PAYMENT_TYPE_20_REFUND ? acc + _payment.amount : acc;
                            }, 0);
                        } else {
                            paid_amount = refund_payment.amount;
                        }

                        let refund_amount, base_amount;
                        if (payment.overpayment_amount) { // If has overpayment_amount
                            refund_amount = payment.amount - payment.overpayment_amount;
                            base_amount = paid_amount - payment.overpayment_amount;
                        } else {
                            refund_amount = payment.amount;
                            base_amount = paid_amount;
                        }

                        // Only publish a finite percentage — a 0/absent/non-numeric base
                        // leaves refund_percent null so the blade renders '--'.
                        let percent = (refund_amount / base_amount) * 100;
                        if (isFinite(percent)) {
                            payment.refund_percent = percent.toFixed(2) + ' %';
                        }
                    }
                    catch(ex){
                        console.log(ex);
                    }
                }
            }
        });
    }

    viewInterestDetails(payment){
        const self = this;

        if(!payment){
            return;
        }
        self.editViewChargedWaiveOff = false;
        self.selected_payment = payment;
        self.selected_interest = payment.daily_interest_details;
        $.each(self.selected_interest, function (index, interest) {
            if(!interest.status){
                interest.selected = true;
            }else{
                interest.selected = false;
            }
        })
        $("#chargeableInterestDetailsViewModal").modal('show');
    }

    reCalculateInterest(){
        const self = this;
        $("#chargeableInterestDetailsViewModal").modal('hide');
        self.SSConfirmationService.getConfirmed(
            'Confirmation Required',
            'Are you sure you want to re-calculate the interest? If yes, please proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url =
                    "sec/developer/sales/" +
                    self.sale_id +
                    "/payments/" +
                    self.selected_payment.id +
                    "/recalculate-daily-interest";

                loading(true);
                self.SSHttpService.putAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Interest Re-Calculated Successfully.');

                    if(response.data && response.data.payment_daily_interests){

                        // $("#chargeableInterestDetailsViewModal").modal('hide');
                        self.getSalePayments(false); // Sync local data
                        self.$timeout(function(){
                            self.selected_interest = response.data.payment_daily_interests;
                        });
                    }

                });
            }
        );


    }

    getTotalInterest(interest_details){
        const self = this;

        if(!interest_details){
            return 0;
        }

        var total_interest = 0;
        $.each(interest_details, function(index, interest){
            if(!interest.status || interest.status === self.DAILY_INTEREST_STATUS_CHARGEABLE || interest.status === self.DAILY_INTEREST_STATUS_PENDING){
                total_interest += interest.daily_interest;
            }
        });

        return self.SSUtilService.formatCurrency(total_interest);
    }

    /**
     * WEB-3654: Open the "Add Manual Interest" form for the currently-viewed payment.
     *
     * Resets the form/error state, swaps the Interest Details modal for the add
     * modal (Bootstrap modals don't stack cleanly), and (re)attaches the date
     * picker. The picker uses the WEB-3646 re-pin guard because the modal is a
     * fixed-position Bootstrap modal — jQuery UI otherwise bakes the page
     * scrollTop into the calendar's `top`, dropping it below the input.
     *
     * @returns {void}
     * @remarks Gated client-side by DMS_SALES_PAYMENTS_INTEREST_MANUAL_ADD; the server
     *          re-checks the same property-scoped permission.
     */
    openAddManualInterest() {
        const self = this;

        if (!self.selected_payment) {
            return;
        }

        self.manualInterest = {
            value_date: null,
            outstanding_amount: null,
            interest_rate: null,
            daily_interest: null
        };
        self.manualInterestErrors = {};

        $('#chargeableInterestDetailsViewModal').modal('hide');
        $('#addManualInterestModal').modal('show');

        self.$timeout(function () {
            let $picker = jQuery('#manual_interest_value_date');
            try { $picker.datepicker('destroy'); } catch (e) {}
            $picker.datepicker({
                dateFormat: 'dd/mm/yy',
                changeMonth: true,
                changeYear: true,
                maxDate: 0, // WEB-3654: the interest value date cannot be in the future
                beforeShow: function (input, inst) {
                    let $input = jQuery(input);
                    let inFixedContainer = $input.parents().filter(function () {
                        return jQuery(this).css('position') === 'fixed';
                    }).length > 0;

                    if (!inFixedContainer) {
                        return;
                    }

                    setTimeout(function () {
                        inst.dpDiv.css({
                            top: $input.offset().top - jQuery(document).scrollTop() + $input.outerHeight(),
                            left: $input.offset().left - jQuery(document).scrollLeft()
                        });
                    }, 0);
                }
            });
        });
    }

    /**
     * WEB-3654: Close the Add Manual Interest form without saving and return to
     * the Interest Details modal.
     *
     * @returns {void}
     */
    cancelAddManualInterest() {
        const self = this;
        $('#addManualInterestModal').modal('hide');
        $('#chargeableInterestDetailsViewModal').modal('show');
    }

    /**
     * WEB-3654: Validate the Add Manual Interest form.
     *
     * Field rules:
     *  - Date: required, a real DD/MM/YYYY calendar date, not in the future.
     *  - Interest Amount: required, numeric, greater than zero, max 2 decimals.
     *  - Outstanding Amount / Rate: optional (may be left blank); when provided
     *    must be numeric >= 0 with max 2 decimals.
     *
     * The date guard reuses isValidEntryDate() to block the dropped year-digit
     * corruption (WEB-3629) before the value is serialized.
     *
     * @returns {boolean} true when the form passes validation.
     */
    isValidManualInterestInput() {
        const self = this;

        let isValid = true;
        self.manualInterestErrors = {};

        let mi = self.manualInterest || {};

        // Amount / percent values are capped at 2 decimal places.
        let hasMaxTwoDecimals = function (value) {
            let s = value.toString();
            let dot = s.indexOf('.');
            return dot === -1 || (s.length - dot - 1) <= 2;
        };

        // Date — required, a real DD/MM/YYYY calendar date, not in the future.
        if (!mi.value_date) {
            self.manualInterestErrors.value_date = 'Please enter a date.';
            isValid = false;
        } else if (!self.isValidEntryDate(mi.value_date)) {
            self.manualInterestErrors.value_date = 'Please enter a valid date (DD/MM/YYYY).';
            isValid = false;
        } else if (moment(mi.value_date.toString().trim().split(' ')[0], ['DD/MM/YYYY', 'D/M/YYYY'], true).isAfter(moment(), 'day')) {
            self.manualInterestErrors.value_date = 'Date cannot be in the future.';
            isValid = false;
        }

        // Interest Amount — required, numeric, greater than zero, max 2 decimals.
        let interest = mi.daily_interest;
        if (interest === null || interest === undefined || interest === '') {
            self.manualInterestErrors.daily_interest = 'Please enter the interest amount.';
            isValid = false;
        } else if (isNaN(parseFloat(interest)) || parseFloat(interest) <= 0) {
            self.manualInterestErrors.daily_interest = 'Interest amount must be greater than zero.';
            isValid = false;
        } else if (!hasMaxTwoDecimals(interest)) {
            self.manualInterestErrors.daily_interest = 'Interest amount allows at most 2 decimal places.';
            isValid = false;
        }

        // Outstanding Amount & Rate — optional; validate only when provided.
        let optionalNumericFields = [
            { key: 'outstanding_amount', label: 'outstanding amount' },
            { key: 'interest_rate', label: 'rate' }
        ];

        $.each(optionalNumericFields, function (index, field) {
            let value = mi[field.key];
            if (value === null || value === undefined || value === '') {
                return; // optional — leaving it blank is allowed
            }
            if (isNaN(parseFloat(value)) || parseFloat(value) < 0) {
                self.manualInterestErrors[field.key] = 'Please enter a valid ' + field.label + ' (0 or more).';
                isValid = false;
            } else if (!hasMaxTwoDecimals(value)) {
                self.manualInterestErrors[field.key] = 'The ' + field.label + ' allows at most 2 decimal places.';
                isValid = false;
            }
        });

        return isValid;
    }

    /**
     * WEB-3654: Persist a manually-entered interest row for the selected payment.
     *
     * POSTs to sec/developer/sales/{saleId}/payments/{paymentId}/manual-interest.
     * On success the returned row (is_manual=1, status=NULL) is appended to the
     * open list and the page payments are re-synced so totals/badges update.
     *
     * @returns {void}
     */
    saveManualInterest() {
        const self = this;

        if (!self.isValidManualInterestInput()) {
            return;
        }

        let url =
            'sec/developer/sales/' +
            self.sale_id +
            '/payments/' +
            self.selected_payment.id +
            '/manual-interest';

        // Outstanding Amount and Rate are optional. Server validation is nullable
        // and the columns accept NULL (WEB-3654 iter-2), so a blank field is
        // omitted from the payload and stored as NULL (not 0).
        let params = {
            'value_date': self.SSDateService.formateWithTimeAsNoon(self.manualInterest.value_date),
            'daily_interest': self.manualInterest.daily_interest
        };

        let outstanding = self.manualInterest.outstanding_amount;
        if (outstanding !== null && outstanding !== undefined && outstanding !== '') {
            params.outstanding_amount = outstanding;
        }

        let rate = self.manualInterest.interest_rate;
        if (rate !== null && rate !== undefined && rate !== '') {
            params.interest_rate = rate;
        }

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Manual interest entry added.');

            let newEntry = response.data && response.data.payment_daily_interest
                ? response.data.payment_daily_interest
                : null;
            if (newEntry) {
                // New manual rows have a NULL status; mirror viewInterestDetails so
                // they are pre-selected for Charge/Waive like any other unconfirmed row.
                newEntry.selected = !newEntry.status;
                if (!self.selected_interest) {
                    self.selected_interest = [];
                }
                self.selected_interest.push(newEntry);
            }

            // Re-sync the page-level payment data (totals, late-payment badges).
            self.getSalePayments(false);

            $('#addManualInterestModal').modal('hide');
            $('#chargeableInterestDetailsViewModal').modal('show');
        });
    }

    /**
     * WEB-3654: Delete an interest row after confirmation.
     *
     * DELETEs sec/developer/sales/{saleId}/payments/{paymentId}/manual-interest/{interestId}.
     * Offered on every row (auto + manual). On success the row is spliced from
     * the open list and the page payments are re-synced.
     *
     * @param {Object} interest The interest row to delete.
     * @returns {void}
     */
    deleteManualInterest(interest) {
        const self = this;

        if (!interest || !interest.id || !self.selected_payment) {
            return;
        }

        // The confirmation dialog (#confirmationModal, in the layout include) and
        // the Interest Details modal are both Bootstrap modals at the default
        // z-index, and the details modal sits later in the DOM — so showing the
        // confirmation on top renders it BEHIND the details modal. Hide the
        // details modal first (same approach as reCalculateInterest) and reopen
        // it once the confirmation closes, whether the user proceeds or cancels.
        $('#chargeableInterestDetailsViewModal').modal('hide');
        $('#confirmationModal').one('hidden.bs.modal', function () {
            self.$timeout(function () {
                $('#chargeableInterestDetailsViewModal').modal('show');
            });
        });

        self.SSConfirmationService.getConfirmed(
            'Confirmation Required',
            'Are you sure you want to delete this interest entry?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url =
                    'sec/developer/sales/' +
                    self.sale_id +
                    '/payments/' +
                    self.selected_payment.id +
                    '/manual-interest/' +
                    interest.id;

                loading(true);
                self.SSHttpService.deleteAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Interest entry deleted.');

                    if (self.selected_interest) {
                        let idx = self.selected_interest.findIndex(function (item) {
                            return item.id === interest.id;
                        });
                        if (idx > -1) {
                            self.selected_interest.splice(idx, 1);
                        }
                    }

                    // Re-sync the page-level payment data (totals, late-payment badges).
                    self.getSalePayments(false);
                });
            }
        );
    }

    getAvailablePayments() {
        const self = this;

        let availablePayments = [];

        if (self.sale_sales && self.sale_sales.hasOwnProperty("payment_plan_id") && self.sale_sales.payment_plan_id) {
            availablePayments = self.payment_plan_clauses;
        } else {
            if (self.payment_types) {
                jQuery.each(self.payment_types, function (i, _payment_type) {
                    let _a = self.$filter('filter')(self.sale_payments, {type: _payment_type.id}, true);
                    if (!(_a && _a.length)) {
                        availablePayments.push(_payment_type);
                    }
                });
            }
        }

        return availablePayments;
    }

    //-------------------------------------------
    // Save Methods

    /**
     * WEB-3659: Convert a user-entered amount that may carry thousand-separator
     * commas (e.g. the Refund "Due Amount" free-text input value "3,747.36")
     * into a plain Number suitable for the API.
     *
     * The payments endpoint validates `due_amount` with Laravel's `numeric`
     * rule, which rejects any value containing a comma — so the comma-formatted
     * string was being returned as "The due amount must be a number." (412001).
     *
     * @param {string|number|null|undefined} value Raw model value from a free-text amount input.
     * @returns {number|null} The numeric value, or null when blank / non-numeric.
     */
    parseAmountInput(value) {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        let parsed = parseFloat(value.toString().replace(/,/g, '').trim());
        return isNaN(parsed) ? null : parsed;
    }

    savePayment(showPaymentInstrumentPopup) {
        const self = this;

        self.paymentInfoErrors = {};
        if(!self.isValidPaymentInfoInput()){
            return;
        }

        if(!self.paymentInfoParams.Update){
            self.paymentInfoParams.payment_plan_clause_id = self.paymentInfoParams.clause ? self.paymentInfoParams.clause.id : null;
        }
        self.current_payment = angular.copy(self.paymentInfoParams);

        // WEB-3659: the Refund "Due Amount" is a free-text input, so users can
        // type thousand-separator commas (e.g. "3,747.36"). The API validates
        // due_amount as numeric (commas fail), so normalise to a plain Number
        // before POST. Leave null/blank untouched so non-refund flows that omit
        // it are unaffected.
        if (self.current_payment.due_amount !== null && self.current_payment.due_amount !== undefined && self.current_payment.due_amount !== '') {
            self.current_payment.due_amount = self.parseAmountInput(self.current_payment.due_amount);
        }

        // WEB-3670: only an ABORTED sale's refund (type 20) carries a sibling
        // `forfeiture_amount` (refunded + forfeited == total received). A normal
        // refund (e.g. overpayment return) and every other payment type must NOT
        // send it. Normalise commas like due_amount in case it was ever surfaced
        // as a free-text field.
        if (self.current_payment.type == self.PAYMENT_TYPE_20_REFUND && self.isAbortedSale()) {
            if (self.current_payment.forfeiture_amount !== null && self.current_payment.forfeiture_amount !== undefined && self.current_payment.forfeiture_amount !== '') {
                self.current_payment.forfeiture_amount = self.parseAmountInput(self.current_payment.forfeiture_amount);
            }
        } else {
            delete self.current_payment.forfeiture_amount;
        }

        let handleResponse = function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                // WEB-3670 / WEB-3669: abort refund did not fully cancel the sale
                // (refunded + forfeited != total received). Surface the server
                // message inline rather than the generic 412 toast.
                if (response.sub_code == 305043) {
                    self.SSAlertService.danger('Invalid Refund!', response.message || 'Abort refund must fully cancel the sale: refunded + forfeited must equal the total amount received.');
                    return;
                }
                // WEB-3647: surface the API's descriptive message (e.g. a refund
                // tracking-number collision) instead of the generic
                // "Invalid Params!" toast that parseAndDisplayError shows for a 412.
                self.SSAlertService.parseAndDisplayServerError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            let payment = self.updateLocalPaymentObject(response.data.payment);
            self.processSalePayments();
            self.getSaleDetails();

            if (showPaymentInstrumentPopup) {
                self.showPaymentInstrumentPopup(payment);
            }
        };

        if(self.current_payment.serving_date){
            self.current_payment.serving_date = self.formateWithTimeAsMorning(self.current_payment.serving_date);
        }
        self.current_payment.expiry_date = self.formateWithTimeAsMorning(self.current_payment.expiry_date) || null;
        self.current_payment.extended_expiry_date = self.formateWithTimeAsMorning(self.current_payment.extended_expiry_date) || null;
        self.current_payment.due_date = self.formateWithTimeAsMorning(self.current_payment.due_date);
        if(!self.current_payment.interest_rate && self.current_payment.interest_rate === ""){
            self.current_payment.interest_rate = null; // if empty, set null to clear value
        }
        if (self.current_payment.grace_period) {
            let due_date = moment(self.current_payment.due_date, "YYYY-MM-DD HH:mm:ss");
            self.current_payment.expiry_date = due_date.add(self.current_payment.grace_period, 'days').format("DD/MM/YYYY");
            self.current_payment.expiry_date = self.formateWithTimeAsMorning(self.current_payment.expiry_date);
        }

        if (!self.sale_sales.payment_plan_id && self.current_payment.payment_plan_clause_id) {
            self.current_payment.type = angular.copy(self.current_payment.payment_plan_clause_id);
            self.current_payment.payment_plan_clause_id = null;
        }

        let url = 'sec/developer/sales/' + self.sale_id + '/payments';
        let params = self.current_payment;

        loading(true);
        if (self.current_payment.id) {
            url += '/' + self.current_payment.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }

    }

    isValidPaymentInfoInput(){
        const self = this;

        let isValid = true;

        if (!self.paymentInfoParams.clause) {
            self.paymentInfoErrors.type = "Please select a payment clause";
            isValid = false;
        }

        /** WEB-3013 AllGreen : Post Data to SAP single or multiple data selection and post
         * If refund clause, Due amount is required
         */
        if (self.paymentInfoParams.clause.payment_type === self.PAYMENT_TYPE_20_REFUND){
            // WEB-3659: validate the de-comma'd value. parseFloat("3,747.36")
            // returns 3 (stops at the comma), so the old check silently passed a
            // value the API later rejects as non-numeric; parseAmountInput strips
            // the commas and returns null for blank / non-numeric input.
            let dueAmount = self.parseAmountInput(self.paymentInfoParams.due_amount);
            if (dueAmount === null || dueAmount === 0) {
                self.paymentInfoErrors.due_amount = "Please enter a valid due amount";
                isValid = false;
            } else if (self.paymentInfoParams.refund_type == self.PAYMENT_REFUND_TYPE_20_REFUND && self.isAbortedSale()) {
                // WEB-3670: an abort refund must fully cancel the sale —
                // refunded + forfeited == total received — so the refunded
                // amount can never exceed the total received (which would make
                // the forfeiture negative). The server enforces the same rule
                // (sub_code 305043); this is the immediate client-side guard.
                // Only for an aborted sale — a normal refund is unconstrained.
                self.recalculateRefundForfeitureAmount();
                let received = self.paymentInfoParams.total_received_amount;
                if (received != null && dueAmount > parseFloat(received) + 0.005) {
                    self.paymentInfoErrors.due_amount = "Refund cannot exceed the total received amount (" + self.SSAppService.getFormattedAmountWithDecimal(received) + ").";
                    isValid = false;
                }
            }

            // WEB-3641: For a refund, the refund date — labelled "Credit Date" on the popup per
            // WEB-3726 — is required, must be a valid date, and cannot be in the future (current
            // or past dates only).
            // WEB-3718: an Interest Waiver (refund_type = 10) is a dated Credit Note too, so its
            // Credit Date is now editable in the popup and validated by the same rules.
            if (self.paymentInfoParams.refund_type == self.PAYMENT_REFUND_TYPE_20_REFUND
                || self.paymentInfoParams.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER) {
                if (!self.paymentInfoParams.due_date) {
                    self.paymentInfoErrors.due_date = "Please select the credit date";
                    isValid = false;
                } else if (!self.isValidEntryDate(self.paymentInfoParams.due_date)) {
                    self.paymentInfoErrors.due_date = "Please enter a valid credit date";
                    isValid = false;
                } else if (moment(self.paymentInfoParams.due_date.toString().trim().split(' ')[0], ['DD/MM/YYYY', 'D/M/YYYY'], true).isAfter(moment(), 'day')) {
                    self.paymentInfoErrors.due_date = "Credit date cannot be a future date";
                    isValid = false;
                }
            }
        }

        return isValid;
    }

    saveInterestWaiver() {
        const self = this;
        if (!self.isValidInterestWaiverInput()) {
            return;
        }
        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');
            self.updateLocalPaymentObject(response.data.payment);
            // self.current_payment = response.data.payment;
            self.current_payment.waiver_date = self.SSUtilService.formatDateDMY(self.current_payment.waiver_date.split(" ")[0]);
            self.getSaleDetails();
            self.hideModals();

        };

        let url = 'sec/developer/sales/' + self.sale_id + '/payments/' + self.current_payment.id +'/interest-waiver';
        self.current_payment_update = angular.copy(self.current_payment);
        self.current_payment_update.waiver_date = self.formateWithTimeAsMorning(self.current_payment_update.waiver_date);
        let params = self.current_payment_update;

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
    }

    saveSelectionInstrument() {
        const self = this;

        let bank_name = null;
        if (self.current_instrument.bank_name == 'Others') {
            bank_name = self.current_instrument.bank_name_other;
        } else {
            bank_name = self.current_instrument.bank_name;
            self.current_instrument.bank_name_other = null;
        }

        if (self.current_instrument.buyer_has_own_account == 1) {
            self.current_instrument.relationship_with_account_holder = null;
        }

        self.instrument_errors = {};

        if (!self.isValidSelectionInstrumentInput()) {
            return;
        }

        let params = {
            type: self.current_instrument.type,
            bank_name: bank_name,
            account_holder_name: self.current_instrument.account_holder_name,
            relationship_with_account_holder: self.current_instrument.relationship_with_account_holder,
            amount: self.current_instrument.amount,
            file_uri: self.current_instrument.file_uri,
            bank_in_date: self.getFormattedDate(self.current_instrument.bank_in_date),
            status: self.current_instrument.status,
            instrument_no: self.current_instrument.instrument_no
        };

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            self.hideModals();
            self.getSaleUnitDetails();
        };

        loading(true);
        let url = 'sec/sales/' + self.sale_id + '/selections/' + self.current_payment.sale_selection_id + '/payments/' + self.current_payment.id + '/instruments';

        if (self.current_instrument.id) {
            url += '/' + self.current_instrument.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    isValidSelectionInstrumentInput() {
        const self = this;

        let isValid = true;

        if (self.current_instrument.hasOwnProperty("bank_in_date") && self.current_instrument.bank_in_date != null) {
            if (self.isFirstDateBeforeSecondDate(self.current_instrument.bank_in_date, self.current_instrument.cheque_date)) {
                self.instrument_errors.bank_in_date = "Bank in date cannot be earlier than cheque date";
                isValid = false;
            }
        }

        //  'INSTRUMENT_TYPE_FAST_CASH' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_FAST_CASH) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
            // WEB-1127: DMS/ Payments Details page:  Make all Images upload field  Optional
            // if(!self.current_instrument.file_uri){
            //     self.instrument_errors.file_uri = "Please upload the required image";
            //     isValid = false;
            // }
        }

        // 'INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER || self.current_instrument.type == self.INSTRUMENT_TYPE_BANK_TRANSFER) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
        }

        // 'INSTRUMENT_TYPE_GIRO' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_GIRO) {
            // Validation fields: Transaction number, Amount
            // false params for no validation of account holder name
            isValid = self.validateCommonPaymentInputFields(false);

            // Validate 'Receiving Date'
            if (!self.current_instrument.receiving_date) {
                self.instrument_errors.receiving_date = "The receiving date field is required.";
                isValid = false;
            }
        }

        // 'INSTRUMENT_TYPE_DEBIT_CARD' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_DEBIT_CARD) {
            // Validation fields: Transaction number, Amount, Account Holder Name
            isValid = self.validateCommonPaymentInputFields();
        }

        // 'INSTRUMENT_TYPE_CASH_IN' VALIDATION
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CASH_IN) {
            if (!self.current_instrument.amount) {
                self.instrument_errors.amount = "The amount field is required.";
                isValid = false;
            }
        }

        return isValid;
    }

    savePaymentInstrument(reversal = null) {
        const self = this;

        let bank_name = null;
        if (self.current_instrument.bank_name && self.current_instrument.bank_name.toLowerCase() == 'others') {
            bank_name = self.current_instrument.bank_name_other;
        } else {
            bank_name = self.current_instrument.bank_name;
            self.current_instrument.bank_name_other = null;
        }

        let card_company = null;
        if (self.current_instrument.type == self.INSTRUMENT_TYPE_CREDIT_CARD){
            if (self.current_instrument.card_company == 'Others') {
                card_company = self.current_instrument.card_company_other;
            } else {
                card_company = self.current_instrument.card_company;
                self.current_instrument.card_company_other = null;
            }
        }

        if (self.current_instrument.buyer_has_own_account == 1) {
            self.current_instrument.relationship_with_account_holder = null;
            self.current_instrument.non_buyer_payee_id = null;
        }else{
            if(self.non_buyer_payee_settings.enable == 1){
                self.current_instrument.relationship_with_account_holder = null;
            }else{
                if(self.current_instrument.relationship_with_account_holder){
                    self.current_instrument.non_buyer_payee_id = null;
                }
            }
        }

        self.instrument_errors = {};

        // A reversal only flips an already-saved, already-validated instrument to
        // BOUNCED and records the bounce reason/date. The reversal modal exposes ONLY
        // the reason + bounced date — none of the instrument's other fields (cheque /
        // receiving / bank-in dates, amount, …). Running the full isValidPaymentInput()
        // here re-validates those read-only fields and silently blocks the reversal
        // whenever pre-existing data trips a rule (e.g. bank-in date earlier than
        // cheque date, or a stored date not in DD/MM/YYYY form), because the reversal
        // modal renders none of those instrument_errors. So skip the full validation
        // for reversals and validate only the reversal's own inputs.
        if (reversal) {
            self.error_reissue_reason = false;
            self.error_bounced_date = null;

            if (!self.reversal_reason) {
                self.error_reissue_reason = true;
                return;
            }
            if (!self.formatBouncedDateForApi(self.bounced_date_input)) {
                self.error_bounced_date = 'Please select a valid bounced date.';
                return;
            }
        } else if (!self.isValidPaymentInput()) {
            return;
        }

        // WEB-3524 — "GST receiving" flag. Only commercial-unit, non-refund instruments can be GST;
        // anything else is forced to 0 (the server also force-clears it for refunds).
        let is_gst_payment = (self.sale_units && self.sale_units.category == self.UNIT_CATEGORY_COMMERCIAL
            && self.current_payment.type != self.PAYMENT_TYPE_20_REFUND
            && self.current_instrument.is_gst_payment == 1) ? 1 : 0;

        let params = {
            type: self.current_instrument.type,
            bank_name: bank_name,
            account_holder_name: self.current_instrument.account_holder_name,
            relationship_with_account_holder: self.current_instrument.relationship_with_account_holder,
            instrument_no: self.current_instrument.instrument_no,
            amount: self.current_instrument.amount,
            interest_amount: self.current_instrument.interest_amount,
            file_uri: self.current_instrument.file_uri,
            property_account_id: self.current_instrument.property_account_id,
            cheque_date: self.getFormattedDate(self.current_instrument.cheque_date),
            cheque_amount:self.current_instrument.cheque_amount,
            receiving_date: self.getFormattedDate(self.current_instrument.receiving_date),
            bank_in_date: self.getFormattedDate(self.current_instrument.bank_in_date),
            status: self.current_instrument.status,
            remarks: self.current_instrument.remarks,
            bounced_reason: self.current_instrument.bounced_reason,
            bounced_date: self.current_instrument.bounced_date,
            created_by: self.current_instrument.created_by,
            updated_by: self.current_instrument.updated_by,
            card_company: card_company,
            non_buyer_payee_id: self.current_instrument.non_buyer_payee_id,
            is_gst_payment: is_gst_payment,
        };

        if (self.reversal_reason) {
            params.bounced_reason = self.reversal_reason;
        }

        if (reversal) {
            params.bounced_date = self.formatBouncedDateForApi(self.bounced_date_input);
        }

        var user_id = self.SSUserService.getUser().id;
        if (self.current_instrument.created_by) {
            params.updated_by = user_id;
        } else {
            params.created_by = user_id;
        }

        if (self.current_instrument.type != self.INSTRUMENT_TYPE_CHEQUE
            && self.current_instrument.type != self.INSTRUMENT_TYPE_CASHIERS_ORDER) {
            params.cheque_date = null;
            params.cheque_amount = null;
        }

        self.cleanupExtraFields(params);

        self.instrument_errors.non_buyer_payee_id = null;

        // Skip on the reversal path (same reasoning as the isValidPaymentInput() skip
        // above): a reversal never edits the 3rd-party payor, and this error is written
        // to instrument_errors.non_buyer_payee_id, which the reversal modal does not
        // render — so re-checking it would silently block the reversal if
        // non_buyer_payee_settings was toggled on after the instrument was created (or
        // for a legacy instrument).
        if(!reversal
            && self.current_instrument.buyer_has_own_account == 0
            && self.non_buyer_payee_settings.enable == 1
            && !self.current_instrument.non_buyer_payee_id) {

            self.instrument_errors.non_buyer_payee_id = "Please select the 3rd Party Payor. If your 3rd Party Payor is not in the list, please go to \"3rd Party Payor Details\" section and add the required entity.";
            return;
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Saved successfully.');

            self.hideModals();
            self.updateLocalPaymentObject(response.data.payment);
            self.reversal_reason = null;
            self.processSalePayments();
            if(self.property_accounts_master) self.property_accounts = angular.copy(self.property_accounts_master);
        };

        loading(true);
        let url = 'sec/developer/sales/' + self.sale_id + '/payments/' + self.current_payment.id + '/instruments';

        if (self.current_instrument.id) {
            url += '/' + self.current_instrument.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    cleanupExtraFields(current_instrument){
        const self = this;

        let instrument = self.instrument_visible_fields[current_instrument.type];
        instrument.id = true;
        instrument.type = true;
        instrument.status = true;
        instrument.remarks = true;
        instrument.non_buyer_payee_id = true;
        instrument.property_account_id = true;
        instrument.bounced_reason = true;
        instrument.bounced_date = true;
        instrument.is_gst_payment = true; // WEB-3524 — keep the GST flag regardless of instrument type

        $.each(current_instrument, function(key, value) {
            if(!instrument[key]){
                current_instrument[key] = null;
            }
        });
    }

    addPaymentPlan(){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/payment-plan';
        let params = {
            payment_plan_id: self.selected_payment_plan_id,
        };

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Payment plan added successfully.');
            self.getSaleDetails();
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
    }

    getFormattedDate(date) {
        const self = this;

        try {
            if (date != '' && date != null) {
                var _date = '';

                // IF TIME IS ALSO THERE THEN SPLIT ONLY DATE PART
                if (date.includes(' ')) {
                    date = date.split(" ")[0];
                }

                _date = self.SSDateService.formateWithTimeAsNoon(date);

                if (!_date) {
                    return null;
                }

                // WEB-3629 — backstop: never forward an out-of-range date to the server.
                // A mistyped short year (e.g. "16/06/206") becomes "206-06-16 ..." here,
                // which MySQL DATETIME coerces to "0000-00-00 00:00:00". Drop out-of-range
                // years (return null) so a malformed date is never persisted, even from
                // callers that bypass isValidPaymentInput().
                let year = parseInt(_date.split('-')[0], 10);
                if (isNaN(year) || year < 1000 || year > 9999) {
                    return null;
                }

                // return new Date(self.parseDate(_date));
                return _date;
            } else {
                return null;
            }
        } catch (ex) {
            console.log(ex);
        }
    }

    formateWithTimeAsMorning(date){
        if (!date) {
            return;
        }

        if (date.indexOf('/') > -1) {
            var array = date.split('/', 3);
            date = array[2] + '-' + array[1] + '-' + array[0];
        }

        return date + ' 12:00:00';
    }

    parseDate(date) {
        const self = this;

        let parsed = Date.parse(date);
        if (!isNaN(parsed)) {
            return parsed;
        }

        return Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' '));
    }

    updateLocalPaymentObject(newPayment) {
        const self = this;

        let existingPayment = null;

        jQuery.each(self.sale_payments, function (i, _payment) {
            if (_payment.id == newPayment.id) {
                existingPayment = _payment;
                return false;
            }
        });

        if (existingPayment) {
            angular.merge(existingPayment, newPayment);
        } else {
            self.sale_payments.push(newPayment);
        }

        return existingPayment ? existingPayment : newPayment;
    }

    paymentInstrumentBounced(payment, instrument) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.current_payment = payment;
                self.current_instrument = angular.copy(instrument);

                self.current_instrument.status = self.INSTRUMENT_STATUS_BOUNCED;

                self.savePaymentInstrument();
            }
        );
    }

    deleteSelectionInstrument(payment, instrument) {

        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {
                self._deleteSelectionInstrument(payment, instrument);
            }
        );
    }

    _deleteSelectionInstrument(payment, instrument) {
        const self = this;

        let url = 'sec/sales/' + self.sale_id + '/selections/' + payment.sale_selection_id + '/payments/' + payment.id + '/instruments/' + instrument.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Selection Instrument deleted successfully.');
            self.getSaleUnitDetails();

        });

    }

    _deletePaymentInstrument(payment, instrument) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/payments/' + payment.id + '/instruments/' + instrument.id + '/delete';
        let params = {
            'saleId': self.sale_id,
            'paymentId': payment.id,
            'instrumentId': instrument.id
        };
        /*'bank_date' : self.bank_date,*/
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Payment Instrument deleted successfully.');
            // if(instrument && payment) {
            //payment.instruments.splice(instrument,1);
            // }
            self.getSalePayments();

        });

    }

    deletePayment(payment_id, $event) {

        const self = this;

        $event.stopPropagation();

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {

                //self.OTPService.getVerified(
                // self.OTPService.TYPE_SESSION_2FA,
                // function (data) {
                self._deletePayment(payment_id);
                // }
                // );
            }
        );
    }

    deletePaymentInstrument(payment, instrument) {

        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function (selectedOption) {

                //self.OTPService.getVerified(
                // self.OTPService.TYPE_SESSION_2FA,
                // function (data) {
                self._deletePaymentInstrument(payment, instrument);
                // }
                // );
            }
        );
    }

    _deletePayment(payment_id) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/payments/' + payment_id + '/delete';
        let params = {
            'saleId': self.sale_id,
            'paymentId': payment_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'Payment deleted successfully.');
            // if(instrument && payment) {
            //payment.instruments.splice(instrument,1);
            // }
            self.getSaleDetails();
        });

    }

    /**
     * Resolve the default Refund Due Date for a NEW refund, derived from sale context.
     *
     * WEB-3641 (Scenario 1 & 3): the refund due date must NOT be inherited from the
     * parent payment / clause (that leaked the OTP date onto refunds). Instead:
     *   - Aborted OR re-issued sale -> the date the user entered in the Abort/Re-issue
     *     popup, which is persisted on the sale as otp_aborted_date
     *   - All other cases           -> empty (user picks manually)
     *
     * @returns {string|null} a DD/MM/YYYY date string, or null when the field should start empty.
     */
    resolveRefundDueDate() {
        const self = this;
        const sale = self.sale_sales;

        if (sale
            && sale.otp_aborted_date
            && sale.otp_aborted_date != '0000-00-00 00:00:00') {
            return self.getLocaleDate(sale.otp_aborted_date);
        }
        return null;
    }

    //-------------------------------------------
    // Show Popup Methods

    showPaymentPopup(payment, $event, typeRefund = false) {
        const self = this;

        if ($event) {
            $event.stopPropagation();
        }

        self.hideModals();
        self.paymentInfoParams = {};
        self.paymentInfoErrors = {};

        if(payment){
            if(typeRefund === self.PAYMENT_REFUND_TYPE_20_REFUND){
                // Need to check for developer settings. If settings don't exist do not proceed.
                let refundPaymentSettings = self.SettingsService.getSetting(self.developerSettings, 'refund_payment_tracking_no');
                if(!refundPaymentSettings) {
                    self.SSAlertService.danger('Error!', 'Please add settings for refund payments');
                    return;
                }
            }
            self.paymentInfoParams = angular.copy(payment);
            self.paymentInfoParams.paymentId = payment.id;
            self.paymentInfoParams.clause = self.getClauseById(payment.payment_plan_clause_id);
            self.filteredPaymentPlanClauses = self.getFilteredPaymentPlanClauses(self.paymentInfoParams.clause, typeRefund);

            if(self.paymentInfoParams.clause){
                self.paymentInfoParams.type = self.paymentInfoParams.clause.id;
            }

            self.paymentInfoParams.serving_date = payment.serving_date ? self.getLocaleDate(payment.serving_date) : self.today;
            self.paymentInfoParams.due_date = payment.due_date ? self.getLocaleDate(payment.due_date) : null;
            self.paymentInfoParams.expiry_date = payment.expiry_date ? self.getLocaleDate(payment.expiry_date) : null;
            self.paymentInfoParams.extended_expiry_date = payment.extended_expiry_date? self.getLocaleDate(payment.extended_expiry_date) : null;

            if (self.paymentInfoParams.serving_letter_uri) {
                let extension = self.paymentInfoParams.serving_letter_uri.substr((self.paymentInfoParams.serving_letter_uri.lastIndexOf('.') +1));

                if(extension == 'pdf'){
                    self.paymentInfoParams.file_uri = '/images/pdf-placeholder.png';
                }
                else{
                    self.getPresignedUrl(
                        self.ASSET_MODEL_PAYMENT_SERVING_LETTER,
                        self.paymentInfoParams.paymentId,
                        function (presignedUrl) {
                            self.paymentInfoParams.file_uri = presignedUrl;
                        }
                    );
                }
            }

            self.paymentInfoParams.Update = true;
            if(typeRefund && payment.type == self.PAYMENT_TYPE_20_REFUND || typeRefund == self.PAYMENT_REFUND_TYPE_10_WAIVER|| typeRefund == self.PAYMENT_REFUND_TYPE_20_REFUND){
                // Note: In case of new Payment setting parameters
                // to fetch latest clauses into array
                self.paymentInfoParams.clause = self.filteredPaymentPlanClauses.find(x => x.code === 'REFUND');
                self.paymentInfoParams.serving_letter_uri = null;
                self.paymentInfoParams.tracking_no = null;
                self.paymentInfoParams.type = self.PAYMENT_TYPE_20_REFUND;
                // To show payment name if existed in pop up
                self.paymentInfoParams.payment_id = payment.id;
                self.paymentInfoParams.childPayment = payment;
                self.paymentInfoParams.id = null;
                // To remove payment plan clause for refund type
                if(self.paymentInfoParams.payment_plan_clause_id === 'REFUND'){
                    self.paymentInfoParams.payment_plan_clause_id = null;
                }
                self.paymentInfoParams.Update = false;
                if(typeRefund == self.PAYMENT_REFUND_TYPE_10_WAIVER || payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER){
                    self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_10_WAIVER;
                    if(typeRefund == self.PAYMENT_REFUND_TYPE_10_WAIVER ) {
                        self.paymentInfoParams.due_amount = parseFloat(self.paymentInfoParams.late_payment).toFixed(2);
                        // WEB-3718: a new Interest Waiver Credit Note defaults to today's Credit Date
                        // (a valid, non-future date), instead of inheriting the parent clause's
                        // due_date which may be in the future and would fail the credit-date
                        // validation. The user can still change it in the popup before saving.
                        self.paymentInfoParams.due_date = moment().format("DD/MM/YYYY");
                    }
                }
                else{
                    self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_20_REFUND;
                    // WEB-3641 (Scenario 1 & 3): do NOT inherit the parent payment's due_date
                    // (it leaked the OTP/clause date onto the refund). Default from sale context.
                    self.paymentInfoParams.due_date = self.resolveRefundDueDate();
                    self.paymentInfoParams.amount_calculation = '100';
                    self.calculatePaymentRefundAmount(100);
                }
            }
            else if(!typeRefund && payment.type == self.PAYMENT_TYPE_20_REFUND){
                self.paymentInfoParams.clause = self.filteredPaymentPlanClauses.find(x => x.code === 'REFUND');
                // To show payment name if existed in edit mode
                if(self.paymentInfoParams.hasOwnProperty('payment_id') && self.paymentInfoParams.payment_id) {
                    self.paymentInfoParams.childPayment = self.sale_payments.find(x => x.id === self.paymentInfoParams.payment_id);
                }
                self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_20_REFUND;
                self.paymentInfoParams.amount_calculation = '100';
                if(payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER){
                    self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_10_WAIVER;
                    if(typeRefund == self.PAYMENT_REFUND_TYPE_10_WAIVER ) {
                        self.paymentInfoParams.due_amount = parseFloat(self.paymentInfoParams.late_payment).toFixed(2);
                    }
                }
            }
        }
        else{
            self.filteredPaymentPlanClauses = self.getFilteredPaymentPlanClauses();
            self.paymentInfoParams.serving_date = self.today;
            self.paymentInfoParams.status = self.PAYMENT_STATUS_RECEIVED
        }

        // WEB-3908: with the project's Billing-Date lock ON, show the served date in the (now
        // read-only) Billing Date field from the moment the modal opens, so an existing payment
        // whose stored dates differ does not display a value the next save would silently replace.
        self.syncBillingDateWithNoticeServedDate();

        // WEB-3641: the modal's date inputs sit inside clause/refund-type ng-if
        // blocks, so binding the datepickers synchronously here (before Angular
        // renders them) misses the fields opened via the Refund button and others.
        // Defer the bind to after the modal has rendered (see helper).
        self.initPaymentModalDatePickers();

        $('#PaymentModal06').modal('show');
        if(self.paymentInfoParams.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER){
            $('#PaymentModal06').css('overflow-y','scroll');
        }
    }

    uploadSelectionFiles(files, instrument, upload_type, document_kind, selection) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/sales/' + self.sale_id + '/selections/' + self.current_payment.selection_id + '/payments/' + self.current_payment.id + '/instruments/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            instrument['file_uri'] = response.config.data.key;
            instrument.file = file;
        });
    }

    replaceSelectionFiles(files, upload_type, document_kind, documentObj, selection) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let callback = self.uploadSelectionFiles(files, documentObj, upload_type, document_kind, selection);

        self.removeSelectionFile(documentObj, callback);
    }

    removeSelectionFile(documentObj, callback) {
        const self = this;

        documentObj.file_uri = null;
        documentObj["show_file_url"] = null;
        documentObj.file = null;

        if (callback) {
            callback;
        }
    }

    showSelectionInstrumentPopup(payment, instrument) {
        const self = this;

        self.instrument_errors = {};

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self.current_payment = payment;

                if (instrument) {
                    self.current_instrument = angular.copy(instrument);
                    self.current_instrument.bank_code = self.getPropertyBankCode(self.current_instrument.property_account_id);
                    let today = '';

                    if (self.current_instrument.cheque_date) {
                        self.current_instrument.cheque_date = self.SSUtilService.formatDateDMY(self.current_instrument.cheque_date.split(" ")[0]);
                    } else {
                        // Set default to today date
                        self.current_instrument.cheque_date = today;
                    }

                    if (self.current_instrument.receiving_date) {
                        self.current_instrument.receiving_date = self.SSUtilService.formatDateDMY(self.current_instrument.receiving_date.split(" ")[0]);
                    } else {
                        // Set default to today date
                        self.current_instrument.receiving_date = today;
                    }


                    if (self.current_instrument.bank_in_date) {
                        self.current_instrument.bank_in_date = self.SSUtilService.formatDateDMY(self.current_instrument.bank_in_date.split(" ")[0]);
                    } else {
                        // If sale is imported from excel, then don't populate Bank-in Date
                        if (!self.sale_sales.added_from_import) {
                            // Set default to today date
                            self.current_instrument.bank_in_date = today;
                        }
                    }
                    // If 'relationship_with_account_holder' parameter is empty/null then it
                    // means buyer has own account, then set respective value for radio button(s)
                    if (!self.current_instrument.relationship_with_account_holder) {
                        self.current_instrument.buyer_has_own_account = 1;
                    } else {
                        self.current_instrument.buyer_has_own_account = 0;
                    }
                } else {
                    self.current_instrument = {
                        status: self.INSTRUMENT_STATUS_RECEIVED
                    };
                }

                self.hideModals();

                $('#SelectionInstrumentModal06').modal('show');
                $('#SelectionInstrumentModal06').css('overflow-y', 'auto');
            });
    }

    showPaymentInstrumentPopup(payment, instrument) {
        const self = this;

        self.instrument_errors = {};
        self.instrument_visible_fields = {};
        // self.OTPService.getVerified(
        //     self.OTPService.TYPE_SESSION_2FA,
        //     function (data) {
                self.current_payment = payment;

                if (instrument) {

                    self.instrument_visible_fields[instrument.type] = {};

                    self.current_instrument = angular.copy(instrument);

                    // let bank_name = self.banks_master.find(x => x.name == self.current_instrument.bank_name);
                    // if(!bank_name){
                    //     self.current_instrument.bank_name_other = self.current_instrument.bank_name_other? self.current_instrument.bank_name_other : self.current_instrument.bank_name;
                    //     self.current_instrument.bank_name = 'OTHERS';
                    // }

                    if (self.banks_master.indexOf(self.current_instrument.bank_name) === -1) {
                        self.current_instrument.bank_name_other = self.current_instrument.bank_name;
                        self.current_instrument.bank_name = "OTHERS";
                    } else {
                        if(self.current_instrument.bank_name.toLowerCase() != "others")
                            self.current_instrument.bank_name_other = null;
                    }

                    self.current_instrument.bank_code = self.getPropertyBankCode(self.current_instrument.property_account_id);
                    let today = '';

                    if (self.current_instrument.cheque_date) {
                        self.current_instrument.cheque_date = self.SSUtilService.formatDateDMY(self.current_instrument.cheque_date.split(" ")[0]);
                    } else {
                        // Set default to today date
                        self.current_instrument.cheque_date = today;
                    }

                    if (self.current_instrument.receiving_date) {
                        self.current_instrument.receiving_date = self.SSUtilService.formatDateDMY(self.current_instrument.receiving_date.split(" ")[0]);
                    } else {
                        // Set default to today date
                        self.current_instrument.receiving_date = today;
                    }


                    if (self.current_instrument.bank_in_date) {
                        self.current_instrument.bank_in_date = self.SSUtilService.formatDateDMY(self.current_instrument.bank_in_date.split(" ")[0]);
                    } else {
                        // If sale is imported from excel, then don't populate Bank-in Date
                        if (!self.sale_sales.added_from_import) {
                            // Set default to today date
                            self.current_instrument.bank_in_date = today;
                        }
                    }

                    // If 'relationship_with_account_holder' parameter is empty/null then it
                    // means buyer has own account, then set respective value for radio button(s)
                    if ((!self.current_instrument.relationship_with_account_holder && self.non_buyer_payee_settings.enable==0) || (self.non_buyer_payee_settings.enable == 1 && !self.current_instrument.non_buyer_payee_id)) {
                        self.current_instrument.buyer_has_own_account = 1;
                    } else {
                        self.current_instrument.buyer_has_own_account = 0;
                    }

                    // WEB-3524 — normalise the GST flag to 1/0 so the YES/NO radio binds correctly
                    self.current_instrument.is_gst_payment = (self.current_instrument.is_gst_payment == 1) ? 1 : 0;
                } else {
                    self.current_instrument = {
                        status: self.INSTRUMENT_STATUS_RECEIVED,
                        type: 1,
                        payment_type_amount: 1,
                        buyer_has_own_account: 1,
                        is_gst_payment: 0 // WEB-3524 — default new instruments to non-GST
                    };
                }

                if (self.current_payment.type == self.PAYMENT_TYPE_14_MAINTENANCE_FEE) {
                    self.property_accounts = self.property_accounts_master.filter(x => x.account_type == self.PROPERTY_ACCOUNT_TYPE_MANAGING_COUNCIL_ACCOUNT)
                } else if (self.current_payment.type == self.PAYMENT_TYPE_15_SURVEY_FEE) {
                    self.property_accounts = self.property_accounts_master.filter(x => x.account_type == self.PROPERTY_ACCOUNT_TYPE_CURRENT_ACCOUNT)
                } else {
                    self.property_accounts = angular.copy(self.property_accounts_master);
                }

                self.hideModals();

                $('#PaymentInstrumentModal06').modal('show');
                $('#PaymentInstrumentModal06').css('overflow-y', 'auto');
            // });
    }

    showPaymentRefundPopup($event) {
        const self = this;

        // $event.stopPropagation();

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Please confirm to proceed.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                let existingPayment = self.hasRefundPayment();

                if (existingPayment) {
                    self.showPaymentInstrumentPopup(existingPayment);
                } else {
                    self.current_payment = {
                        type: self.PAYMENT_TYPE_20_REFUND
                    };

                    self.savePayment(true);
                }
            }
        );
    }

    hasRefundPayment() {
        const self = this;

        let existingPayment = null;

        jQuery.each(self.sale_payments, function (i, _payment) {
            if (_payment.type == self.PAYMENT_TYPE_20_REFUND) {
                existingPayment = _payment;
                return false;
            }
        });

        return existingPayment;
    }

    //-------------------------------------------

    uploadServingLetter(files, certificate_document) {
        const self = this;

        self.paymentInfoErrors.serving_letter_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.paymentInfoErrors.serving_letter_uri = 'Please upload PDF or image file only';
            return;
        }

        // Show 'image' preview
        if(format_type == self.PROPERTY_DOCUMENT_FORMAT_IMG){
            var reader = new FileReader();
            reader.onload = function(event) {
                certificate_document['file_uri'] = event.target.result;
            }
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(file);
        }
        else{
            certificate_document['file_uri'] = '/images/pdf-placeholder.png';
        }

        let policyUrl = 'sec/developer/sales/' + self.sale_id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            certificate_document['serving_letter_uri'] = response.config.data.key;
        });
    }

    replaceServingLetter(files, documentObj) {
        const self = this;

        self.paymentInfoErrors.serving_letter_uri = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.paymentInfoErrors.serving_letter_uri = 'Please upload PDF or image file only';
            return;
        }

        let callback = self.uploadServingLetter(files, documentObj);

        self.removeServingLetter(documentObj, callback);
    }

    removeServingLetter(documentObj, callback) {
        const self = this;

        documentObj.serving_letter_uri = null;
        documentObj["show_file_url"] = null;

        callback;
    }

    buyerAddressFormat(address, type) {
        const self = this;

        let address_line1 = null;
        let address_line2 = null;

        jQuery.each(address, function (name, value) {
            if (name == 'line1' && value !== null) {
                address_line1 = value;
            }
            if (name == 'line2' && value !== null) {
                address_line1 += value;
            }
            if (name == 'unit_no' && value !== null) {
                address_line1 += value;
            }

            if (name == 'district' && value !== null) {
                address_line2 = value;
            }
            if (name == 'country' && value !== null) {
                address_line2 += value;
            }
            if (name == 'postalcode' && value !== null) {
                address_line2 += value;
            }

        });

        if (type == 'primary') {
            self.primary_address = {
                address_line1: address_line1,
                address_line2: address_line2
            };
        } else {
            self.mailing_address = {
                address_line1: address_line1,
                address_line2: address_line2
            };
        }


    }

    getBuyerDetails() {
        const self = this;

        let url = 'sec/buyers/' + self.buyer_detail.buyer_id;
        let params = {
            'buyerId': self.buyer_detail.buyer_id,
            'include': 'individual,' +
                ' company, ' +
                'primary_address,' +
                ' mailing_address,' +
                ' email_contact,' +
                ' phone1_contact, ' +
                'phone2_contact,' +
                ' documents,' +
                ' officers,' +
                ' lawyers'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //get sale details
            self.buyer = response.data;

        });
    }

    prepareDeveloperProperties() {
        const self = this;

        let url = 'sec/developer/properties';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;

            self.$timeout(function () {
                $("select.dashboard-select#property-select").niceSelect('update');
            });

            self.retrieveApplications();
        });
    }

    displayControls(index, sale) {
        const self = this;

        self.selected_sale = sale;

        let close = true;
        if ($("#control_" + index).hasClass("show")) {
            close = false;
        }

        $(".controls").removeClass("show");

        if (close) {
            $("#control_" + index).toggleClass("show");
        }
    }

    onAcceptConfirm() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_APPROVED
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_APPROVED;
            self.SSAlertService.success('Success!', 'Sale is approved successfully.');

            self.onOTP();
        });
    }

    onOTP() {
        const self = this;

        self.hideModals();

        self.showOTPModal = true;
        $('#developerSaleApplicationOTPModal').modal('show');
    }

    onRejectConfirm() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/status';
        let params = {
            'status': self.SALE_STATUS_REJECTED
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.selected_sale.status = self.SALE_STATUS_REJECTED;
            self.SSAlertService.success('Success!', 'Sale is rejected successfully.');
        });
    }

    generateOTP() {
        const self = this;

        let url = 'sec/developer/sales/' + self.selected_sale.id + '/generate-otp';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();
            self.selected_sale.status = self.SALE_STATUS_OTP;

            let sale_document = response.data.sale_document;
            self.selected_sale.documents.push(sale_document);

            self.SSAlertService.success('Success!', 'OTP is generated successfully.');

            url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': sale_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                //Open OTP in new tab
                window.open(response.data.presigned_url, '_blank');
            });
        });
    }

    executeSpa(sale) {
        const self = this;

        let url = 'sec/developer/sales/' + sale.id + '/enter-spa';
        let params = {
            'saleId': sale.id,
            'spa_date': "2018-06-14"
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.spaStatus = response.data;
            self.SSAlertService.success('Success!', 'SPA date saved successfully.');
        });
    }

    executeExercise(sale) {
        const self = this;

        let url = 'sec/developer/sales/' + sale.id + '/exercise';
        let params = {
            'saleId': sale.id,
            'exercise_date': "2018-06-14"
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.spaStatus = response.data;
            self.SSAlertService.success('Success!', 'Exercise date saved successfully.');
        });
    }

    executeExtend(sale) {
        const self = this;

        let url = 'sec/developer/sales/' + sale.id + '/extend';
        let params = {
            'saleId': sale.id,
            'expiry_date': "2018-06-14"
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Update sale status
            self.spaStatus = response.data;
            self.SSAlertService.success('Success!', 'Date Extended successfully.');
        });
    }

    viewOTP() {
        const self = this;

        let sale_document = self.selected_sale.documents.filter(x => x.type === self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED && x.document_kind === self.PROPERTY_DOCUMENT_KIND_OTP);

        if (sale_document.length > 0) {
            let url = 'sec/assets/presigned-url';
            let params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': sale_document[0].id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                //Open OTP in new tab
                window.open(response.data.presigned_url, '_blank');
            });
        }

    }

    prepareSaleStatuses() {
        const self = this;

        self.sale_statuses = [
            {
                id: self.SALE_STATUS_DRAFT,
                name: "Draft"
            },
            {
                id: self.SALE_STATUS_PENDING,
                name: "Pending"
            },
            {
                id: self.SALE_STATUS_SUBMITTED,
                name: "Submitted"
            },
            {
                id: self.SALE_STATUS_VERIFIED,
                name: "Verified"
            },
            {
                id: self.SALE_STATUS_APPROVED,
                name: "Approved"
            },
            {
                id: self.SALE_STATUS_REJECTED,
                name: "Rejected"
            },
            {
                id: self.SALE_STATUS_OTP,
                name: "OTP Generated"
            },
            {
                id: self.SALE_STATUS_CHEQUE_ENTERED,
                name: "Cheque Entered"
            },
            {
                id: self.SALE_STATUS_SPA_ENTERED,
                name: "SPA Entered"
            },
            {
                id: self.SALE_STATUS_EXTENDED,
                name: "Sale Extended"
            },
            {
                id: self.SALE_STATUS_EXERCISED,
                name: "Sale Exercised"
            },
            {
                id: self.SALE_STATUS_EXPIRED,
                name: "Sale Expired"
            },
            {
                id: self.SALE_STATUS_ABORTED,
                name: "Sale Aborted"
            },
            {
                id: self.SALE_STATUS_INVALID,
                name: "Sale Invalid"
            },
            {
                id: self.SALE_STATUS_DONE,
                name: "Sale Completed"
            },
            {
                id: self.SALE_STATUS_DELETED,
                name: "Sale Deleted"
            }
        ];

        self.$timeout(function () {
            $("select.dashboard-select#status-select").niceSelect('update');
        });
    }

    /**
     * WEB-3614 — Build the Subsale Draft/Approved status list (mirrors prepareSaleStatuses).
     */
    prepareSubsaleStatuses() {
        const self = this;

        self.subsale_statuses = [
            {
                id: self.SUBSALE_STATUS_DRAFT,
                name: "Draft"
            },
            {
                id: self.SUBSALE_STATUS_APPROVED,
                name: "Approved"
            }
        ];
    }

    /**
     * WEB-3614 — Resolve a subsale status value to its display label.
     * @param {number} status One of SUBSALE_STATUS_*.
     * @returns {string} The label, or '--' when unknown.
     */
    getSubsaleStatusLabel(status) {
        const self = this;

        let found = self.subsale_statuses
            ? self.subsale_statuses.find(x => x.id === status)
            : null;
        return found ? found.name : '--';
    }

    prepareEoiStatuses() {
        const self = this;
        self.eoi_statuses = [
            {
                id: self.EOI_STATUS_DRAFT,
                name: "Draft"
            },
            {
                id: self.EOI_STATUS_TRANSFERRED,
                name: "Transferred"
            },
            {
                id: self.EOI_STATUS_SUBMITTED,
                name: "Submitted"
            },
            {
                id: self.EOI_STATUS_VERIFIED,
                name: "Verified"
            },
            {
                id: self.EOI_STATUS_WITHDRAWN,
                name: "Withdrawn"
            },
            {
                id: self.EOI_STATUS_REJECTED,
                name: "Rejected"
            },
            {
                id: self.EOI_STATUS_REGISTERED,
                name: "Registered"
            },
            {
                id: self.EOI_STATUS_SUCCESSFUL,
                name: "Successful"
            },
            {
                id: self.EOI_STATUS_UNSUCCESSFUL,
                name: "Unsuccessful"
            },
            {
                id: self.EOI_STATUS_COMPLETED,
                name: "Completed"
            }
        ];

        self.$timeout(function () {
            $("select.dashboard-select#status-select").niceSelect('update');
        });
    }

    onReview(sale) {
        const self = this;

        self.$window.location.href = '/developer/sales/applications/review?sale_id=' + sale.id;

    }

    onAccept(sale) {
        const self = this;

        self.hideModals();

        self.showAccept = true;
        $('#developerSaleApplicationAcceptModal').modal('show');
    }

    onReject(sale) {
        const self = this;

        self.hideModals();

        self.showReject = true;
        $('#developerSaleApplicationRejectModal').modal('show');
    }

    hideModals() {
        const self = this;

        self.showReview = false;
        self.showAccept = false;
        self.showReject = false;
        self.showAgent = false;
        self.showBuyer = false;
        self.showSaleBuyer = false;
        self.showOTPModal = false;
        self.show_send_email = false;
        self.email_phone_modal = false;
        self.showInfoModal = false;
        self.show_upload_document_modal = false;
        self.registerEoiAgentModal = false;
        self.downloadReportModal = false;
        self.showSelectionEmailModal = false;
        self.showSelectionEditModal = false;
        self.displayReorderBuyersModal = false;
        self.showViewDetailModal = false;

        if ($('#developerSaleApplicationReviewModal').is(':visible')) $('#developerSaleApplicationReviewModal').modal('hide');
        if ($('#developerSalePriceAcceptModal').is(':visible')) $('#developerSalePriceAcceptModal').modal('hide');
        if ($('#developerSaleApplicationAcceptModal').is(':visible')) $('#developerSaleApplicationAcceptModal').modal('hide');
        if ($('#developerSaleApplicationRejectModal').is(':visible')) $('#developerSaleApplicationRejectModal').modal('hide');
        if ($('#developerSaleApplicationAgentModal').is(':visible')) $('#developerSaleApplicationAgentModal').modal('hide');
        if ($('#developerSaleApplicationBuyerModal').is(':visible')) $('#developerSaleApplicationBuyerModal').modal('hide');
        if ($('#developerSaleApplicationOTPModal').is(':visible')) $('#developerSaleApplicationOTPModal').modal('hide');
        if ($('#executeSPAModal').is(':visible')) $('#executeSPAModal').modal('hide');

        if ($('#PaymentModal06').is(':visible')) $('#PaymentModal06').modal('hide');
        if ($('#PaymentInstrumentModal06').is(':visible')) $('#PaymentInstrumentModal06').modal('hide');
        if ($('#SelectionInstrumentModal06').is(':visible')) $('#SelectionInstrumentModal06').modal('hide');

        if ($('#LawyerDetailModal').is(':visible')) $('#LawyerDetailModal').modal('hide');
        if ($('#developerSaleApplicationSendEmailModal').is(':visible')) $('#developerSaleApplicationSendEmailModal').modal('hide');
        if ($('#developerSaleApplicationReGenerateOTPModal').is(':visible')) $('#developerSaleApplicationReGenerateOTPModal').modal('hide');
        if ($('#developerSaleApplicationGenerateOTPModal').is(':visible')) $('#developerSaleApplicationGenerateOTPModal').modal('hide');

        if ($('#email_phone_modal').is(':visible')) $('#email_phone_modal').modal('hide');
        if ($('#infoMessageModal').is(':visible')) $('#infoMessageModal').modal('hide');
        if ($('#ReversalModal').is(':visible')) $('#ReversalModal').modal('hide');
        if ($('#addSubsaleModal').is(':visible')) $('#addSubsaleModal').modal('hide');
        if ($('#developerSaleApplicationUploadDocumentModal').is(':visible')) $('#developerSaleApplicationUploadDocumentModal').modal('hide');
        if ($('#registerCreateAgentModal').is(':visible')) $('#registerCreateAgentModal').modal('hide');
        if ($('#developerSaleApplicationReIssueLOAModal').is(':visible')) $('#developerSaleApplicationReIssueLOAModal').modal('hide');
        if ($('#AddCommissionModal').is(':visible')) $('#AddCommissionModal').modal('hide');
        if ($('#InterestWaiverModal').is(':visible')) $('#InterestWaiverModal').modal('hide');
        if ($('#downloadReportModal').is(':visible')) $('#downloadReportModal').modal('hide');
        if ($('#InterestWaiverModal').is(':visible')) $('#InterestWaiverModal').modal('hide');

        if ($('#selection_email_modal').is(':visible')) $('#selection_email_modal').modal('hide');
        if ($('#selection_edit_modal').is(':visible')) $('#selection_edit_modal').modal('hide');
        if ($('#reorder_buyers_modal').is(':visible')) $('#reorder_buyers_modal').modal('hide');
        if ($('#chargeableInterestDetailsViewModal').is(':visible')) $('#chargeableInterestDetailsViewModal').modal('hide');
        if ($('#calculatePaymentInterest').is(':visible')) $('#calculatePaymentInterest').modal('hide');
        if ($('#documentSigningHistoryModal').is(':visible')) $('#documentSigningHistoryModal').modal('hide');
        if ($('#viewDetailModal').is(':visible')) $('#viewDetailModal').modal('hide');
        if ($('#sendRequestInterestStatusByEmailViewModal').is(':visible')) $('#sendRequestInterestStatusByEmailViewModal').modal('hide');
        if ($('#mark_posting_confirmation_modal').is(':visible')) $('#mark_posting_confirmation_modal').modal('hide');


    }

    previousPage() {
        const self = this;

        self.offset = self.offset - parseInt(self.limit);
        self.retrieveApplications();
    }

    nextPage() {
        const self = this;

        self.offset = self.offset + parseInt(self.limit);
        self.retrieveApplications();
    }

    updateFilter() {
        const self = this;

        self.offset = 0;
        self.retrieveApplications();
    }

    onViewSummary(sale) {
        const self = this;

        self.$window.location.href = '/developer/sales/applications/summary?sale_id=' + sale.id;
    }

    /**
     * WEB-4343 - Load the server's sale status display labels into self.saleStatus.
     *
     * @remarks This is the same source the Sales & Payments listing reads
     * (PaymentApplicationController.getStatus), so the Details page shows the exact
     * wording the listing shows. It runs in the background: it deliberately does not
     * toggle the page-wide loading() spinner, and a failure is silent because
     * checkStatus() falls back to the locally prepared sale_statuses names.
     *
     * @returns {void}
     */
    getStatus() {
        const self = this;

        let url = 'config';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                return;
            }

            //get sale status
            self.saleStatus = response.data.sale_statuses;
        });
    }

    /**
     * WEB-4343 - Resolve a sale's status to the label used in the Sales & Payments listing.
     *
     * @param {Object} sale The sale record; only `status` is read.
     * @returns {?string} The server's display label, or the locally prepared name from
     *                    prepareSaleStatuses() when the server config carries no entry for
     *                    that status (Cheque Entered, Sale Extended, Sale Invalid), else null.
     * @remarks The two label sets differ on purpose - e.g. SALE_STATUS_OTP displays as
     * "Pending SPA Date, On Hold" and SALE_STATUS_SPA_ENTERED as "Pending Exercise Date" -
     * so the server labels must win wherever they exist.
     */
    checkStatus(sale) {
        const self = this;

        if (!sale || !sale.status) {
            return null;
        }

        let statusDetail = null;

        jQuery.each(self.saleStatus || [], function (i, status) {
            if (status.id == sale.status) {
                statusDetail = status.display;
                return false;
            }

        });

        if (!statusDetail && self.sale_statuses) {
            let local_status = self.sale_statuses.find(x => x.id == sale.status);
            statusDetail = local_status ? local_status.name : null;
        }

        return statusDetail;
    }

    /**
     * WEB-4343 - Colour for a sale's status. Mirrors checkColor() in
     * resources/assets/js/views/developer/sales/payment.js so the Details page and the
     * Sales & Payments listing never disagree on what a sale looks like.
     *
     * @param {Object} sale The sale record; only `status` is read.
     * @returns {?string} 'orange' (pending / verified / extended), 'red' (rejected /
     *                    expired / aborted), 'green' (exercised), or null for the
     *                    default text colour.
     */
    checkColor(sale) {
        const self = this;

        if (!sale || !sale.status) {
            return null;
        }

        if (sale.status == self.SALE_STATUS_PENDING
            || sale.status == self.SALE_STATUS_EXTENDED
            || sale.status == self.SALE_STATUS_VERIFIED
        ) {
            return 'orange';
        }

        if (sale.status == self.SALE_STATUS_REJECTED
            || sale.status == self.SALE_STATUS_EXPIRED
            || sale.status == self.SALE_STATUS_ABORTED
        ) {
            return 'red';
        }

        if (sale.status == self.SALE_STATUS_EXERCISED) {
            return 'green';
        }

        return null;
    }

    retrieveApplications() {
        const self = this;
        self.SSAlertService.message = null

        let status = self.sale_status;

        if (!self.sale_status) {
            status = [
                self.SALE_STATUS_OTP,
                self.SALE_STATUS_CHEQUE_ENTERED,
                self.SALE_STATUS_SPA_ENTERED,
                self.SALE_STATUS_EXTENDED,
                self.SALE_STATUS_EXERCISED,
                self.SALE_STATUS_EXPIRED,
                self.SALE_STATUS_INVALID
            ].join(',');
        } else {
            status = [self.sale_status];
        }

        let url = 'sec/developer/sales';
        let params = {
            'property_id': self.property_id,
            'status': status,
            'limit': self.limit,
            'offset': self.offset,
            'include': 'eois, properties, units, brokers, agencies, sale_buyers, question_answers, documents, history',
            'send_total_count': true
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sales = response.data.sales;
            self.sales_total = response.data.total_count;

            if (self.sales) {
                jQuery.each(self.sales, function (i, sale) {
                    if (sale.history) {
                        jQuery.each(sale.history, function (i, record) {
                            if (record.status == self.SALE_STATUS_SPA_ENTERED) {
                                sale.spaDate = record.created_at;
                                sale.expiryDate = record.created_at;
                            }
                            if (record.status == self.SALE_STATUS_EXERCISED) {
                                sale.exercisedDate = record.created_at;
                                sale.expiryDate = record.created_at;
                            }
                            if (record.status == self.SALE_STATUS_EXTENDED) {
                                sale.expiryDate = record.created_at;
                            }
                            sale.remark = record.remarks;

                        });
                    }
                    sale.aml = sale.aml ? JSON.parse(sale.aml) : null;
                });
            }

            let brokers = response.data.brokers;

            //Process broker and agency
            $.each(brokers, function (index, broker) {
                broker["agency"] = response.data.agencies.find(x => x.id === broker.agency_id);
            });

            //Process sales
            $.each(self.sales, function (index, sale) {
                let main_broker_user_id = sale.brokers.find(x => x.broker_role === self.BROKER_ROLE_MAIN_BROKER).broker_user_id;

                sale['main_broker'] = brokers.find(x => x.user_id === main_broker_user_id);

                sale['buyers'] = [];

                $.each(sale.sale_buyers, function (index, buyer) {
                    let processed_buyer = JSON.parse(buyer.data);
                    sale['buyers'].push(processed_buyer);
                });

                sale["eoi"] = response.data.eois.find(x => x.id === sale.eoi_id);
                sale["unit"] = response.data.units.find(x => x.id === sale.unit_id);

                sale['property_name'] = self.properties.find(x => x.id === sale.eoi.property_id).name;
            });

        });
    }

    executeSPAModal(sale) {
        const self = this;
        self.hideModals();
        self.sale = sale;
        // self.selected_broker = broker;
        $('#executeSPAModal').modal('show');
    }

    ExecuteExerciseModal(sale) {
        const self = this;
        self.hideModals();
        self.sale = sale;
        // self.selected_broker = broker;
        $('#ExecuteExerciseModal').modal('show');
    }

    ExecuteExtendModal(sale) {
        const self = this;

        self.hideModals();
        self.sale = sale;
        // self.selected_broker = broker;
        $('#ExecuteExtendModal').modal('show');
    }

    showBuyersModal(buyers) {
        const self = this;

        self.hideModals();

        self.showBuyer = true;
        self.selected_buyers = buyers;
        $('#developerSaleApplicationBuyerModal').modal('show');
    }

    paymentInstrumentFieldVisibility(payment, instrument, field) {
        const self = this;

        if (!(payment && instrument && field)) {
            return false;
        }

        if(!self.instrument_visible_fields){
            self.instrument_visible_fields = {};
        }

        if(!self.instrument_visible_fields[instrument.type]){
            self.instrument_visible_fields[instrument.type] = {};
        }

        if (payment.type == self.PAYMENT_TYPE_20_REFUND) {

            if (-1 != jQuery.inArray(field, [
                'bank_name',
                'account_holder_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'instrument_no',
                'amount_calculation',
                'amount',
                'file_uri',
                'property_account_id',
                'receiving_date',
                'status',
                'cheque_date',
                'cheque_amount',
                'bank_in_date',
                'status',
                'tracking_no'
            ])) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }

            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }

        } else {

            return self.getFieldVisibilityStatus(instrument, field);
        }

        return false;
    }

    getFieldVisibilityStatus(instrument, field) {
        const self = this;

        if (instrument.type == self.INSTRUMENT_TYPE_CHEQUE || instrument.type == self.INSTRUMENT_TYPE_CASHIERS_ORDER) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }

            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_BANK_TRANSFER) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_CASH_IN) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_CREDIT_CARD) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_CASH) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_GIRO) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_DEBIT_CARD) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        } else if (instrument.type == self.INSTRUMENT_TYPE_FAST_CASH
            || instrument.type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS
            || instrument.type == self.INSTRUMENT_TYPE_EDP
            || instrument.type == self.INSTRUMENT_TYPE_EDP_PLUS) {
            if (-1 != jQuery.inArray(field, self.getFields(instrument.type))) {
                self.instrument_visible_fields[instrument.type][field] = true;
                return true;
            }
            if (field == 'bank_name_other') {
                if (instrument.bank_name == 'Others') {
                    self.instrument_visible_fields[instrument.type][field] = true;
                    return true;
                }
            }
        }

        return false;
    }

    getFields(type){
        const self = this;

        if(type == self.INSTRUMENT_TYPE_CHEQUE || type == self.INSTRUMENT_TYPE_CASHIERS_ORDER){
            return [
                'bank_name',
                'account_holder_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'instrument_no',
                'amount',
                'file_uri',
                'property_account_id',
                'receiving_date',
                'bank_in_date',
                'status',
                'cheque_date',
                'cheque_amount',
                'interest_amount',
                'status',
                'tracking_no'
            ];
        } else if(type == self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER){
            return [
                'bank_name',
                'account_holder_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'instrument_no',
                'receiving_date',
                'amount',
                'file_uri',
                'interest_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_BANK_TRANSFER){
            return [
                'bank_name',
                'account_holder_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'instrument_no',
                'receiving_date',
                'amount',
                'file_uri',
                'interest_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_CASH_IN){
            return [
                'amount',
                'file_uri',
                'interest_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_CREDIT_CARD){
            return [
                'bank_name',
                'account_holder_name',
                'instrument_no',
                'amount',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'interest_amount',
                'payment_type_amount',
                'card_company'
            ];
        } else if(type == self.INSTRUMENT_TYPE_CASH){
            return [
                'amount',
                'receiving_date',
                'payment_type_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_GIRO){
            return [
                'bank_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'receiving_date',
                'instrument_no',
                'amount',
                'interest_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_DEBIT_CARD){
            return [
                'bank_name',
                'account_holder_name',
                'instrument_no',
                'amount',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'interest_amount'
            ];
        } else if(type == self.INSTRUMENT_TYPE_FAST_CASH
            || type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS
            || type == self.INSTRUMENT_TYPE_EDP
            || type == self.INSTRUMENT_TYPE_EDP_PLUS){
            return [
                'bank_name',
                'account_holder_name',
                'buyer_has_own_account',
                'relationship_with_account_holder',
                'non_buyer_payee_id',
                'instrument_no',
                'amount',
                'file_uri',
                'interest_amount'
            ];
        }
    }

    paymentInstrumentFieldLabel(payment, instrument, field) {
        const self = this;

        let fieldLabel = field;
        if (!(payment && instrument && field)) {
            return fieldLabel;
        }

        let LABELS = {};

        if (instrument.type == self.INSTRUMENT_TYPE_CHEQUE) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Account Holder Name',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'Cheque No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                file_uri: 'Cheque Image',
                receiving_date: 'Date Received',
                bank_in_date: 'Bank-in Date',
                status: 'Status',
                tracking_no: 'Tracking Number',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_CASHIERS_ORDER) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Account Holder Name',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'Cashiers\' Order No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                file_uri: 'Upload Image',
                receiving_date: 'Date Received',
                bank_in_date: 'Bank-in Date',
                status: 'Status',
                tracking_no: 'Tracking Number',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_FAST_CASH
            || instrument.type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS
            || instrument.type == self.INSTRUMENT_TYPE_EDP
            || instrument.type == self.INSTRUMENT_TYPE_EDP_PLUS) {
            let instrumentNoPrefix = 'Fast Cash';
            if (instrument.type == self.INSTRUMENT_TYPE_PAYNOW_OTHERS) {
                instrumentNoPrefix = 'PayNow';
            } else if (instrument.type == self.INSTRUMENT_TYPE_EDP) {
                instrumentNoPrefix = 'EDP';
            } else if (instrument.type == self.INSTRUMENT_TYPE_EDP_PLUS) {
                instrumentNoPrefix = 'EDP+';
            }
            LABELS = {
                type: 'Payment Mode',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Account Holder Name',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: instrumentNoPrefix + ' Transaction No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                file_uri: 'Upload Transfer Image',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_TELEGRAPHIC_TRANSFER) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Account Holder Name',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'TT Transaction No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                receiving_date: 'Date Received',
                file_uri: 'Upload Image',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_BANK_TRANSFER) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Account Holder Name',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'Transaction No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                receiving_date: 'Date Received',
                file_uri: 'Upload Image',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_GIRO) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'GIRO Transaction No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                receiving_date: 'Date Received',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_DEBIT_CARD) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Name on Debit Card',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'Debit Card No.',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_CREDIT_CARD) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                bank_name: 'Bank',
                card_company: 'Card Company',
                bank_name_other: 'Please specify the bank name.',
                account_holder_name: 'Name on Credit Card',
                buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
                relationship_with_account_holder: 'Relationship with Buyer',
                payment_type_amount: 'Please select payment amount type',
                instrument_no: 'Credit Card No. (Last 4 numbers)',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_CASH) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                payment_type_amount: 'Please select payment amount type',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                receiving_date: 'Date Received',
                non_buyer_payee_id: '3rd Party Payor'
            };
        } else if (instrument.type == self.INSTRUMENT_TYPE_CASH_IN) {
            LABELS = {
                type: 'Payment Mode',
                property_account_id: 'Account Credited To',
                payment_type_amount: 'Please select payment amount type',
                amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                file_uri: 'Upload Image',
                interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
                non_buyer_payee_id: '3rd Party Payor'
            };
        }

        let LABELS2 = {
            type: 'Payment Mode',
            property_account_id: 'Account Debited From',
            bank_name: 'Bank',
            bank_name_other: 'Please specify the bank name.',
            account_holder_name: 'Account Holder Name',
            buyer_has_own_account: 'Is the Account that of the Buyer(s)?',
            relationship_with_account_holder: 'Relationship with Buyer',
            payment_type_amount: 'Please select payment amount type',
            instrument_no: 'Reference No',
            amount_calculation: 'Refund',
            amount: 'Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
            interest_amount: 'Interest Amount ('+self.SSAppService.getCurrencySymbol(self.sale_property.country)+')',
            file_uri: 'Upload Image',
            receiving_date: 'Date Paid',
            bank_in_date: 'Bank-in Date',
            status: 'Status',
            tracking_no: 'Tracking Number',
            non_buyer_payee_id: '3rd Party Payor'
        };

        if (payment.type == self.PAYMENT_TYPE_20_REFUND) {
            if (field in LABELS2) {
                fieldLabel = LABELS2[field];
            }
        } else {
            if (field in LABELS) {
                fieldLabel = LABELS[field];
            }
        }

        return fieldLabel;
    }

    viewInstrumentFile(instrument) {
        const self = this;

        if (!instrument) return;

        if (instrument.file_uri
            && instrument.file_uri.toLowerCase().endsWith(".pdf")
        ) {
            if (instrument.show_file_url) {
                self.SSUtilService.openUrlInNewTab(instrument.show_file_url);
            } else if (instrument.image_uri) {
                self.SSUtilService.openUrlInNewTab(instrument.image_uri);
            }
        } else {
            instrument.show_image = !(instrument.show_image);
        }
    }

    calculateRefundAmount(payment, instrument) {
        const self = this;
        let sum = 0;
        jQuery.each(self.sale_payments, function (i, _payment) {
                sum += parseFloat(_payment.amount);
        });
        let amount_calculation = parseInt(instrument.amount_calculation);
        if (amount_calculation) {
            instrument.amount = parseFloat((sum * (amount_calculation / 100)).toFixed(2));
        }
    }

    calculatePaymentRefundAmount(percentage) {
        const self = this;
        let amount = 0;
        let refundedAmount = 0;
        if(!percentage){
            percentage = 100;
        }

        let childPayment = self.paymentInfoParams.childPayment;
        if(childPayment){
            if (childPayment.overpayment_amount && childPayment.overpayment_amount > 0) { // If has overpayment amount
                amount = childPayment.due_amount - childPayment.refunded_amount;
            } else {
                amount = childPayment.amount - childPayment.refunded_amount;
            }
        }
        else{
            amount = self.sale_payments.reduce((acc, _payment) => {
                return _payment.type != self.PAYMENT_TYPE_20_REFUND ? (acc + _payment.amount - _payment.refunded_amount) : acc;
            }, 0);
            refundedAmount = self.sale_payments.reduce((acc, _payment) => {
                return _payment.type == self.PAYMENT_TYPE_20_REFUND && !_payment.payment_id ? acc + _payment.amount : acc;
            }, 0);
        }
        self.paymentInfoParams.due_amount = parseFloat((amount - refundedAmount) * (percentage/100)).toFixed(2);
        if (childPayment && childPayment.overpayment_amount && childPayment.overpayment_amount > 0) { // If has overpayment amount
            try{
                self.paymentInfoParams.base_due_amount = parseFloat(self.paymentInfoParams.due_amount);
                self.paymentInfoParams.due_amount = (parseFloat(self.paymentInfoParams.due_amount) + childPayment.overpayment_amount).toFixed(2); // Add overpayment_amount to due_amount
            }catch (e){
                console.error(e);
            }
        }

        // WEB-3670: keep the forfeiture amount in sync with the refunded amount.
        self.recalculateRefundForfeitureAmount();
    }

    /**
     * WEB-3670: Total amount received under the sale = sum of every NON-bounced
     * payment-instrument amount across the sale's NON-refund payments (booking
     * fee + clause payments). This is the JS mirror of the server's
     * PaymentService::getSaleReceivedAmount(), so the abort-refund split
     * (refunded + forfeited) reconciles exactly against the value the API
     * validates — see WEB-3669 / error sub_code 305043.
     *
     * @returns {number} The total received amount, rounded to 2 decimals.
     */
    /**
     * WEB-3670: True when the sale being refunded is an Aborted Sale. Forfeiture
     * (and the refunded+forfeited == received full-cancellation rule) only applies
     * to an aborted sale's refund — not to a normal refund such as an overpayment
     * return on a still-active sale.
     *
     * @returns {boolean}
     */
    isAbortedSale() {
        const self = this;
        return !!(self.sale_sales && self.sale_sales.status == self.SALE_STATUS_ABORTED);
    }

    getSaleReceivedAmount() {
        const self = this;
        let received = 0;
        (self.sale_payments || []).forEach(function (_payment) {
            if (_payment.type == self.PAYMENT_TYPE_20_REFUND) {
                return; // Skip refund payments.
            }
            (_payment.instruments || []).forEach(function (instrument) {
                if (instrument.status == self.INSTRUMENT_STATUS_BOUNCED) {
                    return; // Skip bounced instruments — never "received".
                }
                let amount = parseFloat(instrument.amount);
                if (!isNaN(amount)) {
                    received += amount;
                }
            });
        });
        return parseFloat(received.toFixed(2));
    }

    /**
     * WEB-3670: For an Aborted Sale refund (type 20), the forfeited amount is the
     * complement of the refunded `due_amount` against the sale's total received
     * amount: forfeited = received - refunded. Both values are sent to
     * savePayment and the server rejects any split that does not reconcile to the
     * received total (sub_code 305043 — see WEB-3669).
     *
     * Keeps `total_received_amount`, `forfeiture_amount` and `forfeiture_percentage`
     * on paymentInfoParams in sync; called whenever the refunded amount changes
     * (percentage radios + the custom due-amount input).
     */
    recalculateRefundForfeitureAmount() {
        const self = this;

        // WEB-3670: forfeiture only applies to an ABORTED sale's refund (the
        // refund cancels the whole sale). A normal refund — e.g. returning an
        // overpayment on a still-active sale — has no forfeiture, so clear the
        // fields and never send them.
        if (!self.isAbortedSale()) {
            self.paymentInfoParams.total_received_amount = null;
            self.paymentInfoParams.forfeiture_amount = null;
            self.paymentInfoParams.forfeiture_percentage = null;
            return;
        }

        let received = self.getSaleReceivedAmount();
        self.paymentInfoParams.total_received_amount = received;

        let refunded = self.parseAmountInput(self.paymentInfoParams.due_amount);
        if (refunded === null) {
            self.paymentInfoParams.forfeiture_amount = null;
            self.paymentInfoParams.forfeiture_percentage = null;
            return;
        }

        let forfeited = parseFloat((received - refunded).toFixed(2));
        self.paymentInfoParams.forfeiture_amount = forfeited;
        self.paymentInfoParams.forfeiture_percentage = received > 0
            ? parseFloat(((forfeited / received) * 100).toFixed(2))
            : 0;
    }

    processSaleOtherDocuments() {
        const self = this;

        self.sale_sales.other_documents = {};
        self.sale_sales.other_aml_cft_documents = {};
        let buyer_declaration_form_counter = 1;
        let document_count = {};

        $.each(self.sale_sales.documents, function (index, buyer_document) {
            self.checkRegenerate(buyer_document);

            if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_FORM) {
                if (buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM && self.sale_sales.sale_buyers.length > 1) {
                    buyer_document["title"] = buyer_document.name + ' - ' + buyer_declaration_form_counter;
                    buyer_declaration_form_counter++;
                } else {
                    buyer_document["title"] = buyer_document.name;
                }

                if (buyer_document.document_id) {
                    self.sale_sales.other_documents[buyer_document.document_id] = buyer_document;
                } else {
                    self.sale_sales.other_documents[buyer_document.id] = buyer_document;
                }

            } else if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP) {
                buyer_document["title"] = "OTP";

                self.sale_sales.other_documents[buyer_document.id] = buyer_document;
            } else if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS) {
                buyer_document["title"] = "Buyer Particulars";

                self.sale_sales.other_documents[buyer_document.id] = buyer_document;
            } else if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED) {
                buyer_document["title"] = buyer_document["name"];

                /** WEB-2919 Corporate Sales: Other AML/CFT Entities **/
                if(buyer_document.document_kind === self.PROPERTY_DOCUMENT_KIND_AML){
                    self.sale_sales.other_aml_cft_documents[buyer_document.id] = buyer_document;
                }else{
                    self.sale_sales.other_documents[buyer_document.id] = buyer_document;
                }
            } else if (buyer_document.type == self.PROPERTY_DOCUMENT_TYPE_USER_DOC
                && buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTHER
            ) {
                buyer_document["title"] = buyer_document["name"];

                self.sale_sales.other_documents[buyer_document.id] = buyer_document;
            } else if (buyer_document.beneficiary_id) {
                let beneficiary = self.sale_sales.beneficiaries.find(x => x.id == buyer_document.beneficiary_id);

                if (buyer_document.file_uri && beneficiary) {
                    let url = 'sec/assets/presigned-url';
                    let params = {
                        'model': self.ASSET_MODEL_SALE_DOCUMENT,
                        'id': buyer_document.id
                    };

                    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                        if (response instanceof Error) {
                            loading(false);
                            self.SSAlertService.parseAndDisplayError(response);
                            return;
                        }

                        buyer_document["show_file_url"] = response.data.presigned_url;
                    });

                    if (!beneficiary.hasOwnProperty("documents")) {
                        beneficiary["documents"] = {};
                    }
                    beneficiary["documents"][buyer_document.document_kind] = buyer_document;
                }
            }

            if(buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_AML){
                document_count[self.PROPERTY_DOCUMENT_KIND_AML] = 1;
            }
            if(buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP){
                document_count[self.PROPERTY_DOCUMENT_KIND_OTP] = 1;
            }
            if(buyer_document.document_kind == self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS){
                document_count[self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS] = 1;
            }
        });

        if(!document_count[self.PROPERTY_DOCUMENT_KIND_AML]) {
            /** WEB-2919 Corporate Sales: Other AML/CFT Entities **/
            self.sale_sales.other_aml_cft_documents[0] = {title: 'AML/CFT', document_kind: self.PROPERTY_DOCUMENT_KIND_AML};
            //self.sale_sales.other_documents[0] = {title: 'AML/CFT', document_kind: self.PROPERTY_DOCUMENT_KIND_AML};
        }

        /**
         * WEB-3547: Order the AML/CFT Scan Reports table by document timestamp.
         *
         * other_aml_cft_documents is keyed by numeric document id, and ng-repeat over an
         * object iterates integer-like keys in ascending id order — not chronological order
         * (e.g. a 30/04 scan rendered above a 07/03 one). Convert it to an array sorted by
         * the displayed timestamp (updated_at, falling back to created_at) ascending so the
         * table reads oldest-first. Array.sort is stable, so rows sharing a timestamp
         * (e.g. Buyer + 3rd Party Payor generated in the same run) keep their relative order.
         */
        self.sale_sales.other_aml_cft_documents = Object.values(self.sale_sales.other_aml_cft_documents)
            .sort(function (a, b) {
                let aTimestamp = a.updated_at || a.created_at;
                let bTimestamp = b.updated_at || b.created_at;
                if (!aTimestamp && !bTimestamp) return 0;
                if (!aTimestamp) return -1;
                if (!bTimestamp) return 1;
                return moment.utc(aTimestamp).valueOf() - moment.utc(bTimestamp).valueOf();
            });
        if(self.property_settings_otp_spa === 'OTP'
            && !document_count[self.PROPERTY_DOCUMENT_KIND_OTP]
        ) {
            self.sale_sales.other_documents[-1] = {title: 'OTP', document_kind: self.PROPERTY_DOCUMENT_KIND_OTP};
        }
        if(!document_count[self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS]) {
            self.sale_sales.other_documents[-2] = {title: 'Buyer Particulars', document_kind: self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS};
        }

        self.sale_sales.selection_documents = [];
        $.each(self.sale_sales.documents, function(i, document){
            if(document.document_kind == self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER){
                let _document = self.sale_sales.selection_documents.find(x => x.document_id == document.document_id);
                if(!_document){
                    self.sale_sales.selection_documents.push(document);
                }
            }
        });

        $.each(self.sale_sales.key_handover_appointment_documents, function (i, _document){
            _document.title = _document.name;
            _document.document_kind = self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION;
            self.sale_sales.other_documents[_document.document_id] = _document;
        });

        // Map buyer documents
        self.mapBuyerDocuments();
    }

    downloadDocument(document, forceDownload = false) {
        const self = this;

        if (document.file_uri) {
            loading(true);
            let model = self.ASSET_MODEL_SALE_DOCUMENT;
            if(document.key_handover_appointment_id){
                model = self.ASSET_MODEL_KEY_HANDOVER_APPOINTMENT_DOCUMENT;
            }
            self.getPresignedUrl(
                model,
                document.id,
                function (presignedUrl) {
                    loading(false);
                    if (presignedUrl) {
                        window.open(presignedUrl, '_blank');
                    }
                },
                forceDownload
            );
        } else {
            window.open(self.SSHttpService.getApiURL('sec/developer/sales/'+self.sale_sales.id+'/documents/'+document.id+'/download'), '_blank');
        }
    }

    downloadAllDocuments(type = null) {
        const self = this;

        let url = self.SSHttpService.getApiURL('sec/developer/sales/' + self.sale_sales.id + '/documents/download');
        /** WEB-2919 Corporate Sales: Other AML/CFT Entities
         * If downloading only AML documents need to send additional param only_aml_docs as true
         * If downloading All documents except AML documents need to send additional param only_aml_docs as false
         * By default if only_aml_docs param not set then all documents including AML documents will be downloaded **/
        if(type === "AML"){
            url += "&only_aml_docs=true";
        }else {
            url += "&only_aml_docs=false";
        }
        window.open(url, '_blank');
    }

    regenerateFormE(document){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/re-generate-form-e';
        let params = {
            document_kind: document.document_kind
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                self.updateLocalDocument(document, response.data);

                //Get pre-signed url
                let url = 'sec/assets/presigned-url';
                let params = {
                    'model': self.ASSET_MODEL_SALE_DOCUMENT,
                    'id': response.data.sale_documents.id
                };

                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    window.open(response.data.presigned_url, '_blank');
                });
            }

        });
    }

    regenerateBuyerParticular(document) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/re-generate-bpf';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let buyer_particular_obj = response.data;

            if(buyer_particular_obj){
                self.updateLocalDocument(document, buyer_particular_obj);

                //Get pre-signed url
                let url = 'sec/assets/presigned-url';
                let params = {
                    'model': self.ASSET_MODEL_SALE_DOCUMENT,
                    'id': buyer_particular_obj.id
                };

                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    window.open(response.data.presigned_url, '_blank');
                });
            }

        });
    }

    regenerateCongratulationsLetter(document) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/regenerate-congratulations-letter';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data){
                self.updateLocalDocument(document, response.data);
                //Get pre-signed url
                let url = 'sec/assets/presigned-url';
                let params = {
                    'model': self.ASSET_MODEL_SALE_DOCUMENT,
                    'id': response.data.sale_documents.id
                };

                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    window.open(response.data.presigned_url, '_blank');
                });
            }
        });
    }

    updateLocalDocument(document, data){
        const self = this;

        if(!document || !data){
            return;
        }

        let _document = (data.sale_documents)? data.sale_documents : data;

        // Update document in sale
        try{
            delete self.sale_sales.other_documents[document.id];

            document.id = _document.id;
            document.file_uri = _document.file_uri;
            self.sale_sales.other_documents[_document.id] = document;

        }catch(ex){
            console.log(ex);
        }
    }

    sendCongratulationsLetter() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/send-congratulations-letter';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Congratulations letter is sent successfully.');
        });
    }

    sendEmail(sale) {
        const self = this;
        self.hideModals();
        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self.hideModals();
                self.resetEmailObject();

                self.show_send_email = true;

                self._getEmailData();
            });
    }

    resetEmailObject() {
        const self = this;

        self.emailSendingData = null;

        self.email_receipient = {
            buyer: true,
            agent: true,
            developer_lawyer: true,
            developer: true,
            buyer_lawyer: false,
            teamic: false
        };
        self.email_document = {
            buyer_particular: null,
            cover_letter: null,
            otp: null,
            pdi: null,
            purchaser_declaration: null,
            congratulation_letter: null,
            annexes: null
        };

        self.receipent_data = {};
        self.document_custom = 0;
    }

    _getEmailData() {
        const self = this;
        let url = 'sec/developer/sales/' + self.sale_id + '/get-sale-emails-details';

        let params = {
            'saleId': self.sale_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.emailSendingData = response.data;
            self.parseEmailData();
            $('#developerSaleApplicationSendEmailModal').modal('show');
        });
    }

    _sendEmail() {
        const self = this;

        self.callSendEmailApi();
    }

    callSendEmailApi() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/send-emails';

        let params = {
            'saleId': self.sale_id,

            'recipients': {
                "buyer_emails": [],
                "broker_emails": [],
                "buyer_lawyer_emails": [],
                "developer_emails": [],
                "property_lawyer_emails": [],
                "teamic_emails": []
            },
            'document_ids': [],
            'keyhandover_document_ids': [],
        };

        if (self.email_receipient.buyer) {
            params["recipients"]["buyer_emails"] = self.pushToSendEmailParams(self.receipent_data.buyer, params["recipients"]["buyer_emails"]);
        }

        if (self.email_receipient.agent) {
            params["recipients"]["broker_emails"] = self.pushToSendEmailParams(self.receipent_data.agent, params["recipients"]["broker_emails"]);
        }

        if (self.email_receipient.buyer_lawyer) {
            params["recipients"]["buyer_lawyer_emails"] = self.pushToSendEmailParams(self.receipent_data.buyer_lawyer, params["recipients"]["buyer_lawyer_emails"]);
        }

        if (self.email_receipient.developer) {
            params["recipients"]["developer_emails"] = self.pushToSendEmailParams(self.receipent_data.developer, params["recipients"]["developer_emails"]);
        }

        if (self.email_receipient.developer_lawyer) {
            params["recipients"]["property_lawyer_emails"] = self.pushToSendEmailParams(self.receipent_data.developer_lawyer, params["recipients"]["property_lawyer_emails"]);
        }

        if (self.email_receipient.teamic) {
            params["recipients"]["teamic_emails"] = self.pushToSendEmailParams(self.receipent_data.teamic, params["recipients"]["teamic_emails"]);
        }

        if (self.document_custom == 0) {
            params['document_ids'] = ['auto'];
        } else {

            for (let i = 0; i < self.receipent_data.sendDocuments.length; i++) {
                if (self.receipent_data.sendDocuments[i].selected){
                    if(self.receipent_data.sendDocuments[i].is_keyhandover_doc){
                        params['keyhandover_document_ids'].push(self.receipent_data.sendDocuments[i].id)
                    }else{
                        params['document_ids'].push(self.receipent_data.sendDocuments[i].id)
                    }
                }
            }


        }

        params['document_ids'] = params['document_ids'].join();
        params['keyhandover_document_ids'] = params['keyhandover_document_ids'].join();

        if(params.recipients && typeof params.recipients != "string"){
            params.recipients = JSON.stringify(params.recipients);
        }
        if(params.document_ids && typeof params.document_ids != "string"){
            params.document_ids = JSON.stringify(params.document_ids);
        }

        if(params.keyhandover_document_ids && typeof params.keyhandover_document_ids != "string"){
            params.keyhandover_document_ids = JSON.stringify(params.keyhandover_document_ids);
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();

            self.SSAlertService.success('Send Email successfully.');
        });
    }

    parseEmailData() {
        const self = this;
        //Documents
        let documents = null;
        let buyer_particular = [];
        let cover_letter = [];
        let pdi = [];
        let otp = [];
        let purchaser_declaration = [];
        let congratulation_letter = [];
        let annexes = [];
        let sendDocuments = [];
        let document_ids = [];
        let email_allowed_kinds = [
            self.PROPERTY_DOCUMENT_KIND_DECLARATION_FORM,
            self.PROPERTY_DOCUMENT_KIND_COVER_LETTER_FORM,
            self.PROPERTY_DOCUMENT_KIND_PDI_FORM,
            self.PROPERTY_DOCUMENT_KIND_BUYER_PARTICULARS,
            self.PROPERTY_DOCUMENT_KIND_ANNEXES,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_A,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_B3,
            self.PROPERTY_DOCUMENT_KIND_ANNEX_C,
            self.PROPERTY_DOCUMENT_KIND_OTP,
            self.PROPERTY_DOCUMENT_KIND_BUYER_CONGRATULATIONS_LETTER,
            self.PROPERTY_DOCUMENT_KIND_SIDE_LETTER,
            self.PROPERTY_DOCUMENT_KIND_SELECTIONS_LETTER,
            self.PROPERTY_DOCUMENT_KIND_NON_BUYER_PAYEE,
            self.PROPERTY_DOCUMENT_KIND_EXTERNAL_AGENT,
            self.PROPERTY_DOCUMENT_KIND_OTHER,
            self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION,
            self.PROPERTY_DOCUMENT_KIND_BUYER_DECLARATION_FOR_SELF_PAYMENT // WEB-4691: Form 1 - Payment Declaration (for Purchaser)
        ];
        documents = _.each(self.emailSendingData.documents, function (ele) {

            if (email_allowed_kinds.includes(ele.document_kind)) {
                if (!ele.document_id) {
                    sendDocuments.push({"id": ele.id, "name": ele.name, "selected": false, "is_keyhandover_doc": false});
                } else if (!document_ids.includes(ele.document_id)) {
                    sendDocuments.push({"id": ele.id, "name": ele.name, "selected": false, "is_keyhandover_doc": false});
                    document_ids.push(ele.document_id);
                }
            }

        });
        documents = _.each(self.emailSendingData.keyhandover_documents, function (ele) {

            if ( self.PROPERTY_DOCUMENT_KIND_KEY_HANDOVER_COLLECTION === ele.document_kind) {
                if (!ele.document_id) {
                    sendDocuments.push({"id": ele.id, "name": ele.name, "selected": false, "is_keyhandover_doc": true});
                } else if (!document_ids.includes(ele.document_id)) {
                    sendDocuments.push({"id": ele.id, "name": ele.name, "selected": false, "is_keyhandover_doc": true});
                    document_ids.push(ele.document_id);
                }
            }

        });
        self.receipent_data = {
            buyer: [],
            agent: [],
            developer: [],
            developer_lawyer: [],
            buyer_lawyer: [],
            teamic: [],

            purchaser_declaration: purchaser_declaration,
            buyer_particular: buyer_particular,
            cover_letter: cover_letter,
            pdi: pdi,
            otp: otp,
            congratulation_letter: congratulation_letter,
            annexes: annexes,
            sendDocuments: sendDocuments
        };

        self.prepareReceipientObj(self.emailSendingData.recipients.buyer_emails, self.receipent_data.buyer);
        self.prepareReceipientObj(self.emailSendingData.recipients.broker_emails, self.receipent_data.agent);
        self.prepareReceipientObj(self.emailSendingData.recipients.developer_emails, self.receipent_data.developer);
        self.prepareReceipientObj(self.emailSendingData.recipients.property_lawyer_emails, self.receipent_data.developer_lawyer);
        self.prepareReceipientObj(self.emailSendingData.recipients.buyer_lawyer_emails, self.receipent_data.buyer_lawyer, false);
        self.prepareReceipientObj(self.emailSendingData.recipients.teamic_emails, self.receipent_data.teamic, false);
    }

    prepareReceipientObj(emails_array, obj, selected = true) {
        $.each(emails_array, function (index, email) {
            let buyer_obj = {
                'email': email,
                'selected': selected
            }

            obj.push(buyer_obj);
        })
    }

    pushToSendEmailParams(emails_array, obj) {
        obj = [];
        $.each(emails_array, function (index, email_obj) {
            if (email_obj.selected) {
                obj.push(email_obj.email);
            }
        });

        return obj;
    }

    getOtpDocs() {
        const self = this;

        self.otp_documents = [];
        self.loa_documents = [];

        if (!self.property_documents) {
            self.otp_documents = [{
                id: null,
                name: 'Default'
            }];
            return;
        }

        $.each(self.property_documents, function (i, e) {
            if (e.document_kind == self.PROPERTY_DOCUMENT_KIND_OTP && e.is_enabled) {
                self.otp_documents.push(e);
            }

            // Get 'LOA' documents for 'RE-ISSUE' case
            if(e.document_kind == self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AGREEMENT){
                self.loa_documents.push(e);
            }
        });

        if (self.otp_documents.length == 0) {
            self.otp_documents = [{
                id: null,
                name: 'Default'
            }];
        }
    }

    regenerateOTP(document) {
        const self = this;

        self.currentSale = self.sale_sales;

        /** WEB-2918 DMS: OTP Date - Add permissions **/
        self.selected_property_id = self.sale_sales.property_id;

        if (self.currentSale.otp_date && self.currentSale.otp_date.length > 10) {
            self.otp_date = moment(self.currentSale.otp_date).format('DD/MM/YYYY');
        } else {
            self.otp_date = self.currentSale.otp_date;
        }

        /* WEB-2871 DMS: Generate OTP popup doesn't show Document's dropdown
        * Add otp_spa settings info for re-generate model */
        if(self.currentSale){
            self.currentSale.property_settings = self.currentSale.property_settings || {};
            self.currentSale.property_settings["otp_spa"] = self.property_settings_otp_spa || 'OTP'; // Default to OTP
        }

        self.current_document = document;
        self.selected_otp_document = document.property_document_id;

        $('#developerSaleApplicationReGenerateOTPModal').modal('show');
    }

    onProceedReGenerateOTP(send_email, regenerate, sale) {
        const self = this;

        if (self.edit_otp_regenerate) {
            // Open OTP in editor
            self.$window.location.href = '/developer/sales/' + sale.id + '/editotp';
        } else {
            self._generateOTP(send_email, regenerate, sale);
        }
    }

    generateOTPModal(document) {
        const self = this;

        var booking_fee = {};

        self.currentSale = self.sale_sales;
        self.currentSale.id = self.sale_id;
        self.actual_booking_fee = 0;

        /** WEB-2918 DMS: OTP Date - Add permissions **/
        self.selected_property_id = self.sale_sales.property_id;

        jQuery.each(self.currentSale.payments, function (i, payments) {
            if (payments.type == self.PAYMENT_TYPE_01_BOOKING_FEE) {
                booking_fee = payments;
                return false;
            }
        });

        let payment_plan = self.getPaymentPlan();

        if(payment_plan && payment_plan.payment_plan_clauses){

            let clause = payment_plan.payment_plan_clauses.find(x => x.payment_type == self.PAYMENT_TYPE_01_BOOKING_FEE);

            if(clause && clause.amount_percentage){
                self.booking_fee_percentage = clause.amount_percentage;
            }
        }

        // self.actual_booking_fee = Math.round((self.currentSale.price * (self.booking_fee_percentage/100)) * 100) / 100;
        // if (booking_fee.amount) {
        //     total_booking_fee = booking_fee.amount;
        // }
        // if (total_booking_fee < self.actual_booking_fee) {
        //     $('#developerSaleApplicationBookingfeeAlertModal').modal('show');
        //     return;
        // }

        self.actual_booking_fee = booking_fee.due_amount;

        if (booking_fee.amount < booking_fee.due_amount) {
          $('#developerSaleApplicationBookingfeeAlertModal').modal('show');
          return;
        }

        // self.otp_date = moment().format('DD/MM/YYYY');
        // self.selected_otp_document = document.property_document_id;

        if (self.currentSale.otp_date && self.currentSale.otp_date.length > 10) {
            self.otp_date = moment(self.currentSale.otp_date).format('DD/MM/YYYY');
        } else {
            self.otp_date = moment().format('DD/MM/YYYY');
        }
        self.current_document = document;
        self.selected_otp_document = document? document.property_document_id:{};

        $("#ui-datepicker-div").css({"top": "238.5px !important"});

        $('#developerSaleApplicationGenerateOTPModal').modal('show');
    }

    // GENERATE OTP CASE
    onProceedGenerateOtp(send_email, regenerate, sale) {
        const self = this;

        if (self.edit_otp) {
            // Open OTP in editor
            self.$window.location.href = '/developer/sales/' + sale.id + '/editotp?redirect=developer/sales/payments/' + sale.id + '/details?id=' + self.parameters.id;
        } else {
            self._generateOTP(send_email, regenerate, sale);
        }
    }

    _generateOTP(send_email, regenerate, sale) {
        const self = this;

        let url = 'sec/developer/sales/' + sale.id + '/generate-otp';
        let params = {
            'send_email': send_email,
            'otp_date': self.SSDateService.formateWithTimeAsNoon(self.otp_date),
            'document': self.selected_otp_document,
            'regenerate': regenerate,
            timezone: self.SSDateService.getLocalTimezone()
        };

        loading(true);
        // API updated from 'GET' to 'POST' method
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();
            self.sale_sales.status = self.SALE_STATUS_OTP;
            sale.otp_date = self.otp_date;

            let sale_document = response.data.sale_document;
            self.current_document.property_document_id = sale_document.property_document_id;
            self.sale_sales.documents.push(sale_document);

            self.SSAlertService.success('OTP is generated successfully.');

            self.viewOTP();
        });
    }

    viewOTP() {
        const self = this;

        let sale_document = self.sale_sales.documents.filter(x => x.type === self.PROPERTY_DOCUMENT_TYPE_SYSTEM_GENERATED && x.document_kind === self.PROPERTY_DOCUMENT_KIND_OTP);

        if (sale_document.length > 0) {
            let url = 'sec/assets/presigned-url';
            let params = {
                model: self.ASSET_MODEL_SALE_DOCUMENT,
                id: sale_document[0].id
            };

            loading(true);
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                // Open OTP in new tab
                window.open(response.data.presigned_url, '_blank');
            });
        }
    }

    clearForm() {
        const self = this;

        self.lawyer.law_firm_name = '';
        self.lawyer.code = '';
        self.lawyer.first_name = '';
        self.lawyer.last_name = '';
        self.lawyer.email = '';
        self.lawyer.phone1 = '';

        $('input#lawyer_phone').intlTelInput('setNumber', '');
    }

    processSaleHistory() {
        const self = this;

        self.sale_sales['brokers_detail'] = [];

        $.each(self.sale_sales.brokers, function (index, broker) {
            let broker_role = broker.broker_role;
            broker = self.brokers.find(x => x.user_id === broker.broker_user_id);
            broker['role_name'] = self.SSEoiService.broker_roles.find(x => x.id === broker_role).name;
            self.sale_sales.brokers_detail.push(broker);
        });

        //Process history
        if (self.sale_sales.hasOwnProperty("history") && self.sale_sales.history.length > 0) {
            let filtered_remarks = [];
            let filtered_aml_remarks = [];

            $.each(self.sale_sales.history, function (index, history_individual) {
                let users = self.sale_users;

                let status_obj = self.sale_statuses.find(x => x.id === history_individual.status);
                history_individual["status_name"] = status_obj ? status_obj.name : null;

                let _user = users.find(x => x.id === history_individual.created_by);
                history_individual["user"] = _user ? _user : {}; // Set not null
                let broker_detail = self.sale_sales.brokers_detail.find(x => x.user_id === history_individual.created_by);
                history_individual["user"]["role_name"] = broker_detail ? broker_detail.role_name : "Team IC";

                filtered_remarks.push(history_individual);
                // WEB-3416 / WEB-3356: identify AML Risk Assessment history rows by the
                // structured `type` column instead of a remarks-column prefix. Prevents a
                // user-typed remark starting with "AML Risk Assessment" from being shown here.
                if (history_individual.type === self.HISTORY_ENTRY_TYPE_AML_RISK_ASSESSMENT) {
                    filtered_aml_remarks.push(history_individual);
                }
            });

            if (filtered_remarks.length > 0) {
                self.sale_sales["filtered_remarks"] = filtered_remarks;
            }
            if (filtered_aml_remarks.length > 0) {
                self.sale_sales["filtered_aml_remarks"] = filtered_aml_remarks;
            }
        }

        //Process eoi history
        if (self.sale_sales.hasOwnProperty("eoi_history") && self.sale_sales.eoi_history.length > 0) {
            let filtered_remarks = [];

            $.each(self.sale_sales.eoi_history, function (index, history_individual) {
                let users = self.sale_users;

                let status_obj = self.eoi_statuses.find(x => x.id === history_individual.status);
                history_individual["status_name"] = status_obj ? status_obj.name : null;

                let _user = users.find(x => x.id === history_individual.created_by);
                history_individual["user"] = _user ? _user : {}; // Set not null
                let broker_detail = self.sale_sales.brokers_detail.find(x => x.user_id === history_individual.created_by);
                history_individual["user"]["role_name"] = broker_detail ? broker_detail.role_name : "Team IC";

                filtered_remarks.push(history_individual);
            });

            if (filtered_remarks.length > 0) {
                self.sale_sales["eoi_filtered_remarks"] = filtered_remarks;
            }
        }
    }

    savePPFormRemarks(){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/update-sale-pp-form-remarks';
        let params = {
            'pp_form_remarks': self.ppFormRemarksCopy
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.sale_sales.pp_form_remarks = angular.copy(self.ppFormRemarksCopy);
            self.SSAlertService.success('Success!', 'PP Form Remarks updated successfully.');
            self.hideModals();
            self.editPPFormRemarks(false);
        });
    }

    saveAgentRemarks(){
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/update-sale-agent-remarks';
        let params = {
            'remarks': self.agentRemarksCopy
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.sale_sales.remarks = angular.copy(self.agentRemarksCopy);
            self.SSAlertService.success('Success!', 'Agent Remarks updated successfully.');
            self.hideModals();
            self.editAgentRemarks(false);
        });
    }

    showAddSaleRemarksModal() {
        const self = this;
        self.SSSaleRemarksService.showAddSaleRemarksModal(self.sale_sales, function (saleHistory) {
            if (saleHistory) {
                if (!(self.sale_sales.history)) {
                    self.sale_sales.history = [];
                }
                self.sale_sales.history.push(saleHistory);

                self.processSaleHistory();
            }
        });
    }

    saveSalePrice() {
        const self = this;

        if(!self.salePriceCopy) {
            self.SSAlertService.danger("Error:", "Please enter Selling Price");
            return;
        }
        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                self.hideModals();
                self.showAccept = true;
                $('#developerSalePriceAcceptModal').modal('show');
            });
    }

    _saveSalePrice() {
        const self = this;
        var booking_fee = {};
        var total_booking_fee = 0;
        self.actual_booking_fee = 0;
        let url = 'sec/developer/sales/' + self.sale_id + '/updateSalePrice';
        let params = {
            'price': self.salePriceCopy
        };

        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.sale_sales.price = angular.copy(self.salePriceCopy);
            if(self.sale_sales.price && self.sale_sales.price>0){
                self.sale_sales["psf"] = self.sale_units.size_ft2 ? self.SSAppService.getRoundOffValue(self.sale_sales.price / self.sale_units.size_ft2, self.PROJECT_COUNTRY) : '--';
            }else{
                self.sale_sales["psf"] = self.sale_units.size_ft2 ? self.SSAppService.getRoundOffValue(self.sale_units.price / self.sale_units.size_ft2, self.PROJECT_COUNTRY) : '--';
            }
            self.SSAlertService.success('Success!', 'Sale Price updated successfully.');
            self.hideModals();
            self.editSalePrice(false);

            jQuery.each(self.sale_payments, function (i, payment) {
                if (payment.type == '1') {
                    booking_fee = payment;
                    return false;
                }
            });

            self.actual_booking_fee = Math.round((self.salePriceCopy / 100 * 5) * 100) / 100;
            if (booking_fee.amount) {
                total_booking_fee = booking_fee.amount;
            }

            if (total_booking_fee < self.actual_booking_fee) {
                $('#developerSaleApplicationBookingfeeAlertModal2').modal('show');
                return;
            }

        });
    }

    // Agencies for drop down list,
    getAgencies() {
        const self = this;

        self.agencies = [];
        let url = 'agencies';
        let params = {
            'format': 1
        };

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.agencies_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.agencies_loading = false;

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.agencies) {
                self.agencies = response.data.agencies;

                self.filterAvailableAgencies();

                if(!self.sale_sales.agency_name){
                    self.sale_sales.agency_name = self.getAgencyName(self.sale_sales.agency_id);
                }

                // Get sale agency detail
                try {
                    let _sale_agency = (self.agencies && self.agencies.length > 0) ? self.agencies.find(x => x.id == self.sale_sales.agency_id) : null;
                    self.sale_sales.agency_profile = _sale_agency ? _sale_agency.profile : {};
                } catch (ex) {
                    console.log(ex);
                }
            }

            self.getSalesBrokers();
        });
    }

    filterAvailableAgencies() {
        const self = this;

        if (self.agencies == null)
            return;

        self.availableAgencies = [{
            id: null,
            name: "Please Select"
        }];

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, agency) {
                self.availableAgencies.push({
                    id: agency.id,
                    name: agency.name
                });
            });
        }
    }

    searchAgent() {
        const self = this;
        self.saveButton  = false;

        self.agents = [];
        let url = 'agents/search';
        let params = {
            criteria: self.criteria
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.agents) {


                if(response.data.agents.length)
                    self.saveButton  = true;

                self.agents = response.data.agents;
                    $.each(self.agents, function (index, agent) {
                        if (self.SSEoiService.brokers_obj && self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id)) {
                            agent["unselected"] = false;
                        } else {
                            agent["unselected"] = true;
                        }
                    })
            }

            self.searched = true;
        });
    }

    onCreateAgent() {
        const self = this;
        self.hideModals();
        self.registerErrors = {};
        let input = $('input');
        let resource_id = 'a41ce851-728e-4d65-8dc5-e0515a01ff31';

        if(self.search_type != 2 && self.criteria){
            let phoneCriteria = "";
            if(self.search_type == 3){
                phoneCriteria = self.criteria.toString().trim().replace(/\s/g, '');
                if(phoneCriteria.charAt(0) == '+'){
                    phoneCriteria = phoneCriteria.replace(/^\+/, '').slice(2);
                }
            }
            loading(true);
            $.ajax({
                url: 'https://data.gov.sg/api/action/datastore_search?resource_id=' + resource_id + '&q=' + (self.search_type==3 ? phoneCriteria :  self.criteria),
                success: function (response) {
                    loading(false);

                    if (response && response.result && response.result.records && response.result.records.length > 0) {
                        let result = response.result.records[0];
                        let agency = self.agencies.find(x => x.name == result.estate_agent_name);
                        self.registerParams = {
                            user_first_name: result.salesperson_name,
                            broker_agency_id: agency ? agency.id : 0,
                            broker_reg_no: result.registration_no
                        };

                        self.$timeout(function () {
                            $("select.eoi-select#register_agent_agency").niceSelect('update');
                        });

                    }  else {
                        self.registerParams = {};
                        if(self.criteria){
                            if(self.search_type == 1){
                                self.registerParams['broker_reg_no'] = self.criteria;
                            }
                            else if(self.search_type == 3){
                                self.registerParams['user_phone1'] = self.criteria;
                            }
                        }
                    }
                    input.trigger('change');
                },
                error: function (response) {
                    loading(false);
                    self.registerParams = {};
                    // check if input is Email/CEA No/Phone No/Name and set in modal fields respectively
                    if(self.criteria){
                        if(self.search_type == 1){
                            self.registerParams['broker_reg_no'] = self.criteria;
                        }
                        else if(self.search_type == 3){
                            self.registerParams['user_phone1'] = self.criteria;
                        }
                    }
                    input.trigger('change');
                }
            });
        } else {
            self.registerParams = {};
            input.trigger('change');
        }

        if(self.criteria){
            if(self.search_type == 2){
                self.registerParams['user_email'] = self.criteria;
            }
        }

        self.registerEoiAgentModal = true;
        self.maskPhoneNumber(self, 'ctrl.', 'frm-register-agent');
        $('#registerCreateAgentModal').modal('show');

        self.$timeout(function () {
            $("select.eoi-select#register_agent_agency").niceSelect('update');
        });

        self.$timeout(function () {
            $("select.eoi-select#agency-select").niceSelect('update');
        });

        self.$timeout(function () {
            $("select.eoi-select#register_agent_role").niceSelect('update');
        });
    }

    prepareRoles() {
        const self = this;

        self.PROJECT_BROKER_TYPES_SELECT = [
            {
                'id': 1,
                'name': 'TEAMLEAD'
            }
            ,
            {
                'id': 2,
                'name': 'ASSISTANT TEAMLEAD'
            }
            ,
            {
                'id': 3,
                'name': 'BROKER'
            }
            ,
            {
                'id': 4,
                'name': 'TAGGER'
            }
        ];

        self.$timeout(function () {
            $("select.dashboard-select#register_agent_role").niceSelect('update');
        });
    }

    registerAgent() {
        const self = this;

        if (self.validateRegisterParams()) {
            return;
        }

        let params = self.registerParams;
        params["ignore_cea"] = true;

        if (self.registerParams.add_to_core_team) {
            params["project_id"] = self.property.project_id;
        } else {
            params["project_id"] = null;
        }

        let url = 'register-broker';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (responseObj) {
                loading(false);

                if (responseObj instanceof Error) {
                    if (responseObj.sub_code == 305015 || responseObj.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }

                    self.registerError = responseObj.message;

                    // Form Errors
                    self.enquireErrors = {};
                    self.registerErrors = {};

                    jQuery.each(responseObj.data, function (key, value) {
                        try {
                            self.enquireErrors[key] = value[0];
                        } catch (ex) {
                        }
                        try {
                            self.registerErrors[key] = value[0];
                        } catch (ex) {
                        }
                    });
                    return;
                }

                self.hideModals();

                let agent = responseObj.data.broker;
                agent["user"] = responseObj.data.user;
                agent["agency_name"] = self.agencies.find(x => x.id === agent.agency_id).name;

                self.SSAlertService.success('Success!', 'Agent registered successfully')

                self.saveButton = false;
                self.addSelectedAgent(agent);
            }
        );
    }

    validateRegisterParams() {
        const self = this;

        let hasError = false;
        self.registerErrors = {};

        if (!self.registerParams.user_first_name) {
            self.registerErrors.user_first_name = "The First Name field is required.";
            hasError = true;
        }
        if (!self.registerParams.user_last_name) {
            self.registerErrors.user_last_name = "The Last Name field is required.";
            hasError = true;
        }
        if (!self.registerParams.user_email) {
            self.registerErrors.user_email = "The Email field is required.";
            hasError = true;
        }

        if (!self.registerParams.user_phone1) {
            self.registerErrors.user_phone1 = "The Phone field is required.";
            hasError = true;
        }
        if (self.registerParams.broker_nric && !validateNRIC(self.registerParams.broker_nric)) {
            self.registerErrors.broker_nric = "The NRIC/FIN format is wrong.";
            hasError = true;
        }

        if (!self.registerParams.broker_agency_id) {
            self.registerErrors.broker_agency_id = "The Agency field is required.";
            hasError = true;
        }

        // If add_to_core_team is checked then this field is required, otherwise optional
        if (self.registerParams.add_to_core_team) {
            if (!self.registerParams.broker_role) {
                self.registerErrors.broker_role = "The Role field is required.";
                hasError = true;
            }
        }


        if (!self.registerParams.broker_reg_no) {
            self.registerErrors.broker_reg_no = "The Registration No. field is required.";
            hasError = true;
        }

        if (jQuery('.intl-tel-input').hasClass('has-error') && jQuery("[allowdropdown='']").val() != '') {
            self.registerErrors.user_phone1 = "The Phone format is not valid.";
            hasError = true;
        }

        return hasError;
    }

    addSelectedAgent(agent) {
        const self = this;

        agent["unselected"] = false;
        agent["broker_role"] = 1;
        if(!self.SSEoiService.brokers_obj){
            self.SSEoiService.brokers_obj = [];
        }

        if (self.SSEoiService.brokers_obj && self.SSEoiService.brokers_obj.length == 1) {
            agent.broker_role = 2;
        } else if (self.SSEoiService.brokers_obj &&  self.SSEoiService.brokers_obj.length == 2) {
            agent.broker_role = 3;
        }

        self.selectRole(agent, agent.broker_role);
        self.SSEoiService.brokers_obj.push(agent);

        self.$timeout(function () {
            $("select.eoi-select#broker_" + (self.SSEoiService.brokers_obj && self.SSEoiService.brokers_obj.length - 1)).niceSelect('update');
        });

        if (self.SSEoiService.brokers_obj &&  self.SSEoiService.brokers_obj.length == 1) {
            self.$timeout(function () {
                $("select.eoi-select#my_broker_role").niceSelect('update');
            });
        }
    }

    selectRole(agent, old_role) {
        const self = this;

        if (agent.broker_role === 1) {
            // Broker Role 1 = Buyer Agent
            if(self.SSEoiService.brokers_obj){
                let filtered_array = self.SSEoiService.brokers_obj.filter(x => x.broker_role === 1);
                if (filtered_array.length > 1) {
                    agent.broker_role = old_role;
                    self.SSAlertService.danger("Error!", "Only 1 buyer agent is allowed.");
                    self.$timeout(function () {
                        $("select.eoi-select").niceSelect('update');
                    });
                    return;
                }
            }
        }
        // NEW EQUIRMENT allow multiple sale consultants

        // if (agent.broker_role === 5) {
        //     // Broker Role 5 = Sales consultant
        //     let filtered_array = self.SSEoiService.brokers_obj.filter(x => x.broker_role === 5);
        //     if (filtered_array.length > 1) {
        //         agent.broker_role = old_role;
        //         self.SSAlertService.danger("Error!", "Only 1 sales consultant is allowed.");
        //         self.$timeout(function () {
        //             $("select.eoi-select").niceSelect('update');
        //         });
        //         return;
        //     }
        // }

        agent["role_name"] = self.SSEoiService.broker_roles.find(x => x.id === agent.broker_role).name;
    }

    removeAgent(agent) {
        const self = this;

        self.saveButton = true;
        self.saveButton_after_remove = true;

        if (self.SSEoiService.brokers_obj.length > 0) {
            self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id).unselected = true;
        }

        self.SSEoiService.brokers_obj = $.grep(self.SSEoiService.brokers_obj, function (e) {
            return e.user.id != agent.user.id;
        });

        self.$timeout(function () {
            $("select.eoi-select#my_broker_role").niceSelect('update');
        });
    }

    saveBrokers() {
        const self = this;
        self.saveButton = false;
        self.saveButton_after_remove = false;

        if (self.validateCoBroke()) {
            self._saveBrokers();
        }
    }

    _saveBrokers() {
        const self = this;

        let params = [];
        jQuery.each(self.SSEoiService.brokers_obj, function (index, broker) {
            params.push([broker.user.id, broker.broker_role]);
        });

        let url = 'sec/developer/sales/' + self.sale_sales.id + '/brokers';

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Broker(s) updated successfully.');

            self.EDIT_AGENTS = false;

            // Get updated sale object
            self.getSaleDetails();

        });
    }

    validateCoBroke() {
        const self = this;

        let co_broker_arr = [];
        //Validate role of each brokers
        for (var i = 0; i < self.SSEoiService.brokers_obj.length; i++) {
            co_broker_arr.push(self.SSEoiService.brokers_obj[i].broker_role);
        }

        let counts = {};
        co_broker_arr.forEach(function (x) {
            counts[x] = (counts[x] || 0) + 1;
        });

        if (counts.hasOwnProperty("undefined")) {
            self.SSAlertService.danger('Error!', 'Please select role for each agent');
            return false;
        }

        if (counts.hasOwnProperty(1)) {
            if (counts[1] > 1) {
                self.SSAlertService.danger('Error!', 'Only 1 buyer agent is allowed');
                return false;
            }
        }
        else {
            if (!counts.hasOwnProperty(1) && !counts.hasOwnProperty(4) && !counts.hasOwnProperty(5)) {
                self.SSAlertService.danger('Error!', 'One of the agent must be the buyer agent or team ic or sales consultant.');
                return false;
            }
        }

        //NEW REQUIRMENT allow multiple sale consultants
        // else if (counts.hasOwnProperty(5)) {
        //     if (counts[5] > 1) {
        //         self.SSAlertService.danger('Error!', 'Only 1 sales consultant is allowed');
        //         return false;
        //     }
        // }

        return true;
    }

    initEmptyValues(data) {
        const self = this;

        var DEFAULT_VALUE = "";

        if (data.individual) {
            data.individual.title = data.individual.title ? data.individual.title : DEFAULT_VALUE;
            data.individual.first_name = data.individual.first_name ? data.individual.first_name : DEFAULT_VALUE;
            data.individual.last_name = data.individual.last_name ? data.individual.last_name : DEFAULT_VALUE;
            data.individual.legal_name = data.individual.legal_name ? data.individual.legal_name : DEFAULT_VALUE;
            data.individual.identity_type = data.individual.identity_type ? data.individual.identity_type : DEFAULT_VALUE;
            data.individual.nationality = data.individual.nationality ? data.individual.nationality : DEFAULT_VALUE;
            data.individual.country_of_origin = data.individual.country_of_origin ? data.individual.country_of_origin : DEFAULT_VALUE;
            data.individual.national_id = data.individual.national_id ? data.individual.national_id : DEFAULT_VALUE;
            data.individual.passport_no = data.individual.passport_no ? data.individual.passport_no : DEFAULT_VALUE;
            data.individual.foreigner_national_id = data.individual.foreigner_national_id ? data.individual.foreigner_national_id : DEFAULT_VALUE;
            data.individual.industry = data.individual.industry ? data.individual.industry : DEFAULT_VALUE;
            data.individual.occupation = data.individual.occupation ? data.individual.occupation : DEFAULT_VALUE;
            data.individual.gender = data.individual.gender ? data.individual.gender : DEFAULT_VALUE;
            data.individual.dob = data.individual.dob ? data.individual.dob : DEFAULT_VALUE;
            data.individual.marital_status = data.individual.marital_status ? data.individual.marital_status : DEFAULT_VALUE;
        } else {
            data.individual = {};
            data.individual.title = DEFAULT_VALUE;
            data.individual.first_name = DEFAULT_VALUE;
            data.individual.last_name = DEFAULT_VALUE;
            data.individual.legal_name = DEFAULT_VALUE;
            data.individual.identity_type = DEFAULT_VALUE;
            data.individual.nationality = DEFAULT_VALUE;
            data.individual.country_of_origin = DEFAULT_VALUE;
            data.individual.national_id = DEFAULT_VALUE;
            data.individual.passport_no = DEFAULT_VALUE;
            data.individual.foreigner_national_id = DEFAULT_VALUE;
            data.individual.industry = DEFAULT_VALUE;
            data.individual.occupation = DEFAULT_VALUE;
            data.individual.gender = DEFAULT_VALUE;
            data.individual.dob = DEFAULT_VALUE;
            data.individual.marital_status = DEFAULT_VALUE;
        }

        // Email Contact
        if (data.email_contact) {
            data.email_contact.value = data.email_contact.value ? data.email_contact.value : DEFAULT_VALUE;
        } else {
            data.email_contact = {};
            data.email_contact.value = DEFAULT_VALUE;
        }

        // Phone1 Contact
        if (data.phone1_contact) {
            data.phone1_contact.value = data.phone1_contact.value ? data.phone1_contact.value : DEFAULT_VALUE;
        } else {
            data.phone1_contact = {};
            data.phone1_contact.value = DEFAULT_VALUE;
        }

        // Phone2 Contact
        if (data.phone2_contact) {
            data.phone2_contact.value = data.phone2_contact.value ? data.phone2_contact.value : DEFAULT_VALUE;
        } else {
            data.phone2_contact = {};
            data.phone2_contact.value = DEFAULT_VALUE;
        }

        // Primary Address
        if (data.primary_address) {
            data.primary_address.line1 = data.primary_address.line1 ? data.primary_address.line1 : DEFAULT_VALUE;
            data.primary_address.line2 = data.primary_address.line2 ? data.primary_address.line2 : DEFAULT_VALUE;
            data.primary_address.unit_no = data.primary_address.unit_no ? data.primary_address.unit_no : DEFAULT_VALUE;
            data.primary_address.postcode = data.primary_address.postcode ? data.primary_address.postcode : DEFAULT_VALUE;
            data.primary_address.city = data.primary_address.city ? data.primary_address.city : DEFAULT_VALUE;
            data.primary_address.district = data.primary_address.district ? data.primary_address.district : DEFAULT_VALUE;
            data.primary_address.province = data.primary_address.province ? data.primary_address.province : DEFAULT_VALUE;
            data.primary_address.country = data.primary_address.country ? data.primary_address.country : DEFAULT_VALUE;
        } else {
            data.primary_address = {};
            data.primary_address.line1 = DEFAULT_VALUE;
            data.primary_address.line2 = DEFAULT_VALUE;
            data.primary_address.unit_no = DEFAULT_VALUE;
            data.primary_address.postcode = DEFAULT_VALUE;
            data.primary_address.city = DEFAULT_VALUE;
            data.primary_address.district = DEFAULT_VALUE;
            data.primary_address.province = DEFAULT_VALUE;
            data.primary_address.country = DEFAULT_VALUE;
        }

        // Mailing Address
        if (data.mailing_address) {
            data.mailing_address.line1 = data.mailing_address.line1 ? data.mailing_address.line1 : DEFAULT_VALUE;
            data.mailing_address.line2 = data.mailing_address.line2 ? data.mailing_address.line2 : DEFAULT_VALUE;
            data.mailing_address.unit_no = data.mailing_address.unit_no ? data.mailing_address.unit_no : DEFAULT_VALUE;
            data.mailing_address.postcode = data.mailing_address.postcode ? data.mailing_address.postcode : DEFAULT_VALUE;
            data.mailing_address.city = data.mailing_address.city ? data.mailing_address.city : DEFAULT_VALUE;
            data.mailing_address.district = data.mailing_address.district ? data.mailing_address.district : DEFAULT_VALUE;
            data.mailing_address.province = data.mailing_address.province ? data.mailing_address.province : DEFAULT_VALUE;
            data.mailing_address.country = data.mailing_address.country ? data.mailing_address.country : DEFAULT_VALUE;
        } else {
            data.mailing_address = {};
            data.mailing_address.line1 = DEFAULT_VALUE;
            data.mailing_address.line2 = DEFAULT_VALUE;
            data.mailing_address.unit_no = DEFAULT_VALUE;
            data.mailing_address.postcode = DEFAULT_VALUE;
            data.mailing_address.city = DEFAULT_VALUE;
            data.mailing_address.district = DEFAULT_VALUE;
            data.mailing_address.province = DEFAULT_VALUE;
            data.mailing_address.country = DEFAULT_VALUE;
        }

        return data;
    }

    getLocaleDate(date){
        const self = this;

        let localeDate = moment(moment(date, "YYYY-MM-DD")).format("DD/MM/YYYY");

        return localeDate;
    }

    // New functions for 'Additional Re-issue' case
    proceedForBuyerSigning() {
        const self = this;

        // Select first document by default if there is only 1 document
        if(self.loa_documents.length == 1){
            let loa_document = self.loa_documents[0];
            self.selected_loa_documents.push(loa_document.id);
        }

        self.loa_document_error = "";


        if(self.SSEoiService.brokers_obj.length == 0 ){

            self.SSConfirmationService.getConfirmed(
                'Confirm!',
                'You are sure you want to proceed without any agent',
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function(data){
                        self.hideModals();
                        $('#developerSaleApplicationReIssueLOAModal').modal('show');
                        self.initSelectizejs();
                    });
                }
            );
        }
            else{

            self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function(data){
                self.hideModals();
                $('#developerSaleApplicationReIssueLOAModal').modal('show');
                self.initSelectizejs();
            });
        }





    }

    _proceedForBuyerSigning() {
        const self = this;

        self.loa_document_error = "";

        if(self.loa_documents.length > 0 && self.selected_loa_documents.length <= 0){
            self.loa_document_error = "Please select a document to proceed.";
            return;
        }

        console.log("selected_loa_documents: " + self.selected_loa_documents.join());

        let url = 'sec/developer/sales/'+ self.sale_id +'/send-for-resigning';
        //Now sending multiple LOA documents ids instead of a single id
        let params = {
            loa_document_ids: self.selected_loa_documents.join(),
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'Sale updated successfully.');

            // Disable the section for changes
            $('.reissue').css("opacity", "0.5");
            $('.reissue :button').prop('disabled', true);
            $('strong').off("click");
            $('span').off("click");
            $('div').off("click");

            self.SSConfirmationService.getConfirmed(
                'Success!',
                'The documents have been successfully sent to the respective buyers for their signature',
                self.SSConfirmationService.TYPE_OK,
                function () {
                    // Redirect to previous page
                    self.$window.location.href = '/developer/sales/payments?id=' + self.parameters.id;
                }
            );
        });
    }

    showUploadDocumentPopup() {
        const self = this;

        self.upload_doc_obj = {
            document_kind: self.PROPERTY_DOCUMENT_KIND_OTHER,
        };
        self.upload_doc_error = {};

        self.$timeout(function () {
            $("select.dashboard-select#document_kind").niceSelect('update');
        });

        self.hideModals();
        self.show_upload_document_modal = true;
        $('#developerSaleApplicationUploadDocumentModal').modal('show');
    }

    uploadOtherDocument(files, other_document, upload_type) {
        const self = this;

        self.upload_doc_error.document = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.upload_doc_error.document = "Please upload PDF file only";
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.sale_id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            other_document['file_uri'] = response.config.data.key;
            other_document.file = file;
            self.upload_doc_error.document = "";
        });
    }

    replaceOtherDocument(files, upload_type, documentObj) {
        const self = this;

        self.upload_doc_error.document = "";

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.upload_doc_error.document = "Please upload PDF file only";
            return;
        }

        let callback = self.uploadOtherDocument(files, documentObj, upload_type);

        self.removeOtherDocument(documentObj, callback);
    }

    removeOtherDocument(documentObj, callback) {
        const self = this;

        documentObj.file_uri = null;
        documentObj["show_file_url"] = null;
        documentObj.file = null;

        callback;
    }

    _uploadOtherDocument() {
        const self = this;

        if (!self.validateUploadDocumentParams()) {
            return;
        }

        let url = 'sec/developer/sales/' + self.sale_id + '/documents';
        let params = {
            name: self.upload_doc_obj.name,
            type: self.PROPERTY_DOCUMENT_TYPE_FORM,
            format: self.PROPERTY_DOCUMENT_FORMAT_PDF,
            document_kind: self.upload_doc_obj.document_kind,
            file_uri: self.upload_doc_obj.file_uri
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.hideModals();

            let temp_sale_document = response.data.sale_document;
            temp_sale_document.title = temp_sale_document.name;
            self.sale_sales.other_documents[temp_sale_document.id] = temp_sale_document;
            self.SSAlertService.success('Success!', 'File uploaded successfully.');
        });
    }

    validateUploadDocumentParams() {
        const self = this;

        self.upload_doc_error.name = self.upload_doc_obj.name ? '' : 'Name of Document is required.';
        self.upload_doc_error.document_kind = self.upload_doc_obj.document_kind ? '' : 'Type of Document is required.';
        self.upload_doc_error.document = self.upload_doc_obj.file_uri ? '' : 'Document file is required.';

        return !(
            self.upload_doc_error.file_uri
            || self.upload_doc_error.document_kind
            || self.upload_doc_error.document
        );
    }

    lawfirmChanged() {
        const self = this;

        let selected_law_firm = null;
        if (self.law_firms && self.saleBuyerParams.data.lawyer.law_firm_name != 'OTHERS') {
            jQuery.each(self.law_firms, function (i, law_firm) {
                if(law_firm.name == self.saleBuyerParams.data.lawyer.law_firm_name) {
                    selected_law_firm = law_firm;
                    return false;
                }
            });
        }

        if (selected_law_firm) {
            self.saleBuyerParams.data.lawyer.code = selected_law_firm.code;
        } else {
            self.saleBuyerParams.data.lawyer.code = null;
        }
    }

    // Methods to upload buyer documents
    uploadNewDocumentFiles(files, file_name, upload_type, document_kind, buyer, document_id = null) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else if( file.type.indexOf("application/pdf") !== -1
                && (document_kind === self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE
                || document_kind === self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION)) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'document_id': document_id,
            'buyer': buyer,
            'callback': self.uploadNewBuyerDocCallback
        };

        self.file.callback(self);
    }

    uploadNewBuyerDocCallback(self) {
        self.uploadBuyerDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.buyer, self.file.document_id);
    }

    uploadBuyerDocumentFiles(files, file_name, upload_type, document_kind, buyer, document_id) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else if( file.type.indexOf("application/pdf") !== -1
            && (document_kind === self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE
                || document_kind === self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION)) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        let policyUrl = 'sec/buyers/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadBuyerDocument(response.config.data.key, file_name, upload_type, format_type, document_kind, buyer, document_id);
        });
    }

    _uploadBuyerDocument(file_uri, file_name, upload_type, format_type, document_kind, buyer, document_id) {
        const self = this;

        let url = '';
        let params = {};
        let is_subsale = false;

        if (buyer.subsale_id) {
            is_subsale = true;
            url = 'sec/developer/sales/' + self.sale_sales.id + '/subsales/' + buyer.subsale_id + '/documents';
            params = {
                name: file_name,
                type: upload_type,
                format: format_type,
                document_kind: document_kind,
                file_uri: file_uri,
                subsale_buyer_id: buyer.id,
            };
        } else {
            url = 'sec/developer/sales/' + self.sale_sales.id + '/documents';
            params = {
                name: file_name,
                type: upload_type,
                format: format_type,
                document_kind: document_kind,
                file_uri: file_uri,
                sale_buyer_id: buyer.id,
            };
        }

        let handleResponse = function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (!buyer.hasOwnProperty("documents")) {
                buyer["documents"] = {};
            }

            let uploaded_document;

            if (is_subsale) {
                uploaded_document = response.data.subsale_document ? response.data.subsale_document : response.data;
            } else {
                uploaded_document = response.data.sale_document ? response.data.sale_document : response.data;
            }

            buyer["documents"][document_kind] = uploaded_document;

            //To retrieve preview image
            url = 'sec/assets/presigned-url';
            params = {
                'model': is_subsale ? self.ASSET_MODEL_SUBSALE_DOCUMENT : self.ASSET_MODEL_SALE_DOCUMENT,
                'id': uploaded_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                let message = (document_id ? 'File updated successfully.' : 'File uploaded successfully.');
                self.SSAlertService.success('Success!', message);
                buyer["documents"][document_kind]["show_file_url"] = response.data.presigned_url;

                // Update buyer
                self.selectedSaleBuyer = buyer;
                self.saleBuyerParams = buyer;
            });
        };

        loading(true);
        if (document_id) {
            url += '/' + document_id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    removeBuyerDocument(document, buyer, callback) {
        const self = this;

        if(!document){
            return;
        }

        self._document_to_remove = document;

        let url = '';
        let is_subsale = false;

        if (buyer.subsale_id) {
            is_subsale = true;
            url = 'sec/developer/sales/' + self.sale_sales.id + '/subsales/' + buyer.subsale_id + '/documents/' + document.id + '/delete';
        } else {
            url = 'sec/developer/sales/' + self.sale_sales.id + '/documents/' + document.id + '/delete';
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File removed successfully.');

            buyer["documents"][self._document_to_remove.document_kind] = null;

            // Update buyer
            self.selectedSaleBuyer = buyer;
            self.saleBuyerParams = buyer;

            // Remove this document from 'self.sale_sales.documents'
            if (is_subsale) {
                self.sale_sales.subsales_documents = $.grep(self.sale_sales.subsales_documents, function(i, doc){
                    return doc.id != self._document_to_remove.id;
                });
            } else {
                self.sale_sales.documents = $.grep(self.sale_sales.documents, function(i, doc){
                    return doc.id != self._document_to_remove.id;
                });
            }

            if (callback) {
                callback;
            }
        });
    }

    replaceBuyerDocument(files, file_name, upload_type, document_kind, buyer, document) {
        const self = this;

        if(!document){
            return;
        }

        self.uploadNewDocumentFiles(files, file_name, upload_type, document_kind, buyer, document.id);
    }

     // Methods to upload 3rd Party Payor documents
     uploadNewNonBuyerDocumentFiles(files, file_name, upload_type, document_kind, buyer, document_id = null) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'document_id': document_id,
            'buyer': buyer,
            'callback': self.uploadNewNonBuyerDocCallback
        };

        self.file.callback(self);
    }

    uploadNewNonBuyerDocCallback(self) {
        self.uploadNonBuyerPayeeDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.buyer, self.file.document_id);
    }

    uploadNonBuyerPayeeDocumentFiles(files, file_name, upload_type, document_kind, buyer, document_id) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload image file only');
            return;
        }

        let policyUrl = 'sec/buyers/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadNonBuyerPayeeDocument(response.config.data.key, file_name, upload_type, format_type, document_kind, buyer, document_id);
        });
    }

    _uploadNonBuyerPayeeDocument(file_uri, file_name, upload_type, format_type, document_kind, buyer, document_id) {
        const self = this;

        let url = '';
        let params = {};
        url = 'sec/developer/sales/' + self.sale_sales.id + '/documents';
        params = {
            name: file_name,
            type: upload_type,
            format: format_type,
            document_kind: document_kind,
            file_uri: file_uri,
            non_buyer_payee_id: buyer.id,
        };

        let handleResponse = function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (!buyer.hasOwnProperty("sale_documents")) {
                buyer["sale_documents"] = {};
            }

            let uploaded_document;

            uploaded_document = response.data.sale_document ? response.data.sale_document : response.data;

            buyer["sale_documents"][document_kind] = uploaded_document;

            //To retrieve preview image
            url = 'sec/assets/presigned-url';
            params = {
                'model': self.ASSET_MODEL_SALE_DOCUMENT,
                'id': uploaded_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                let message = (document_id ? 'File updated successfully.' : 'File uploaded successfully.');
                self.SSAlertService.success('Success!', message);
                buyer["sale_documents"][document_kind]["show_file_url"] = response.data.presigned_url;

                // Update buyer
                self.selectedSaleNonBuyerPayee = buyer;
                self.saleNonBuyerPayeeParams = buyer;
            });
        };

        loading(true);
        if (document_id) {
            url += '/' + document_id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    removeNonBuyerPayeeDocument(document, buyer, callback) {
        const self = this;

        if(!document){
            return;
        }

        self._document_to_remove = document;

        let url = '';
        let is_subsale = false;
        url = 'sec/developer/sales/' + self.sale_sales.id + '/documents/' + document.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File removed successfully.');

            buyer["sale_documents"][self._document_to_remove.document_kind] = null;

            // Update buyer
            self.selectedSaleNonBuyerPayee = buyer;
            self.saleNonBuyerPayeeParams = buyer;

            if (callback) {
                callback;
            }
        });
    }

    replaceNonBuyerPayeeDocument(files, file_name, upload_type, document_kind, buyer, document) {
        const self = this;

        if(!document){
            return;
        }

        self.uploadNewNonBuyerDocumentFiles(files, file_name, upload_type, document_kind, buyer, document.id);
    }

    getPaymentClauses() {
        const self = this;

        if (self.sale_sales.payment_plan_id) {
            let url = 'sec/developer/payment-plans/' + self.sale_sales.payment_plan_id + '/clauses';

            loading(true);
            self.SSHttpService.getAPIRequest(url).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if (response.data.payment_plan_clauses && response.data.payment_plan_clauses.length > 0) {
                    // WEB-4179: render in the order the server returns (by `order`,
                    // child clauses directly beneath their parent) — no local re-sort.
                    self.payment_plan_clauses = response.data.payment_plan_clauses;
                }

                // To open in case of abort
                if(SHOWSUITE.data.url_param.status === 'abort' && self.afterAbort) {
                    self.paymentInfoParams = {};
                    self.afterAbort = false;
                    const paymentInformation = $("#paymentInformation");
                    if (paymentInformation) {
                        paymentInformation.trigger('click');
                        paymentInformation[0].scrollIntoView({behavior: 'smooth'});
                    }
                    self.showPaymentPopup();
                    self.filteredPaymentPlanClauses = self.getFilteredPaymentPlanClauses();
                    self.paymentInfoParams.clause = self.filteredPaymentPlanClauses.find(x => x.code === 'REFUND');
                    self.paymentInfoParams.amount_calculation = '100';
                    self.calculatePaymentRefundAmount(100);
                    self.paymentInfoParams.type = self.PAYMENT_TYPE_20_REFUND;
                    self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_20_REFUND;
                    let non_refund_payments = self.sale_payments.filter(payment => payment.type != self.PAYMENT_REFUND_TYPE_20_REFUND);
                    if (non_refund_payments.length == 1) {
                        let payment = self.sale_payments.find(payment => payment.type == self.PAYMENT_TYPE_01_BOOKING_FEE);
                        if(payment) {
                            self.paymentInfoParams.payment_id = payment.id;
                            self.paymentInfoParams.childPayment = payment;
                        }
                    }
                    self.changePaymentClause();
                }

                self.processSalePayments();
            });
        } else {
            self.processSalePayments();
        }
    }

    /**
     * WEB-3641: (re)bind the jQuery-UI datepickers on the Sales & Payments modal's
     * date inputs. Those inputs live inside clause / refund-type ng-if blocks that
     * only render once a clause is chosen, so an init fired synchronously while the
     * modal opens (or before the clause is picked) runs before the field exists and
     * never binds — the field then shows no calendar (seen on the Refund-button
     * popup's "Refund Due Date" and on the clause-gated Notice Served / Billing
     * dates). Running the bind inside a $timeout defers it to after the current
     * digest's DOM sync, so every currently-rendered date field is bound. Re-binding
     * an already-bound input is a jQuery-UI no-op, so this is safe to call from every
     * open / clause-change path.
     */
    initPaymentModalDatePickers() {
        const self = this;
        // WEB-3726: the modal is a fixed-position Bootstrap modal — on jQuery UI 1.12.x the
        // calendar opens below the input by the page-scroll amount (same root cause as
        // WEB-3646 / WEB-3654), so every picker bound here gets the guarded beforeShow re-pin.
        let rePin = self.getFixedModalDatepickerRePin();
        self.$timeout(function () {
            $('#PaymentModal06 .payment-info-date').datepicker({ dateFormat: 'dd/mm/yy', maxDate: new Date(), beforeShow: rePin });
            $('#refund_due_date').datepicker({ dateFormat: 'dd/mm/yy', maxDate: new Date(), beforeShow: rePin });
            $('#expiry_date').datepicker({ dateFormat: 'dd/mm/yy', beforeShow: rePin });
            if (self.paymentInfoParams && self.paymentInfoParams.expiry_date) {
                $('#ext_due_date').datepicker('option', 'minDate', self.paymentInfoParams.expiry_date);
            } else {
                $('#ext_due_date').datepicker({ dateFormat: 'dd/mm/yy', beforeShow: rePin });
            }
        });
    }

    /**
     * WEB-3726: build the shared `beforeShow` hook that re-pins a jQuery UI datepicker
     * opened from inside a fixed-position container (any Bootstrap `.modal`).
     *
     * jQuery UI 1.12.x bakes the document scrollTop into the calendar's `top` even when
     * the input sits in a fixed container, dropping the calendar below the field by the
     * page-scroll amount (off-screen when scrolled far). The hook recomputes the position
     * inside a setTimeout(0) so it runs after jQuery UI's own placement. Inputs without a
     * fixed-position ancestor are left untouched (in-page pickers position correctly), and
     * on jQuery UI 1.13.x — where the upstream bug is fixed — the re-pin recomputes the
     * same value, so it is a harmless no-op.
     *
     * @returns {function(HTMLElement, Object): void} `beforeShow(input, inst)` handler for
     *          the jQuery UI datepicker options object.
     */
    getFixedModalDatepickerRePin() {
        return function (input, inst) {
            let $input = jQuery(input);
            let inFixedContainer = $input.parents().filter(function () {
                return jQuery(this).css('position') === 'fixed';
            }).length > 0;

            if (!inFixedContainer) {
                return;
            }

            setTimeout(function () {
                inst.dpDiv.css({
                    top: $input.offset().top - jQuery(document).scrollTop() + $input.outerHeight(),
                    left: $input.offset().left - jQuery(document).scrollLeft()
                });
            }, 0);
        };
    }

    /**
     * WEB-3908 / WEB-3906 — is the payment Billing Date locked to the Notice Served Date?
     *
     * @remarks
     * True only when the project's `billing_date_follows_notice_served_date` setting is ON *and* the
     * entry in the modal is an ordinary instalment payment.
     *
     * Refund / Credit Note entries (type 20, including the interest-waiver credit note) are excluded
     * because this SETTING does not govern them — not because their dates are left alone. Since
     * WEB-4260 the server couples a refund's Billing and Notice Served Dates UNCONDITIONALLY, on
     * every project, setting on or off, with the Billing Date leading. So there is nothing for this
     * predicate to decide there, and the refund screen's Credit Date must stay editable. (The
     * earlier interest-waiver exemption described in WEB-3710 was removed by WEB-4260 — do not
     * reinstate it here.)
     *
     * The modal's Notice Served / Billing Date row is itself gated on `clause.code !== 'REFUND'`,
     * so those guards are belt-and-braces — they also make the predicate safe for
     * syncBillingDateWithNoticeServedDate(), which runs outside that row's ng-if.
     *
     * Drives `ng-disabled` on the Billing Date input in modal_payment_06.blade.php. The lock is
     * cosmetic only: PaymentService::resolveCoupledNoticeAndBillingDates() enforces it server-side
     * and ignores a client-supplied due_date when the setting is ON, so a stale client cannot write
     * a wrong date.
     *
     * @returns {boolean} True when the Billing Date input must be shown read-only.
     */
    isBillingDateLocked() {
        const self = this;

        if (!self.isBillingDateFollowsNoticeServedDateEnabled || !self.paymentInfoParams) {
            return false;
        }

        // A Refund / Credit Note entry is identified by its clause code or its refund_type — NOT by
        // `type == PAYMENT_TYPE_20_REFUND`.
        //
        // Careful: two different things are called "type". The `payments.type` COLUMN holds a
        // payment_type (1-20), where 20 genuinely means refund. But `paymentInfoParams.type` — the
        // model this predicate would be reading — is overwritten with the selected clause's
        // payment_plan_clauses PRIMARY KEY (see showPaymentPopup: `type = clause.id`), which is an
        // unrelated auto-increment id. A clause row with id 20 would therefore collide with the
        // constant and wrongly unlock the field. Defensive rather than observed: clause ids happen
        // to run 65-640 on the current internal DB, but nothing keeps a fresh install off id 20.
        //
        // Every refund path sets refund_type, which also covers the case where the REFUND clause is
        // missing from the dropdown list and `clause` ends up undefined.
        if (self.paymentInfoParams.refund_type
            || (self.paymentInfoParams.clause && self.paymentInfoParams.clause.code === 'REFUND')
        ) {
            return false;
        }

        return true;
    }

    /**
     * WEB-3908 / WEB-3906 — mirror the Billing Date from the Notice Served Date.
     *
     * @remarks
     * Runs from the Notice Served Date input's `ng-change` and from every path that rebuilds the
     * modal's dates, so the locked field always displays the value the server will actually persist.
     *
     * The `ng-change` covers a calendar pick as well as typing because jQuery UI's _selectDate()
     * fires a `change` on the input, which Angular's input directive listens to. Note that it only
     * does so when the picker has NO `onSelect` option — adding one to these pickers (they are
     * bound in initPaymentModalDatePickers()) would silently break the mirror.
     *
     * Mirrors the server invariant that the coupling only ever COPIES a date and never erases one:
     * a blank Notice Served Date leaves the existing Billing Date untouched. Wiping it here would
     * blank the Billing Date of a not-yet-served payment merely by opening the modal.
     *
     * @returns {void} Mutates self.paymentInfoParams.due_date in place.
     */
    syncBillingDateWithNoticeServedDate() {
        const self = this;

        if (!self.isBillingDateLocked() || !self.paymentInfoParams.serving_date) {
            return;
        }

        self.paymentInfoParams.due_date = self.paymentInfoParams.serving_date;
    }

    changePaymentClause() {
        const self = this;

        if (self.paymentInfoParams.clause) {

            let payment_clause = self.paymentInfoParams.clause;

            self.paymentInfoParams.interest_rate = payment_clause.interest_rate;
            self.paymentInfoParams.grace_period = payment_clause.grace_period ? payment_clause.grace_period : 0;
            self.paymentInfoParams.due_amount = self.SSUtilService.calculateTypedValue(parseFloat(self.sale_sales.price), payment_clause.amount_type, payment_clause.amount_percentage, 2);

            // Special calculation for Maintenance Fee and Survey Fee
            if(payment_clause.payment_type == self.PAYMENT_TYPE_15_SURVEY_FEE){
                self.paymentInfoParams.due_amount = self.sale_units.survey_fee;
            }
            else if(payment_clause.payment_type == self.PAYMENT_TYPE_14_MAINTENANCE_FEE){
                let setting = self.top_maintenance_and_survey_fee_settings;
                self.paymentInfoParams.due_amount = self.sale_units.share_value * setting.base_value * setting.no_of_months;
            }

            if (payment_clause.payment_type == self.PAYMENT_TYPE_02_DEPOSIT
                && payment_clause.balance_payment_indicator
            ) {
                let paymentPlanClause = self.getPaymentPlanClauses().find(x => x.payment_type == self.PAYMENT_TYPE_01_BOOKING_FEE);
                if(paymentPlanClause){
                    let bookingFee = self.SSUtilService.calculateTypedValue(parseFloat(self.sale_sales.price), paymentPlanClause.amount_type, paymentPlanClause.amount_percentage, 2);
                    if (bookingFee) {
                        self.paymentInfoParams.due_amount -= bookingFee;
                    }
                    if (self.paymentInfoParams.due_amount < 0) {
                        self.paymentInfoParams.due_amount = 0;
                    }
                }
            }

            if (payment_clause.trigger_type == SHOWSUITE.PAYMENT_TRIGGER_TYPE_SPA_RECEIVED && self.sale_sales.hasOwnProperty("spa_date") && payment_clause.days) {
                let spa_date = moment(self.sale_sales.spa_date, "YYYY-MM-DD");
                self.paymentInfoParams.due_date = spa_date.add(payment_clause.days, 'days').format("DD/MM/YYYY");
            } else {
                self.paymentInfoParams.due_date = moment().format("DD/MM/YYYY");
            }

            if(payment_clause.code === 'REFUND'){
                self.calculatePaymentRefundAmount(100);
                self.paymentInfoParams.amount_calculation = '100';
                self.paymentInfoParams.type = this.PAYMENT_TYPE_20_REFUND;
                self.paymentInfoParams.refund_type = self.PAYMENT_REFUND_TYPE_20_REFUND;
                // WEB-3641 (Scenario 1 & 3): a refund's due date is never derived from the
                // clause — override the clause-based due_date set above with sale context
                // (aborted / re-issued -> the Abort/Re-issue popup date, otherwise empty).
                self.paymentInfoParams.due_date = self.resolveRefundDueDate();
            }

            // WEB-3908: on a project that locks the Billing Date to the Notice Served Date, the
            // clause-derived due_date computed above is not what the server will store — overwrite
            // it with the served date so the locked field shows the value that will be persisted.
            // No-ops for a REFUND clause (isBillingDateLocked() returns false there).
            self.syncBillingDateWithNoticeServedDate();

            // WEB-3641: selecting a clause renders a different set of date inputs via
            // ng-if (Refund Due Date for refunds; Notice Served / Billing dates for
            // other clauses). Re-bind the datepickers after that render so every
            // newly-shown date field gets a calendar.
            self.initPaymentModalDatePickers();
        }
    }

    getPropertyBankName(id) {
        const self = this;

        if (!id || !self.property_accounts) {
            return;
        }

        let propertyAccount = null;
        jQuery.each(self.property_accounts, function (i, _propertyAccount) {
            if (_propertyAccount.id == id) {
                propertyAccount = _propertyAccount;
                return false;
            }
        });

        let name = null;
        if (propertyAccount) {
            name = propertyAccount.bank_name;

        }

        return name;
    }

    getPropertyBankCode(id) {
        const self = this;

        if (!id || !self.property_accounts) {
            return;
        }

        let propertyAccount = null;
        jQuery.each(self.property_accounts, function (i, _propertyAccount) {
            if (_propertyAccount.id == id) {
                propertyAccount = _propertyAccount;
                return false;
            }
        });

        let name = null;
        if (propertyAccount) {
            name = propertyAccount.bank_code;

        }

        return name;
    }


    selectDeveloperAccount() {
        const self = this;

        if(self.current_payment.type == self.PAYMENT_TYPE_20_REFUND){
            let name = self.getPropertyBankName(self.current_instrument.property_account_id);
            if (name != null) {
                self.current_instrument.bank_name = name;
            }
            else {
                self.current_instrument.bank_name = "Others";
                self.current_instrument.bank_name_other = name;
            }
        }

        self.current_instrument.bank_code = self.getPropertyBankCode(self.current_instrument.property_account_id);
    }

    limitKeypress($event, value, maxLength) {
        if (value != undefined && value.toString().length >= maxLength) {
            $event.preventDefault();
        }
    }

    getPropertyCommissions() {
        let self = this;

        // if(! (self.checkPermission('PROPERTY_COMMISSION_GET'))){
        //     console.log('User don\'t have permission to view commissions');
        //     return;
        // }

        let property_id = (self.sale_property && self.sale_property.id)? self.sale_property.id : self.sale_sales.property_id;

        let url = 'sec/developer/properties/' + property_id + '/commissions';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.propertyCommissions = response.data.property_commissions;
            //Parsing Data to Object
            self.propertyCommissions.forEach(x => {
                if(x.data)
                    x.data = JSON.parse(x.data);
            });

            //Get Sale Commissions
            self.getSaleCommissions();
        });

    }

    showCommissionPopup(commission, $event) {
        const self = this;

        if ($event) {
            $event.stopPropagation();
        }

        self.hideModals();

        if (commission) {
            self.current_commission = angular.copy(commission);
        }

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self.current_commission = {};
            self.current_sale_commission_params = {};

            $('#sale_commission_name').prop('disabled', false);
            $('#AddCommissionModal').modal('show');
        });
    }

    commissionFieldLabel(commission, field) {
        const self = this;

        let fieldLabel = field;

        let LABELS = {
            type: 'Commission Type',
            name: 'Commission Name',
            commission_amount_value : 'Commission Value',
            commission_amount_type : 'Commission Type',
            incentives_amount_value : 'Incentive Value',
            incentives_amount_type : 'Incentive Type',
            data : 'Data Set',
            data_name : 'Name of Field',
            data_fields : 'Data Fields',
            incentives_gst_inclusive:'Incentives GST Inclusive',
            commission_gst_inclusive:'Commission GST Inclusive'
        };
        return fieldLabel = LABELS[field];
    }

    nameConversion(value){
        const self = this;
        let _v = (value.toLowerCase()).replace(/[\s.]/g,'_').toString();
        return _v;
    }

    validateSaleCommissionData(){
        const self = this;

        if(self.current_commission.data){
            for(let i = 0; i < self.current_commission.data.length ;i++){
                if(self.current_sale_commission_params.data[self.nameConversion(self.current_commission.data[i].name + "_value")]){
                   self.current_sale_commission_params.data[self.nameConversion(self.current_commission.data[i].name)] = self.current_sale_commission_params.data[self.nameConversion(self.current_commission.data[i].name + "_value")];
                   delete self.current_sale_commission_params.data[self.nameConversion(self.current_commission.data[i].name + "_value")];
                }
                else{
                    delete self.current_sale_commission_params.data[self.nameConversion(self.current_commission.data[i].name + "_value")];
                }
            }
        }
    }


    saveSaleCommission(){
        const self = this;

        let valid = self.parseSaleCommissionData();
        if(valid)
            self._saveSaleCommission();
    }

    _saveSaleCommission(){
        const self = this;

        let url = 'sec/developer/sales/' + self.data.sale_id + '/commissions';

        let params = angular.copy(self.current_sale_commission_params);

        if (!params) {
            return;
        }

        if(params.data){
            params.data = JSON.stringify(params.data);
        }else{
            params.data = null;
        }

        self.hideModals();

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!',  'Commission updated successfully.');
            self.getSaleCommissions();
            self.current_sale_commission_params = {};
            self.current_commission = {};
        };

        loading(true);
        if (self.current_sale_commission_params.id) {
            url += '/' + self.current_sale_commission_params.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        }
        else{
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    getSaleCommissions() {
        let self = this;

        if(! (self.checkPermission('DMS_PYMTS_VW_COMM'))){ return false; }

        let url = 'sec/developer/sales/' + self.sale_id + '/commissions';

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.sale_commission_loading = true;
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            self.sale_commission_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.saleCommissions = response.data.sale_commissions;

            //Filter Appointed Agency Commissions
            self.saleCommissions = self.saleCommissions.filter(x => x.type != 10);

            //Parsing Data to Object
            self.saleCommissions.forEach(x => {
                if(x.data) {
                    x.data = JSON.parse(x.data);
                }
            });
        });

    }

    // SALE COMMISSION & INCENTIVES

    editSaleCommission(editMode,sale_commission) {
        const self = this;
        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
            self._editSaleCommission(editMode,sale_commission);
        });
    }

    _editSaleCommission(editMode,sale_commission) {
        const self = this;

        self.commissionEditMode = editMode;
        self.current_sale_commission_params = {};

        self.current_commission = angular.copy(sale_commission);

        self.current_sale_commission_params = {
            id: sale_commission.id,
            name : sale_commission.name,
            type : sale_commission.type,
            commission_amount_value: sale_commission.commission_amount_value,
            commission_amount_type: sale_commission.commission_amount_type,
            commission_gst_inclusive: sale_commission.commission_gst_inclusive,
            incentives_amount_value: sale_commission.incentives_amount_value,
            incentives_amount_type: sale_commission.incentives_amount_type,
            incentives_gst_inclusive: sale_commission.incentives_gst_inclusive,
            property_commission_id : sale_commission.property_commission_id,
            data : []
        };

        self.temporaryData = [];
        if(self.current_commission.data && self.checkSaleCommissionType(self.current_commission.data)) {
            for(let key in self.current_commission.data){
                self.current_sale_commission_params.data[key+'_name'] = key;
                self.current_sale_commission_params.data[key+'_id'] = key;
                self.current_sale_commission_params.data[key+"_value"] = [];

                self.propertyCommissions.forEach(function (value) {
                    if(value.data){
                        value.data.forEach(function (parentData) {
                            if(self.nameConversion(parentData.name) == key){
                                if(parentData.dataset) {
                                    parentData.dataset.forEach(function (data) {
                                        let valueCheck = true;
                                        //Selecting Already Selected Values
                                        self.current_commission.data[key].forEach(function (dataset) {
                                            if(data.id == dataset.id){
                                                self.current_sale_commission_params.data[key+"_value"].push(dataset);
                                                valueCheck = false;
                                            }
                                        });
                                        //Pushing Values from Property Commission
                                        if(valueCheck){
                                            self.current_commission.data[key].push(data);
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
                self.current_commission.data[key].push({id:"other",name:"OTHER"});

                self.temporaryData.push({
                    name: key,
                    dataset : self.current_commission.data[key]
                });
            }
            self.current_commission.data = self.temporaryData;
        }
        else{
            self.current_sale_commission_params.data = self.current_commission.data;
        }

        $('#sale_commission_name').prop('disabled',true);
        $('#AddCommissionModal').modal('show');

        $('#AddCommissionModal').on('hidden.bs.modal',function () {
            self.current_commission = {};
            self.commissionEditMode = false;
        });

    }

    deleteSaleCommission(sale_commission) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete.',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                    self._deleteSaleCommission(sale_commission);
                });
            }
        );
    }

    _deleteSaleCommission(sale_commission) {
        let self = this;

        self.hideModals();

        let url = 'sec/developer/sales/' + self.sale_id + '/commissions/'+sale_commission.id+'/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.getSaleCommissions();
        });

    }

    prepareSelectionSettings(property_settings) {
        const self = this;

        let selection_settings_obj = property_settings.find(x => x.name === self.PROPERTY_SETTINGS_SELECTIONS);

        if (selection_settings_obj && selection_settings_obj.value) {
            let selection_settings = JSON.parse(selection_settings_obj.value);
            if (selection_settings.hasOwnProperty("enable") && selection_settings.enable == 1) {
                self.display_selection_row = true;
            }
        }
    }
    prepareDocumentTypeSettings(property_settings) {
        const self = this;

        // DocumentType - OTP/SPA
        self.property_settings_otp_spa = 'OTP';
        let property_settings_otp_spa_obj = property_settings.find(x => x.name === "otp_spa");
        if (property_settings_otp_spa_obj) {
            self.property_settings_otp_spa = property_settings_otp_spa_obj.value === "SPA" ? "SPA" : "OTP";
        }
    }

    chooseSelectionEmail() {
        const self = this;

        $.each(self.unit_selections, function(index, selection) {
            selection.is_lock = false;
        });

        self.hideModals();

        self.showSelectionEmailModal = true;
        $('#selection_email_modal').modal('show');
    }

    editSelections() {
        const self = this;

        $.each(self.unit_selections, function(index, selection) {
            selection.is_lock = false;
        });

        self.hideModals();

        self.showSelectionEditModal = true;
        $('#selection_edit_modal').modal('show');
    }

    sendSelectionsEmail() {
        const self = this;

        //Validate lock selection
        if (self.validateLockSelection()) {
            return;
        }

        let message = null;
        self.hideModals();

        if (self.is_resend_selection_email) {
            message = 'You are about to retrigger an email to the buyer for the selections of options.\n\nPlease Note, if there are any email sent previously to the buyer will no longer be active.\n\nPlease advice the buyer to click on the new email to perform the selection action.';
        } else {
            message = 'You are about to send an email to the buyer for the selections of options.\n\nPlease Note, if there are any email sent previously to the buyer will no longer be active.\n\nPlease advice the buyer to click on the new email to perform the selection action.';
        }

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            message,
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                    self._sendSelectionsEmail();
                });
            }
        );
    }

    _sendSelectionsEmail() {
        const self = this;

        //Update selection lock status first
        let url = "";
        let param = {};

        url = 'sec/sales/' + self.sale_id + '/selections';
        let selection_answer_text_obj = [];

        $.each(self.unit_selections, function(index, selection) {
            if (!selection.hasOwnProperty("answer_text")) {
                selection.answer_text = "";
            }
            if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                //Process answer
                let answer_array = [];
                $.each(selection.formatted_choices, function (i, choice) {
                    if (choice.answer) {
                        answer_array.push(choice.label.name);
                    }
                });
                selection.answer_text = JSON.stringify(answer_array);
            }

            selection_answer_text_obj.push([selection.id, selection.answer_text, selection.is_lock]);
        });

        param = selection_answer_text_obj;

        loading(true);
        self.SSHttpService.postAPIRequest(url, param).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.hideModals();
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            //Get the latest sale selection status
            self.sale_sales.selections_status = response.data.sale.selections_status;

            if (self.sale_sales.selections_status && (self.sale_sales.selections_status == self.SELECTIONS_STATUS_SELECTED || self.sale_sales.selections_status == self.SELECTIONS_STATUS_PENDING_RESELECTION)) {
                self.is_resend_selection_email = true;
            }

            url = 'sec/sales/' + self.sale_id + '/selections/send-selections-email';
            param = {
                resend: self.is_resend_selection_email ? 1 : 0
            };
            self.SSHttpService.getAPIRequest(url, param).then(function (response) {
                loading(false);
                self.hideModals();
                if (response instanceof Error) {
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.getSaleDetails();

                self.SSAlertService.success("Success!", "Email has been sent to the buyer.");
            });
        });
    }



    updateSaleSelections() {
        const self = this;

        //Validate lock selection
        if (self.validateLockSelection()) {
            return;
        }

        let message = null;
        self.hideModals();

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are You Sure, You want to manually update the Selection Option(s)',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                    self._updateSaleSelections();
                });
            }
        );
    }

    _updateSaleSelections() {
        const self = this;

        //Update selection lock status first
        let url = "";
        let param = {};

        url = 'sec/sales/' + self.sale_id + '/selections';
        let selection_answer_text_obj = [];

        $.each(self.unit_selections, function(index, selection) {
            if (!selection.hasOwnProperty("answer_text")) {
                selection.answer_text = "";
            }
            if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                //Process answer
                let answer_array = [];
                $.each(selection.formatted_choices, function (i, choice) {
                    if (choice.answer) {
                        answer_array.push(choice.label.name);
                    }
                });
                selection.answer_text = JSON.stringify(answer_array);
            }

            selection_answer_text_obj.push([selection.id, selection.answer_text, selection.is_lock]);
        });

        let params = {
            body: selection_answer_text_obj,
            update_answers: true,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.hideModals();
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.hideModals();
            loading(false);
            self.getSaleDetails();
            self.getSalesHistory();
            self.SSAlertService.success("Success!", "Selections updated successfully.");
        });
    }



    /**
     * Download the Official Receipt (non-refund payment) or Credit Note (refund payment) report
     * for the given instrument + payment combination.
     *
     * Routes to the v2 endpoint when the current user holds the developer-wide
     * `DMS_REPORTS_OFFICIAL_RECEIPT_REPORT_V2` permission — that endpoint internally branches
     * on payment.type (refund → kind 83 Credit Note template; else → kind 77 Official Receipt
     * template). Falls back to the legacy v1 endpoint otherwise. v1 only knows about kind 77
     * and is the path used by clients not yet opted into the v2 flow (e.g. Allgreen).
     *
     * @remarks Uses the developer-wide `hasPermission()` check (not the per-property variant)
     *   because the v2 permission was redefined to property_level=0 server-side; the v2 vs v1
     *   selection is therefore role-wide, not per-property. See WEB-3460 iter-2.
     *
     * @param {number|string} instrument_id  Payment-instrument ID identifying the funds transfer.
     * @param {number|string} payment_id     Parent payment ID; the server uses payment.type to
     *                                       decide receipt vs credit-note when on the v2 path.
     * @return {void}
     */
    downloadReceipt(instrument_id,payment_id){
        const self = this;
        const v2 = self.SSUserService.hasPermission('DMS_REPORTS_OFFICIAL_RECEIPT_REPORT_V2');
        const endpoint = v2
            ? 'sec/developer/reports/official-receipt-report-v2'
            : 'sec/developer/reports/official-receipt-report';
        let url = self.SSHttpService.getApiURL(endpoint+'?payment_id='+payment_id+'&instrument_id='+instrument_id);
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }
    downloadTaxInvoice(payment_id){
        const self = this;
        let url = self.SSHttpService.getApiURL('sec/developer/reports/tax-invoice-report?payment_id='+payment_id); // self.SSHttpService.getReportURL('api/reports/tax-invoice-report');
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    getPaymentPlans() {
        const self = this;

        let url = 'sec/developer/payment-plans';

        let params = {
            'include': 'payment_plan_clauses',
        };

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.payment_plan_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.payment_plan_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            try {
                if (response.data && response.data.payment_plans) {
                    self.payment_plans = response.data.payment_plans;
                    $.each(self.payment_plans, function(index, plan){
                        // Only add parent clauses for current sale appointed payment plan
                        if(self.sale_sales && plan.id == self.sale_sales.payment_plan_id) {
                            $.each(plan.payment_plan_clauses, function (_index, clause) {
                                // Find the parent for payment clause if available and add it to name
                                if (clause.parent_payment_plan_clause_id) {
                                    let parentPaymentPlanClause = plan.payment_plan_clauses.find(x => x.id == clause.parent_payment_plan_clause_id);
                                    if (parentPaymentPlanClause)
                                        clause.name += ` (${parentPaymentPlanClause.name})`;
                                }
                            });
                        }
                    })
                    self.payment_plan = self.getPaymentPlan();
                }
            } catch (ex) {
                console.log(ex);
            }

            //Get sale payment, moved here as payment plans call response needed
            self.getSalePayments(true);
        });
    }

    getPaymentTypeDisplayName(payment_type) {
        const self = this;
        switch (parseInt(payment_type)) {
            case self.PAYMENT_PLAN_TYPE_NPS:
                return "NPS";
                break;

            case self.PAYMENT_PLAN_TYPE_DPS:
                return "DPS";
                break;

            case self.PAYMENT_PLAN_TYPE_PVT:
                return "PVT";
                break;

            default:
                return "";
                break;
        }
    }

    getClauseById(clauseId){
        const self = this;

        if(!clauseId){
            return;
        }

        let clause = null;

        try{
            let payment_plan = self.getPaymentPlan();
            if(payment_plan){
                let clauses = payment_plan.payment_plan_clauses;
                clause = clauses.find(x => x.id == clauseId);
            }
        }
        catch(ex){
            console.log(ex);
        }

        return clause;
    }

    getPaymentPlanClauses(){
        const self = this;

        if(!self.paymentInfoParams){
            return;
        }

        let clauses = [];

        try{
            let payment_plan = self.getPaymentPlan();
            if(payment_plan){
                clauses = payment_plan.payment_plan_clauses;
            }
        }
        catch(ex){
            console.log(ex);
        }

        let refundClause = clauses.find(x => x.payment_type === self.PAYMENT_TYPE_20_REFUND);
        // ADD REFUND CLAUSE BY DEFAULT
        if(!refundClause) {
            clauses.push({
                id: null,
                code: "REFUND",
                amount_percentage: 100,
                name: "Refund",
                description: "Refund",
                payment_type: self.PAYMENT_TYPE_20_REFUND,
            })
        } else if(refundClause.aborted_indicator){ // If refund clause exists, and aborted_indicator is ON
            if (self.sale_sales.status != self.SALE_STATUS_ABORTED) {
                // If sale status is not aborted, need to show default refund if aborted indicator is ON
                clauses = clauses.filter(x => x.payment_type !== self.PAYMENT_TYPE_20_REFUND);
                clauses.push({
                    id: null,
                    code: "REFUND",
                    amount_percentage: 100,
                    name: "Refund",
                    description: "Refund",
                    payment_type: self.PAYMENT_TYPE_20_REFUND,
                })
            }
        }
        return clauses;
    }

    getFilteredPaymentPlanClauses(clause, typeRefund = false){
        const self = this;

        let clauses = self.getPaymentPlanClauses();
        if (typeRefund) { // If payment refund popup opened, only show refund payment type clauses
            clauses = clauses.filter(x => x.payment_type === self.PAYMENT_TYPE_20_REFUND);
        }
        if (clause) {
            return clauses;
        } else {
            let ids = (self.sale_payments.filter(x=> x.type !== self.PAYMENT_TYPE_12_DLP && x.type !== self.PAYMENT_TYPE_20_REFUND)).map(x => x.type);
            let createdPaymentPlanClauseIds = self.sale_payments.map(x => x.payment_plan_clause_id);
            let createdClauseIds = clauses.filter(x => createdPaymentPlanClauseIds.includes(x.id)).map(x=>x.id);
            let _filteredPaymentPlanClauses = clauses.filter(x => !ids.includes(x.payment_type));
            _filteredPaymentPlanClauses = _filteredPaymentPlanClauses.filter(x => {
                // Allow multiple payment entries for Refund and DLP
                return x.payment_type === self.PAYMENT_TYPE_20_REFUND || x.payment_type === self.PAYMENT_TYPE_12_DLP || !createdClauseIds.includes(x.id)
            });
            clauses = _filteredPaymentPlanClauses.filter(x => (!x.parent_payment_plan_clause_id || (x.parent_payment_plan_clause_id && createdClauseIds.includes(x.parent_payment_plan_clause_id))));
        }

        return clauses;
    }

    getPaymentPlan(){
        const self = this;

        if(!self.sale_sales){
            return;
        }

        let payment_plan = null;

        try{
            $.each(self.payment_plans, function(index, plan){
                if(plan.id == self.sale_sales.payment_plan_id){
                    payment_plan = plan;
                    return;
                }
            });
        }
        catch(ex){
            console.log(ex);
        }

        return payment_plan;
    }

    downloadSaleReport(sale_id){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/detailed-interest-report');
        url += '&sale_id='+sale_id;
        url += '&to_date='+self.generateReport.to_date;
        url += '&from_date='+self.generateReport.from_date;

        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
        self.generateReport.to_date = null;
        self.generateReport.from_date = null;
        self.hideModals();
    }

    toggleModal(){
        const self = this;
        self.$timeout(function () {
            jQuery('.datepicker2').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "yy-mm-dd"
            });
        });
        self.downloadReportModal = true;
        $('#downloadReportModal').modal('show');
    }

    downloadStatementOfAccountReport(){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/statement-of-account');
        url += '&sale_id='+self.sale_sales.id;
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    downloadStatementOfAccountWithExtendedDueDateReport(){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/statement-of-account-with-extended-due-date');
        url += '&sale_id='+self.sale_sales.id;
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    downloadAmlRiskAssessmentHistoryReport(type){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/sales-aml-cft-detail-status-report');
        url += '&sale_id='+self.sale_sales.id;
        url += '&property_id='+self.sale_sales.property_id;
        if(type === 'pdf'){
            url += '&report_type=pdf';
        }
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    downloadCompletionAccountReport(type){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/completion-account-report');
        if(type === 'COMPLETION_ACCOUNT_2'){
             url = self.SSHttpService.getReportURL('api/reports/completion-account-report-2');
        }
        url += '&sale_id='+self.sale_sales.id;
        url += '&property_id='+self.sale_sales.property_id;
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }
    downloadSalesNoteDocument() {
        const self = this;
        let url = self.SSHttpService.getApiURL('sec/developer/sales/' + self.sale_sales.id + '/sales-note-document?remarks=' + self.salesNoteRemarks);
        let url_ping = window.open(encodeUrlWithParams(url), '_blank');
        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully.");
        }
    }
    downloadProcessRefundReport(payment_id){
        const self = this;
        let url = self.SSHttpService.getReportURL('api/reports/process-refund-forfeiture-report');
        url += '&payment_id='+payment_id;
        let url_ping = window.open(url,'_blank');
        if(url_ping)
        {
            self.SSAlertService.success("Success!", "Download completed successfully");
        }
    }

    prepareReorderBuyerObj() {
        const self = this;

        self.reorder_buyers = angular.copy(self.sale_sales.sale_buyers);
        self.order_list = [];
        $.each(self.reorder_buyers, function(index, buyer) {
            buyer.order = index + 1;
            let obj = {id: index + 1, name: index + 1};
            self.order_list.push(obj);

            if (!(buyer.hasOwnProperty("processed_data") && buyer.processed_data)) {
                if (typeof buyer.data == 'string') {
                    buyer.processed_data = JSON.parse(buyer.data);
                } else {
                    buyer.processed_data = buyer.data;
                }
            }
        });
    }

    showReorderBuyersModal() {
        const self = this;

        self.hideModals();
        self.displayReorderBuyersModal = true;

        self.prepareReorderBuyerObj();
        $('#reorder_buyers_modal').modal('show');
    }

    changeBuyerOrder(buyer, old_order) {
        const self = this;

        let to_update_buyer = self.reorder_buyers.find(x => x.order == buyer.order && x.id != buyer.id);
        to_update_buyer.order = angular.copy(old_order);
    }

    updateBuyerOrder(buyer_params) {
        const self = this;

        let url = "";
        let params = {};

        $.each(self.reorder_buyers, function(index, buyer) {

            if(buyer.sale_id){
                url = 'sec/developer/sales/' + buyer.sale_id + '/buyers/' + buyer.id;
            }
            else if(buyer.subsale_id){
                url = 'sec/developer/sales/'+ self.sale_sales.id +'/subsales/' + buyer.subsale_id + '/buyers/' + buyer.id;
            }

            if (!(buyer.hasOwnProperty("processed_data") && buyer.processed_data)) {
                if (typeof buyer.data == 'string') {
                    buyer.processed_data = JSON.parse(buyer.data);
                } else {
                    buyer.processed_data = buyer.data;
                }
            }

            if (buyer_params && buyer && buyer.processed_data
                    && buyer.processed_data.id === buyer_params.buyer_id) {
                params = angular.copy(buyer_params);
            } else {
                params = {
                    buyer_id: buyer.processed_data.id,
                    order: buyer.order,
                    data: JSON.stringify(buyer.processed_data),
                    updated_at: buyer.updated_at
                };
            }

            loading(true);
            self.SSHttpService.putAPIRequest(url, params).then(function (response) {
                if (response instanceof Error) {
                    loading(false);
                    self.hideModals();
                    if (response.sub_code == 305015 || response.sub_code == 412002) {
                        self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                        return;
                    }
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if (index == self.reorder_buyers.length - 1) {
                    self.SSAlertService.success('Buyers order updated successfully.');
                    self.hideModals();
                    self.$window.location.reload();
                }
            });
        });
    }

    initSelectizejs() {
        const self = this;

        let $select = $('#selectize').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });
    }

    parseSaleCommissionData(){
        const self = this;

        let temporaryDataArray = {};
        let valid = true;
        if(angular.isString(self.current_sale_commission_params.data)){
            return valid;
        }

        let propertyCommission = self.propertyCommissions.find(x => x.name == self.current_sale_commission_params.name);
        if(propertyCommission && propertyCommission.data){
            propertyCommission.data.forEach(function (data) {
                    let namedValue = self.nameConversion(data.name);
                    if(self.current_sale_commission_params.data[namedValue+"_value"] && self.current_sale_commission_params.data[namedValue+"_value"].hasOwnProperty('id')){
                        let newObj = {
                            id:self.current_sale_commission_params.data[namedValue+"_value"].id,
                            name:self.current_sale_commission_params.data[namedValue+"_value"].name
                        };
                        temporaryDataArray[namedValue] = Array(newObj);
                    }
                    else{
                        temporaryDataArray[namedValue] = self.current_sale_commission_params.data[namedValue + "_value"];
                        if(data.is_required){
                            if(!angular.isArray(self.current_sale_commission_params.data[namedValue + "_value"]) && !self.current_sale_commission_params.data[namedValue + "_value"])
                                valid = false;
                        }
                    }
            });
        }
        self.current_sale_commission_params.data = temporaryDataArray;

        return valid;
    }

    commissionSelectionChange(){
        const self = this;

        self.current_commission = angular.copy(self.propertyCommissions.find(x => x.id == self.current_commission.id));
        self.current_sale_commission_params = angular.copy(self.current_commission);
        self.current_sale_commission_params['sale_id'] = self.data.sale_id;
        self.current_sale_commission_params['property_commission_id'] = self.current_sale_commission_params['id'];
        delete self.current_sale_commission_params['id'];

        self.current_sale_commission_params.data = {};

        if(self.current_commission.data) {
            self.current_commission.data.forEach((value, index) => {
                let named_value = self.nameConversion(value.name);
                self.current_sale_commission_params.data[named_value+'_name'] = named_value;
                self.current_sale_commission_params.data[named_value+'_id'] = named_value;
                self.current_sale_commission_params.data[named_value+"_value"] = null;
                if(value.dataset)
                    value.dataset.push({id:"other",name:"OTHER"});
            });
        }
        else{
            self.current_sale_commission_params.data = "";
        }
    }

    initSelectizejsClass() {
        const self = this;

        let $select = $('.selectize').selectize({
            delimiter: ',',
            persist: false,
            create: function (input) {
                return {
                    value: input,
                    text: input
                }
            }
        });
    }

    checkOutputForOther(key){
        const self = this;
        let check = false;
        if(angular.isArray(self.current_sale_commission_params.data[key+'_value'])) {
            self.current_sale_commission_params.data[key + '_value'].forEach(function (value) {
                if (value.id === 'other') {
                    self.current_sale_commission_params.data[key + '_id'] = 'other';
                    check = true;
                }
            });
        }
        else{
            if(self.current_sale_commission_params.data[key+'_value'].id === 'other'){
                self.current_sale_commission_params.data[key + '_id'] = 'other';
                check = true;
            }
        }
        if(check) {
            self.current_sale_commission_params.data[key + '_value'] = [];
        }
        else{
            self.current_sale_commission_params.data[key+'_id'] = key;
        }

    }

    checkSaleCommissionType(saleCommissionData){
        if(typeof (saleCommissionData) == 'object')
            return true;
        else if(typeof(saleCommissionData == 'string'))
            return false;
    }

    calculatePaymentInterestPopup(payment){
        const self = this;
        self.hideModals();
        self.selectedPayment = angular.copy(payment);
        self.selectedPayment.clause = payment && payment.payment_plan_clause_id ? self.getClauseById(payment.payment_plan_clause_id) : null;
        self.calculateInterestParams.payment_date = null;
        self.calculateInterestParams.interest_amount = null;
        self.calculateInterestErrors.payment_date = null;
        self.interestCalculation = true;
        $('#calculatePaymentInterest').modal('show');
    }

    getCalculateInterestValidity(){
        const self = this;
        let formatted_date = self.SSDateService.formateWithTimeAsNoon(self.calculateInterestParams.payment_date);
        let payment_date = self.SSUtilService.parseDate(formatted_date);
        let expiry_date = self.SSUtilService.parseDate(self.selectedPayment.expiry_date);

        if(payment_date > expiry_date){
            self.calculateInterestErrors.payment_date = null;
            return true;
        }
        else{
            self.calculateInterestErrors.payment_date = 'Selected Date is smaller than Due Date';
            return false;
        }
    }

    getInterestRate(){
        const self = this;
        let url = 'sec/developer/sales/'+self.sale_id+'/payments/'+self.selectedPayment.id+'/estimated-late-fee';

        self.calculateInterestParams.interest_amount = null;

        if(!self.getCalculateInterestValidity()){
            return;
        }
        let params = {
            expected_payment_date: self.SSDateService.formateWithTimeAsNoon(self.calculateInterestParams.payment_date),
            send_email: 0
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.calculateInterestParams.interest_amount = response.data.estimated_late_fee;
        });
    }

    sendCalculateInterestEmail(){
        const self = this;

        let url = 'sec/developer/sales/'+self.sale_id+'/payments/'+self.selectedPayment.id+'/estimated-late-fee';

        self.calculateInterestParams.interest_amount = null;

        if(!self.getCalculateInterestValidity()){
            return;
        }
        let params = {
            expected_payment_date: self.SSDateService.formateWithTimeAsNoon(self.calculateInterestParams.payment_date),
            send_email: 1,
            'recipients': {
                "buyer_emails": [],
                "broker_emails": [],
                "buyer_lawyer_emails": [],
                "developer_emails": [],
                "property_lawyer_emails": [],
                "teamic_emails": []
            },
        };

        if (self.email_receipient.buyer) {
            params["recipients"]["buyer_emails"] = self.pushToSendEmailParams(self.receipent_data.buyer, params["recipients"]["buyer_emails"]);
        }

        if (self.email_receipient.agent) {
            params["recipients"]["broker_emails"] = self.pushToSendEmailParams(self.receipent_data.agent, params["recipients"]["broker_emails"]);
        }

        if (self.email_receipient.buyer_lawyer) {
            params["recipients"]["buyer_lawyer_emails"] = self.pushToSendEmailParams(self.receipent_data.buyer_lawyer, params["recipients"]["buyer_lawyer_emails"]);
        }

        if (self.email_receipient.developer) {
            params["recipients"]["developer_emails"] = self.pushToSendEmailParams(self.receipent_data.developer, params["recipients"]["developer_emails"]);
        }

        if (self.email_receipient.developer_lawyer) {
            params["recipients"]["property_lawyer_emails"] = self.pushToSendEmailParams(self.receipent_data.developer_lawyer, params["recipients"]["property_lawyer_emails"]);
        }

        if (self.email_receipient.teamic) {
            params["recipients"]["teamic_emails"] = self.pushToSendEmailParams(self.receipent_data.teamic, params["recipients"]["teamic_emails"]);
        }


        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.calculateInterestParams.interest_amount = response.data.estimated_late_fee;
            self.selectedPayment = null;
            self.calculateInterestParams.payment_date = null;
            self.calculateInterestParams.interest_amount = null;
            self.calculateInterestErrors.payment_date = null;
            self.SSAlertService.success("Success!", "Email Sent successfully");
        });
        self.interestCalculation = false;
    }

    editOtpOrderNo(check){
        const self = this;
        if(check){
            self.updateSaleEditMode = true;
            self.updateSaleParams.purchase_mode = self.sale_sales.purchase_mode;
            self.updateSaleParams.staff_id = self.sale_sales.staff_id;
            self.updateSaleParams.order_no = self.sale_sales.order_no;
            self.updateSaleParams.tele_sales_no = self.sale_sales.tele_sales_no;
            self.updateSaleParams.referral_type = self.sale_sales.referral_type;
            self.updateSaleParams.referral_name = self.sale_sales.referral_name;
            self.updateSaleParams.referral_code = self.sale_sales.referral_code;
            self.updateSaleParams.is_management_sale = self.sale_sales.is_management_sale;
            self.updateSaleParams.remarks_for_lawyer = self.sale_sales.remarks_for_lawyer;
            if(self.sale_sales.hasOwnProperty('requested_spa_issue_date'))
                self.updateSaleParams.requested_spa_issue_date = self.sale_sales.requested_spa_issue_date;
        }
        else{
            self.updateSaleEditMode = false;
            self.updateSaleParams = {};
        }
    }

    saveOtpOrderNo(){
        const self = this;
        let url = 'sec/developer/sales/' + self.sale_id + '/update-sale-fields';

        let param = self.updateSaleParams;

        loading(true);
        self.SSHttpService.putAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.mapBeneficiaryServerErrors(response);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.editOtpOrderNo(false);
            self.getSaleDetails();
        });
    }

    updateBuyerSale(){
        const self = this;
        let url = 'sec/developer/sales/' + self.sale_id + '/update-sale-fields';

        let param = self.buyerSaleParams;

        loading(true);
        self.SSHttpService.putAPIRequest(url, param).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.mapBeneficiaryServerErrors(response);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            angular.merge(self.sale_sales,response.data.sale);
            self.buyerSaleEditMode = false;
        });
    }

    getSalePropertyDetails() {
        const self = this;

        let url = 'properties/' + self.sale_sales.property_id;
        let params = {
            'include': 'property_discounts, property_payment_plans, property_accounts',
        };

        // WEB-1736 - Replace generic loading animation into individual loading animation for each category
        self.discounts_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.discounts_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_property = response.data.property;
            self.IS_THAILAND_PROJECT = response.data.property.country == self.THAILAND_COUNTRY_CODE;
            self.PROJECT_COUNTRY = response.data.property.country;

            /** WEB-2811 AMS/DMS : AUS country support **/
            self.IDENTITY_TYPES = self.SSConfigService.getIdentityTypes(self.PROJECT_COUNTRY);

            self.prepareBanksData();

            self.property_accounts = self.sale_property ? self.sale_property.property_accounts : null;
            self.property_accounts_master = angular.copy(self.property_accounts);

            self.getPaymentPlans();

            self.sale_property_discounts = response.data.property.property_discounts;

            if (self.sale_sales.payment_plan_id && response.data.property.property_payment_plans) {
                self.sale_sales.payment_plan = response.data.property.property_payment_plans.find(x => x.id === self.sale_sales.payment_plan_id);
            }

            try {

                self.getPropertyDocs(self.sale_property);

                //Get Selection Settings
                self.prepareSelectionSettings(response.data.property.settings);
                self.prepareDocumentTypeSettings(response.data.property.settings);
                self.prepareBuyingInTrustSettings(response.data.property.settings);
                self.getSaleUnitDetails();
                self.getStaffCommissions();
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    getSaleUnitDetails() {
        const self = this;

        let url = 'properties/' + self.sale_sales.property_id + '/units/' + self.sale_sales.unit_id;

        let param = {
            'return_stack': true,
            'include': 'selections'
        };

        self.unit_loading = true;
        self.SSHttpService.getAPIRequest(url, param).then(function (response) {
            self.unit_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_units = response.data.unit;
            self.stacks = response.data.stack;

            self.getSaleDiscounts();
            self.checkScroll();

            // eoi_unit.price is the list price as of reservation; fall back only when the snapshot is missing.
            if (self.sale_sales.eoi_unit && self.sale_sales.eoi_unit.price) {
                self.sale_sales.unit_listing_price = self.sale_sales.eoi_unit.price;
            } else if (self.sale_sales.unit_price_schedule && self.sale_sales.unit_price_schedule.price) {
                self.sale_sales.unit_listing_price = self.sale_sales.unit_price_schedule.price;
            } else {
                self.sale_sales.unit_listing_price = self.sale_units.price;
            }

            if(self.sale_sales.price && self.sale_sales.price>0){
                self.sale_sales["psf"] = response.data.unit.size_ft2 ? self.SSAppService.getRoundOffValue(self.sale_sales.price / response.data.unit.size_ft2, self.PROJECT_COUNTRY) : '--';
            }else{
                self.sale_sales["psf"] = response.data.unit.size_ft2 ? self.SSAppService.getRoundOffValue(response.data.unit.price / response.data.unit.size_ft2, self.PROJECT_COUNTRY) : '--';
            }

            self.raw_selections = response.data.selections;

            //Filter out selections that not belongs to the sale
            self.unit_selections = [];

            $.each(self.raw_selections, function(index, selection) {
                let found_selection = self.sale_sales.sale_selections.find(x => x.selection_id == selection.id);

                if (found_selection) {
                    self.unit_selections.push(selection);
                }
            });

            //Rearrange the selection order
            if (self.unit_selections && self.unit_selections.length > 0) {
                self.unit_selections.sort(function (a, b) {
                  return a.order - b.order;
                });
            }

            url = 'sec/sales/' + self.sale_sales.id + '/selections/payments';
            param = {
              'include': 'instruments'
            };

            self.SSHttpService.getAPIRequest(url, param).then(function (response) {
                self.unit_loading = false;
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.sale_selection_payments = response.data.sale_selection_payments;
                self.display_sale_selection_payments = [];

                $.each(self.unit_selections, function(index, selection) {
                    selection.sale_selection = self.sale_sales.sale_selections.find(x => x.selection_id === selection.id);

                    if (selection.sale_selection) {
                      selection.sale_payment = self.sale_selection_payments.find(x => x.sale_selection_id == selection.sale_selection.id);

                      if (selection.sale_payment) {
                        self.display_sale_selection_payments.push(selection);
                        $.each(selection.sale_payment.instruments, function(i, instrument) {
                          if (instrument.cheque_date) {
                              instrument.cheque_date = moment(self.parseDate(instrument.cheque_date)).format('YYYY-MM-DD');
                          }

                          if (instrument.bank_in_date) {
                              instrument.bank_in_date = moment(self.parseDate(instrument.bank_in_date)).format('YYYY-MM-DD');
                          }

                          instrument.typeName = self.$filter('filter')(self.instrument_types, {id: instrument.type}, true)[0].name;

                          if (instrument.file_uri) {
                            let url = 'sec/assets/presigned-url';
                            let params = {
                              'model': SHOWSUITE.ASSET_MODEL_SELECTION_PAYMENT_INSTRUMENT,
                              'id': instrument.id
                            };
                            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                              if (response instanceof Error) {
                                self.SSAlertService.parseAndDisplayError(response);
                                return;
                              }

                              instrument.show_file_url = response.data.presigned_url;
                            });
                          }
                        });
                      }
                    }

                    //Prepare to setup choices
                    if (selection.type == SHOWSUITE.QUESTION_TYPE_SELECT || selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX || selection.type == SHOWSUITE.QUESTION_TYPE_RADIO) {
                        selection["formatted_choices"] = selection.choices;

                        if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                            let formatted_choices = angular.copy(selection.formatted_choices);
                            selection.formatted_choices = [];
                            $.each(formatted_choices, function (j, choice) {
                                let new_choice = {};
                                new_choice["label"] = choice;
                                new_choice["answer"] = false;
                                selection.formatted_choices.push(new_choice);
                            });
                        }

                        if (selection.sale_selection && selection.sale_selection.selection_answer_text) {
                            if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                                let answered_choices = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text)

                                if(answered_choices && typeof answered_choices != 'string'){
                                    $.each(answered_choices, function(i, choice) {
                                        let found_choice = selection.formatted_choices.find(x => x.label.name == choice);
                                        if (found_choice) {
                                            found_choice.answer = true;
                                        }
                                    });
                                }

                                selection.sale_selection.formatted_answer = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text);

                                if (Array.isArray(selection.sale_selection.formatted_answer)) {
                                    selection.sale_selection.formatted_answer = selection.sale_selection.formatted_answer.join(", ");
                                }
                            } else {
                                // If selections updated and type 'checkbox' changed to 'radio'
                                // https://showsuite.atlassian.net/browse/WEB-2301
                                selection.answer_text = self.SSEoiService.getFormattedAnswer(selection.sale_selection.selection_answer_text, true);
                                selection.sale_selection.formatted_answer = selection.answer_text;
                            }
                        } else {
                            //Auto select default answer
                            // if (selection.type == SHOWSUITE.QUESTION_TYPE_CHECKBOX) {
                            //     let default_choices = JSON.parse(selection.default_choice)

                            //     $.each(default_choices, function(i, choice) {
                            //         let found_choice = selection.formatted_choices.find(x => x.label.name == choice);

                            //         if (found_choice) {
                            //             found_choice.answer = true;
                            //         }
                            //     });
                            // } else {
                            //     selection.answer_text = selection.default_choice;
                            // }
                        }
                    }
                });
            });
        });

        self.$timeout(function(){
            if(self.urlPaymentInformation){
                const paymentInformation = $("#paymentInformation");
                if(paymentInformation){
                    paymentInformation[0].scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }

    getSalesBuyers() {
        const self = this;

        if(! (self.checkPermission('DMS_PYMTS_VW_BUYER'))){ return false; }

        let url = 'sec/developer/sales/' + self.sale_id + '/buyers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                // WEB-3109 - make call regardless of getSalesBuyers response
                self.getSubsales();
                self.getSaleBeneficiaries();
                return;
            }

            if (response.data && response.data.saleBuyers && response.data.saleBuyers.length > 0) {
                self.sale_sales.sale_buyers = response.data.saleBuyers;

                self.sale_sales.sale_buyers = _.sortBy(self.sale_sales.sale_buyers, 'order');

                /** WEB-2937 Corporate Sale - Support for Multiple Signatories
                 * Set sale buyers in SSEoiService for utility functions **/
                self.SSEoiService.buyers = self.sale_sales.sale_buyers.map(buyer => {
                    try{
                        return JSON.parse(buyer.data);
                    }catch(e){
                        console.warn("Error occurred parsing buyer data", e);
                    }
                });

                $.each(self.sale_sales.sale_buyers, function(index, buyer) {
                    if (buyer.data && typeof buyer.data == "string") {
                        buyer.data = JSON.parse(buyer.data);

                        if (buyer.data) {
                            self.initEditLawyerDetail(buyer.data, buyer.data);
                        }
                    }

                    buyer.processed_data = buyer.data;
                });

                let saleBuyer = self.sale_sales.sale_buyers.find(x => x.order == 1);

                if (saleBuyer) {
                    self.selectSaleBuyer(saleBuyer);
                } else {
                    self.selectSaleBuyer(self.sale_sales.sale_buyers[0]);
                }
            }

            // WEB-3109 - make call regardless of getSalesBuyers response
            self.getSubsales();
            self.getSaleBeneficiaries();
        });
    }

    getSalesNonBuyerPayees() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/non-buyer-payees';
        let params = {
            'include': 'individual, company, primary_address, email_contact, phone1_contact, phone2_contact, documents',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.sale_non_buyer_payees && response.data.sale_non_buyer_payees.length > 0) {
                self.sale_sales.sale_non_buyer_payees = response.data.sale_non_buyer_payees;

                self.sale_sales.sale_non_buyer_payees = _.sortBy(self.sale_sales.sale_non_buyer_payees, 'order');

                self.SSEoiService.nonBuyerPayees = angular.copy(self.sale_sales.sale_non_buyer_payees);

                $.each(self.sale_sales.sale_non_buyer_payees, function(index, nonBuyerPayee) {
                    if (nonBuyerPayee.data && typeof nonBuyerPayee.data == "string") {
                        nonBuyerPayee.data = JSON.parse(nonBuyerPayee.data);
                        nonBuyerPayee.processed_data = nonBuyerPayee.data;
                    }

                    if(!nonBuyerPayee.order){
                        nonBuyerPayee.order = index + 1;
                    }

                });

                let saleNonBuyerPayee = self.sale_sales.sale_non_buyer_payees.find(x => x.order == 1);

                if (saleNonBuyerPayee) {
                    self.selectSaleNonBuyerPayee(saleNonBuyerPayee);
                } else {
                    self.selectSaleNonBuyerPayee(self.sale_sales.sale_non_buyer_payees[0]);
                }
            }
        });
    }


    getSalesWitnesses() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/witnesses';
        let params = {
            'include': 'individual, primary_address, email_contact, phone1_contact, phone2_contact, documents',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.sale_witnesses && response.data.sale_witnesses.length > 0) {
                self.sale_sales.sale_witnesses = response.data.sale_witnesses;

                self.sale_sales.sale_witnesses = _.sortBy(self.sale_sales.sale_witnesses, 'order');

                $.each(self.sale_sales.sale_witnesses, function(index, witness) {
                    if (witness.data && typeof witness.data == "string") {
                        witness.data = JSON.parse(witness.data);
                        witness.processed_data = witness.data;
                    }

                    if(!witness.order){
                        witness.order = index + 1;
                    }

                });

                let saleWitness = self.sale_sales.sale_witnesses.find(x => x.order == 1);

                if (saleWitness) {
                    self.selectWitness(saleWitness);
                } else {
                    self.selectWitness(self.sale_sales.sale_witnesses[0]);
                }
            }
        });
    }

    getSalesOccupier() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/occupiers';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.saleOccupiers && response.data.saleOccupiers.length > 0) {
                self.sale_sales.sale_occupiers = response.data.saleOccupiers;

                self.sale_sales.sale_occupiers = _.sortBy(self.sale_sales.sale_occupiers, 'order');
                $.each(self.sale_sales.sale_occupiers, function(index, occupier) {
                    if (occupier.data && typeof occupier.data == "string") {
                        occupier.data = JSON.parse(occupier.data);
                    }

                    occupier.processed_data = occupier.data;
                });

                let saleOccupier = self.sale_sales.sale_occupiers.find(x => x.order == 1);
                if (saleOccupier) {
                    self.selectSaleOccupier(saleOccupier);
                } else {
                    self.selectSaleOccupier(self.sale_sales.sale_occupiers[0]);
                }
            }
        });
    }

    getSalesDocuments() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/documents';
        /** WEB-2811 AMS/DMS : AUS country support
         * Retrieve documents with signee details by including params 'documents' and 'document_signees' **/
        let params = {
            include: 'documents, document_signees'
        }

        self.documents_loading = true;
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            self.documents_loading = false;
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.sales_documents && response.data.sales_documents.length > 0) {
                self.sale_sales.documents = response.data.sales_documents;
                /** WEB-2811 AMS/DMS : AUS country support **/
                self.sale_sales.sales_documents_list = response.data.documents;

                self.sale_sales.key_handover_appointment_documents = response.data.key_handover_appointment_documents;

                self.processSaleOtherDocuments();
            }

            self.allDocumentHistory = [];

            if(response.data && response.data.documents_history && response.data.documents_history.length > 0)
            {
                self.allDocumentHistory = response.data.documents_history;

                $.each(self.allDocumentHistory, function(index, history){
                    let document = self.sale_sales.documents.find(x => x.document_id == history.document_id);
                    if(document){
                        if(document.history){
                            document.history.push(history);
                        }
                        else{
                            document.history = [];
                            document.history.push(history);
                        }
                    }
                });
            }
        });

    }

    checkRegenerate(document){
        const self = this;

        if(document.type == self.PROPERTY_DOCUMENT_TYPE_FORM
            && document.format == self.PROPERTY_DOCUMENT_FORMAT_HTML
            && !document.is_user_uploaded
            && document.file_uri){
            document.show_regenerate = true;
        }
    }

    getSalesMortgagees() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/mortgagee';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.mortgagee = response.data.mortgagee;

            if (self.sale_sales.mortgagee && self.sale_sales.mortgagee.possession_date) {
                self.sale_sales.mortgagee.possession_date = self.SSUtilService.formatUtcToLocalDate(self.sale_sales.mortgagee.possession_date);
            }
        });
    }

    getSalesBrokers() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/brokers';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.brokers = response.data.sale_brokers;

            //Get brokers details
            if (self.sale_sales.brokers && self.sale_sales.brokers.length > 0) {
                self.getBrokersDetails();
            }
        });
    }

    getBrokersDetails() {
        const self = this;

        let url = 'brokers/' + self.sale_sales.brokers.map(x => x.broker_user_id).join(",");
        let params = {
            include: 'user'
        }

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.brokers = response.data.brokers;

            if (self.brokers && self.brokers.length > 0) {
                $.each(self.brokers, function (index, broker) {
                    let _broker = self.sale_sales.brokers.find(x => x.broker_user_id == broker.user_id);
                    if (_broker) {
                        let role_name = self.SSEoiService.broker_roles.find(x => x.id == _broker.broker_role);
                        broker.role_name = role_name ? role_name.name : '--';
                        broker.broker_role = _broker.broker_role;
                    }

                    // Update agency name
                    let agency = self.agencies.find(x => x.id === broker.agency_id);
                    broker.agency_name = agency ? agency.name : '--';

                });

                self.$timeout(function () {
                    self.brokers = _.sortBy(self.brokers, 'broker_role');
                });

                self.getSalesHistory();
            }
        });
    }

    getSalesHistory() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/history';
        let params = {
            'include': 'users,eoi_history'
        };

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.history = response.data.sale_history;
            self.sale_sales.eoi_history = response.data.eoi_history;

            let users_list = response.data.users;
            try{
                let current_user = self.SSUserService.getUser();
                if(current_user) {
                    if (users_list && users_list.length
                        && !users_list.find(u=> u.id == current_user.id)) {
                        users_list.push(current_user);
                    }
                }
            } catch (e) {
                console.error(e);
            }

            self.sale_users = users_list;
            self.subsale_users = users_list;
            self.processSaleHistory();
        });
    }

    getSaleDiscounts() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/discounts';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.sale_discounts = response.data.sale_discounts;

            // Prepare Discount info
            if (self.sale_sales.hasOwnProperty("sale_discounts") && self.sale_sales.sale_discounts.length > 0 && self.sale_property_discounts && self.sale_property_discounts.length > 0) {

                // Get formatted discounts
                let sale_discounts = self.SSEoiService.getDiscountInfo(self.sale_sales.sale_discounts, self.sale_property_discounts, self.sale_units.price);

                if (!self.sale_sales.hasOwnProperty('discounts') || !self.sale_sales.discounts) {
                    self.sale_sales.discounts = [];
                }
                self.sale_sales.discounts = sale_discounts.discounts;
                self.sale_units.final_sale_price = sale_discounts.final_sale_price;

                // If there is discounted sale price then update it in sale object
                if (sale_discounts.final_sale_price) {
                    self.sale_sales.discounted_price = sale_discounts.final_sale_price;
                }
            }
        });
    }

    getSalesSelections() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/selections';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.sale_selections = response.data.sale_selections;
            self.getSalesUnitPriceSchedule();
        });
    }

    getSalesUnitPriceSchedule() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/unit-price-schedule';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.unit_price_schedule = response.data.unit_price_schedule;
            self.getSalePropertyDetails();
        });
    }

    getSaleBeneficiaries(saleBeneficiary, getDocument = true) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/beneficiaries';
        let params = {
            'include': 'primary_address'
        };

        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                // WEB-3109 - make call regardless of getSaleBeneficiaries response
                if (getDocument) {
                    self.getSalesDocuments();
                }
                return;
            }

            self.sale_sales.beneficiaries = response.data.beneficiaries;

            if (getDocument) {
                if (saleBeneficiary) {
                    self.selectSaleBeneficiary(saleBeneficiary);
                } else {
                    self.selectSaleBeneficiary(self.sale_sales.beneficiaries[0]);
                }

                self.getSalesDocuments();
            } else {
                if (saleBeneficiary) {
                    let selectedBeneficiary = self.sale_sales.beneficiaries.find(x => x.id == saleBeneficiary.id);
                    if (selectedBeneficiary) {
                        self.selectSaleBeneficiary(selectedBeneficiary);
                    } else {
                        self.selectSaleBeneficiary(self.sale_sales.beneficiaries[0]);
                    }
                } else {
                    self.selectSaleBeneficiary(self.sale_sales.beneficiaries[0]);
                }

            }
        });
    }

    selectSaleBeneficiary(saleBeneficiary) {
        const self = this;

        if(!saleBeneficiary){
            return;
        }

        self.saleBeneficiaryEditMode = false;
        self.saleBeneficiaryParams = null;
        self.selectedSaleBeneficiary = saleBeneficiary;
    }

    editSaleBeneficiary(editMode) {
        const self = this;

        if (editMode) {
            self.saleBeneficiaryParams = {};
            self.saleBeneficiaryParams = angular.copy(self.selectedSaleBeneficiary);

            /** WEB-2900 AML Scan: GuocoLand Feedback
             * Following code cause issue when mapping salutation
            if(self.saleBeneficiaryParams.title)
                self.saleBeneficiaryParams.title = parseInt(self.saleBeneficiaryParams.title);**/

            if (self.saleBeneficiaryParams.dob) {
                self.saleBeneficiaryParams.dob = self.SSUtilService.formatUtcToLocalDate(self.saleBeneficiaryParams.dob);
            }

            /** WEB-3626 - format the new date fields + hydrate the nationality lists from CSV **/
            if (self.saleBeneficiaryParams.date_of_naturalization) {
                self.saleBeneficiaryParams.date_of_naturalization = self.SSUtilService.formatUtcToLocalDate(self.saleBeneficiaryParams.date_of_naturalization);
            }
            if (self.saleBeneficiaryParams.passport_issued_date) {
                self.saleBeneficiaryParams.passport_issued_date = self.SSUtilService.formatUtcToLocalDate(self.saleBeneficiaryParams.passport_issued_date);
            }
            if (self.saleBeneficiaryParams.passport_expiry_date) {
                self.saleBeneficiaryParams.passport_expiry_date = self.SSUtilService.formatUtcToLocalDate(self.saleBeneficiaryParams.passport_expiry_date);
            }
            self.saleBeneficiaryParams.other_nationalities_list = self.parseNationalitiesToList(self.saleBeneficiaryParams.other_nationalities);
            self.saleBeneficiaryParams.previous_nationalities_list = self.parseNationalitiesToList(self.saleBeneficiaryParams.previous_nationalities);

            if (self.saleBeneficiaryParams.primary_address) {
                self.saleBeneficiaryParams.primary_address_line1 = self.saleBeneficiaryParams.primary_address.line1;
                self.saleBeneficiaryParams.primary_address_line2 = self.saleBeneficiaryParams.primary_address.line2;
                self.saleBeneficiaryParams.primary_address_unit_no = self.saleBeneficiaryParams.primary_address.unit_no;
                self.saleBeneficiaryParams.primary_address_postcode = self.saleBeneficiaryParams.primary_address.postcode;
                self.saleBeneficiaryParams.primary_address_city = self.saleBeneficiaryParams.primary_address.city;
                self.saleBeneficiaryParams.primary_address_district = self.saleBeneficiaryParams.primary_address.district;
                self.saleBeneficiaryParams.primary_address_province = self.saleBeneficiaryParams.primary_address.province;
                self.saleBeneficiaryParams.primary_address_country = self.saleBeneficiaryParams.primary_address.country;
            }
        } else {
            self.saleBuyerParams = null;
            self.beneficiary_error = {};
        }

        if (self.saleBeneficiaryParams.industry) {
            let industry_occupation = self.SSEoiService.industry_occupation[self.saleBeneficiaryParams.industry];

            if (!industry_occupation) {
                self.saleBeneficiaryParams["industry_other"] = angular.copy(self.saleBeneficiaryParams.industry);
                self.saleBeneficiaryParams["industry"] = 'OTHERS';
            }
        }
        if (self.saleBeneficiaryParams.occupation && self.saleBeneficiaryParams.industry) {
            let industry_occupation = self.SSEoiService.industry_occupation[self.saleBeneficiaryParams.industry];

            if (industry_occupation) {
                const occupation_obj = Object.values(industry_occupation.occupation).find(item => item.name === self.saleBeneficiaryParams.occupation);
                // let occupation_obj = industry_occupation.occupation[self.saleBeneficiaryParams.occupation];
                if (!occupation_obj) {
                    self.saleBeneficiaryParams["occupation_other"] = angular.copy(self.saleBeneficiaryParams.occupation);
                    self.saleBeneficiaryParams["occupation"] = 'OTHERS';
                }
            } else {
                self.saleBeneficiaryParams["occupation_other"] = angular.copy(self.saleBeneficiaryParams.occupation);
                self.saleBeneficiaryParams["occupation"] = 'OTHERS';
            }
        }
        if (self.saleBeneficiaryParams.phone1 != null) {
            self.saleBeneficiaryParams["phone1_contact_value"] = self.saleBeneficiaryParams.phone1.value;
        }

        if (self.saleBeneficiaryParams.phone2 != null) {
            self.saleBeneficiaryParams["phone2_contact_value"] = self.saleBeneficiaryParams.phone2.value;
        }
        if (self.saleBeneficiaryParams.email != null) {
            self.saleBeneficiaryParams["email_contact_value"] = self.saleBeneficiaryParams.email.value;
        }

        self.saleBeneficiaryEditMode = editMode;
        self.newBeneficiaryMode = editMode;
        self.$timeout(function () {
            self.initBeneficiaryDatepickers();
        });
    }

    /**
     * WEB-3626 - Initialise the beneficiary form datepickers. The naturalization /
     * passport-issued inputs carry `.no_future_date` (no future dates) and the
     * passport-expiry input carries `.no_past_date` (future dates only).
     */
    initBeneficiaryDatepickers() {
        $('.datepicker').datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "1900:+0",
            dateFormat: "dd/mm/yy"
        });
        $('.datepicker.no_future_date').datepicker('option', 'maxDate', '0');
        $('.datepicker.no_past_date').datepicker('option', { minDate: 0, yearRange: "2023:+20" });
    }

    /** WEB-3626 - "10,702" CSV (server shape) <-> [{country:10},{country:702}] UI rows */
    parseNationalitiesToList(csv) {
        if (!csv) return [];
        return String(csv).split(',')
            .map(c => parseInt(c, 10))
            .filter(c => !isNaN(c))
            .map(c => ({ country: c }));
    }

    nationalitiesListToCsv(list) {
        if (!Array.isArray(list)) return '';
        return list.map(i => i && i.country)
            .filter(c => c !== null && c !== undefined && c !== '')
            .join(',');
    }

    /** WEB-3626 - "10,702" CSV of country codes -> "Singapore, Malaysia" for read-only display */
    getBeneficiaryNationalityNames(csv) {
        const self = this;
        if (!csv) return '--';
        return String(csv).split(',')
            .map(c => self.SSConfigService.getCountryName(parseInt(c, 10)))
            .filter(n => n)
            .join(', ') || '--';
    }

    addBeneficiaryNationality(type) {
        const self = this;
        if (!self.saleBeneficiaryParams) return;
        let key = type === 'previous' ? 'previous_nationalities_list' : 'other_nationalities_list';
        if (!Array.isArray(self.saleBeneficiaryParams[key])) {
            self.saleBeneficiaryParams[key] = [];
        }
        self.saleBeneficiaryParams[key].push({});
    }

    removeBeneficiaryNationality(type, index) {
        const self = this;
        let key = type === 'previous' ? 'previous_nationalities_list' : 'other_nationalities_list';
        if (Array.isArray(self.saleBeneficiaryParams[key])) {
            self.saleBeneficiaryParams[key].splice(index, 1);
        }
    }

    /** WEB-3626 - clear the underlying value when the "N/A" indicator is ticked */
    onBeneficiaryNaToggle(field) {
        const self = this;
        if (!self.saleBeneficiaryParams) return;
        if (field === 'date_of_naturalization' && self.saleBeneficiaryParams.date_of_naturalization_na_ind) {
            self.saleBeneficiaryParams.date_of_naturalization = null;
        }
        if (field === 'other_nationalities' && self.saleBeneficiaryParams.other_nationalities_na_ind) {
            self.saleBeneficiaryParams.other_nationalities_list = [];
        }
        if (field === 'previous_nationalities' && self.saleBeneficiaryParams.previous_nationalities_na_ind) {
            self.saleBeneficiaryParams.previous_nationalities_list = [];
        }
    }

    prepareBuyingInTrustSettings(property_settings) {
        const self = this;

        let buying_in_trust_settings_obj = property_settings.find(x => x.name === self.PROPERTY_SETTINGS_BUYING_IN_TRUST);

        if (buying_in_trust_settings_obj && buying_in_trust_settings_obj.value == 1) {
            self.enable_buying_in_trust = true;
        }
    }

    removeBeneficiary(beneficiary) {
        const self = this;

        // Old records have 'buyer_id' new have 'buyer.id'
        // UPDATED: 10-April-2019, pass sale buyer id (i.e buyer.id) to delete buyer
        var beneficiary_id = beneficiary.id;
        let url = 'sec/developer/sales/' + self.sale_id + '/beneficiaries/' + beneficiary_id + '/delete';

        self.SSConfirmationService.getConfirmed(
            'Please confirm to proceed.',
            'Are you sure you want to delete this beneficiary?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if (response.sub_code == 305015 || response.sub_code == 412002) {
                            self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                            return;
                        }
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }

                    self.sale_sales.beneficiaries = jQuery.grep(self.sale_sales.beneficiaries, function (obj) {
                        return obj.id !== beneficiary_id;
                    });

                    self.SSAlertService.success('Beneficiary deleted successfully.');

                    // User can not delete first buyer, so there must be one buyer
                    self.selectSaleBeneficiary(self.sale_sales.beneficiaries[0])
                });
            }
        );
    }

    saveSaleBeneficiary(saleBeneficiaryParams) {
        const self = this;

        // Validation is not implemented for edit mode
        // self.resetBuyerErrors();
        // if(!self.isValidBuyerInput()){
        //   return;
        // }
        self.beneficiary_error = {};
        if (!self.isValidBeneficiaryInput(saleBeneficiaryParams)) {
            self.SSAlertService.danger('Error!', 'Please fill in the required fields.');
            return;
        }

        self.SSConfirmationService.getConfirmed(
            'Please confirm to proceed.',
            'Are you sure you want to save the changes?',
            self.SSConfirmationService.TYPE_YES_NO,
            function () {
                self._saveSaleBeneficiary();
            }
        );
    }

    _saveSaleBeneficiary() {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/beneficiaries';

        if(self.saleBeneficiaryParams.email_contact_value){
            self.saleBeneficiaryParams['email'] = self.saleBeneficiaryParams.email_contact_value;
        }else{
            self.saleBeneficiaryParams['email'] = null;
        }
        if(self.saleBeneficiaryParams.phone1_contact_value){
            self.saleBeneficiaryParams['phone1'] = self.saleBeneficiaryParams.phone1_contact_value;
        }else{
            self.saleBeneficiaryParams['phone1'] = null;
        }
        if(self.saleBeneficiaryParams.phone2_contact_value){
            self.saleBeneficiaryParams['phone2'] = self.saleBeneficiaryParams.phone2_contact_value;
        }else{
            self.saleBeneficiaryParams['phone2'] = null;
        }

        let params = angular.copy(self.saleBeneficiaryParams);

        /** WEB-3626 - format date fields onto the COPY only, never the ng-model-bound model.
         * Mutating the bound model leaves a store-format string ("YYYY-MM-DD 12:00:00") in the
         * input after a failed (412) save; the next save re-parses it as DD/MM/YYYY → "Invalid date". */
        if (params.dob) {
            params.dob = self.SSUtilService.formatDateToStoreWithUtc12(params.dob);
        }
        if (params.date_of_naturalization) {
            params.date_of_naturalization = self.SSUtilService.formatDateToStoreWithUtc12(params.date_of_naturalization);
        }
        if (params.passport_issued_date) {
            params.passport_issued_date = self.SSUtilService.formatDateToStoreWithUtc12(params.passport_issued_date);
        }
        if (params.passport_expiry_date) {
            params.passport_expiry_date = self.SSUtilService.formatDateToStoreWithUtc12(params.passport_expiry_date);
        }

        if (self.saleBeneficiaryParams.industry_other && self.saleBeneficiaryParams.industry === 'OTHERS') {
            params['industry'] = self.saleBeneficiaryParams.industry_other;
        }else{
            self.saleBeneficiaryParams.industry_other = '';
            params['industry_other'] = '';
        }

        if (self.saleBeneficiaryParams.occupation_other && self.saleBeneficiaryParams.occupation === 'OTHERS') {
            params['occupation'] = self.saleBeneficiaryParams.occupation_other;
        }else{
            self.saleBeneficiaryParams.occupation_other = '';
            params['occupation_other'] = '';
        }

        /** WEB-3626 - serialize the nationality rows to the CSV shape the server expects,
         * honour the "N/A" indicators, and drop passport details unless identity = Passport. */
        params['other_nationalities'] = self.nationalitiesListToCsv(self.saleBeneficiaryParams.other_nationalities_list);
        params['previous_nationalities'] = self.nationalitiesListToCsv(self.saleBeneficiaryParams.previous_nationalities_list);
        delete params['other_nationalities_list'];
        delete params['previous_nationalities_list'];

        if (self.saleBeneficiaryParams.other_nationalities_na_ind) {
            params['other_nationalities'] = '';
        }
        if (self.saleBeneficiaryParams.previous_nationalities_na_ind) {
            params['previous_nationalities'] = '';
        }
        if (self.saleBeneficiaryParams.date_of_naturalization_na_ind) {
            params['date_of_naturalization'] = null;
        }

        if (self.saleBeneficiaryParams.identity_type != self.BENEFICIARY_IDENTITY_PASSPORT) {
            params['passport_issued_by'] = null;
            params['passport_issued_date'] = null;
            params['passport_expiry_date'] = null;
        }

        if(!self.isValidUnitNum(params)) return;

        self.update_sale_url = url;
        self.update_sale_params = params;

        if (self.saleBeneficiaryParams.id) {
            self.update_sale_url += '/' + self.saleBeneficiaryParams.id;
            self.callUpdateSaleBeneficiaryAPI(self);
        } else {
            self.callInsertSaleBeneficiaryAPI(self);
        }
    }

    callUpdateSaleBeneficiaryAPI(self) {
        loading(true);
        self.SSHttpService.putAPIRequest(self.update_sale_url, self.update_sale_params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Beneficiary updated successfully.');

            angular.merge(self.selectedSaleBeneficiary, response.data.beneficiary);

            self.saleBeneficiaryEditMode = false;
            self.newBeneficiaryMode = false;

            self.selectSaleBeneficiary(self.selectedSaleBeneficiary);
        });
    }

    callInsertSaleBeneficiaryAPI(self) {
        loading(true);
        self.SSHttpService.postAPIRequest(self.update_sale_url, self.update_sale_params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger("Please Note:", "This sale has been updated by another user. You will not be able to make further updates to this sale.")
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Beneficiary save successfully.');

            self.selectedSaleBeneficiary = response.data.beneficiary;

            self.newBeneficiaryMode = false;

            self.getSaleBeneficiaries(self.selectedSaleBeneficiary, false);
        });
    }

    /**
     * WEB-3626 - Surface the server's per-field 412 validation errors on the inline
     * beneficiary_error.* spans (the generic parseAndDisplayError toast alone doesn't
     * tell the user which field failed). HttpService.makeErrorObject puts the validator
     * errors object ({field: [messages]}) at response.data.
     */
    mapBeneficiaryServerErrors(response) {
        const self = this;
        const fieldErrors = response && response.data;
        if (!fieldErrors || typeof fieldErrors !== 'object') {
            return false;
        }
        const map = {
            title: 'errTitle',
            legal_name: 'errLegalName',
            identity_type: 'errIdentityType',
            identity_no: 'errIdentityNo',
            national_id: 'errIdentityNo',
            nationality: 'errNationality',
            gender: 'errGender',
            dob: 'errDob',
            date_of_naturalization: 'errDateOfNaturalization',
            other_nationalities: 'errOtherNationalities',
            previous_nationalities: 'errPreviousNationalities',
            passport_issued_by: 'errPassportIssuedBy',
            passport_issued_date: 'errPassportIssuedDate',
            passport_expiry_date: 'errPassportExpiryDate',
            primary_address_line1: 'errPrimaryAddressLine1',
            primary_address_line2: 'errPrimaryAddressLine2',
            primary_address_postcode: 'errPrimaryAddressPostCode',
            primary_address_country: 'errPrimaryAddressCountry'
        };
        self.beneficiary_error = self.beneficiary_error || {};
        let mapped = false;
        Object.keys(fieldErrors).forEach(function (field) {
            const key = map[field];
            if (!key) return;
            const val = fieldErrors[field];
            self.beneficiary_error[key] = Array.isArray(val) ? val[0] : val;
            mapped = true;
        });
        return mapped;
    }

    isValidBeneficiaryInput() {
        const self = this;

        let isValid = true;

        if (!self.saleBeneficiaryParams.title) {
            self.beneficiary_error.errTitle = 'The Satulation field is required.';
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.legal_name) {
            self.beneficiary_error.errLegalName = 'The Name as on NRIC/Passport field is required.';
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.identity_type) {
            self.beneficiary_error.errIdentityType = 'The Identity Type field is required.';
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.identity_no) {
            self.beneficiary_error.errIdentityNo = 'The Identity Number field is required.';
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.nationality) {
            self.beneficiary_error.errNationality = 'The Nationality field is required.';
            isValid = false;
        }
        if (self.saleBeneficiaryParams.gender === null ||
                self.saleBeneficiaryParams.gender === undefined) {
            self.beneficiary_error.errGender = 'The Gender field is required.';
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.primary_address_line1) {
            self.beneficiary_error.errPrimaryAddressLine1 = 'The Address Line 1 field is required.';
            isValid = false;
        }
        if (!self.SSUtilService.isValidPostcode(self.saleBeneficiaryParams.primary_address_postcode, self.saleBeneficiaryParams.primary_address_country)) {
            self.beneficiary_error.errPrimaryAddressPostCode = self.SSUtilService.getPostCodeValidationMsg(self.saleBeneficiaryParams.primary_address_postcode, self.saleBeneficiaryParams.primary_address_country);
            isValid = false;
        }
        if (!self.saleBeneficiaryParams.primary_address_country) {
            self.beneficiary_error.errPrimaryAddressCountry = 'The Country field is required.';
            isValid = false;
        }

        /** WEB-3626 - config-driven required checks for the new fields (only when the
         * PP Form Settings mark them visible AND required, and not flagged N/A). */
        let bset = self.beneficiary_pp_form_settings || {};
        const isReq = (key) => !!(bset[key] && bset[key].visible && bset[key].required);

        if (isReq('date_of_naturalization')
                && !self.saleBeneficiaryParams.date_of_naturalization_na_ind
                && !self.saleBeneficiaryParams.date_of_naturalization) {
            self.beneficiary_error.errDateOfNaturalization = 'The Date of Naturalization field is required.';
            isValid = false;
        }
        if (isReq('other_nationalities')
                && !self.saleBeneficiaryParams.other_nationalities_na_ind
                && !self.nationalitiesListToCsv(self.saleBeneficiaryParams.other_nationalities_list)) {
            self.beneficiary_error.errOtherNationalities = 'The Other Nationalities field is required.';
            isValid = false;
        }
        if (isReq('previous_nationalities')
                && !self.saleBeneficiaryParams.previous_nationalities_na_ind
                && !self.nationalitiesListToCsv(self.saleBeneficiaryParams.previous_nationalities_list)) {
            self.beneficiary_error.errPreviousNationalities = 'The Previous Nationalities field is required.';
            isValid = false;
        }

        if (self.saleBeneficiaryParams.identity_type == self.BENEFICIARY_IDENTITY_PASSPORT) {
            if (isReq('passport_issued_by') && !self.saleBeneficiaryParams.passport_issued_by) {
                self.beneficiary_error.errPassportIssuedBy = 'The Passport Issued By field is required.';
                isValid = false;
            }
            if (isReq('passport_issued_date') && !self.saleBeneficiaryParams.passport_issued_date) {
                self.beneficiary_error.errPassportIssuedDate = 'The Passport Issued Date field is required.';
                isValid = false;
            }
            if (isReq('passport_expiry_date') && !self.saleBeneficiaryParams.passport_expiry_date) {
                self.beneficiary_error.errPassportExpiryDate = 'The Passport Expiry Date field is required.';
                isValid = false;
            }
        }

        return isValid;
    }

    uploadNewBeneficiaryDocumentFiles(files, file_name, upload_type, document_kind, beneficiary) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'beneficiary': beneficiary,
            'callback': self.uploadNewBeneficiaryDocCallback
        };

        self.file.callback(self);
    }

    uploadNewBeneficiaryDocCallback(self) {
        self.uploadBeneficiaryDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.beneficiary);
    }

    uploadBeneficiaryDocumentFiles(files, file_name, upload_type, document_kind, beneficiary) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        let policyUrl = 'sec/developer/sales/' + self.sale_id + '/documents/s3-policy-document';

        loading(true);
        self.SSAwsService.uploadAPIRequest(file, policyUrl, function (response) {

            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self._uploadBeneficiaryDocument(response.config.data.key, file_name, upload_type, format_type, document_kind, beneficiary);
        });
    }

    _uploadBeneficiaryDocument(file_uri, file_name, upload_type, format_type, document_kind, beneficiary) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/documents';
        let params = {
            name: file_name,
            type: upload_type,
            format: format_type,
            document_kind: document_kind,
            file_uri: file_uri,
            authorisation_code: self.buyer_doc_verification_code,
            beneficiary_id: beneficiary.id
        };

        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File uploaded successfully.');

            if (!beneficiary.hasOwnProperty("documents")) {
                beneficiary["documents"] = {};
            }
            beneficiary["documents"][document_kind] = response.data.sale_document;

            //To retrieve preview image
            url = 'sec/assets/presigned-url';
            params = {
                'model': SHOWSUITE.ASSET_MODEL_SALE_DOCUMENT,
                'id': response.data.sale_document.id
            };
            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                beneficiary["documents"][document_kind]["show_file_url"] = response.data.presigned_url;
            });

        });
    }

    removeBeneficiaryDocCallBack(self) {
        let url = 'sec/developer/sales/' + self.sale_id + '/documents/' + self.file.documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Success!', 'File deleted successfully.');

            self.file.beneficiary["documents"][self.file.documentObj.document_kind] = null;
        });
    }

    removeBeneficiaryDocument(documentObj, beneficiary) {
        const self = this;

        self.file = {
            'beneficiary': beneficiary,
            'documentObj': documentObj,
            'callback': self.removeBeneficiaryDocCallBack
        };

        self.file.callback(self);
    }

    replaceBeneficiaryDocCallBack(self) {
        //Delete existing file
        let url = 'sec/developer/sales/' + self.sale_id + '/documents/' + self.file.documentObj.id + '/delete';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.file.beneficiary["documents"][self.file.documentObj.document_kind] = null;
            self.uploadBeneficiaryDocumentFiles(self.file.files, self.file.file_name, self.file.upload_type, self.file.document_kind, self.file.beneficiary);
        });
    }

    replaceBeneficiaryDocumentFiles(files, file_name, upload_type, document_kind, beneficiary, documentObj) {
        const self = this;

        if (!files || files.length < 1) return;
        let file = files[0];
        let format_type = null;

        if (file.type.indexOf("application/pdf") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_PDF;
        } else if (file.type.indexOf("image") !== -1) {
            format_type = self.PROPERTY_DOCUMENT_FORMAT_IMG;
        } else {
            self.SSAlertService.danger('Error!', 'Please upload PDF or image file only');
            return;
        }

        self.file = {
            'files': files,
            'file_name': file_name,
            'upload_type': upload_type,
            'document_kind': document_kind,
            'beneficiary': beneficiary,
            'documentObj': documentObj,
            'callback': self.replaceBeneficiaryDocCallBack
        };

        self.file.callback(self);
    }

    addNewSaleBeneficiary() {
        const self = this;

        self.newBeneficiaryMode = true;
        self.saleBeneficiaryEditMode = true;
        self.saleBeneficiaryParams = {
            other_nationalities_list: [],
            previous_nationalities_list: []
        };
        self.beneficiary_error = {};

        self.$timeout(function () {
            self.initBeneficiaryDatepickers();
        });
    }

    getSubsalesDocuments(subsale) {
        const self = this;

        let url = 'sec/developer/sales/' + self.sale_id + '/subsales/'+ subsale.id + '/documents';

        self.SSHttpService.getAPIRequest(url).then(function (response) {
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.subsales_documents && response.data.subsales_documents.length > 0) {
                self.sale_sales.subsales_documents = response.data.subsales_documents;

                self.processSubsaleBuyerDocuments();
            }
        });
    }

    processSubsaleBuyerDocuments() {
        const self = this;

        // Map subsales buyer documents (NRIC/Passport) from sale_documents
        $.each(self.sale_sales.sale_buyers, function(i, saleBuyer) {
            $.each(self.sale_sales.subsales_documents, function(index, document){
                if(document.subsale_buyer_id == saleBuyer.id){
                    if(document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_FRONT
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_NRIC_BACK
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_PASSPORT
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_COMPANY_CERTIFICATE
                        || document.document_kind == self.PROPERTY_DOCUMENT_KIND_LETTER_OF_AUTHORISATION){

                        if(!saleBuyer.hasOwnProperty('documents')){
                            saleBuyer['documents'] = {};
                        }

                        // To retrieve preview image
                        if (document.file_uri && document.id) {
                            self.getPresignedUrl(
                                self.ASSET_MODEL_SUBSALE_DOCUMENT,
                                document.id,
                                function (presignedUrl) {
                                    saleBuyer.documents[document.document_kind] = document;
                                    saleBuyer.documents[document.document_kind]["show_file_url"] = presignedUrl;
                                }
                            );
                        }
                    }
                }
            });
        });

    }

    downloadPic(file_obj, model_type) {
        const self = this;

        model_type = model_type ? model_type : file_obj.type;

        //Retrieve new pre-signed url to avoid timeout issue from S3
        let url = 'sec/assets/presigned-url';
        let params = {
            'model': model_type,
            'id': file_obj.id
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            window.open(response.data.presigned_url, '_blank');
        });
    }

    validateLockSelection() {
        const self = this;

        let invalid = false;

        $.each(self.unit_selections, function(index, selection) {
            selection.error = "";
            if (selection.is_lock) {
                if (selection.type == self.QUESTION_TYPE_CHECKBOX) {
                    let unanswered = true;
                    $.each(selection.formatted_choices, function (i, choice) {
                        if (choice.answer) {
                            unanswered = false;
                        }
                    });

                    if (unanswered) {
                        selection.error = "Please select at least an answer for locking the selection.";
                        invalid = true;
                    }
                } else {
                    if (!selection.answer_text) {
                        selection.error = "Please select an answer for locking the selection.";
                        invalid = true;
                    }
                }
            }
        });

        return invalid;
    }

    renderHtml(selection) {
        const self = this;

        // WEB-3597 — allow-list sanitise rich text before trusting it for ng-bind-html.
        return self.$sce.trustAsHtml(window.ssSanitizeHtml(selection));
    }

    getStaffCommissions() {
        const self = this;
        if(!self.checkPermission('DMS_SALE_STAFF_COMMISSIONS_VIEW')){
            return;
        }
        let url =
            "sec/developer/sales/" + self.sale_id + "/get-staff-commissions";
        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_staff_commissions = response.data.sale_staff_commissions;
        });
    }

    getStaffCommissionTypeName() {
        const self = this;
        if (!self.sale_sales) return;
        let staffComissionType = self.sale_sales.hasOwnProperty(
            "staff_commission_type"
        )
            ? self.STAFF_COMMISSION_TYPES.find(
                  (x) => x.id == self.sale_sales.staff_commission_type
              )
            : null;
        return self.sale_sales.staff_commission_type && staffComissionType
            ? staffComissionType.name
            : "--";
    }

    _parseStaffCommissionRole(role) {
        const self = this;
        if (role == null || (typeof role === "string" && role.length === 0))
            return null;
        return parseInt(role);
    }

    getStaffCommissionRoleName(role) {
        const self = this;
        let staffRole = self._parseStaffCommissionRole(role);
        if (!staffRole) return "--";

        let staffRoleName = self.STAFF_COMMISSION_TEAM_ROLES.find(
            (x) => x.id == staffRole
        );
        return staffRoleName ? staffRoleName.name : "--";
    }

    calculateCommission() {
        const self = this;
        if(!self.checkPermission('DMS_SALE_STAFF_COMMISSIONS_CALCULATE')) return;
        let url =
            "sec/developer/sales/" +
            self.sale_id +
            "/calculate-staff-commissions";
        loading(true);
        self.SSHttpService.putAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.hideModals();
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_staff_commissions = angular.copy(response.data.sale_staff_commissions);
            if (self.sale_staff_commissions && self.sale_staff_commissions.length == 0) {
                self.SSAlertService.success(
                    "Success",
                    "Commission Calculated Successfully"
                );
            } else {
                self.SSAlertService.success(
                    "Success",
                    "Commission Re-Calculated Successfully"
                );
            }
            self.checkTotalPercentage();
        });

    }

    getStaffTotalAmount(saleStaffCommission) {
        const self = this;
        if (!saleStaffCommission) return;
        return (
            parseFloat(saleStaffCommission.commission_amount) +
            parseFloat(saleStaffCommission.incentive_amount)
        );
    }

    getTotalAmount() {
        const self = this;

        return (
            parseFloat(self.sale_sales.staff_commission_amount ? self.sale_sales.staff_commission_amount :0 ) +
            parseFloat(self.sale_sales.staff_incentive_amount? self.sale_sales.staff_incentive_amount : 0)
        );
    }

    checkTotalPercentage() {
        const self = this;
        if (!self.sale_staff_commissions) return false;
        else if (self.sale_staff_commissions.length == 0) return false;
        let totalPercentage = 0;
        $.each(
            self.sale_staff_commissions,
            function (index, saleStaffCommission) {
                totalPercentage += parseFloat(saleStaffCommission.commission_value);
            }
        );
        // if total percentage dows not add up to 100 show warning msg.
        if (totalPercentage != 100) return true;
        return false;
    }

    showViewInfoModal(body){
        const self = this;
        self.hideModals();
        self.detailModalBody = body;
        self.showViewDetailModal = true;
        $('#viewDetailModal').modal('show');


    }

      // ----------- GENERAL SETTINGS SECTION  -------

      getPropertySettings() {
        const self = this;

        let url = 'sec/developer/properties/'+ self.sale_sales.property_id +'/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.property_settings){
                // Get PP FORM Settings
                let settings = self.SettingsService.getSetting(response.data.property_settings, 'pp_form_required_fields');
                self.pp_form_settings = settings? settings.value : self.SSConfigService.getPPFormRequiredFields();
                /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
                self.pp_form_settings = self.SSEoiService.initSignatorySettingsIfEmpty(self.pp_form_settings);

                settings= null;
                settings = self.SettingsService.getSetting(response.data.property_settings, 'payment_types_dms');

                let instrument_types = [];
                if(settings && settings.value && settings.value.length){
                    self.instrument_types.forEach(type => {
                        if(settings.value.indexOf(type.id) != -1){
                            instrument_types.push(type);
                        }
                    });
                    self.instrument_types = instrument_types;
                }

                settings = null;
                // Get Non Buyer Payee PP FORM Settings
                settings = self.SettingsService.getSetting(response.data.property_settings, 'pp_form_required_fields_non_buyer_payee');
                self.nbp_pp_form_settings = settings? settings.value : self.SSConfigService.getNonBuyerPayeeFormRequiredFields();
                settings = self.SettingsService.getSetting(response.data.property_settings, 'non_buyer_payee_settings');
                self.non_buyer_payee_settings = settings? settings.value : self.SSConfigService.getNonBuyerPayeeSettings();

                settings = self.SettingsService.getSetting(response.data.property_settings, 'pp_form_required_fields_witness');
                self.pp_form_witness_settings = settings? settings.value : self.SSConfigService.getWitnessFormRequiredFields();

                /** WEB-3626 Beneficiary PP Form Settings (drives visibility/required of the
                 * naturalization, other/previous nationalities and passport fields) **/
                settings = self.SettingsService.getSetting(response.data.property_settings, 'pp_form_required_fields_beneficiary');
                self.beneficiary_pp_form_settings = settings? settings.value : self.SSConfigService.getBeneficiaryOwnerRequiredFields();
                settings = self.SettingsService.getSetting(response.data.property_settings, 'witness_settings');
                self.witness_settings = settings? settings.value : self.SSConfigService.getWitnessSettings();

                settings = self.SettingsService.getSetting(response.data.property_settings, 'top_maintenance_and_survey_fee');
                self.top_maintenance_and_survey_fee_settings = settings ? settings.value : {};

                /** WEB-3614 — project-level Subsale Draft → Approved flow toggle (default OFF).
                 * Gates the Draft/Approved badge, the Approve action, the optional-Draft create form
                 * and the Draft-delete action on the DMS Sale Details page. */
                settings = self.SettingsService.getSetting(response.data.property_settings, 'subsale_approval_flow');
                self.isSubsaleApprovalFlowEnabled = !!(settings && settings.value && settings.value.enable);

                /** WEB-3908 / WEB-3906 — project-level `billing_date_follows_notice_served_date`
                 * (default OFF). When ON, the Billing Date (payments.due_date) on an ordinary clause
                 * payment is locked and mirrors the Notice Served Date (payments.serving_date).
                 * Fails closed exactly like PaymentService::billingDateFollowsNoticeServedDateEnabled():
                 * an absent row, a blank/unparseable value or a missing `enabled` key all read as OFF,
                 * so the UI can never disagree with the server about which state is in force. */
                settings = self.SettingsService.getSetting(response.data.property_settings, 'billing_date_follows_notice_served_date');
                self.isBillingDateFollowsNoticeServedDateEnabled = !!(settings && settings.value && settings.value.enabled);

                /** WEB-2811 AMS/DMS : AUS country support **/
                settings = self.SettingsService.getSetting(response.data.property_settings, 'document_signing_method');
                self.SSEoiService.document_signing_method = settings? settings.value : null;

                /** WEB-2827 Show/Hide Payment Settings - Start **/
                settings = self.SettingsService.getSetting(response.data.property_settings, 'payment_types_dms');
                self.is_payment_section_disabled = !!(settings && settings.value && settings.value.includes(-1));

                /** WEB-2919 Corporate Sales: Other AML/CFT Entities **/
                settings = self.SettingsService.getSetting(response.data.property_settings, 'other_aml_cft_settings');
                self.other_aml_cft_settings = settings? settings.value : self.SSConfigService.getDefaultToggleSettings();

                /** WEB-2937 Corporate Sale - Support for Multiple Signatories **/
                settings = self.SettingsService.getSetting(response.data.property_settings, 'corporate_purchase_multiple_signatories_support');
                self.SSEoiService.corporate_purchase_multiple_signatories_support = settings? settings.value : {};

                /** If buyer_identity_documents_disabled contains 1 aaginst an identity document type(buyers/ beneficiaries/ non_buyers_payees/ others/ witnesses)
                 * then need to hide the document upload sectiion for that type **/
                let is_upload_doc_section_disabled_settings = self.SettingsService.getSetting(response.data.property_settings, 'buyer_identity_documents_disabled');
                if(is_upload_doc_section_disabled_settings && is_upload_doc_section_disabled_settings.value){
                    self.is_upload_doc_section_disabled = is_upload_doc_section_disabled_settings.value;

                    if(self.is_payment_section_disabled &&
                        (self.is_upload_doc_section_disabled &&
                            self.is_upload_doc_section_disabled.buyers === 1 &&
                            self.is_upload_doc_section_disabled.beneficiaries === 1 &&
                            self.is_upload_doc_section_disabled.non_buyers_payees === 1 &&
                            self.is_upload_doc_section_disabled.witnesses === 1 &&
                            self.is_upload_doc_section_disabled.others === 1)){
                        /** Need to hide upload buyer documents step if payment section and all upload document sections are disabled **/
                        self.is_skip_upload_buyer_documents_step = true;
                    }
                }
                /** WEB-2827 Show/Hide Payment Settings - End **/
            }
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
                else{
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    maskModalPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        /** WEB-2811 AMS/DMS : AUS country support **/
        let country = self.PROJECT_COUNTRY || null;
        let countryCode = self.SSUtilService.getCountryShortCode(country);

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: countryCode,
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: [countryCode]
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }


            field.on("keyup change", function () {
                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        //Display error
                        // let input = $('input');
                        // input.trigger('change');
                        if (!self.registerErrors) {
                            self.registerErrors = {};
                        }
                        self.registerErrors.user_phone1 = "Invalid Contact No. Please enter the correct contact no.";
                    }
                } else {
                    //Remove error
                    // let input = $('input');
                    // input.trigger('change');
                    if (!self.registerErrors) {
                        self.registerErrors = {};
                    }
                    self.registerErrors.user_phone1 = "";

                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

    getNonBuyerPayeeName(instrument){
        const self = this;
        if(instrument){
            if(self.sale_sales && self.sale_sales.sale_non_buyer_payees && self.sale_sales.sale_non_buyer_payees.length){
                let nonBuyerPayee = self.sale_sales.sale_non_buyer_payees.find(x => x.id === instrument.non_buyer_payee_id);
                if(nonBuyerPayee){
                    return nonBuyerPayee.individual? nonBuyerPayee.individual.legal_name : nonBuyerPayee.company ? nonBuyerPayee.company.name : '--';
                }
            }
        }

        return "--";
    }

    Back(){
        const self = this;

        let url = '/developer/sales/payments?id='+ self.parameters.id;

        if(self.urlPaymentInformation){
            url = '/developer/sales/applications/review?sale_id='+ self.sale_sales.id +'&id=1';
        }

        self.$window.location.href = url;
    }

    /** WEB-2811 AMS/DMS : AUS country support - Start **/
    isDocSignNeededFromUser(document_id){
        const self = this;

        let documentSignee = self.getLoggedInUserDcoumentSigneeObj(document_id);
        return (documentSignee && !documentSignee.signed_at);
    }

    getLoggedInUserDcoumentSigneeObj(document_id){
        const self = this;

        let userId = self.SSUserService.getUser().id;
        let documentSigneeObj = {};
        try{
            let docSigneeWrapperObj = self.sale_sales.sales_documents_list.filter(doc => doc.id == document_id);
            if (docSigneeWrapperObj && docSigneeWrapperObj.length > 0) {
                documentSigneeObj = docSigneeWrapperObj[0].document_signees.filter( d => d.developer_user_id == userId)[0];
            }
        }catch(e){
            console.error("An error occurred while retrieving document signee object")
        }

        return documentSigneeObj;
    }

    openSignDocumentLink( document ){
        const self = this;

        self.showDocumentSigningPopup(document, self.getLoggedInUserDcoumentSigneeObj(document.document_id));
    }

    showDocumentSigningPopup(saleDocument, documentSignee) {
        const self = this;

        let url = 'pub/documents/' + saleDocument.document_id + '?signee_token=' + documentSignee.token + '&__email=1';
        /** WEB-2811 AMS/DMS : AUS country support **/
        if(!self.SSEoiService.document_signing_method || self.SSEoiService.document_signing_method === 'signature_pad'){
            url += '&__sp=1';
        }else if(self.SSEoiService.document_signing_method === 'name_initials'){
            // Empty for now
        }
        url = self.SSHttpService.getApiURL(url);

        window.open(url, '_blank');

        saleDocument["show_sign_loading"] = true;
        self.pingDocument(saleDocument, documentSignee);
    }

    pingDocument(saleDocument, documentSignee) {
        const self = this;

        let url = 'sec/sales/' + saleDocument.sale_id + '/documents/' + saleDocument.id;

        self.SSHttpService.getAPIRequest(url).then(
            function (response) {
                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                let returned_signee = response.data.sale_document.document.document_signees
                    .find(x => x.id === documentSignee.id);

                if (returned_signee && returned_signee.signed_at) {
                    try{
                        let docIndex = self.sale_sales.sales_documents_list
                            .findIndex(doc => doc.id === saleDocument.document_id);
                        let docSigneeIndex = self.sale_sales.sales_documents_list[docIndex].document_signees
                            .findIndex(ds => ds.id === returned_signee.id);
                        self.sale_sales.sales_documents_list[docIndex].document_signees[docSigneeIndex] = returned_signee;
                    }catch(e){
                        console.error("An error occurred updating document_signee object");
                    }
                }

                //Successfully get the document object
                if (response.data.sale_document.file_uri == null &&
                        (returned_signee && returned_signee.signed_at == null)) {
                    self.timeout_promise = self.$timeout(function () {
                        self.pingDocument(saleDocument, documentSignee);
                    }, 5000); // 5 sec delay
                } else {
                    saleDocument.file_uri = response.data.sale_document.file_uri;
                    saleDocument["show_sign_loading"] = null;
                }
            }
        );
    }

    getNRICLabel(){
        const self = this;
        return self.SSEoiService.getNRICLabel(self.PROJECT_COUNTRY)
    }
    /** WEB-2811 AMS/DMS : AUS country support - End **/

    getAmlDocumentTypeIndicator( document, isTitle = false ){
        const self = this;

        let indicator, title = "";
        if(document && document.aml_scan_type){
            if(document.aml_scan_type === self.AML_SCAN_TYPE_EOI){
                indicator = "E";
                title = "Scan Generated for EOI";
            }else if(document.aml_scan_type === self.AML_SCAN_TYPE_OTP){
                indicator = "O";
                title = "Scan Generated for OTP";
            }else if(document.aml_scan_type === self.AML_SCAN_TYPE_ON_GOING){
                indicator = "C";
                title = "Scan Generated for On-going/Continuous Monitoring";
            }else if(document.aml_scan_type === self.AML_SCAN_TYPE_MANUAL){
                indicator = "M";
                title = "Manual Generated Scan";
            }else if(document.aml_scan_type === self.AML_SCAN_TYPE_TOP){
                indicator = "T";
                title = "Scan Generated for TOP";
            }else if(document.aml_scan_type === self.AML_SCAN_TYPE_LEGAL_COMPLETION){
                indicator = "L";
                title = "Scan Generated for Legal Completion";
            }
        }

        if(isTitle){
            return title;
        }

        return indicator;
    }

    getAmlScanEntityType(document) {
        if (!document) return '';

        if (document.sale_buyer_id) return 'Buyer';
        if (document.beneficiary_id) return 'Beneficiary - Buying In-trust';
        if (document.non_buyer_payee_id) return '3rd Party Payor';
        if (document.other_entity_id) return 'Other AML/CFT Entity';
        if (document.legal_entity_buyer_id) return 'Legal Arrangement';
        if (document.key_personnel_id) return 'Key Personnel';
        if (document.subsale_buyer_id) return 'Subsale Buyer';

        return '';
    }

    /** WEB-2919 Corporate Sales: Other AML/CFT Entities - START **/
    showAddAmlEntityPopup(entity){
        const self = this;

        self.clearAddAmlEntityPopupFields();
        if(entity){ // If Edit
            self.addAmlParams = angular.copy(entity);
            if(entity.date_of_birth){
                self.addAmlParams.date_of_birth = self.SSUtilService.formatUtcToLocalDate(self.addAmlParams.date_of_birth);
            }
        }

        self.$timeout(function() {
            $("select.eoi-select").niceSelect('update');
        });

        self.showAddAmlCftModal = true;
        $('#addAmlCftModal').modal('show');
    }

    hideAddAmlEntityPopup(){
        const self = this;

        self.clearAddAmlEntityPopupFields();
        self.showAddAmlCftModal = false;
        $('#addAmlCftModal').modal('hide');
    }

    clearAddAmlEntityPopupFields(isTypeChange = false){
        const self = this;

        if(isTypeChange){
            let id = self.addAmlParams.id;
            let type = self.addAmlParams.type;
            self.addAmlParams = {
                id,
                type
            };
        }else{
            self.addAmlParams = {};
        }
        self.addAmlErrors = {};
        self.SSAlertService.clear();

        self.$timeout(function() {
            $("select.eoi-select").niceSelect('update');
        });
    }

    saveAmlCftEntity(){
        const self = this;
        self.addAmlErrors = {};

        if(!self.isValidAmlCftForm()){
            return false;
        }

        let _addAmlParams = angular.copy(self.addAmlParams);
        /* Prepare params before adding/updating */
        if(_addAmlParams.date_of_birth) {
            _addAmlParams.date_of_birth = self.SSUtilService.formatDateToStoreWithUtc12(_addAmlParams.date_of_birth);
        }
        if(!_addAmlParams.type){ // Set default type as Individual
            _addAmlParams.type = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        }
        if(!_addAmlParams.identity_type && _addAmlParams.type === SHOWSUITE.BUYER_TYPE_INDIVIDUAL){ // Set default identity type as Singaporean for Individual
            _addAmlParams.identity_type = SHOWSUITE.IDENTITY_TYPE_SINGAPOREAN;
        }
        if(!_addAmlParams.identity_type && _addAmlParams.type === SHOWSUITE.BUYER_TYPE_COMPANY){ // Set default identity type as Company for Company
            _addAmlParams.identity_type = SHOWSUITE.IDENTITY_TYPE_COMPANY;
        }
        if(!_addAmlParams.gender && _addAmlParams.type === SHOWSUITE.BUYER_TYPE_INDIVIDUAL){ // Set default Gender as Undisclosed
            _addAmlParams.gender = 0;
        }

        let url = 'sec/aml-scan-other-entities';
        let params = {
            sale_id: self.sale_id,
            property_id: self.sale_property.id,
            type: _addAmlParams.type || null,
            legal_name: _addAmlParams.legal_name || null,
            identity_type: _addAmlParams.identity_type || null,
            identity_no: _addAmlParams.identity_no || null,
            nationality: _addAmlParams.nationality || null,
            gender: _addAmlParams.gender || null,
            date_of_birth: _addAmlParams.date_of_birth || null,
            country_of_birth: _addAmlParams.country_of_birth || null,
        };

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.entity){
                if(_addAmlParams.id) { // If Edit
                    self.sale_sales.amlOtherEntities = self.sale_sales.amlOtherEntities.map(e => {
                        if (e.id === _addAmlParams.id) { // Update entity
                            e = response.data.entity;
                        }
                        return e;
                    })
                } else{
                    self.sale_sales.amlOtherEntities = self.sale_sales.amlOtherEntities || [];
                    self.sale_sales.amlOtherEntities.push(response.data.entity);
                }
            }
            self.hideAddAmlEntityPopup();
            self.SSAlertService.success(`AML/CFT entity ${_addAmlParams.id? 'updated':'added'} successfully.`);
        };

        loading(true);
        if(_addAmlParams.id){ // If Edit
            url += '/' + _addAmlParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        }else{
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    isValidAmlCftForm(){
        const self = this;

        if(!self.addAmlParams){ return false; }

        let isValid = true;
        if(!self.addAmlParams.legal_name){
            self.addAmlErrors.legal_name = true;
            isValid = false;
        }
        if((self.addAmlParams.type && self.addAmlParams.type === self.BUYER_TYPE_COMPANY)
            && !self.addAmlParams.identity_no){
            self.addAmlErrors.identity_no = true;
            isValid = false;
        }
        return isValid;
    }

    deleteAmlCftEntity(entity){
        const self = this;

        self.SSConfirmationService.getConfirmed('Confirmation!', 'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/aml-scan-other-entities/' + entity.id;

                loading(true);
                self.SSHttpService.deleteAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return false;
                    }
                    self.sale_sales.amlOtherEntities = self.sale_sales.amlOtherEntities.filter(e => e.id !== entity.id);
                    self.SSAlertService.success('Entity deleted successfully.');
                });
            }
        );
    }


    //Import Section
    hideAmlImortSection(){
        const self = this;

        self.SSAlertService.clear();
        self.importAmlParams = null;
        self.showImportAmlEntitySection = false;
    }

    setAmlImportFile(files){
        const self = this;

        self.importAmlParams.excelFile = files[0];
    }

    importAmlScanEntities() {
        const self = this;

        if(!self.importAmlParams.excelFile) {
            self.SSAlertService.danger('Please select file to import.');
        }

        loading(true);
        self.Upload.upload({
            url: self.SSHttpService.getApiURL('sec/aml-scan-other-entities/import'),
            method: 'POST',
            data: {
                sale_id: self.sale_id,
                file_import: self.importAmlParams.excelFile
            },
            withCredentials: true
        }).then(function (response) {
            loading(false);

            response = response.data ? response.data : {};
            if (response.code !== 200) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.sale_sales.amlOtherEntities = self.sale_sales.amlOtherEntities || [];
            if(response.data && response.data.aml_scan_records){
                response.data.aml_scan_records.forEach(e=> {
                    self.sale_sales.amlOtherEntities.push(e);
                })
                self.hideAmlImortSection();
                self.SSAlertService.success('AML/CFT entity Excel imported successfully.');
            }
        }, function (response) {
            loading(false);

            response = response.data ? response.data : {};
            if (response.code !== 200) {
                if(!response.sub_code && !response.message){
                    self.SSAlertService.danger("Unable to upload file. Please contact support.");
                }else{
                    self.SSAlertService.parseAndDisplayError(response);
                }
            }
        }, function (evt) {
        });
    }

    getOtherAmlCftEntities() {
        const self = this;

        let url = 'sec/aml-scan-other-entities/sale/' + self.sale_id;
        let params = {};

        loading(true);
        self.SSHttpService.getAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data && response.data.entities && response.data.entities.length > 0) {
                self.sale_sales.amlOtherEntities = response.data.entities;
            }
        });
    }
    /** WEB-2919 Corporate Sales: Other AML/CFT Entities - END **/

    /** WEB-2937 Corporate Sale - Support for Multiple Signatories - Start **/
    isShowEntityTypeFields(type, saleBuyer){
        const self = this;

        if(!self.sale_sales || !self.sale_sales.sale_buyers
                || !self.sale_sales.sale_buyers[0] || !self.sale_sales.sale_buyers[0].data){
            if((self.newBuyerMode || self.subSaleMode)
                && self.saleBuyerParams && self.saleBuyerParams.data && self.saleBuyerParams.data.type){
                if(type === 'individual'){
                    return self.saleBuyerParams.data.type === self.BUYER_TYPE_INDIVIDUAL;
                }else if(type === 'signatory'){
                    return false;
                }else if(type === 'company'){
                    return self.saleBuyerParams.data.type === self.BUYER_TYPE_COMPANY;
                }
            }
        }

        let first_buyer = self.sale_sales.sale_buyers[0];
        if(self.SHOW_PREVIOUS_BUYERS && self.previous_sale_buyers && self.previous_sale_buyers.length){
            first_buyer = self.previous_sale_buyers[0];
        }

        if(self.newBuyerMode
                && self.saleBuyerParams
                && self.saleBuyerParams.data
                && self.saleBuyerParams.data.type){
            if(type === 'individual'){
                return first_buyer.data.type === self.BUYER_TYPE_INDIVIDUAL
                    && self.saleBuyerParams.data.type === self.BUYER_TYPE_INDIVIDUAL;
            }else if(type === 'signatory'){
                return first_buyer.data.type === self.BUYER_TYPE_COMPANY
                    && self.saleBuyerParams.data.type === self.BUYER_TYPE_INDIVIDUAL;
            }else if(type === 'company'){
                return self.saleBuyerParams.data.type === self.BUYER_TYPE_COMPANY;
            }
        }else if(saleBuyer && saleBuyer.data){
            if(type === 'individual'){
                return first_buyer.data.type === self.BUYER_TYPE_INDIVIDUAL
                    && saleBuyer.data.type === self.BUYER_TYPE_INDIVIDUAL;
            }else if(type === 'signatory'){
                return first_buyer.data.type === self.BUYER_TYPE_COMPANY
                    && saleBuyer.data.type === self.BUYER_TYPE_INDIVIDUAL;
            }else if(type === 'company'){
                return saleBuyer.data.type === self.BUYER_TYPE_COMPANY;
            }
        }

        return false;
    }

    updateSaleBuyersOrder(){
        const self = this;

        // TODO: need to verify Sub Sale case
        if(!self.sale_sales || !self.sale_sales.sale_buyers
                || !self.sale_sales.sale_buyers.length
                || !self.SSEoiService.buyers) { return false; }

        // Update all buyer order based on sorted indexes
        self.sale_sales.sale_buyers.forEach(sb => {
            let index = sb.data? self.SSEoiService.buyers.findIndex(b => b.id === sb.data.id) : null;
            if(index !== null && index !== undefined && index > -1){
                sb.order = index+1;
            }
        })

        let url = `sec/developer/sales/${self.sale_id}/buyers/buyer-order`;
        let buyer_order_param = [];
        self.sale_sales.sale_buyers.map((b,index) => {
            buyer_order_param.push({
                id: b.id,
                order: b.order || index+1
            })
        })
        let params = {
            data: buyer_order_param
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url,params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.$window.location.reload(); // TODO: Fix the data issue
                return;
            }

            if (response.data) {
                // console.log(response);
            }
            self.$window.location.reload(); // TODO: Fix the data issue
        });
    }
    /** WEB-2937 Corporate Sale - Support for Multiple Signatories - End **/


    onBuyerClickLandedProperty(addressType){
        const self = this;
        if(addressType == "primary"){
            if(!self.primary_address_residence_type){
                self.primary_address_residence_type = true;
                self.saleBuyerParams.data.primary_address.unit_no = null;
                self.saleBuyerParams.data.primary_address.residence_type = self.RESIDENCE_TYPE_LANDED_PROPERTY;
            }else{
                self.primary_address_residence_type = false;
                self.saleBuyerParams.data.primary_address.residence_type = null;
            }
        }else if(addressType == "mailing"){
            if(!self.mailing_address_residence_type){
                self.mailing_address_residence_type = true;
                self.saleBuyerParams.data.mailing_address.residence_type = self.RESIDENCE_TYPE_LANDED_PROPERTY;
                self.saleBuyerParams.data.mailing_address.unit_no = null;
            }else{
                self.mailing_address_residence_type = false;
                self.saleBuyerParams.data.mailing_address.residence_type = null;
            }
        }
    }

    onThirdPartyPayorClickLandedProperty(){
        const self = this;
        if(!self.third_party_primary_address_residence_type){
            self.third_party_primary_address_residence_type = true;
            self.saleNonBuyerPayeeParams.primary_address.unit_no = null;
            self.saleNonBuyerPayeeParams.primary_address.residence_type = self.RESIDENCE_TYPE_LANDED_PROPERTY;
        }else{
            self.third_party_primary_address_residence_type = false;
            self.saleNonBuyerPayeeParams.primary_address.residence_type = null;
        }
    }

    onWitnessClickLandedProperty(){
        const self = this;
        if(!self.witness_primary_address_residence_type){
            self.witness_primary_address_residence_type = true;
            self.witnessParams.primary_address.unit_no = null;
            self.witnessParams.primary_address.residence_type = self.RESIDENCE_TYPE_LANDED_PROPERTY;
        }else{
            self.witness_primary_address_residence_type = false;
            self.witnessParams.primary_address.residence_type = null;
        }
    }

    /** WEB-3013 Post Data to SAP single or multiple data selection and post - START */
    updatePostingStatus(entity_obj, updated_posting_status, category = this.CATEGORY_INSTRUMENT, payment) {
        const self = this;

        if (!entity_obj || !updated_posting_status) { return false; }

        self.posting_alert_msg = "Please update Invoice status first.";
        // WEB-4703: a normal refund has no posting of its own (only its instrument posts), so its
        // instrument is not held back behind the payment's status — same as the app.
        if (category === self.CATEGORY_INSTRUMENT && payment && self.isPaymentPostingApplicable(payment)) {
            if (updated_posting_status === self.INSTRUMENT_POSTING_STATUS_REVIEWED){
                // If marking instrument status reviewed then payment must have at least reviewed status
                if (payment.posting_status !== self.INSTRUMENT_POSTING_STATUS_REVIEWED
                    && payment.posting_status !== self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING
                    && payment.posting_status !== self.INSTRUMENT_POSTING_STATUS_POSTED){
                    $('#posting_status_update_not_allowed_modal').modal('show');
                    return false;
                }
            } else if (payment.posting_status !== self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING
                && payment.posting_status !== self.INSTRUMENT_POSTING_STATUS_POSTED) {
                $('#posting_status_update_not_allowed_modal').modal('show');
                return false;
            }
        }

        if (category === self.CATEGORY_INSTRUMENT) {
            /** WEB-3184 Allgreen - Marking for Posting - Bank-in Date is required
             * Need to require Bank-in Date if payment type is cheque else always require Receiving Date **/
            self.posting_alert_msg = "";
            if (entity_obj.type == self.INSTRUMENT_TYPE_CHEQUE) {
                self.posting_alert_msg = !entity_obj.bank_in_date? "Please enter Bank-in date." : "";
            } else if (!entity_obj.receiving_date) {
                self.posting_alert_msg = "Please enter Date Received.";
            }

            if ((!payment || payment.type !== self.PAYMENT_TYPE_20_REFUND)// WEB-3184: Skip check for Refund/Aborted
                    && self.posting_alert_msg) {
                $('#posting_status_update_not_allowed_modal').modal('show');
                return false;
            }
        } else if (category === self.CATEGORY_PAYMENT && !entity_obj.serving_date) {
            self.posting_alert_msg = "Please enter Notice Served Date.";
            $('#posting_status_update_not_allowed_modal').modal('show');
            return false;
        }

        self.posting_date_error = null;
        let confirmation_message = null;
        if (updated_posting_status === self.INSTRUMENT_POSTING_STATUS_REVIEWED) {
            confirmation_message = "Are you sure you want to Mark Reviewed?";

            let handleResponse = function (response) {
                self.SSAlertService.success("Posting status updated successfully.");

                if (category === self.CATEGORY_PAYMENT) {
                    if (response && response.data && response.data.payments && response.data.payments.indexOf(entity_obj.id) > -1){
                        entity_obj.posting_status = updated_posting_status; // Update local payment
                    }
                } else {
                    if (response && response.data && response.data.instruments && response.data.instruments.indexOf(entity_obj.id) > -1){
                        entity_obj.posting_status = updated_posting_status; // Update local instrument
                    }
                }
            }

            self.SSConfirmationService.getConfirmed('Confirm!', confirmation_message,
                self.SSConfirmationService.TYPE_DEFAULT,
                function () {
                    self._updatePostingStatusReviewed(entity_obj, updated_posting_status, category, handleResponse);
                }
            )
        } else if (updated_posting_status === self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING) {
            self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function () {
                self.selected_entity_obj = entity_obj;
                self.selected_category = category;
                self.selected_posting_status = updated_posting_status;
                self.posting_api_error = null; // Reset previous error when opening the modal

                // WEB-4570: the earliest selectable date is the Financial Period Close
                // min_open_date (no bound when nothing is closed); future dates are never
                // allowed. The posting-date window itself is enforced server-side (WEB-3411).
                self._loadPostingMinOpenDate(self.sale_sales.property_id, function (minDate) {
                    jQuery('#posting_date').datepicker("destroy"); // Ensure old settings are removed
                    jQuery('#posting_date').datepicker({
                        changeMonth: true,
                        changeYear: true,
                        dateFormat: "dd/mm/yy",
                        minDate: minDate,
                        maxDate: new Date(),
                    });

                    let date = new Date(); // Set the current date as posting date by default
                    self.posting_date = date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth()+1).toString().padStart(2, '0') + '/' +date.getFullYear();
                    if (category === self.CATEGORY_INSTRUMENT){
                        // If Date Received exists against instrument, set as posting date
                        if (entity_obj.receiving_date) {
                            self.posting_date = self.SSUtilService.formatDateDMY(entity_obj.receiving_date.split(" ")[0]);
                        }
                    } else if (category === self.CATEGORY_PAYMENT) {
                        if (entity_obj.serving_date) {
                            // If Date Received exists against instrument, set as posting date
                            self.posting_date = self.SSUtilService.formatDateDMY(entity_obj.serving_date.split(" ")[0]);
                        }
                    }
                    if(entity_obj.bank_in_date){
                        $('#mark_posting_confirmation_modal').modal('show');
                    }else{
                        self.SSConfirmationService.getConfirmed('Confirm!', 'You want to continue without bank in date?',
                            self.SSConfirmationService.TYPE_DEFAULT,
                            function () {
                                $('#mark_posting_confirmation_modal').modal('show');
                            }
                        )
                    }
                });

            })
        }
    }

    /**
     * WEB-4570: Fetch the earliest open (not period-closed) posting date for a project.
     * Calls back with a local Date, or null when nothing is closed or the request fails —
     * the server still validates every posting date, so a failure only loosens the picker.
     *
     * @param {number} propertyId
     * @param {function(?Date)} callback
     */
    _loadPostingMinOpenDate(propertyId, callback) {
        const self = this;

        if (!propertyId) { callback(null); return; }

        loading(true);
        self.SSHttpService.getAPIRequest('sec/developer/posting-period-close', {property_id: propertyId}).then(function (response) {
            loading(false);
            let periods = (response instanceof Error || !response || !response.data) ? null : response.data.posting_periods;
            let minOpenDate = periods && periods.length ? periods[0].min_open_date : null;
            callback(minOpenDate ? self.SSUtilService.parseDate(String(minOpenDate).substring(0, 10)) || null : null);
        });
    }

    _updatePostingStatusReviewed(entity_obj, updated_posting_status, category, callback) {
        const self = this;

        if (!entity_obj || !entity_obj.id || !updated_posting_status) { return false; }
        let url = 'sec/developer/sales/payments/instruments/update-posting-status';
        let params = {
            posting_status: updated_posting_status,
            category
        };
        if (category === self.CATEGORY_PAYMENT) {
            params.payment_ids = [entity_obj.id];
        } else {
            params.instrument_ids = [entity_obj.id];
        }

        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.SSAlertService.parseAndDisplayError(response);
                return false;
            }

            if (callback) { callback(response); }
        });
    }

    updatePostingStatusPost() {
        const self = this;

        self.posting_date_error = null;
        self.posting_api_error = null;
        let entity_obj = self.selected_entity_obj;
        let category = self.selected_category;
        if (!entity_obj || !entity_obj.id || !self.selected_posting_status) { return false; }

        // Check posting date is required.
        // WEB-3411: posting-window enforcement is server-side; the API rejects with subcode
        // 301040 if the date is outside the developer's configured SAP posting window. The
        // server's message is shown both via SSAlertService.parseAndDisplayError (global
        // toast) and inline below the modal buttons (posting_api_error) so the user sees
        // it without dismissing the modal.
        if (!self.posting_date) {
            self.posting_date_error = "Please select posting date.";
            return false;
        }

        let url = 'sec/developer/sales/payments/instruments/update-posting-status';
        let params = {
            posting_status: self.selected_posting_status,
            category: self.selected_category,
            posting_date: self.posting_date
        };
        if (category === self.CATEGORY_PAYMENT) {
            params.payment_ids = [entity_obj.id];
        } else {
            params.instrument_ids = [entity_obj.id];
        }

        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                // Show the server's message inline in the modal so the user sees it
                // without dismissing the dialog. parseAndDisplayError still fires for
                // the global toast / status-code-specific handling.
                self.posting_api_error = (response && response.data && response.data.message)
                    || (response && response.message)
                    || "Posting failed. Please try again or contact support.";
                self.SSAlertService.parseAndDisplayError(response);
                return false;
            }
            self.posting_api_error = null;
            $('#mark_posting_confirmation_modal').modal('hide');
            self.SSAlertService.success("Posting status updated successfully.");

            if (self.selected_category === self.CATEGORY_PAYMENT) {
                if (response && response.data && response.data.payments && response.data.payments.indexOf(entity_obj.id) > -1){
                    self.selected_entity_obj.posting_status = self.selected_posting_status; // Update local payment
                    self.selected_entity_obj.posting_date = self.posting_date; // Update local posting_date
                }
            } else {
                if (response && response.data && response.data.instruments && response.data.instruments.indexOf(entity_obj.id) > -1){
                    self.selected_entity_obj.posting_status = self.selected_posting_status; // Update local instrument
                    self.selected_entity_obj.posting_date = self.posting_date; // Update local posting_date
                }
            }
        });

    }

    getPostingStatusDisplayName(posting_status) {
        const self = this;

        let posting_status_name = "";
        if (!posting_status || posting_status === self.INSTRUMENT_POSTING_STATUS_PENDING) {
            posting_status_name = "Pending";
        } else if (posting_status === self.INSTRUMENT_POSTING_STATUS_REVIEWED) {
            posting_status_name = "Reviewed";
        } else if (posting_status === self.INSTRUMENT_POSTING_STATUS_MARKED_FOR_POSTING) {
            posting_status_name = "Marked for Posting";
        } else if (posting_status === self.INSTRUMENT_POSTING_STATUS_POSTED) {
            posting_status_name = "Posted";
        }

        return posting_status_name;
    }

    /**
     * WEB-4703: whether a payment carries its OWN SAP posting status (Posting Status,
     * Mark Reviewed / Post, Posting Date) on the Sale Details payment card.
     *
     * A normal refund — a refund payment (`payments.type` = 20) with no payment plan clause
     * that is not an Interest Waiver, e.g. an overpayment returned to the buyer — is never
     * posted itself; only its refund instrument is (SapDocumentBuilder skips the payment, and
     * AllGreen's LedgerExport only stamps payments that have a clause). Showing the
     * payment-level section there let users mark a payment that the system then ignores.
     *
     * Everything else keeps it: non-refund payments, clause-bound refunds (Aborted sale,
     * posted as a billing) and Interest Waivers (refund_type = 10 — no instrument, posted via
     * the payment). Same rule as the Digital Bookings app (dms_sales_payment_information_detail.dart).
     *
     * @remarks `payment.type` here is the payments.type COLUMN (20 = refund), not the payment
     *          modal's `paymentInfoParams.type`, which holds a clause id. Loose comparisons on
     *          purpose: the API may send these as strings. Mirrored in lawyer/sales/details.js.
     *
     * @param {Object} payment Sale payment row (type, payment_plan_clause_id, refund_type).
     * @returns {boolean} false only for a normal refund; true otherwise, including no payment.
     */
    isPaymentPostingApplicable(payment) {
        const self = this;

        if (!payment || payment.type != self.PAYMENT_TYPE_20_REFUND) { return true; }
        if (payment.payment_plan_clause_id) { return true; }

        return payment.refund_type == self.PAYMENT_REFUND_TYPE_10_WAIVER;
    }

    toggleEmailRecipients(value, recipients) {
        const self = this;

        if (!recipients || !recipients.length) { return false; }

        if (value) { // If header checkbox checked set all email recipients checked
            recipients.forEach(r => r.selected = true);
        } else { // If header checkbox unchecked set all email recipients unchecked
            recipients.forEach(r => r.selected = false);
        }
    }

    toggleEmailRecipientsHeader(headerName, recipients) {
        const self = this;

        if (!recipients || !recipients.length) { return false; }

        let isOneRecipientChecked = recipients.find(r => r.selected);

        if (isOneRecipientChecked) { // If an email recipient checked, set header checkbox checked
            self.email_receipient[headerName] = self.email_receipient[headerName] || true;
        } else { // If all email recipients unchecked, set the header checkbox unchecked
            self.email_receipient[headerName] = false;
        }
    }
    /** WEB-3013 Post Data to SAP single or multiple data selection and post - END */

    toggleAllTabs() {
        const self = this;

        // Collapse all open tabs
        jQuery.each( jQuery("#paymentDetails>.card"),  function( index, source ) {
            let cardHeader = jQuery(jQuery(source).find('.card-header')[0]);
            let cardBlock = jQuery(jQuery(source).find('.card-block')[0]);

            if (cardBlock.is(':visible')) {
                cardBlock.slideUp('slow', function () {
                    cardHeader.find('i.fa-caret-down').removeClass('fa-caret-down').addClass('fa-caret-left');
                });
            }
        });
    }

    getInterestChargeStatus(status){
        const self = this;
        if(!status){
            return 'Not Confirmed'
        }else if( status === self.DAILY_INTEREST_STATUS_PENDING){
            return 'Pending'
        }else if( status === self.DAILY_INTEREST_STATUS_CHARGEABLE){
            return 'Charged'
        }else if( status === self.DAILY_INTEREST_STATUS_WAIVED){
            return 'Waived'
        }
    }
    getStatusColor(status){
        const self = this;
        if(!status){
            return 'orange'
        }else if( status === self.DAILY_INTEREST_STATUS_PENDING){
            return 'blue'
        }else if( status === self.DAILY_INTEREST_STATUS_CHARGEABLE){
            return 'red'
        }else if( status === self.DAILY_INTEREST_STATUS_WAIVED){
            return 'green'
        }
    }

    showInterestRequestPopup(status){
        const self = this;
        self.interest_request_status = status;
        self.interest_status_receipent_data = []
        self.prepareReceipientObjInterestRequest(self.interestStatusEmailSendingData['recipients'], self.interest_status_receipent_data);
        $('#chargeableInterestDetailsViewModal').modal('hide');
        $('#sendRequestInterestStatusByEmailViewModal').modal('show');
    }

    getEmailDataForChargeableInterest() {
        const self = this;
        let url =
            "sec/developer/sales/" +
            self.sale_id +
            "/get-daily-interest-request-emails";

        let params = {
            saleId: self.sale_id,
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.interestStatusEmailSendingData = response.data;
            self.interest_status_receipent_data = [];

        });
    }

    prepareReceipientObjInterestRequest(emails_array, obj) {
        $.each(emails_array, function (index, email) {
            let buyer_obj = {
                'email': email,
                'selected': true
            }

            obj.push(buyer_obj);
        })
    }

    callSendRequestInterestStatusByEmailApi() {
        const self = this;

        let url =
            "sec/developer/sales/" +
            self.sale_id +
            "/payments/" +
            self.selected_payment.id +
            "/request-charge-waive-interest";

        let params = {
            'status': self.interest_request_status ? self.interest_request_status : null,
            'recipients': []
        };

        if(self.selected_interest.length){
            let selectedInterestIds = [];
            $.each(self.selected_interest, function (index, interest) {
              if(interest.selected){
                  selectedInterestIds.push(interest.id);
              }
            })
            if(selectedInterestIds.length > 0){
                params['interest_ids'] = selectedInterestIds;
            }
        }

        if (self.interest_status_receipent_data) {
            params["recipients"] = params["recipients"].concat(self.pushToSendEmailParams(self.interest_status_receipent_data, []));
        }

        // if(params.recipients && typeof params.recipients != "string"){
        //     params.recipients = JSON.stringify(params.recipients);
        // }
        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support. ');
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Send Request Email successfully.');
            self.$window.location.reload();
        });
    }

    chargedInterest(status){
        const self = this;

        let url =
            "sec/developer/sales/" +
            self.sale_id +
            "/payments/" +
            self.selected_payment.id +
            "/charge-waive-interest";

        let params = {
            'status': status,
        };

        if(self.selected_interest.length){
            let selectedInterestIds = [];
            $.each(self.selected_interest, function (index, interest) {
                if(interest.selected){
                    selectedInterestIds.push(interest.id);
                }
            })
            if(selectedInterestIds.length > 0){
                params['interest_ids'] = selectedInterestIds;
            }
        }
        loading(true);
        self.SSHttpService.putAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support. ');
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Interest Status updated.');
            self.$window.location.reload();
        });
    }
    isInterestSelected(){
        const self = this;
        let isSelected = false;
        $.each(self.selected_interest, function (index, interest) {
            if(interest.selected){
                isSelected = true;
                return false;
            }
        })
        return isSelected;
    }
    resetSelectedInterest(){
        const self = this;
        $.each(self.selected_interest, function (index, interest) {
            if(interest.selected){
                interest.selected = false;
            }
        })
    }

    /** WEB-3020 AllGreen : Sub-Sales Confirmation Letter - Start **/
    openSubsaleConfirmationLetterPopup(){
        const self = this;
        self.subsaleConfirmationLetter = {
            'reference_no':null,
            'email_date' : null,
            'attn' : null
        };
        self.showDownloadSubsaleConfirmationLetterModal = true;
        $('#downloadSubsaleConfirmationLetterModal').modal('show');

    }

    generateSubsaleConfirmationLetter(){
        const self = this;
        let urlParams = "";
        if(self.subsaleConfirmationLetter.reference_no){
            urlParams = urlParams + "reference_no=" + encodeURIComponent(encodeURIComponent(self.subsaleConfirmationLetter.reference_no));
        }
        if(self.subsaleConfirmationLetter.email_date){
            if(urlParams !== ""){
                urlParams = urlParams+"&";
            }
            urlParams = urlParams + "email_date=" + self.subsaleConfirmationLetter.email_date;
        }
        if(self.subsaleConfirmationLetter.attn){
            if(urlParams !== ""){
                urlParams = urlParams+"&";
            }
            urlParams = urlParams + "attn=" + encodeURIComponent(encodeURIComponent(self.subsaleConfirmationLetter.attn));
        }
        if(urlParams !== ""){
            urlParams = "?"+urlParams;
        }
        let url = self.SSHttpService.getApiURL('sec/developer/sales/' + self.sale_sales.id + '/subsale-confirmation-letter-document'+urlParams);
        let url_ping = window.open(encodeUrlWithParams(url), '_blank');
        if (url_ping) {
            self.SSAlertService.success("Success!", "Download completed successfully.");
            self.showDownloadSubsaleConfirmationLetterModal = false;
            $('#downloadSubsaleConfirmationLetterModal').modal('hide');
        }

    }
    /** WEB-3020 AllGreen : Sub-Sales Confirmation Letter - End **/

    getAgentEmailWithRole(email){
        const self = this;
        if(self.brokers.length > 0) {
            let matchedBroker = self.brokers.find(function(broker) {
                return broker.user && broker.user.email === email;
            });
            if(matchedBroker){
                return (matchedBroker.role_name ? (matchedBroker.role_name + " - ") : '') + email;
            }
        }else{
            return email;
        }
    }

    getIsTeleSaleStaff(email){
        const self = this;
        if(self.brokers.length > 0) {
            let matchedBroker = self.brokers.find(function(broker) {
                return broker.user && broker.user.email === email;
            });
            if(matchedBroker){
                return !!matchedBroker.is_tele_sale_staff;
            }else{
                return false;
            }
        }else{
            return false;
        }
    }

    isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    /** WEB-3066 2FA Message - Add the message type in the message. **/
    invalidateEmailLinks() {
        const self = this;

        let url = "sec/developer/sales/"+ self.sale_id +"/invalidate-email-links";

        loading(true);
        self.SSHttpService.putAPIRequest(url).then(function (response) {
            loading(false);
            self.hideModals();
            if (response instanceof Error) {
                if (response.sub_code == 305015 || response.sub_code == 412002) {
                    self.SSAlertService.danger('Oops!', 'Something went wrong. Please contact support. ');
                    return;
                }
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success('Email links invalidated successfully.');
        });
    }

    openAmlRiskAssessmentModal(document) {
        const self = this;

        // WEB-4408 - the Review link is already hidden when the property has no AML Risk
        // Assessment question; this guards any other route into the modal.
        if (!self.hasAmlRiskAssessmentQuestions()) {
            self.SSAlertService.warning("Please Note:", self.AML_RISK_ASSESSMENT_NOT_CONFIGURED_MESSAGE);
            return;
        }

        self.selected_aml_document = document;

        // Prepopulate from existing question answers (if any)
        let levelQuestion = self.getQuestionByMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL);
        let remarksQuestion = self.getQuestionByMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS);

        let riskValue = levelQuestion && levelQuestion.answer_text ? String(levelQuestion.answer_text).trim() : '';
        let remarksValue = remarksQuestion && remarksQuestion.answer_text ? String(remarksQuestion.answer_text) : '';

        // Normalize risk value to match radio values: "Low" | "Medium" | "High"
        if (riskValue) {
            let normalized = riskValue.toLowerCase();
            if (normalized === 'low' || normalized === 'medium' || normalized === 'high') {
                riskValue = normalized.charAt(0).toUpperCase() + normalized.slice(1);
            }
        }

        self.aml_assessment = {
            risk_value: riskValue,
            remarks: remarksValue,
        };
        self.aml_assessment_errors = {};
        $('#modelAmlRiskAssessment').modal('show');
    }

    checkIfQuestionsHaveMarker(marker){
        const self = this;
        let question = self.getQuestionByMarker(marker);
        return question ? !!question : false;
    }

    checkIfQuestionIsRequired(marker) {
        const self = this;
        let question = self.getQuestionByMarker(marker);
        return question ? !!question.is_required : false;
    }

    /**
     * WEB-4408 - find the property question carrying the given marker.
     *
     * `property_questions.marker` is a comma-separated list ("80" or "80,10"), so it is
     * matched with SSUtilService.compareQuestionMarker(), as the EOI and Key Handover AML
     * flows do. A plain `==` missed any question with more than one marker, which hid its
     * field and made the AML review post an empty `question_answers`.
     *
     * @param {number} marker SHOWSUITE.QUESTION_MARKER_* value.
     * @returns {Object|null|undefined} The first matching question, or a falsy value.
     */
    getQuestionByMarker(marker) {
        const self = this;
        if (!self.questions) return null;
        return self.questions.find(q => self.SSUtilService.compareQuestionMarker(q.marker, marker));
    }

    /**
     * WEB-4408 - whether the property has anything for the AML Risk Assessment review to
     * record. Without a Level or Remarks question the modal would post `{}`, which the
     * API rejects (412001) rather than stamping the document Reviewed with no assessment.
     *
     * @returns {boolean}
     */
    hasAmlRiskAssessmentQuestions() {
        const self = this;
        return self.checkIfQuestionsHaveMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL)
            || self.checkIfQuestionsHaveMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS);
    }

    updateRiskAssessment() {
        const self = this;
        self.aml_assessment_errors = {};

        // WEB-4408 - every field shown in the modal is required, as in the EOI and Key
        // Handover AML flows (isValidAmlRiskInput). This used to follow the question's
        // is_required flag, so a review could be saved with the level or remarks blank.
        if (self.checkIfQuestionsHaveMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL) && !self.aml_assessment.risk_value) {
            self.aml_assessment_errors.risk_value = "Risk assessment is required";
        }

        if (self.checkIfQuestionsHaveMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS)
            && !(self.aml_assessment.remarks && self.aml_assessment.remarks.trim())) {
            self.aml_assessment_errors.remarks = "Remarks is required";
        }

        let remarksMaxLength = self.SSConfigService.getAmlRiskAssessmentRemarksMaxLength();
        if (self.aml_assessment.remarks && self.aml_assessment.remarks.length > remarksMaxLength) {
            self.aml_assessment_errors.remarks = "Only " + remarksMaxLength + " characters are allowed for remarks.";
        }

        if (Object.keys(self.aml_assessment_errors).length > 0) {
            return;
        }

        let question_answers = {};
        let levelQuestion = self.getQuestionByMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_LEVEL);
        if (levelQuestion) {
            question_answers[levelQuestion.id] = self.aml_assessment.risk_value;
        }

        let remarksQuestion = self.getQuestionByMarker(self.QUESTION_MARKER_AML_RISK_ASSESSMENT_REMARKS);
        if (remarksQuestion) {
            question_answers[remarksQuestion.id] = self.aml_assessment.remarks;
        }

        // WEB-4408 - never post an empty assessment; the API rejects it with 412001.
        if (Object.keys(question_answers).length === 0) {
            self.SSAlertService.warning("Please Note:", self.AML_RISK_ASSESSMENT_NOT_CONFIGURED_MESSAGE);
            return;
        }

        let url = 'sec/developer/sales/' + self.sale_id + '/questions-answers';
        let params = {
            question_answers: JSON.stringify(question_answers),
            sale_document_id: self.selected_aml_document.id
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            $('#modelAmlRiskAssessment').modal('hide');
            self.SSAlertService.success("AML Risk Assessment updated successfully.");
            if (self.selected_aml_document) {
                self.selected_aml_document.aml_review_status = 20;
            }
            self.$window.location.reload();
        });
    }

    // ----------------------------------------------------------------------
    // SAGE unlock (WEB-3413 iter-2 / iter-17) — extended by WEB-3889 to also
    // handle the generic (non-SAGE) posted-record confirmation.
    // ----------------------------------------------------------------------

    /**
     * Open the unlock confirmation modal for a single record. The
     * record_type the unlock POST will use is derived from the arguments:
     *   - `(payment, instrument)` → unlock the instrument (record_type:
     *     "instrument", record_ids: [instrument.id])
     *   - `(payment, null)`       → unlock the payment itself (record_type:
     *     "payment", record_ids: [payment.id])
     *
     * The same modal element is reused for both SAGE and non-SAGE records;
     * the title/body/Reason-field visibility switch on `ctrl.sageUnlockIsSage`
     * (WEB-3889) — derived from the record's `posting_type` returned by the
     * API (`SAGE`, `OTHER`, or null). `ctrl.sageUnlockRecordType` still picks
     * the payment/instrument noun within either popup.
     *
     * The previous behaviour just flipped `instrument.unlocked_for_posting`
     * locally so the user could edit/delete client-side without the server
     * actually unlocking — that left the server's SAGE lock in place and
     * blocked Regenerate. The unlock now hits the server first (iter-17).
     */
    openSageUnlockModal(payment, instrument) {
        const self = this;

        let isInstrument = !!(instrument && instrument.id);
        let isPayment    = !isInstrument && !!(payment && payment.id);
        if (!isInstrument && !isPayment) { return; }

        let record = isInstrument ? instrument : payment;

        self.sageUnlockPayment    = payment || null;
        self.sageUnlockInstrument = instrument || null;
        self.sageUnlockRecordType = isInstrument ? 'instrument' : 'payment';
        self.sageUnlockIsSage     = record.posting_type === 'SAGE';
        self.sageUnlockReason     = '';
        self.sageUnlockSubmitting = false;

        $('#sageUnlockInstrumentModal').modal('show');
    }

    /**
     * Submit the unlock to POST /sec/sage-reports/admin/unlock. Per Waseem's
     * WEB-3889 confirmation, SAGE and non-SAGE records share this same
     * endpoint/payload shape — `reason` is only sent (and only written to the
     * SAGE audit log) when the record is actually SAGE-locked; it stays
     * unset for the generic case. On success we flip the local record into
     * edit mode, set posting_status to PENDING and clear posting_date so the
     * "Posted: <datetime>" badge disappears straight away (iter-18
     * semantics). For payment-level unlocks we also reset the parent
     * payment's flags so the Edit button reappears.
     */
    confirmSageUnlock() {
        const self = this;

        let recordType = self.sageUnlockRecordType || 'instrument';
        let isSage      = !!self.sageUnlockIsSage;
        let payment    = self.sageUnlockPayment;
        let instrument = self.sageUnlockInstrument;
        let record     = (recordType === 'payment') ? payment : instrument;
        if (!record || !record.id) { return; }

        let propertyId = self._resolveSageUnlockPropertyId(payment, instrument);
        if (!propertyId) {
            self.SSAlertService.danger(
                'Cannot unlock',
                'The project for this ' + recordType + ' could not be determined. Please reload the page and try again.'
            );
            return;
        }

        let payload = {
            property_id: propertyId,
            record_type: recordType,
            record_ids:  [record.id]
        };
        if (isSage) {
            let reason = (self.sageUnlockReason || '').trim();
            if (reason) { payload.reason = reason; }
        }

        self.sageUnlockSubmitting = true;
        loading(true);
        self.SSHttpService.postAPIRequest('sec/sage-reports/admin/unlock', payload).then(function (response) {
            loading(false);
            self.sageUnlockSubmitting = false;

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            // Close modal + sync local state on the unlocked record
            // (iter-18: posting_status flips to PENDING, posting_date clears).
            $('#sageUnlockInstrumentModal').modal('hide');
            record.unlocked_for_posting = true;
            record.posting_status = self.INSTRUMENT_POSTING_STATUS_PENDING;
            record.posting_date   = null;

            self.SSAlertService.success(
                (recordType === 'payment' ? 'Payment unlocked' : 'Instrument unlocked'),
                isSage
                    ? 'You can now edit or delete this ' + recordType + '. The matching row in SAGE Export History is now regeneratable.'
                    : 'You can now edit or delete this ' + recordType + '. Remember to update the posted entry manually in the other system.'
            );
        });
    }

    /**
     * Resolve the property id to send with the unlock request. SAGE rows
     * are always single-property; prefer the field on the instrument /
     * payment, falling back to the parent sale.
     *
     * `self.sale_sales.property_id` is the canonical source — line ~675 of
     * this controller already pins it as `self.pId` right after the sale
     * load, so we use that as the primary fallback. An earlier draft
     * looked at `self.sale_sales.unit.property_id`, which does NOT exist
     * on the loaded sale shape and caused the "project for this
     * instrument could not be determined" error on every unlock click.
     */
    _resolveSageUnlockPropertyId(payment, instrument) {
        const self = this;
        if (instrument && instrument.property_id) { return instrument.property_id; }
        if (payment && payment.property_id)       { return payment.property_id; }
        if (self.pId)                              { return self.pId; }
        if (self.sale_sales && self.sale_sales.property_id) {
            return self.sale_sales.property_id;
        }
        return null;
    }
}

PaymentDetailsController.$inject = [
    "$scope",
    "$window",
    "$filter",
    "$parse",
    "$sce",
    "SSUserService",
    "SSAppService",
    "SSHttpService",
    "SSUtilService",
    "SSDateService",
    "SSEoiService",
    "SSAwsService",
    "SSAlertService",
    "OTPService",
    "SSConfirmationService",
    "$timeout",
    "SSConfigService",
    "SettingsService",
    "SSSaleRemarksService",
    "Upload"
];
app.controller("PaymentDetailsController", PaymentDetailsController);